// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zAccountNotificationsControllerGetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        categories: z.object({
            assignedToYou: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            budgetCapReached: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            campaignFinished: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            conversationFeedback: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            eventCancelled: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            eventCreated: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            eventModified: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            handoffRequested: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            lowBalance: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            mention: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            messageInOpenChat: z.object({
                inApp: z.boolean(),
                sound: z.boolean()
            }),
            messageNew: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            slaBreach: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            templateHealth: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            waitlistActivity: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            })
        }),
        emailEnabled: z.boolean(),
        emailFrequency: z.enum(['immediate', 'digest']),
        quietHours: z.object({
            enabled: z.boolean(),
            endMinute: z.int().gte(0).lte(1439),
            startMinute: z.int().gte(0).lte(1439),
            timezone: z.string().min(1)
        }),
        soundsEnabled: z.boolean(),
        version: z.literal(2),
        webPushEnabled: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAccountNotificationsControllerUpdateBody = z.object({
    categories: z.object({
        assignedToYou: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        budgetCapReached: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        campaignFinished: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        conversationFeedback: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        eventCancelled: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        eventCreated: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        eventModified: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        handoffRequested: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        lowBalance: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        mention: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        messageInOpenChat: z.object({
            inApp: z.boolean().optional(),
            sound: z.boolean().optional()
        }).optional(),
        messageNew: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        slaBreach: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        templateHealth: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional(),
        waitlistActivity: z.object({
            email: z.boolean().optional(),
            inApp: z.boolean().optional(),
            sound: z.boolean().optional(),
            webPush: z.boolean().optional()
        }).optional()
    }).optional(),
    emailEnabled: z.boolean().optional(),
    emailFrequency: z.enum(['immediate', 'digest']).optional(),
    quietHours: z.object({
        enabled: z.boolean().optional(),
        endMinute: z.int().gte(0).lte(1439).optional(),
        startMinute: z.int().gte(0).lte(1439).optional(),
        timezone: z.string().min(1).optional()
    }).optional(),
    soundsEnabled: z.boolean().optional(),
    webPushEnabled: z.boolean().optional()
});

export const zAccountNotificationsControllerUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        categories: z.object({
            assignedToYou: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            budgetCapReached: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            campaignFinished: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            conversationFeedback: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            eventCancelled: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            eventCreated: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            eventModified: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            handoffRequested: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            lowBalance: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            mention: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            messageInOpenChat: z.object({
                inApp: z.boolean(),
                sound: z.boolean()
            }),
            messageNew: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            slaBreach: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            templateHealth: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            }),
            waitlistActivity: z.object({
                email: z.boolean(),
                inApp: z.boolean(),
                sound: z.boolean(),
                webPush: z.boolean()
            })
        }),
        emailEnabled: z.boolean(),
        emailFrequency: z.enum(['immediate', 'digest']),
        quietHours: z.object({
            enabled: z.boolean(),
            endMinute: z.int().gte(0).lte(1439),
            startMinute: z.int().gte(0).lte(1439),
            timezone: z.string().min(1)
        }),
        soundsEnabled: z.boolean(),
        version: z.literal(2),
        webPushEnabled: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAccountPrivacyControllerCancelDeletionResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        cancelled: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAccountPrivacyControllerExportCountsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        backups: z.number().nullable(),
        captured_leads: z.number(),
        conversations: z.number(),
        documents: z.number().nullable(),
        events: z.number(),
        notifications: z.number().nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAccountPrivacyControllerGetDeletionRequestResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        request: z.object({
            cancelledAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            id: z.string(),
            requestedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            scheduledFor: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            status: z.enum([
                'PENDING',
                'CANCELLED',
                'COMPLETED'
            ])
        }).nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAccountPrivacyControllerListExportsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            categories: z.array(z.enum([
                'conversations',
                'events',
                'documents',
                'backups',
                'notifications',
                'captured_leads'
            ])),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            downloadUrl: z.url().nullable(),
            expiresAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            failureReason: z.string().nullable(),
            id: z.string(),
            sizeBytes: z.number().nullable(),
            status: z.enum([
                'PENDING',
                'RUNNING',
                'READY',
                'EXPIRED',
                'FAILED'
            ]),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAccountPrivacyControllerRequestDeletionBody = z.object({
    reason: z.string().max(500).optional()
});

export const zAccountPrivacyControllerRequestDeletionResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        cancelledAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        id: z.string(),
        requestedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        scheduledFor: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        status: z.enum([
            'PENDING',
            'CANCELLED',
            'COMPLETED'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAccountPrivacyControllerRequestExportBody = z.object({
    categories: z.array(z.enum([
        'conversations',
        'events',
        'documents',
        'backups',
        'notifications',
        'captured_leads'
    ])).min(1),
    dateRange: z.object({
        from: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
        to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional()
    }).optional()
});

export const zAccountPrivacyControllerRequestExportResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        id: z.string(),
        status: z.enum([
            'PENDING',
            'RUNNING',
            'READY',
            'EXPIRED',
            'FAILED'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAdminSchedulersControllerGetJobSchedulerResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        scheduler: z.object({
            endDate: z.number().optional(),
            every: z.number().optional(),
            id: z.string().optional(),
            key: z.string().optional(),
            name: z.string().optional(),
            next: z.number().optional(),
            pattern: z.string().optional(),
            tz: z.string().optional()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAdminSchedulersControllerListJobSchedulersResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        schedulers: z.array(z.object({
            endDate: z.number().optional(),
            every: z.number().optional(),
            id: z.string().optional(),
            key: z.string().optional(),
            name: z.string().optional(),
            next: z.number().optional(),
            pattern: z.string().optional(),
            tz: z.string().optional()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAdminSchedulersControllerRemoveJobSchedulerResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        removed: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAdminSecretsControllerCheckSecretExistsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        exists: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAdminSecretsControllerListSecretsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        secrets: z.array(z.string()),
        total: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAdminUsersControllerCreateUserBody = z.object({
    email: z.email().max(320).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
    isActive: z.boolean().optional(),
    isVerified: z.boolean().optional(),
    password: z.string().min(8).max(128),
    role: z.enum(['superuser', 'user']).optional()
});

export const zAdminUsersControllerCreateUserResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.object({
            email: z.email().max(320).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).nullable(),
            id: z.string().max(128),
            isActive: z.boolean().optional(),
            isVerified: z.boolean().optional(),
            name: z.string().max(200).nullish(),
            phoneE164: z.string().max(16).nullish(),
            role: z.enum(['superuser', 'user'])
        }),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAdminUsersControllerDeleteUserResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAdminUsersControllerGetUserResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.object({
            email: z.email().max(320).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).nullable(),
            id: z.string().max(128),
            isActive: z.boolean().optional(),
            isVerified: z.boolean().optional(),
            name: z.string().max(200).nullish(),
            phoneE164: z.string().max(16).nullish(),
            role: z.enum(['superuser', 'user'])
        }),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAdminUsersControllerListUsersResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.array(z.object({
            email: z.email().max(320).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).nullable(),
            id: z.string().max(128),
            isActive: z.boolean().optional(),
            isVerified: z.boolean().optional(),
            name: z.string().max(200).nullish(),
            phoneE164: z.string().max(16).nullish(),
            role: z.enum(['superuser', 'user'])
        })),
        meta: z.object({
            nextCursor: z.string().nullish()
        }),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAdminUsersControllerUpdateUserBody = z.object({
    email: z.email().max(320).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).optional(),
    isActive: z.boolean().optional(),
    isVerified: z.boolean().optional(),
    name: z.string().max(200).nullish(),
    password: z.string().min(8).max(128).optional(),
    phoneE164: z.string().max(16).nullish(),
    role: z.enum(['superuser', 'user']).optional()
});

export const zAdminUsersControllerUpdateUserResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.object({
            email: z.email().max(320).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).nullable(),
            id: z.string().max(128),
            isActive: z.boolean().optional(),
            isVerified: z.boolean().optional(),
            name: z.string().max(200).nullish(),
            phoneE164: z.string().max(16).nullish(),
            role: z.enum(['superuser', 'user'])
        }),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAdminWebhooksControllerRetryWebhookDeliveryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        deliveryId: z.string(),
        requeued: z.boolean(),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAiModelsControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.array(z.union([
            z.object({
                architecture: z.object({
                    input_modalities: z.array(z.string()).optional(),
                    instruct_type: z.string().optional(),
                    modality: z.string().optional(),
                    output_modalities: z.array(z.string()).optional(),
                    tokenizer: z.string().optional()
                }).optional(),
                betaModel: z.boolean().optional(),
                context_length: z.number().optional(),
                created: z.number().optional(),
                deprecation: z.object({
                    date: z.string()
                }).optional(),
                description: z.string().optional(),
                endpoints: z.array(z.object({
                    context_length: z.number(),
                    max_completion_tokens: z.number().nullish(),
                    max_prompt_tokens: z.number().nullish(),
                    model_name: z.string(),
                    name: z.string(),
                    pricing: z.object({
                        audio: z.union([
                            z.string(),
                            z.number()
                        ]).optional(),
                        completion: z.union([
                            z.string(),
                            z.number()
                        ]),
                        discount: z.number().optional(),
                        image: z.union([
                            z.string(),
                            z.number()
                        ]).optional(),
                        image_output: z.union([
                            z.string(),
                            z.number()
                        ]).optional(),
                        image_token: z.union([
                            z.string(),
                            z.number()
                        ]).optional(),
                        input_audio_cache: z.union([
                            z.string(),
                            z.number()
                        ]).optional(),
                        input_cache_read: z.union([
                            z.string(),
                            z.number()
                        ]).optional(),
                        input_cache_write: z.union([
                            z.string(),
                            z.number()
                        ]).optional(),
                        internal_reasoning: z.union([
                            z.string(),
                            z.number()
                        ]).optional(),
                        prompt: z.union([
                            z.string(),
                            z.number()
                        ]),
                        request: z.union([
                            z.string(),
                            z.number()
                        ]).optional(),
                        web_search: z.union([
                            z.string(),
                            z.number()
                        ]).optional()
                    }),
                    provider_name: z.string(),
                    quantization: z.union([
                        z.string(),
                        z.record(z.string(), z.unknown())
                    ]).nullish(),
                    status: z.union([
                        z.string(),
                        z.number()
                    ]).nullish(),
                    supported_parameters: z.array(z.string()).optional(),
                    supports_implicit_caching: z.boolean().optional(),
                    tag: z.string(),
                    uptime_last_30m: z.number().nullish()
                })).optional(),
                id: z.string(),
                maker: z.string().optional(),
                model_name: z.string().optional(),
                modelSource: z.string().optional(),
                name: z.string(),
                offline: z.boolean().optional(),
                per_request_limits: z.object({
                    completion_tokens: z.string().optional(),
                    prompt_tokens: z.string().optional()
                }).optional(),
                pricing: z.object({
                    completion: z.string().optional(),
                    prompt: z.string().optional()
                }).optional(),
                privacy: z.enum(['private', 'anonymized']).optional(),
                provider: z.string().optional(),
                supported_parameters: z.array(z.string()).optional(),
                top_provider: z.object({
                    is_moderated: z.boolean().optional(),
                    max_completion_tokens: z.number().optional()
                }).optional(),
                traits: z.array(z.string()).optional(),
                type: z.enum(['text']),
                variant: z.string().optional()
            }),
            z.object({
                betaModel: z.boolean().optional(),
                constraints: z.object({
                    aspectRatios: z.array(z.string()).optional(),
                    defaultAspectRatio: z.string().optional(),
                    defaultResolution: z.string().optional(),
                    promptCharacterLimit: z.number().optional(),
                    resolutions: z.array(z.string()).optional(),
                    steps: z.object({
                        default: z.number(),
                        max: z.number()
                    }).optional(),
                    widthHeightDivisor: z.number().optional()
                }).optional(),
                created: z.number().optional(),
                deprecation: z.object({
                    date: z.string()
                }).optional(),
                description: z.string().optional(),
                id: z.string(),
                modelSource: z.string().optional(),
                name: z.string(),
                offline: z.boolean().optional(),
                pricing: z.object({
                    generation: z.number().optional(),
                    resolutions: z.record(z.string(), z.number()).optional(),
                    upscale_2x: z.number().optional(),
                    upscale_4x: z.number().optional()
                }),
                privacy: z.enum(['private', 'anonymized']).optional(),
                provider: z.string().optional(),
                supportsWebSearch: z.boolean().optional(),
                traits: z.array(z.string()).optional(),
                type: z.enum(['image'])
            }),
            z.object({
                betaModel: z.boolean().optional(),
                constraints: z.object({
                    aspect_ratios: z.array(z.string()).optional(),
                    audio: z.boolean().optional(),
                    audio_configurable: z.boolean().optional(),
                    audio_input: z.boolean().optional(),
                    durations: z.array(z.string()).optional(),
                    model_type: z.enum([
                        'text-to-video',
                        'image-to-video',
                        'video'
                    ]).optional(),
                    resolutions: z.array(z.string()).optional(),
                    video_input: z.boolean().optional()
                }).optional(),
                created: z.number().optional(),
                deprecation: z.object({
                    date: z.string()
                }).optional(),
                description: z.string().optional(),
                id: z.string(),
                model_sets: z.array(z.string()).optional(),
                modelSource: z.string().optional(),
                name: z.string(),
                offline: z.boolean().optional(),
                privacy: z.enum(['private', 'anonymized']).optional(),
                provider: z.string().optional(),
                traits: z.array(z.string()).optional(),
                type: z.enum(['video'])
            }),
            z.object({
                betaModel: z.boolean().optional(),
                constraints: z.object({
                    aspectRatios: z.array(z.string()).optional(),
                    combineImages: z.boolean().optional()
                }).optional(),
                created: z.number().optional(),
                deprecation: z.object({
                    date: z.string()
                }).optional(),
                description: z.string().optional(),
                id: z.string(),
                modelSource: z.string().optional(),
                name: z.string(),
                offline: z.boolean().optional(),
                pricing: z.object({
                    generation: z.number().optional()
                }),
                privacy: z.enum(['private', 'anonymized']).optional(),
                provider: z.string().optional(),
                traits: z.array(z.string()).optional(),
                type: z.enum(['inpaint'])
            }),
            z.object({
                betaModel: z.boolean().optional(),
                created: z.number().optional(),
                deprecation: z.object({
                    date: z.string()
                }).optional(),
                description: z.string().optional(),
                id: z.string(),
                modelSource: z.string().optional(),
                name: z.string(),
                offline: z.boolean().optional(),
                pricing: z.object({
                    input: z.number().optional(),
                    output: z.number().optional()
                }),
                privacy: z.enum(['private', 'anonymized']).optional(),
                provider: z.string().optional(),
                traits: z.array(z.string()).optional(),
                type: z.enum(['embedding'])
            }),
            z.object({
                betaModel: z.boolean().optional(),
                created: z.number().optional(),
                deprecation: z.object({
                    date: z.string()
                }).optional(),
                description: z.string().optional(),
                id: z.string(),
                modelSource: z.string().optional(),
                name: z.string(),
                offline: z.boolean().optional(),
                pricing: z.object({
                    input: z.number().optional()
                }),
                privacy: z.enum(['private', 'anonymized']).optional(),
                provider: z.string().optional(),
                traits: z.array(z.string()).optional(),
                type: z.enum(['tts']),
                voices: z.array(z.string()).optional()
            }),
            z.object({
                betaModel: z.boolean().optional(),
                created: z.number().optional(),
                deprecation: z.object({
                    date: z.string()
                }).optional(),
                description: z.string().optional(),
                id: z.string(),
                modelSource: z.string().optional(),
                name: z.string(),
                offline: z.boolean().optional(),
                pricing: z.object({
                    per_audio_second: z.number().optional()
                }),
                privacy: z.enum(['private', 'anonymized']).optional(),
                provider: z.string().optional(),
                traits: z.array(z.string()).optional(),
                type: z.enum(['asr'])
            }),
            z.object({
                betaModel: z.boolean().optional(),
                created: z.number().optional(),
                deprecation: z.object({
                    date: z.string()
                }).optional(),
                description: z.string().optional(),
                id: z.string(),
                modelSource: z.string().optional(),
                name: z.string(),
                offline: z.boolean().optional(),
                pricing: z.object({
                    generation: z.number().optional()
                }),
                privacy: z.enum(['private', 'anonymized']).optional(),
                provider: z.string().optional(),
                traits: z.array(z.string()).optional(),
                type: z.enum(['upscale'])
            })
        ]))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAiModelsControllerListBenchmarksResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        attributionUrl: z.string(),
        data: z.array(z.object({
            agenticIndex: z.number().optional(),
            codingIndex: z.number().optional(),
            creatorName: z.string().optional(),
            creatorSlug: z.string().optional(),
            intelligenceIndex: z.number().optional(),
            latencyFirstTokenSeconds: z.number().optional(),
            mathIndex: z.number().optional(),
            name: z.string(),
            priceBlendedUsdPer1m: z.number().optional(),
            releaseDate: z.string().optional(),
            slug: z.string(),
            speedTokensPerSecond: z.number().optional()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAiModelsControllerListProvidersResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.array(z.object({
            name: z.string(),
            privacy_policy_url: z.string().nullish(),
            slug: z.string(),
            status_page_url: z.string().nullish(),
            terms_of_service_url: z.string().nullish()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAiUsageControllerGetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        byDay: z.array(z.object({
            date: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            inputTokens: z.number(),
            outputTokens: z.number(),
            recordCount: z.number(),
            totalCostUsd: z.number(),
            totalTokens: z.number()
        })).optional().default([]),
        byModel: z.array(z.object({
            cachedInputTokens: z.number().optional().default(0),
            cacheWriteInputTokens: z.number().optional().default(0),
            inputTokens: z.number(),
            model: z.string(),
            outputTokens: z.number(),
            reasoningTokens: z.number().optional().default(0),
            recordCount: z.number(),
            totalCostUsd: z.number(),
            totalTokens: z.number()
        })),
        byPreset: z.array(z.object({
            inputTokens: z.number(),
            outputTokens: z.number(),
            presetId: z.string().nullable(),
            presetName: z.string().nullable(),
            recordCount: z.number(),
            totalCostUsd: z.number(),
            totalTokens: z.number()
        })).optional().default([]),
        byUser: z.array(z.object({
            email: z.string().nullish().default(null),
            inputTokens: z.number(),
            name: z.string().nullish().default(null),
            outputTokens: z.number(),
            recordCount: z.number(),
            totalCostUsd: z.number(),
            totalTokens: z.number(),
            userId: z.string().nullable()
        })).optional().default([]),
        byUserMaxCostUsd: z.number().optional().default(0),
        byUserTotal: z.number().optional().default(0),
        performance: z.object({
            averageEffectiveOutputTokensPerSecond: z.number().nullable(),
            averageOutputTokensPerSecond: z.number().nullable(),
            averageResponseTimeMs: z.number().nullable(),
            averageStepTimeMs: z.number().nullable(),
            averageTimeToFirstOutputMs: z.number().nullable(),
            costPer1kTokensUsd: z.number().nullable(),
            costPerResponseUsd: z.number().nullable(),
            maxToolExecutionMs: z.number().nullable(),
            missingPerformanceCount: z.number(),
            missingUsageCount: z.number(),
            p95ResponseTimeMs: z.number().nullable(),
            toolCallCount: z.number(),
            toolErrorCount: z.number(),
            toolErrorRate: z.number().nullable(),
            toolResultCount: z.number(),
            totalGenerations: z.number(),
            totalToolCalls: z.number(),
            totalToolErrors: z.number(),
            totalToolExecutionMs: z.number()
        }),
        periodEnd: z.string(),
        periodStart: z.string(),
        planLimitUsd: z.number().optional().default(0),
        projectedMonthlyTotalUsd: z.number().nullish().default(null),
        totalCostUsd: z.number(),
        totalInputTokens: z.number(),
        totalOutputTokens: z.number(),
        totalRecords: z.number(),
        totalTokens: z.number()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zApiKeysControllerListMineResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.array(z.object({
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            enabled: z.boolean(),
            expiresAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            id: z.string().max(128),
            name: z.string().max(200).nullable(),
            prefix: z.string().max(32).nullable(),
            referenceId: z.string().max(128),
            scopes: z.array(z.string()).nullish(),
            start: z.string().max(32).nullable(),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        })),
        pagination: z.object({
            currentPage: z.int().gte(1).lte(9007199254740991),
            hasNextPage: z.boolean(),
            hasPreviousPage: z.boolean(),
            itemsPerPage: z.int().gte(1).lte(9007199254740991),
            remainingItems: z.int().gte(0).lte(9007199254740991),
            returnedItems: z.int().gte(0).lte(9007199254740991),
            totalItems: z.int().gte(0).lte(9007199254740991),
            totalPages: z.int().gte(1).lte(9007199254740991)
        }),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAppFeedbackControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            appVersion: z.string().nullable(),
            body: z.string(),
            category: z.enum([
                'BUG',
                'IDEA',
                'PRAISE'
            ]),
            consoleLog: z.string().nullable(),
            createdAt: z.string(),
            id: z.string(),
            orgId: z.string(),
            resolvedAt: z.string().nullable(),
            screenshotUrl: z.string().nullable(),
            status: z.enum([
                'NEW',
                'TRIAGED',
                'RESOLVED',
                'WONTFIX'
            ]),
            submitterEmail: z.string().nullable(),
            submitterName: z.string().nullable(),
            triagedById: z.string().nullable(),
            updatedAt: z.string(),
            url: z.string().nullable(),
            userAgent: z.string().nullable(),
            userId: z.string()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAppFeedbackControllerSubmitBody = z.object({
    appVersion: z.string().max(64).optional(),
    body: z.string().min(1).max(5000),
    category: z.enum([
        'BUG',
        'IDEA',
        'PRAISE'
    ]),
    consoleLog: z.string().max(65536).optional(),
    includeConsoleLog: z.boolean().optional().default(false),
    screenshotUrl: z.url().optional(),
    url: z.string().max(2000).optional()
});

export const zAppFeedbackControllerSubmitResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.string(),
        id: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAppFeedbackControllerUpdateStatusBody = z.object({
    id: z.string().min(1),
    status: z.enum([
        'NEW',
        'TRIAGED',
        'RESOLVED',
        'WONTFIX'
    ])
});

export const zAppFeedbackControllerUpdateStatusResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        id: z.string(),
        resolvedAt: z.string().nullable(),
        status: z.enum([
            'NEW',
            'TRIAGED',
            'RESOLVED',
            'WONTFIX'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zBillingControllerGetCheckoutSessionStatusBody = z.object({
    sessionId: z.string().min(1)
});

export const zBillingControllerGetCheckoutSessionStatusResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        billingConfigured: z.boolean(),
        billingInterval: z.enum(['monthly', 'yearly']).nullable(),
        cancelAtPeriodEnd: z.boolean(),
        currentPeriodEnd: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        currentPeriodStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        hasProviderCustomer: z.boolean(),
        market: z.enum([
            'saudi',
            'egypt',
            'global'
        ]).nullable(),
        paymentMethod: z.object({
            brand: z.string(),
            last4: z.string()
        }).nullable(),
        plan: z.enum([
            'chat',
            'standard',
            'premium'
        ]),
        portalAvailable: z.boolean(),
        provider: z.enum([
            'stripe',
            'paymob_eg',
            'paymob_sa'
        ]).nullable(),
        subscriptionStatus: z.enum([
            'none',
            'active',
            'past_due',
            'canceled',
            'trialing'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zBillingControllerGetPricingResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        billingConfigured: z.boolean(),
        plans: z.array(z.object({
            displayName: z.string(),
            features: z.array(z.string()),
            plan: z.enum([
                'chat',
                'standard',
                'premium'
            ]),
            prices: z.record(z.string(), z.object({
                monthly: z.int().gte(-9007199254740991).lte(9007199254740991),
                yearly: z.int().gte(-9007199254740991).lte(9007199254740991),
                yearlyPerMonth: z.int().gte(-9007199254740991).lte(9007199254740991)
            }))
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zBillingControllerGetStatusResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        billingConfigured: z.boolean(),
        billingInterval: z.enum(['monthly', 'yearly']).nullable(),
        cancelAtPeriodEnd: z.boolean(),
        currentPeriodEnd: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        currentPeriodStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        hasProviderCustomer: z.boolean(),
        market: z.enum([
            'saudi',
            'egypt',
            'global'
        ]).nullable(),
        paymentMethod: z.object({
            brand: z.string(),
            last4: z.string()
        }).nullable(),
        plan: z.enum([
            'chat',
            'standard',
            'premium'
        ]),
        portalAvailable: z.boolean(),
        provider: z.enum([
            'stripe',
            'paymob_eg',
            'paymob_sa'
        ]).nullable(),
        subscriptionStatus: z.enum([
            'none',
            'active',
            'past_due',
            'canceled',
            'trialing'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zBillingControllerGetUpcomingInvoiceResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        billingConfigured: z.boolean(),
        hasProviderCustomer: z.boolean(),
        upcoming: z.object({
            amountDue: z.int().gte(-9007199254740991).lte(9007199254740991),
            currency: z.string(),
            lines: z.array(z.object({
                amount: z.int().gte(-9007199254740991).lte(9007199254740991),
                description: z.string().nullable(),
                periodEnd: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
                periodStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
                quantity: z.int().gte(-9007199254740991).lte(9007199254740991).nullable()
            })),
            nextPaymentAttempt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            periodEnd: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            periodStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            subtotal: z.int().gte(-9007199254740991).lte(9007199254740991)
        }).nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zBillingControllerGetUsageResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        messages: z.object({
            limit: z.int().gte(0).lte(9007199254740991),
            periodEnd: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            periodStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            used: z.int().gte(0).lte(9007199254740991)
        }),
        plan: z.enum([
            'chat',
            'standard',
            'premium'
        ]),
        seats: z.object({
            limit: z.int().gte(0).lte(9007199254740991).nullable(),
            used: z.int().gte(0).lte(9007199254740991)
        }),
        storage: z.object({
            limitBytes: z.number().gte(0),
            usedBytes: z.number().gte(0)
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zBillingControllerListInvoicesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        billingConfigured: z.boolean(),
        hasProviderCustomer: z.boolean(),
        invoices: z.array(z.object({
            amountDue: z.int().gte(-9007199254740991).lte(9007199254740991),
            amountPaid: z.int().gte(-9007199254740991).lte(9007199254740991),
            created: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            currency: z.string(),
            description: z.string().nullable(),
            hostedInvoiceUrl: z.string().nullable(),
            id: z.string(),
            invoicePdf: z.string().nullable(),
            number: z.string().nullable(),
            periodEnd: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            periodStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            status: z.enum([
                'draft',
                'open',
                'paid',
                'void',
                'uncollectible'
            ]).nullable()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zBillingControllerSyncAfterCheckoutResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        billingConfigured: z.boolean(),
        billingInterval: z.enum(['monthly', 'yearly']).nullable(),
        cancelAtPeriodEnd: z.boolean(),
        currentPeriodEnd: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        currentPeriodStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        hasProviderCustomer: z.boolean(),
        market: z.enum([
            'saudi',
            'egypt',
            'global'
        ]).nullable(),
        paymentMethod: z.object({
            brand: z.string(),
            last4: z.string()
        }).nullable(),
        plan: z.enum([
            'chat',
            'standard',
            'premium'
        ]),
        portalAvailable: z.boolean(),
        provider: z.enum([
            'stripe',
            'paymob_eg',
            'paymob_sa'
        ]).nullable(),
        subscriptionStatus: z.enum([
            'none',
            'active',
            'past_due',
            'canceled',
            'trialing'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zBookingItemDto = z.object({
    cancelled: z.boolean(),
    endsAt: z.string().nullable(),
    eventDateTime: z.string(),
    eventTypeId: z.string().nullable(),
    id: z.string(),
    phoneE164: z.string().nullable(),
    status: z.string(),
    type: z.string(),
    uid: z.string().nullable(),
    userId: z.string().nullable(),
    userName: z.string().nullable()
});

export const zCalendarControllerGetByPhoneResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.array(z.object({
        allDay: z.boolean().nullish(),
        end: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
        extendedProps: z.object({
            message: z.string().nullish(),
            role: z.string().nullish()
        }).nullish(),
        id: z.string().min(1),
        start: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        title: z.string(),
        user_name: z.string().nullish()
    })).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCalendarControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.record(z.string(), z.array(z.object({
        allDay: z.boolean().nullish(),
        end: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
        extendedProps: z.object({
            message: z.string().nullish(),
            role: z.string().nullish()
        }).nullish(),
        id: z.string().min(1),
        start: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        title: z.string(),
        user_name: z.string().nullish()
    }))).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCampaignsControllerCancelResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        cancelled: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCampaignsControllerCreateBody = z.object({
    audienceSnapshot: z.record(z.string(), z.unknown()).nullish().default(null),
    channel: z.enum(['WHATSAPP']).optional().default('WHATSAPP'),
    name: z.string().min(1).max(120),
    phoneNumberId: z.string().min(1).max(64).nullable(),
    replyMode: z.enum(['AI', 'HUMAN_TAKEOVER']).optional().default('AI'),
    selectedContactIds: z.array(z.string()).max(10000).optional().default([]),
    templateCategory: z.string().nullish().default(null),
    templateLanguage: z.string().min(2).max(16).nullable(),
    templateName: z.string().min(1).max(512).nullable(),
    variableMappings: z.record(z.string(), z.union([
        z.object({
            field: z.enum(['name', 'phoneE164']),
            source: z.enum(['contact_field'])
        }),
        z.object({
            attributeKey: z.string().min(1).max(64),
            source: z.enum(['contact_attribute'])
        }),
        z.object({
            source: z.enum(['static']),
            value: z.string().max(1024)
        }),
        z.object({
            filename: z.string().max(256).optional(),
            kind: z.enum([
                'image',
                'video',
                'document'
            ]),
            source: z.enum(['media']),
            url: z.url().max(2048)
        })
    ])).optional().default({})
});

export const zCampaignsControllerCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        audienceSnapshot: z.record(z.string(), z.unknown()).nullable(),
        channel: z.enum(['WHATSAPP']),
        completedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        completionEventAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdByUserId: z.string().nullable(),
        id: z.string(),
        name: z.string().min(1).max(120),
        orgId: z.string().min(1),
        phoneNumberId: z.string().min(1).max(64).nullable(),
        recipientCount: z.int().gte(0).lte(9007199254740991),
        replyMode: z.enum(['AI', 'HUMAN_TAKEOVER']),
        selectedContactIds: z.array(z.string()).max(10000),
        sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        status: z.enum([
            'DRAFT',
            'SENDING',
            'COMPLETED',
            'FAILED',
            'CANCELLED'
        ]),
        templateCategory: z.string().nullable(),
        templateLanguage: z.string().min(2).max(16).nullable(),
        templateName: z.string().min(1).max(512).nullable(),
        templateSnapshot: z.object({
            category: z.string().min(1),
            components: z.array(z.union([
                z.object({
                    format: z.enum(['TEXT']).optional(),
                    text: z.string().max(60),
                    type: z.enum(['HEADER'])
                }),
                z.object({
                    format: z.enum([
                        'IMAGE',
                        'VIDEO',
                        'DOCUMENT'
                    ]),
                    type: z.enum(['HEADER'])
                }),
                z.object({
                    text: z.string().max(1024),
                    type: z.enum(['BODY'])
                }),
                z.object({
                    text: z.string().max(60),
                    type: z.enum(['FOOTER'])
                }),
                z.object({
                    buttons: z.array(z.object({
                        example: z.array(z.string()).optional(),
                        text: z.string(),
                        type: z.string(),
                        url: z.string().optional()
                    })).max(10),
                    type: z.enum(['BUTTONS'])
                })
            ])),
            language: z.string().min(2).max(16),
            name: z.string().min(1).max(512),
            status: z.enum(['APPROVED'])
        }).nullable(),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        variableMappings: z.record(z.string(), z.union([
            z.object({
                field: z.enum(['name', 'phoneE164']),
                source: z.enum(['contact_field'])
            }),
            z.object({
                attributeKey: z.string().min(1).max(64),
                source: z.enum(['contact_attribute'])
            }),
            z.object({
                source: z.enum(['static']),
                value: z.string().max(1024)
            }),
            z.object({
                filename: z.string().max(256).optional(),
                kind: z.enum([
                    'image',
                    'video',
                    'document'
                ]),
                source: z.enum(['media']),
                url: z.url().max(2048)
            })
        ]))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCampaignsControllerDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        deleted: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCampaignsControllerGetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        campaign: z.object({
            audienceSnapshot: z.record(z.string(), z.unknown()).nullable(),
            channel: z.enum(['WHATSAPP']),
            completedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            completionEventAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            createdByUserId: z.string().nullable(),
            id: z.string(),
            name: z.string().min(1).max(120),
            orgId: z.string().min(1),
            phoneNumberId: z.string().min(1).max(64).nullable(),
            recipientCount: z.int().gte(0).lte(9007199254740991),
            replyMode: z.enum(['AI', 'HUMAN_TAKEOVER']),
            selectedContactIds: z.array(z.string()).max(10000),
            sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            status: z.enum([
                'DRAFT',
                'SENDING',
                'COMPLETED',
                'FAILED',
                'CANCELLED'
            ]),
            templateCategory: z.string().nullable(),
            templateLanguage: z.string().min(2).max(16).nullable(),
            templateName: z.string().min(1).max(512).nullable(),
            templateSnapshot: z.object({
                category: z.string().min(1),
                components: z.array(z.union([
                    z.object({
                        format: z.enum(['TEXT']).optional(),
                        text: z.string().max(60),
                        type: z.enum(['HEADER'])
                    }),
                    z.object({
                        format: z.enum([
                            'IMAGE',
                            'VIDEO',
                            'DOCUMENT'
                        ]),
                        type: z.enum(['HEADER'])
                    }),
                    z.object({
                        text: z.string().max(1024),
                        type: z.enum(['BODY'])
                    }),
                    z.object({
                        text: z.string().max(60),
                        type: z.enum(['FOOTER'])
                    }),
                    z.object({
                        buttons: z.array(z.object({
                            example: z.array(z.string()).optional(),
                            text: z.string(),
                            type: z.string(),
                            url: z.string().optional()
                        })).max(10),
                        type: z.enum(['BUTTONS'])
                    })
                ])),
                language: z.string().min(2).max(16),
                name: z.string().min(1).max(512),
                status: z.enum(['APPROVED'])
            }).nullable(),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            variableMappings: z.record(z.string(), z.union([
                z.object({
                    field: z.enum(['name', 'phoneE164']),
                    source: z.enum(['contact_field'])
                }),
                z.object({
                    attributeKey: z.string().min(1).max(64),
                    source: z.enum(['contact_attribute'])
                }),
                z.object({
                    source: z.enum(['static']),
                    value: z.string().max(1024)
                }),
                z.object({
                    filename: z.string().max(256).optional(),
                    kind: z.enum([
                        'image',
                        'video',
                        'document'
                    ]),
                    source: z.enum(['media']),
                    url: z.url().max(2048)
                })
            ]))
        }),
        counters: z.object({
            delivered: z.int().gte(0).lte(9007199254740991),
            failed: z.int().gte(0).lte(9007199254740991),
            queued: z.int().gte(0).lte(9007199254740991),
            read: z.int().gte(0).lte(9007199254740991),
            replied: z.int().gte(0).lte(9007199254740991),
            sending: z.int().gte(0).lte(9007199254740991),
            sent: z.int().gte(0).lte(9007199254740991)
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCampaignsControllerLaunchResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        campaignId: z.string(),
        recipientCount: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCampaignsControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            campaign: z.object({
                audienceSnapshot: z.record(z.string(), z.unknown()).nullable(),
                channel: z.enum(['WHATSAPP']),
                completedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
                completionEventAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
                createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
                createdByUserId: z.string().nullable(),
                id: z.string(),
                name: z.string().min(1).max(120),
                orgId: z.string().min(1),
                phoneNumberId: z.string().min(1).max(64).nullable(),
                recipientCount: z.int().gte(0).lte(9007199254740991),
                replyMode: z.enum(['AI', 'HUMAN_TAKEOVER']),
                selectedContactIds: z.array(z.string()).max(10000),
                sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
                status: z.enum([
                    'DRAFT',
                    'SENDING',
                    'COMPLETED',
                    'FAILED',
                    'CANCELLED'
                ]),
                templateCategory: z.string().nullable(),
                templateLanguage: z.string().min(2).max(16).nullable(),
                templateName: z.string().min(1).max(512).nullable(),
                templateSnapshot: z.object({
                    category: z.string().min(1),
                    components: z.array(z.union([
                        z.object({
                            format: z.enum(['TEXT']).optional(),
                            text: z.string().max(60),
                            type: z.enum(['HEADER'])
                        }),
                        z.object({
                            format: z.enum([
                                'IMAGE',
                                'VIDEO',
                                'DOCUMENT'
                            ]),
                            type: z.enum(['HEADER'])
                        }),
                        z.object({
                            text: z.string().max(1024),
                            type: z.enum(['BODY'])
                        }),
                        z.object({
                            text: z.string().max(60),
                            type: z.enum(['FOOTER'])
                        }),
                        z.object({
                            buttons: z.array(z.object({
                                example: z.array(z.string()).optional(),
                                text: z.string(),
                                type: z.string(),
                                url: z.string().optional()
                            })).max(10),
                            type: z.enum(['BUTTONS'])
                        })
                    ])),
                    language: z.string().min(2).max(16),
                    name: z.string().min(1).max(512),
                    status: z.enum(['APPROVED'])
                }).nullable(),
                updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
                variableMappings: z.record(z.string(), z.union([
                    z.object({
                        field: z.enum(['name', 'phoneE164']),
                        source: z.enum(['contact_field'])
                    }),
                    z.object({
                        attributeKey: z.string().min(1).max(64),
                        source: z.enum(['contact_attribute'])
                    }),
                    z.object({
                        source: z.enum(['static']),
                        value: z.string().max(1024)
                    }),
                    z.object({
                        filename: z.string().max(256).optional(),
                        kind: z.enum([
                            'image',
                            'video',
                            'document'
                        ]),
                        source: z.enum(['media']),
                        url: z.url().max(2048)
                    })
                ]))
            }),
            counters: z.object({
                delivered: z.int().gte(0).lte(9007199254740991),
                failed: z.int().gte(0).lte(9007199254740991),
                queued: z.int().gte(0).lte(9007199254740991),
                read: z.int().gte(0).lte(9007199254740991),
                replied: z.int().gte(0).lte(9007199254740991),
                sending: z.int().gte(0).lte(9007199254740991),
                sent: z.int().gte(0).lte(9007199254740991)
            })
        })),
        totalCount: z.int().gte(0).lte(9007199254740991),
        totals: z.object({
            delivered: z.int().gte(0).lte(9007199254740991),
            failed: z.int().gte(0).lte(9007199254740991),
            queued: z.int().gte(0).lte(9007199254740991),
            read: z.int().gte(0).lte(9007199254740991),
            replied: z.int().gte(0).lte(9007199254740991),
            sending: z.int().gte(0).lte(9007199254740991),
            sent: z.int().gte(0).lte(9007199254740991)
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCampaignsControllerMetaLimitsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        checkedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        dailyUniqueDelivered: z.int().gte(0).lte(9007199254740991),
        dailyUniqueLimit: z.int().lte(9007199254740991).nullable(),
        dailyUniqueReserved: z.int().gte(0).lte(9007199254740991),
        dailyUniqueUsed: z.int().gte(0).lte(9007199254740991),
        messagingLimitTier: z.string().nullable(),
        monthlyLimit: z.int().gte(0).lte(9007199254740991).nullable(),
        monthlyReserved: z.int().gte(0).lte(9007199254740991),
        monthlyUsed: z.int().gte(0).lte(9007199254740991),
        nextAvailableAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        planAllowed: z.boolean(),
        qualityRating: z.string().nullable(),
        reason: z.string().nullable(),
        status: z.enum([
            'ready',
            'unknown',
            'blocked',
            'unconfigured'
        ]),
        workerAvailable: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCampaignsControllerPreviewCapacityBody = z.object({
    selectedContactIds: z.array(z.string().min(1)).max(10000)
});

export const zCampaignsControllerPreviewCapacityResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        canLaunch: z.boolean(),
        dailyRemaining: z.int().gte(0).lte(9007199254740991).nullable(),
        eligibleRecipients: z.int().gte(0).lte(9007199254740991),
        monthlyRemaining: z.int().gte(0).lte(9007199254740991),
        newUniqueRecipients: z.int().gte(0).lte(9007199254740991),
        nextAvailableAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        reason: z.string().nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCampaignsControllerRecipientsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            campaignId: z.string(),
            claimedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            contactId: z.string(),
            contactName: z.string().nullable(),
            deliveredAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            errorCode: z.string().nullable(),
            errorMessage: z.string().nullable(),
            failedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            failureReason: z.string().nullable(),
            id: z.string(),
            orgId: z.string(),
            phoneE164: z.string(),
            queuedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            readAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            repliedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            resolvedVariables: z.record(z.string(), z.unknown()),
            sendAttemptedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            status: z.enum([
                'QUEUED',
                'SENDING',
                'SENT',
                'DELIVERED',
                'READ',
                'REPLIED',
                'FAILED'
            ]),
            wamid: z.string().nullable()
        })),
        totalCount: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCampaignsControllerUpdateBody = z.object({
    audienceSnapshot: z.record(z.string(), z.unknown()).nullish().default(null),
    channel: z.enum(['WHATSAPP']).optional().default('WHATSAPP'),
    name: z.string().min(1).max(120),
    phoneNumberId: z.string().min(1).max(64).nullable(),
    replyMode: z.enum(['AI', 'HUMAN_TAKEOVER']).optional().default('AI'),
    selectedContactIds: z.array(z.string()).max(10000).optional().default([]),
    templateCategory: z.string().nullish().default(null),
    templateLanguage: z.string().min(2).max(16).nullable(),
    templateName: z.string().min(1).max(512).nullable(),
    variableMappings: z.record(z.string(), z.union([
        z.object({
            field: z.enum(['name', 'phoneE164']),
            source: z.enum(['contact_field'])
        }),
        z.object({
            attributeKey: z.string().min(1).max(64),
            source: z.enum(['contact_attribute'])
        }),
        z.object({
            source: z.enum(['static']),
            value: z.string().max(1024)
        }),
        z.object({
            filename: z.string().max(256).optional(),
            kind: z.enum([
                'image',
                'video',
                'document'
            ]),
            source: z.enum(['media']),
            url: z.url().max(2048)
        })
    ])).optional().default({})
});

export const zCampaignsControllerUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        audienceSnapshot: z.record(z.string(), z.unknown()).nullable(),
        channel: z.enum(['WHATSAPP']),
        completedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        completionEventAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdByUserId: z.string().nullable(),
        id: z.string(),
        name: z.string().min(1).max(120),
        orgId: z.string().min(1),
        phoneNumberId: z.string().min(1).max(64).nullable(),
        recipientCount: z.int().gte(0).lte(9007199254740991),
        replyMode: z.enum(['AI', 'HUMAN_TAKEOVER']),
        selectedContactIds: z.array(z.string()).max(10000),
        sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        status: z.enum([
            'DRAFT',
            'SENDING',
            'COMPLETED',
            'FAILED',
            'CANCELLED'
        ]),
        templateCategory: z.string().nullable(),
        templateLanguage: z.string().min(2).max(16).nullable(),
        templateName: z.string().min(1).max(512).nullable(),
        templateSnapshot: z.object({
            category: z.string().min(1),
            components: z.array(z.union([
                z.object({
                    format: z.enum(['TEXT']).optional(),
                    text: z.string().max(60),
                    type: z.enum(['HEADER'])
                }),
                z.object({
                    format: z.enum([
                        'IMAGE',
                        'VIDEO',
                        'DOCUMENT'
                    ]),
                    type: z.enum(['HEADER'])
                }),
                z.object({
                    text: z.string().max(1024),
                    type: z.enum(['BODY'])
                }),
                z.object({
                    text: z.string().max(60),
                    type: z.enum(['FOOTER'])
                }),
                z.object({
                    buttons: z.array(z.object({
                        example: z.array(z.string()).optional(),
                        text: z.string(),
                        type: z.string(),
                        url: z.string().optional()
                    })).max(10),
                    type: z.enum(['BUTTONS'])
                })
            ])),
            language: z.string().min(2).max(16),
            name: z.string().min(1).max(512),
            status: z.enum(['APPROVED'])
        }).nullable(),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        variableMappings: z.record(z.string(), z.union([
            z.object({
                field: z.enum(['name', 'phoneE164']),
                source: z.enum(['contact_field'])
            }),
            z.object({
                attributeKey: z.string().min(1).max(64),
                source: z.enum(['contact_attribute'])
            }),
            z.object({
                source: z.enum(['static']),
                value: z.string().max(1024)
            }),
            z.object({
                filename: z.string().max(256).optional(),
                kind: z.enum([
                    'image',
                    'video',
                    'document'
                ]),
                source: z.enum(['media']),
                url: z.url().max(2048)
            })
        ]))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCancelBookingResponseDto = z.object({
    cancelled: z.boolean()
});

export const zCapturedLeadsControllerHardDeleteLeadResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCapturedLeadsControllerListFieldDefinitionsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        fields: z.array(z.object({
            description: z.string().max(500).nullable(),
            id: z.string(),
            label: z.string().min(1).max(120),
            name: z.string().min(1).max(64).regex(/^[a-z][a-z0-9_]*$/),
            position: z.int().gte(0).lte(9007199254740991),
            type: z.enum([
                'NAME',
                'PHONE',
                'EMAIL',
                'STRING',
                'NUMBER',
                'DATE',
                'DATETIME',
                'TIME'
            ])
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCapturedLeadsControllerListLeadsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            channel: z.string(),
            contactId: z.string().nullable(),
            createdAt: z.string(),
            deletedAt: z.string().nullable(),
            fields: z.record(z.string(), z.union([
                z.string(),
                z.number()
            ]).nullable()),
            id: z.string(),
            source: z.enum(['AGENT', 'MANUAL']),
            updatedAt: z.string()
        })),
        total: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCapturedLeadsControllerRestoreLeadResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCapturedLeadsControllerSoftDeleteLeadResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCapturedLeadsControllerUpdateLeadBody = z.object({
    fields: z.record(z.string(), z.union([
        z.string(),
        z.number()
    ]).nullable())
});

export const zCapturedLeadsControllerUpdateLeadResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        lead: z.object({
            channel: z.string(),
            contactId: z.string().nullable(),
            createdAt: z.string(),
            deletedAt: z.string().nullable(),
            fields: z.record(z.string(), z.union([
                z.string(),
                z.number()
            ]).nullable()),
            id: z.string(),
            source: z.enum(['AGENT', 'MANUAL']),
            updatedAt: z.string()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCapturedLeadsControllerUpsertFieldDefinitionsBody = z.object({
    fields: z.array(z.object({
        description: z.string().max(500).optional(),
        label: z.string().min(1).max(120),
        name: z.string().min(1).max(64).regex(/^[a-z][a-z0-9_]*$/),
        position: z.int().gte(0).lte(9007199254740991).optional(),
        type: z.enum([
            'NAME',
            'PHONE',
            'EMAIL',
            'STRING',
            'NUMBER',
            'DATE',
            'DATETIME',
            'TIME'
        ])
    })).max(15)
});

export const zCapturedLeadsControllerUpsertFieldDefinitionsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        fields: z.array(z.object({
            description: z.string().max(500).nullable(),
            id: z.string(),
            label: z.string().min(1).max(120),
            name: z.string().min(1).max(64).regex(/^[a-z][a-z0-9_]*$/),
            position: z.int().gte(0).lte(9007199254740991),
            type: z.enum([
                'NAME',
                'PHONE',
                'EMAIL',
                'STRING',
                'NUMBER',
                'DATE',
                'DATETIME',
                'TIME'
            ])
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zChartsControllerDeletePageResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.record(z.string(), z.unknown()).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zChartsControllerGetPageResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        index: z.string(),
        name: z.string(),
        pageId: z.string(),
        records: z.record(z.string(), z.object({
            id: z.string(),
            typeName: z.string()
        })),
        snapshot: z.record(z.string(), z.unknown()).nullable(),
        version: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zChartsControllerOpenResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        document: z.object({
            schema: z.unknown().optional(),
            store: z.record(z.string(), z.object({
                id: z.string(),
                typeName: z.string()
            }))
        }),
        documentVersion: z.int().gte(-9007199254740991).lte(9007199254740991),
        latestPage: z.object({
            index: z.string(),
            name: z.string(),
            pageId: z.string(),
            records: z.record(z.string(), z.object({
                id: z.string(),
                typeName: z.string()
            })),
            snapshot: z.record(z.string(), z.unknown()).nullable(),
            version: z.int().gte(-9007199254740991).lte(9007199254740991)
        }).nullable(),
        session: z.object({
            session: z.unknown(),
            view: z.object({
                editorCamera: z.unknown().optional(),
                editorCamerasByPage: z.unknown().optional(),
                editorPageId: z.unknown().optional(),
                editorStyles: z.unknown().optional(),
                viewerCamera: z.unknown().optional(),
                viewerCamerasByPage: z.unknown().optional(),
                viewerPageId: z.unknown().optional()
            })
        }).nullable(),
        visits: z.array(z.object({
            contactId: z.string(),
            index: z.string(),
            name: z.string(),
            pageId: z.string(),
            updatedAt: z.string()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zChartsControllerPatchBody = z.object({
    document: z.object({
        schema: z.unknown().optional(),
        store: z.record(z.string(), z.object({
            id: z.string(),
            typeName: z.string()
        }))
    }).optional(),
    session: z.object({
        session: z.unknown(),
        view: z.object({
            editorCamera: z.unknown().optional(),
            editorCamerasByPage: z.unknown().optional(),
            editorPageId: z.unknown().optional(),
            editorStyles: z.unknown().optional(),
            viewerCamera: z.unknown().optional(),
            viewerCamerasByPage: z.unknown().optional(),
            viewerPageId: z.unknown().optional()
        })
    }).optional(),
    version: z.int().gte(0).lte(9007199254740991)
});

export const zChartsControllerPatchResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        version: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zChartsControllerReassignBody = z.object({
    toContactId: z.string().min(1)
});

export const zChartsControllerReassignResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        newPageId: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zChartsControllerSavePageBody = z.object({
    index: z.string(),
    name: z.string(),
    records: z.record(z.string(), z.object({
        id: z.string(),
        typeName: z.string()
    })).optional(),
    snapshot: z.record(z.string(), z.unknown()).optional(),
    version: z.int().gte(0).lte(9007199254740991)
});

export const zChartsControllerSavePageResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        version: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerActivateAiPresetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        activePresetId: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerClearCacheResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerCreateBody = z.object({
    agentMediaCapabilities: z.object({
        aiAssistant: z.object({
            audio: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            document: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            image: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            pdf: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            video: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            })
        }),
        systemAgent: z.object({
            audio: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            document: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            image: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            pdf: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            video: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            })
        })
    }).optional().default({ aiAssistant: {
            audio: {
                read: true,
                receive: true,
                send: true
            },
            document: {
                read: true,
                receive: true,
                send: true
            },
            image: {
                read: true,
                receive: true,
                send: true
            },
            pdf: {
                read: true,
                receive: true,
                send: true
            },
            video: {
                read: true,
                receive: true,
                send: true
            }
        }, systemAgent: {
            audio: {
                read: true,
                receive: true,
                send: true
            },
            document: {
                read: true,
                receive: true,
                send: true
            },
            image: {
                read: true,
                receive: true,
                send: true
            },
            pdf: {
                read: true,
                receive: true,
                send: true
            },
            video: {
                read: true,
                receive: true,
                send: true
            }
        } }),
    aiAssistantReceiveAudio: z.boolean().optional().default(true),
    aiAssistantReceiveImages: z.boolean().optional().default(true),
    aiAssistantSendAudio: z.boolean().optional().default(true),
    aiAssistantSendImages: z.boolean().optional().default(true),
    aiPromptPresets: z.array(z.object({
        content: z.string().min(1).max(20000),
        id: z.string().min(1).max(64),
        name: z.string().min(1).max(80)
    })).max(50).optional().default([]),
    availableCalendarLocales: z.array(z.enum(['gregorian', 'hijri'])),
    availableCalendarViews: z.array(z.enum([
        'timeGridWeek',
        'timeGridDay',
        'dayGridMonth',
        'listMonth',
        'multiMonthYear'
    ])),
    availableLanguages: z.array(z.string()),
    businessAddress: z.string().nullable(),
    businessFloorUnit: z.string().nullable(),
    businessGoogleMapsUrl: z.url().nullable(),
    businessLandmark: z.string().nullable(),
    businessLatitude: z.number().nullable(),
    businessLongitude: z.number().nullable(),
    businessName: z.string().nullable(),
    calendarColumns: z.array(z.object({
        databaseField: z.string(),
        dataType: z.enum([
            'text',
            'number',
            'datetime',
            'phone',
            'name',
            'dropdown',
            'boolean'
        ]),
        editorMode: z.enum([
            'input',
            'dropdown',
            'wheel',
            'checkbox'
        ]),
        id: z.string(),
        isEditable: z.boolean(),
        isRequired: z.boolean(),
        metadata: z.object({
            nameMinWords: z.int().gte(2).lte(3).nullish(),
            numericRange: z.object({
                max: z.number().nullish(),
                min: z.number().nullish(),
                step: z.number().nullish()
            }).nullish(),
            options: z.array(z.string()).nullish(),
            optionsMeta: z.array(z.object({
                i18nKey: z.string().nullish(),
                label: z.string().nullish(),
                value: z.string()
            })).nullish(),
            useWheel: z.boolean().nullish()
        }).nullish(),
        name: z.string(),
        title: z.string(),
        width: z.number()
    })),
    calendarDirection: z.enum([
        'ltr',
        'rtl',
        'auto'
    ]),
    calendarFirstDay: z.number().gte(0).lte(6),
    calendarMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish().default(null),
    customCalendarRanges: z.array(z.object({
        daySpecificHours: z.array(z.object({
            day: z.number().gte(0).lte(6),
            endTime: z.string(),
            slotDurationHours: z.number().nullable(),
            startTime: z.string()
        })),
        endDate: z.string(),
        endTime: z.string(),
        id: z.string(),
        name: z.string(),
        slotDurationHours: z.number().nullable(),
        startDate: z.string(),
        startTime: z.string(),
        workingDays: z.array(z.number().gte(0).lte(6))
    })),
    daySpecificHours: z.array(z.object({
        day: z.number().gte(0).lte(6),
        endTime: z.string(),
        startTime: z.string()
    })),
    daySpecificSlotDurations: z.array(z.object({
        dayOfWeek: z.number().gte(0).lte(6),
        durationMinutes: z.number().gt(0),
        id: z.string().nullish(),
        slotDurationHours: z.number().nullish()
    })),
    defaultCalendarView: z.string().nullable(),
    defaultCountryPrefix: z.string(),
    defaultWorkingHours: z.object({
        endTime: z.string(),
        startTime: z.string()
    }),
    documentsColumns: z.array(z.object({
        databaseField: z.string(),
        dataType: z.enum([
            'text',
            'number',
            'datetime',
            'phone',
            'name',
            'dropdown',
            'boolean'
        ]),
        editorMode: z.enum([
            'input',
            'dropdown',
            'wheel',
            'checkbox'
        ]),
        id: z.string(),
        isEditable: z.boolean(),
        isRequired: z.boolean(),
        metadata: z.object({
            nameMinWords: z.int().gte(2).lte(3).nullish(),
            numericRange: z.object({
                max: z.number().nullish(),
                min: z.number().nullish(),
                step: z.number().nullish()
            }).nullish(),
            options: z.array(z.string()).nullish(),
            optionsMeta: z.array(z.object({
                i18nKey: z.string().nullish(),
                label: z.string().nullish(),
                value: z.string()
            })).nullish(),
            useWheel: z.boolean().nullish()
        }).nullish(),
        name: z.string(),
        title: z.string(),
        width: z.number()
    })),
    documentSummaryModel: z.string().nullish().default(null),
    eventColors: z.object({
        defaultEventColor: z.string(),
        documentStrokeColor: z.string()
    }),
    eventTimeFormat: z.object({
        format: z.enum([
            '12h',
            '24h',
            'hidden'
        ]),
        showMeridiem: z.boolean(),
        showMinutes: z.boolean()
    }),
    eventTypes: z.array(z.object({
        afterBufferMinutes: z.int().gte(0).lte(9007199254740991),
        allowMultipleEventsPerDay: z.boolean(),
        allowMultipleFutureEvents: z.boolean(),
        approvalTtlHours: z.int().gte(1).lte(9007199254740991).nullable(),
        beforeBufferMinutes: z.int().gte(0).lte(9007199254740991),
        bookingHorizonAgentDays: z.int().gte(1).lte(9007199254740991).nullable(),
        bookingHorizonSecretaryDays: z.int().gte(1).lte(9007199254740991).nullable(),
        description: z.string().max(2000).nullable(),
        durationMinutes: z.int().gte(1).lte(1440),
        id: z.string().min(1),
        maxFutureEventsPerType: z.int().gte(1).lte(20).nullable(),
        maxPerSlotAgent: z.int().gte(1).lte(9007199254740991).nullable(),
        maxPerSlotSecretary: z.int().gte(1).lte(9007199254740991).nullable(),
        maxSpanDays: z.int().gte(1).lte(732).nullable(),
        minimumBookingNotice: z.int().gte(0).lte(9007199254740991),
        name: z.string().min(1),
        requiresApproval: z.boolean(),
        resourceMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish(),
        resourceName: z.string().min(1).max(60).nullable()
    })).min(1),
    llmContextLimit: z.number().nullable(),
    llmFallbackMaxOutputTokens: z.number().nullable(),
    llmFallbackReasoningEffort: z.enum([
        'off',
        'low',
        'medium',
        'high'
    ]),
    llmFallbackVerbosity: z.enum([
        'low',
        'medium',
        'high'
    ]),
    llmMaxOutputTokens: z.number(),
    llmModel: z.string().nullable(),
    llmModelFallback: z.string().nullable(),
    llmProvider: z.string(),
    llmReasoningEffort: z.enum([
        'off',
        'low',
        'medium',
        'high'
    ]),
    llmVerbosity: z.enum([
        'low',
        'medium',
        'high'
    ]),
    notificationPreferences: z.object({
        notifyOnCancellation: z.boolean(),
        remindersEnabled: z.boolean(),
        timezone: z.string()
    }),
    notificationRules: z.array(z.object({
        channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
        enabled: z.boolean(),
        eventTypeFilter: z.array(z.string()).optional(),
        id: z.string().min(1),
        language: z.string(),
        name: z.string().min(1).max(100),
        options: z.union([
            z.object({
                daysBefore: z.int().gte(1).lte(30),
                sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                type: z.enum(['UPCOMING_EVENT'])
            }),
            z.object({
                hoursBefore: z.number().gte(0.5).lte(24),
                type: z.enum(['SAME_DAY'])
            }),
            z.object({
                delayMinutes: z.int().gte(0).lte(60),
                type: z.enum(['EVENT_CONFIRMATION'])
            }),
            z.object({
                delayMinutes: z.int().gte(0).lte(60),
                type: z.enum(['CANCELLATION_NOTICE'])
            }),
            z.object({
                delayMinutes: z.int().gte(0).lte(60),
                type: z.enum(['EVENT_MODIFICATION'])
            }),
            z.object({
                daysAfter: z.int().gte(1).lte(90),
                sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                type: z.enum(['POST_EVENT_FOLLOWUP'])
            }),
            z.object({
                delayHours: z.number().gte(0.5).lte(168),
                type: z.enum(['NO_SHOW_FOLLOWUP'])
            }),
            z.object({
                inactiveDays: z.int().gte(7).lte(365).optional(),
                sendAtTime: z.string().regex(/^\d{2}:\d{2}$/).optional(),
                type: z.enum(['RE_ENGAGEMENT'])
            }),
            z.object({
                type: z.enum(['CUSTOM'])
            })
        ]),
        scheduledAt: z.string().optional(),
        targetPhones: z.array(z.string()).optional(),
        templateName: z.string(),
        variableMapping: z.record(z.string(), z.string())
    })).default([]),
    ragAgentMode: z.enum([
        '1',
        '4',
        '5'
    ]).optional().default('1'),
    ragSettings: z.object({
        autoRefresh: z.object({
            enabled: z.boolean(),
            intervalHours: z.union([
                z.literal(24),
                z.literal(168)
            ])
        }).optional().default({ enabled: false, intervalHours: 168 }),
        embeddingModel: z.string().optional(),
        embeddingStrategy: z.enum([
            'standard',
            'contextual',
            'late'
        ]).optional(),
        imagePolicy: z.enum([
            'describe',
            'attach',
            'ocr',
            'ignore'
        ]).optional(),
        rerankingMode: z.enum([
            'off',
            'on',
            'automatic'
        ]).optional(),
        savedQueriesEnabled: z.boolean().optional(),
        savedQueriesOnly: z.boolean().optional(),
        searchThreshold: z.number().gte(0).lte(1),
        webSources: z.array(z.object({
            crawlDepth: z.number().gte(1).lte(100),
            enabled: z.boolean(),
            schedule: z.string().optional(),
            url: z.url()
        })).optional()
    }),
    ragToolsEnabled: z.boolean().optional().default(true),
    reminderTemplateConfig: z.array(z.object({
        channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
        language: z.string(),
        messageBody: z.string().optional(),
        name: z.string().min(1).max(50).regex(/^[\w-]+$/),
        sendTime: z.string().regex(/^\d{2}:\d{2}$/),
        templateName: z.string(),
        variableMapping: z.record(z.string(), z.string())
    })),
    requireNameForEvents: z.boolean().optional().default(true),
    requirePhoneForEvents: z.boolean().optional().default(true),
    researcherModel: z.string().nullish().default(null),
    schedulingToolsEnabled: z.boolean().optional().default(true),
    sensitiveDataGuard: z.object({
        maskCards: z.boolean(),
        maskIbans: z.boolean(),
        maskNationalIds: z.boolean(),
        nationalIdCountry: z.enum(['SA', 'EG']).nullable()
    }).optional().default({
        maskCards: true,
        maskIbans: true,
        maskNationalIds: false,
        nationalIdCountry: null
    }),
    slotDurationHours: z.number().gt(0),
    streamReasoning: z.boolean(),
    systemAgentEnabled: z.boolean().optional().default(true),
    systemAgentPrompt: z.string(),
    systemAgentReceiveAudio: z.boolean().optional().default(true),
    systemAgentReceiveImages: z.boolean().optional().default(true),
    systemAgentSendAudio: z.boolean().optional().default(true),
    systemAgentSendImages: z.boolean().optional().default(true),
    systemPrompt: z.string(),
    timezone: z.string(),
    tools: z.array(z.object({
        category: z.enum([
            'shared',
            'assistant',
            'system-agent'
        ]),
        enabled: z.boolean(),
        language: z.string().min(2).max(10).optional(),
        name: z.enum([
            'getCurrentDatetime',
            'searchDocs',
            'getDocumentSchemas',
            'queryStructuredData',
            'scheduleEvent',
            'joinWaitlist',
            'modifyEvent',
            'cancelEvent',
            'getUserData',
            'getAvailableTimeSlots',
            'searchAvailableAppointments',
            'sendBusinessLocation',
            'sendInteractiveButtons',
            'sendInteractiveList',
            'requestPhoneNumber',
            'handoffToHuman',
            'saveFeedback',
            'collectLead',
            'scheduleEvents',
            'modifyEvents',
            'modifyEventRange',
            'cancelEvents',
            'cancelEventRange',
            'getEventSnapshots',
            'getAvailableSlotsBatch',
            'summarizeConversation',
            'getAnalytics',
            'getUsageBreakdown',
            'getKnowledgeGaps',
            'renderChart',
            'manageKnowledgeSource',
            'ingestUploadedFile',
            'triggerRetraining',
            'getAgentSettings',
            'getContactSnapshot',
            'manageContact',
            'manageBeneficiary',
            'queryConversations',
            'searchConversations',
            'getConversationMetrics',
            'manageAutomation',
            'startIntegrationConnection',
            'getChannelStatus',
            'generateInsightsReport'
        ]),
        requiresApproval: z.boolean()
    })),
    verifierMaxLoops: z.int().gte(1).lte(3).optional().default(2),
    verifierModel: z.string().nullish().default('google/gemini-3.1-flash-lite'),
    waitlistEnabled: z.boolean().optional().default(false),
    waitlistOfferBatchSize: z.int().gte(1).lte(10).optional().default(3),
    waitlistOfferTtlMinutes: z.int().gte(5).lte(1440).optional().default(15),
    workingDays: z.array(z.number().gte(0).lte(6))
});

export const zConfigControllerCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ignoredKeys: z.array(z.string()).optional(),
        success: z.literal(true),
        value: z.object({
            activePresetId: z.string().nullish(),
            activePresetName: z.string().nullish(),
            agentMediaCapabilities: z.object({
                aiAssistant: z.object({
                    audio: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    document: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    image: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    pdf: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    video: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    })
                }),
                systemAgent: z.object({
                    audio: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    document: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    image: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    pdf: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    video: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    })
                })
            }).optional().default({ aiAssistant: {
                    audio: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    document: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    image: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    pdf: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    video: {
                        read: true,
                        receive: true,
                        send: true
                    }
                }, systemAgent: {
                    audio: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    document: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    image: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    pdf: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    video: {
                        read: true,
                        receive: true,
                        send: true
                    }
                } }),
            aiAssistantReceiveAudio: z.boolean().optional().default(true),
            aiAssistantReceiveImages: z.boolean().optional().default(true),
            aiAssistantSendAudio: z.boolean().optional().default(true),
            aiAssistantSendImages: z.boolean().optional().default(true),
            aiPromptPresets: z.array(z.object({
                content: z.string().min(1).max(20000),
                id: z.string().min(1).max(64),
                name: z.string().min(1).max(80)
            })).max(50).optional().default([]),
            availableCalendarLocales: z.array(z.enum(['gregorian', 'hijri'])),
            availableCalendarViews: z.array(z.enum([
                'timeGridWeek',
                'timeGridDay',
                'dayGridMonth',
                'listMonth',
                'multiMonthYear'
            ])),
            availableLanguages: z.array(z.string()),
            businessAddress: z.string().nullable(),
            businessFloorUnit: z.string().nullable(),
            businessGoogleMapsUrl: z.url().nullable(),
            businessLandmark: z.string().nullable(),
            businessLatitude: z.number().nullable(),
            businessLongitude: z.number().nullable(),
            businessName: z.string().nullable(),
            calendarColumns: z.array(z.object({
                databaseField: z.string(),
                dataType: z.enum([
                    'text',
                    'number',
                    'datetime',
                    'phone',
                    'name',
                    'dropdown',
                    'boolean'
                ]),
                editorMode: z.enum([
                    'input',
                    'dropdown',
                    'wheel',
                    'checkbox'
                ]),
                id: z.string(),
                isEditable: z.boolean(),
                isRequired: z.boolean(),
                metadata: z.object({
                    nameMinWords: z.int().gte(2).lte(3).nullish(),
                    numericRange: z.object({
                        max: z.number().nullish(),
                        min: z.number().nullish(),
                        step: z.number().nullish()
                    }).nullish(),
                    options: z.array(z.string()).nullish(),
                    optionsMeta: z.array(z.object({
                        i18nKey: z.string().nullish(),
                        label: z.string().nullish(),
                        value: z.string()
                    })).nullish(),
                    useWheel: z.boolean().nullish()
                }).nullish(),
                name: z.string(),
                title: z.string(),
                width: z.number()
            })),
            calendarDirection: z.enum([
                'ltr',
                'rtl',
                'auto'
            ]),
            calendarFirstDay: z.number().gte(0).lte(6),
            calendarMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish().default(null),
            createdAt: z.string().nullish(),
            customCalendarRanges: z.array(z.object({
                daySpecificHours: z.array(z.object({
                    day: z.number().gte(0).lte(6),
                    endTime: z.string(),
                    slotDurationHours: z.number().nullable(),
                    startTime: z.string()
                })),
                endDate: z.string(),
                endTime: z.string(),
                id: z.string(),
                name: z.string(),
                slotDurationHours: z.number().nullable(),
                startDate: z.string(),
                startTime: z.string(),
                workingDays: z.array(z.number().gte(0).lte(6))
            })),
            daySpecificHours: z.array(z.object({
                day: z.number().gte(0).lte(6),
                endTime: z.string(),
                startTime: z.string()
            })),
            daySpecificSlotDurations: z.array(z.object({
                dayOfWeek: z.number().gte(0).lte(6),
                durationMinutes: z.number().gt(0),
                id: z.string().nullish(),
                slotDurationHours: z.number().nullish()
            })),
            defaultCalendarView: z.string().nullable(),
            defaultCountryPrefix: z.string(),
            defaultWorkingHours: z.object({
                endTime: z.string(),
                startTime: z.string()
            }),
            documentsColumns: z.array(z.object({
                databaseField: z.string(),
                dataType: z.enum([
                    'text',
                    'number',
                    'datetime',
                    'phone',
                    'name',
                    'dropdown',
                    'boolean'
                ]),
                editorMode: z.enum([
                    'input',
                    'dropdown',
                    'wheel',
                    'checkbox'
                ]),
                id: z.string(),
                isEditable: z.boolean(),
                isRequired: z.boolean(),
                metadata: z.object({
                    nameMinWords: z.int().gte(2).lte(3).nullish(),
                    numericRange: z.object({
                        max: z.number().nullish(),
                        min: z.number().nullish(),
                        step: z.number().nullish()
                    }).nullish(),
                    options: z.array(z.string()).nullish(),
                    optionsMeta: z.array(z.object({
                        i18nKey: z.string().nullish(),
                        label: z.string().nullish(),
                        value: z.string()
                    })).nullish(),
                    useWheel: z.boolean().nullish()
                }).nullish(),
                name: z.string(),
                title: z.string(),
                width: z.number()
            })),
            documentSummaryModel: z.string().nullish().default(null),
            eventColors: z.object({
                defaultEventColor: z.string(),
                documentStrokeColor: z.string()
            }),
            eventTimeFormat: z.object({
                format: z.enum([
                    '12h',
                    '24h',
                    'hidden'
                ]),
                showMeridiem: z.boolean(),
                showMinutes: z.boolean()
            }),
            eventTypes: z.array(z.object({
                afterBufferMinutes: z.int().gte(0).lte(9007199254740991),
                allowMultipleEventsPerDay: z.boolean(),
                allowMultipleFutureEvents: z.boolean(),
                approvalTtlHours: z.int().gte(1).lte(9007199254740991).nullable(),
                beforeBufferMinutes: z.int().gte(0).lte(9007199254740991),
                bookingHorizonAgentDays: z.int().gte(1).lte(9007199254740991).nullable(),
                bookingHorizonSecretaryDays: z.int().gte(1).lte(9007199254740991).nullable(),
                description: z.string().max(2000).nullable(),
                durationMinutes: z.int().gte(1).lte(1440),
                id: z.string().min(1),
                maxFutureEventsPerType: z.int().gte(1).lte(20).nullable(),
                maxPerSlotAgent: z.int().gte(1).lte(9007199254740991).nullable(),
                maxPerSlotSecretary: z.int().gte(1).lte(9007199254740991).nullable(),
                maxSpanDays: z.int().gte(1).lte(732).nullable(),
                minimumBookingNotice: z.int().gte(0).lte(9007199254740991),
                name: z.string().min(1),
                requiresApproval: z.boolean(),
                resourceMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish(),
                resourceName: z.string().min(1).max(60).nullable()
            })).min(1),
            id: z.union([
                z.number(),
                z.string()
            ]).nullish(),
            llmContextLimit: z.number().nullable(),
            llmFallbackMaxOutputTokens: z.number().nullable(),
            llmFallbackReasoningEffort: z.enum([
                'off',
                'low',
                'medium',
                'high'
            ]),
            llmFallbackVerbosity: z.enum([
                'low',
                'medium',
                'high'
            ]),
            llmMaxOutputTokens: z.number(),
            llmModel: z.string().nullable(),
            llmModelFallback: z.string().nullable(),
            llmProvider: z.string(),
            llmReasoningEffort: z.enum([
                'off',
                'low',
                'medium',
                'high'
            ]),
            llmVerbosity: z.enum([
                'low',
                'medium',
                'high'
            ]),
            notificationPreferences: z.object({
                notifyOnCancellation: z.boolean(),
                remindersEnabled: z.boolean(),
                timezone: z.string()
            }),
            notificationRules: z.array(z.object({
                channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
                enabled: z.boolean(),
                eventTypeFilter: z.array(z.string()).optional(),
                id: z.string().min(1),
                language: z.string(),
                name: z.string().min(1).max(100),
                options: z.union([
                    z.object({
                        daysBefore: z.int().gte(1).lte(30),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                        type: z.enum(['UPCOMING_EVENT'])
                    }),
                    z.object({
                        hoursBefore: z.number().gte(0.5).lte(24),
                        type: z.enum(['SAME_DAY'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['EVENT_CONFIRMATION'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['CANCELLATION_NOTICE'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['EVENT_MODIFICATION'])
                    }),
                    z.object({
                        daysAfter: z.int().gte(1).lte(90),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                        type: z.enum(['POST_EVENT_FOLLOWUP'])
                    }),
                    z.object({
                        delayHours: z.number().gte(0.5).lte(168),
                        type: z.enum(['NO_SHOW_FOLLOWUP'])
                    }),
                    z.object({
                        inactiveDays: z.int().gte(7).lte(365).optional(),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/).optional(),
                        type: z.enum(['RE_ENGAGEMENT'])
                    }),
                    z.object({
                        type: z.enum(['CUSTOM'])
                    })
                ]),
                scheduledAt: z.string().optional(),
                targetPhones: z.array(z.string()).optional(),
                templateName: z.string(),
                variableMapping: z.record(z.string(), z.string())
            })).default([]),
            ragAgentMode: z.enum([
                '1',
                '4',
                '5'
            ]).optional().default('1'),
            ragSettings: z.object({
                autoRefresh: z.object({
                    enabled: z.boolean(),
                    intervalHours: z.union([
                        z.literal(24),
                        z.literal(168)
                    ])
                }).optional().default({ enabled: false, intervalHours: 168 }),
                embeddingModel: z.string().optional(),
                embeddingStrategy: z.enum([
                    'standard',
                    'contextual',
                    'late'
                ]).optional(),
                imagePolicy: z.enum([
                    'describe',
                    'attach',
                    'ocr',
                    'ignore'
                ]).optional(),
                rerankingMode: z.enum([
                    'off',
                    'on',
                    'automatic'
                ]).optional(),
                savedQueriesEnabled: z.boolean().optional(),
                savedQueriesOnly: z.boolean().optional(),
                searchThreshold: z.number().gte(0).lte(1),
                webSources: z.array(z.object({
                    crawlDepth: z.number().gte(1).lte(100),
                    enabled: z.boolean(),
                    schedule: z.string().optional(),
                    url: z.url()
                })).optional()
            }),
            ragToolsEnabled: z.boolean().optional().default(true),
            reminderTemplateConfig: z.array(z.object({
                channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
                language: z.string(),
                messageBody: z.string().optional(),
                name: z.string().min(1).max(50).regex(/^[\w-]+$/),
                sendTime: z.string().regex(/^\d{2}:\d{2}$/),
                templateName: z.string(),
                variableMapping: z.record(z.string(), z.string())
            })),
            requireNameForEvents: z.boolean().optional().default(true),
            requirePhoneForEvents: z.boolean().optional().default(true),
            researcherModel: z.string().nullish().default(null),
            researcherPrompt: z.string().nullish(),
            schedulingToolsEnabled: z.boolean().optional().default(true),
            sensitiveDataGuard: z.object({
                maskCards: z.boolean(),
                maskIbans: z.boolean(),
                maskNationalIds: z.boolean(),
                nationalIdCountry: z.enum(['SA', 'EG']).nullable()
            }).optional().default({
                maskCards: true,
                maskIbans: true,
                maskNationalIds: false,
                nationalIdCountry: null
            }),
            slotDurationHours: z.number().gt(0),
            streamReasoning: z.boolean(),
            systemAgentEnabled: z.boolean().optional().default(true),
            systemAgentPrompt: z.string(),
            systemAgentReceiveAudio: z.boolean().optional().default(true),
            systemAgentReceiveImages: z.boolean().optional().default(true),
            systemAgentSendAudio: z.boolean().optional().default(true),
            systemAgentSendImages: z.boolean().optional().default(true),
            systemPrompt: z.string(),
            timezone: z.string(),
            tools: z.array(z.object({
                category: z.enum([
                    'shared',
                    'assistant',
                    'system-agent'
                ]),
                enabled: z.boolean(),
                language: z.string().min(2).max(10).optional(),
                name: z.enum([
                    'getCurrentDatetime',
                    'searchDocs',
                    'getDocumentSchemas',
                    'queryStructuredData',
                    'scheduleEvent',
                    'joinWaitlist',
                    'modifyEvent',
                    'cancelEvent',
                    'getUserData',
                    'getAvailableTimeSlots',
                    'searchAvailableAppointments',
                    'sendBusinessLocation',
                    'sendInteractiveButtons',
                    'sendInteractiveList',
                    'requestPhoneNumber',
                    'handoffToHuman',
                    'saveFeedback',
                    'collectLead',
                    'scheduleEvents',
                    'modifyEvents',
                    'modifyEventRange',
                    'cancelEvents',
                    'cancelEventRange',
                    'getEventSnapshots',
                    'getAvailableSlotsBatch',
                    'summarizeConversation',
                    'getAnalytics',
                    'getUsageBreakdown',
                    'getKnowledgeGaps',
                    'renderChart',
                    'manageKnowledgeSource',
                    'ingestUploadedFile',
                    'triggerRetraining',
                    'getAgentSettings',
                    'getContactSnapshot',
                    'manageContact',
                    'manageBeneficiary',
                    'queryConversations',
                    'searchConversations',
                    'getConversationMetrics',
                    'manageAutomation',
                    'startIntegrationConnection',
                    'getChannelStatus',
                    'generateInsightsReport'
                ]),
                requiresApproval: z.boolean()
            })),
            updatedAt: z.string().nullish(),
            verifierMaxLoops: z.int().gte(1).lte(3).optional().default(2),
            verifierModel: z.string().nullish().default('google/gemini-3.1-flash-lite'),
            verifierPrompt: z.string().nullish(),
            version: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
            waitlistEnabled: z.boolean().optional().default(false),
            waitlistOfferBatchSize: z.int().gte(1).lte(10).optional().default(3),
            waitlistOfferTtlMinutes: z.int().gte(5).lte(1440).optional().default(15),
            workingDays: z.array(z.number().gte(0).lte(6))
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerCreateAiPresetBody = z.object({
    description: z.string().max(300).optional(),
    name: z.string().min(1).max(60),
    source: z.union([
        z.enum(['blank']),
        z.enum(['current']),
        z.object({
            duplicateOf: z.string().min(1)
        })
    ]),
    template: z.enum([
        'support',
        'sales',
        'booking'
    ]).optional()
});

export const zConfigControllerCreateAiPresetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        description: z.string().max(300).nullable(),
        id: z.string(),
        isActive: z.boolean(),
        llmModel: z.string().nullable(),
        name: z.string().min(1).max(60),
        position: z.int().gte(0).lte(9007199254740991),
        ragAgentMode: z.enum([
            '1',
            '4',
            '5'
        ]).optional().default('1'),
        ragDocScope: z.enum(['ALL', 'SELECTED']),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerDeleteAiPresetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerGetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ignoredKeys: z.array(z.string()).optional(),
        success: z.literal(true),
        value: z.object({
            activePresetId: z.string().nullish(),
            activePresetName: z.string().nullish(),
            agentMediaCapabilities: z.object({
                aiAssistant: z.object({
                    audio: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    document: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    image: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    pdf: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    video: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    })
                }),
                systemAgent: z.object({
                    audio: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    document: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    image: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    pdf: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    video: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    })
                })
            }).optional().default({ aiAssistant: {
                    audio: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    document: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    image: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    pdf: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    video: {
                        read: true,
                        receive: true,
                        send: true
                    }
                }, systemAgent: {
                    audio: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    document: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    image: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    pdf: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    video: {
                        read: true,
                        receive: true,
                        send: true
                    }
                } }),
            aiAssistantReceiveAudio: z.boolean().optional().default(true),
            aiAssistantReceiveImages: z.boolean().optional().default(true),
            aiAssistantSendAudio: z.boolean().optional().default(true),
            aiAssistantSendImages: z.boolean().optional().default(true),
            aiPromptPresets: z.array(z.object({
                content: z.string().min(1).max(20000),
                id: z.string().min(1).max(64),
                name: z.string().min(1).max(80)
            })).max(50).optional().default([]),
            availableCalendarLocales: z.array(z.enum(['gregorian', 'hijri'])),
            availableCalendarViews: z.array(z.enum([
                'timeGridWeek',
                'timeGridDay',
                'dayGridMonth',
                'listMonth',
                'multiMonthYear'
            ])),
            availableLanguages: z.array(z.string()),
            businessAddress: z.string().nullable(),
            businessFloorUnit: z.string().nullable(),
            businessGoogleMapsUrl: z.url().nullable(),
            businessLandmark: z.string().nullable(),
            businessLatitude: z.number().nullable(),
            businessLongitude: z.number().nullable(),
            businessName: z.string().nullable(),
            calendarColumns: z.array(z.object({
                databaseField: z.string(),
                dataType: z.enum([
                    'text',
                    'number',
                    'datetime',
                    'phone',
                    'name',
                    'dropdown',
                    'boolean'
                ]),
                editorMode: z.enum([
                    'input',
                    'dropdown',
                    'wheel',
                    'checkbox'
                ]),
                id: z.string(),
                isEditable: z.boolean(),
                isRequired: z.boolean(),
                metadata: z.object({
                    nameMinWords: z.int().gte(2).lte(3).nullish(),
                    numericRange: z.object({
                        max: z.number().nullish(),
                        min: z.number().nullish(),
                        step: z.number().nullish()
                    }).nullish(),
                    options: z.array(z.string()).nullish(),
                    optionsMeta: z.array(z.object({
                        i18nKey: z.string().nullish(),
                        label: z.string().nullish(),
                        value: z.string()
                    })).nullish(),
                    useWheel: z.boolean().nullish()
                }).nullish(),
                name: z.string(),
                title: z.string(),
                width: z.number()
            })),
            calendarDirection: z.enum([
                'ltr',
                'rtl',
                'auto'
            ]),
            calendarFirstDay: z.number().gte(0).lte(6),
            calendarMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish().default(null),
            createdAt: z.string().nullish(),
            customCalendarRanges: z.array(z.object({
                daySpecificHours: z.array(z.object({
                    day: z.number().gte(0).lte(6),
                    endTime: z.string(),
                    slotDurationHours: z.number().nullable(),
                    startTime: z.string()
                })),
                endDate: z.string(),
                endTime: z.string(),
                id: z.string(),
                name: z.string(),
                slotDurationHours: z.number().nullable(),
                startDate: z.string(),
                startTime: z.string(),
                workingDays: z.array(z.number().gte(0).lte(6))
            })),
            daySpecificHours: z.array(z.object({
                day: z.number().gte(0).lte(6),
                endTime: z.string(),
                startTime: z.string()
            })),
            daySpecificSlotDurations: z.array(z.object({
                dayOfWeek: z.number().gte(0).lte(6),
                durationMinutes: z.number().gt(0),
                id: z.string().nullish(),
                slotDurationHours: z.number().nullish()
            })),
            defaultCalendarView: z.string().nullable(),
            defaultCountryPrefix: z.string(),
            defaultWorkingHours: z.object({
                endTime: z.string(),
                startTime: z.string()
            }),
            documentsColumns: z.array(z.object({
                databaseField: z.string(),
                dataType: z.enum([
                    'text',
                    'number',
                    'datetime',
                    'phone',
                    'name',
                    'dropdown',
                    'boolean'
                ]),
                editorMode: z.enum([
                    'input',
                    'dropdown',
                    'wheel',
                    'checkbox'
                ]),
                id: z.string(),
                isEditable: z.boolean(),
                isRequired: z.boolean(),
                metadata: z.object({
                    nameMinWords: z.int().gte(2).lte(3).nullish(),
                    numericRange: z.object({
                        max: z.number().nullish(),
                        min: z.number().nullish(),
                        step: z.number().nullish()
                    }).nullish(),
                    options: z.array(z.string()).nullish(),
                    optionsMeta: z.array(z.object({
                        i18nKey: z.string().nullish(),
                        label: z.string().nullish(),
                        value: z.string()
                    })).nullish(),
                    useWheel: z.boolean().nullish()
                }).nullish(),
                name: z.string(),
                title: z.string(),
                width: z.number()
            })),
            documentSummaryModel: z.string().nullish().default(null),
            eventColors: z.object({
                defaultEventColor: z.string(),
                documentStrokeColor: z.string()
            }),
            eventTimeFormat: z.object({
                format: z.enum([
                    '12h',
                    '24h',
                    'hidden'
                ]),
                showMeridiem: z.boolean(),
                showMinutes: z.boolean()
            }),
            eventTypes: z.array(z.object({
                afterBufferMinutes: z.int().gte(0).lte(9007199254740991),
                allowMultipleEventsPerDay: z.boolean(),
                allowMultipleFutureEvents: z.boolean(),
                approvalTtlHours: z.int().gte(1).lte(9007199254740991).nullable(),
                beforeBufferMinutes: z.int().gte(0).lte(9007199254740991),
                bookingHorizonAgentDays: z.int().gte(1).lte(9007199254740991).nullable(),
                bookingHorizonSecretaryDays: z.int().gte(1).lte(9007199254740991).nullable(),
                description: z.string().max(2000).nullable(),
                durationMinutes: z.int().gte(1).lte(1440),
                id: z.string().min(1),
                maxFutureEventsPerType: z.int().gte(1).lte(20).nullable(),
                maxPerSlotAgent: z.int().gte(1).lte(9007199254740991).nullable(),
                maxPerSlotSecretary: z.int().gte(1).lte(9007199254740991).nullable(),
                maxSpanDays: z.int().gte(1).lte(732).nullable(),
                minimumBookingNotice: z.int().gte(0).lte(9007199254740991),
                name: z.string().min(1),
                requiresApproval: z.boolean(),
                resourceMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish(),
                resourceName: z.string().min(1).max(60).nullable()
            })).min(1),
            id: z.union([
                z.number(),
                z.string()
            ]).nullish(),
            llmContextLimit: z.number().nullable(),
            llmFallbackMaxOutputTokens: z.number().nullable(),
            llmFallbackReasoningEffort: z.enum([
                'off',
                'low',
                'medium',
                'high'
            ]),
            llmFallbackVerbosity: z.enum([
                'low',
                'medium',
                'high'
            ]),
            llmMaxOutputTokens: z.number(),
            llmModel: z.string().nullable(),
            llmModelFallback: z.string().nullable(),
            llmProvider: z.string(),
            llmReasoningEffort: z.enum([
                'off',
                'low',
                'medium',
                'high'
            ]),
            llmVerbosity: z.enum([
                'low',
                'medium',
                'high'
            ]),
            notificationPreferences: z.object({
                notifyOnCancellation: z.boolean(),
                remindersEnabled: z.boolean(),
                timezone: z.string()
            }),
            notificationRules: z.array(z.object({
                channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
                enabled: z.boolean(),
                eventTypeFilter: z.array(z.string()).optional(),
                id: z.string().min(1),
                language: z.string(),
                name: z.string().min(1).max(100),
                options: z.union([
                    z.object({
                        daysBefore: z.int().gte(1).lte(30),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                        type: z.enum(['UPCOMING_EVENT'])
                    }),
                    z.object({
                        hoursBefore: z.number().gte(0.5).lte(24),
                        type: z.enum(['SAME_DAY'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['EVENT_CONFIRMATION'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['CANCELLATION_NOTICE'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['EVENT_MODIFICATION'])
                    }),
                    z.object({
                        daysAfter: z.int().gte(1).lte(90),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                        type: z.enum(['POST_EVENT_FOLLOWUP'])
                    }),
                    z.object({
                        delayHours: z.number().gte(0.5).lte(168),
                        type: z.enum(['NO_SHOW_FOLLOWUP'])
                    }),
                    z.object({
                        inactiveDays: z.int().gte(7).lte(365).optional(),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/).optional(),
                        type: z.enum(['RE_ENGAGEMENT'])
                    }),
                    z.object({
                        type: z.enum(['CUSTOM'])
                    })
                ]),
                scheduledAt: z.string().optional(),
                targetPhones: z.array(z.string()).optional(),
                templateName: z.string(),
                variableMapping: z.record(z.string(), z.string())
            })).default([]),
            ragAgentMode: z.enum([
                '1',
                '4',
                '5'
            ]).optional().default('1'),
            ragSettings: z.object({
                autoRefresh: z.object({
                    enabled: z.boolean(),
                    intervalHours: z.union([
                        z.literal(24),
                        z.literal(168)
                    ])
                }).optional().default({ enabled: false, intervalHours: 168 }),
                embeddingModel: z.string().optional(),
                embeddingStrategy: z.enum([
                    'standard',
                    'contextual',
                    'late'
                ]).optional(),
                imagePolicy: z.enum([
                    'describe',
                    'attach',
                    'ocr',
                    'ignore'
                ]).optional(),
                rerankingMode: z.enum([
                    'off',
                    'on',
                    'automatic'
                ]).optional(),
                savedQueriesEnabled: z.boolean().optional(),
                savedQueriesOnly: z.boolean().optional(),
                searchThreshold: z.number().gte(0).lte(1),
                webSources: z.array(z.object({
                    crawlDepth: z.number().gte(1).lte(100),
                    enabled: z.boolean(),
                    schedule: z.string().optional(),
                    url: z.url()
                })).optional()
            }),
            ragToolsEnabled: z.boolean().optional().default(true),
            reminderTemplateConfig: z.array(z.object({
                channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
                language: z.string(),
                messageBody: z.string().optional(),
                name: z.string().min(1).max(50).regex(/^[\w-]+$/),
                sendTime: z.string().regex(/^\d{2}:\d{2}$/),
                templateName: z.string(),
                variableMapping: z.record(z.string(), z.string())
            })),
            requireNameForEvents: z.boolean().optional().default(true),
            requirePhoneForEvents: z.boolean().optional().default(true),
            researcherModel: z.string().nullish().default(null),
            researcherPrompt: z.string().nullish(),
            schedulingToolsEnabled: z.boolean().optional().default(true),
            sensitiveDataGuard: z.object({
                maskCards: z.boolean(),
                maskIbans: z.boolean(),
                maskNationalIds: z.boolean(),
                nationalIdCountry: z.enum(['SA', 'EG']).nullable()
            }).optional().default({
                maskCards: true,
                maskIbans: true,
                maskNationalIds: false,
                nationalIdCountry: null
            }),
            slotDurationHours: z.number().gt(0),
            streamReasoning: z.boolean(),
            systemAgentEnabled: z.boolean().optional().default(true),
            systemAgentPrompt: z.string(),
            systemAgentReceiveAudio: z.boolean().optional().default(true),
            systemAgentReceiveImages: z.boolean().optional().default(true),
            systemAgentSendAudio: z.boolean().optional().default(true),
            systemAgentSendImages: z.boolean().optional().default(true),
            systemPrompt: z.string(),
            timezone: z.string(),
            tools: z.array(z.object({
                category: z.enum([
                    'shared',
                    'assistant',
                    'system-agent'
                ]),
                enabled: z.boolean(),
                language: z.string().min(2).max(10).optional(),
                name: z.enum([
                    'getCurrentDatetime',
                    'searchDocs',
                    'getDocumentSchemas',
                    'queryStructuredData',
                    'scheduleEvent',
                    'joinWaitlist',
                    'modifyEvent',
                    'cancelEvent',
                    'getUserData',
                    'getAvailableTimeSlots',
                    'searchAvailableAppointments',
                    'sendBusinessLocation',
                    'sendInteractiveButtons',
                    'sendInteractiveList',
                    'requestPhoneNumber',
                    'handoffToHuman',
                    'saveFeedback',
                    'collectLead',
                    'scheduleEvents',
                    'modifyEvents',
                    'modifyEventRange',
                    'cancelEvents',
                    'cancelEventRange',
                    'getEventSnapshots',
                    'getAvailableSlotsBatch',
                    'summarizeConversation',
                    'getAnalytics',
                    'getUsageBreakdown',
                    'getKnowledgeGaps',
                    'renderChart',
                    'manageKnowledgeSource',
                    'ingestUploadedFile',
                    'triggerRetraining',
                    'getAgentSettings',
                    'getContactSnapshot',
                    'manageContact',
                    'manageBeneficiary',
                    'queryConversations',
                    'searchConversations',
                    'getConversationMetrics',
                    'manageAutomation',
                    'startIntegrationConnection',
                    'getChannelStatus',
                    'generateInsightsReport'
                ]),
                requiresApproval: z.boolean()
            })),
            updatedAt: z.string().nullish(),
            verifierMaxLoops: z.int().gte(1).lte(3).optional().default(2),
            verifierModel: z.string().nullish().default('google/gemini-3.1-flash-lite'),
            verifierPrompt: z.string().nullish(),
            version: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
            waitlistEnabled: z.boolean().optional().default(false),
            waitlistOfferBatchSize: z.int().gte(1).lte(10).optional().default(3),
            waitlistOfferTtlMinutes: z.int().gte(5).lte(1440).optional().default(15),
            workingDays: z.array(z.number().gte(0).lte(6))
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerGetAiPresetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        aiAssistantReceiveAudio: z.boolean().optional().default(true),
        aiAssistantReceiveImages: z.boolean().optional().default(true),
        aiAssistantSendAudio: z.boolean().optional().default(true),
        aiAssistantSendImages: z.boolean().optional().default(true),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        description: z.string().max(300).nullable(),
        id: z.string(),
        isActive: z.boolean(),
        llmContextLimit: z.number().nullable(),
        llmFallbackMaxOutputTokens: z.number().nullable(),
        llmFallbackReasoningEffort: z.enum([
            'off',
            'low',
            'medium',
            'high'
        ]),
        llmFallbackVerbosity: z.enum([
            'low',
            'medium',
            'high'
        ]),
        llmMaxOutputTokens: z.number(),
        llmModel: z.string().nullable(),
        llmModelFallback: z.string().nullable(),
        llmProvider: z.string(),
        llmReasoningEffort: z.enum([
            'off',
            'low',
            'medium',
            'high'
        ]),
        llmVerbosity: z.enum([
            'low',
            'medium',
            'high'
        ]),
        name: z.string().min(1).max(60),
        position: z.int().gte(0).lte(9007199254740991),
        ragAgentMode: z.enum([
            '1',
            '4',
            '5'
        ]).optional().default('1'),
        ragDocScope: z.enum(['ALL', 'SELECTED']),
        ragDocumentIds: z.array(z.string()),
        ragSettings: z.object({
            embeddingModel: z.string().optional(),
            embeddingStrategy: z.enum([
                'standard',
                'contextual',
                'late'
            ]).optional(),
            rerankingMode: z.enum([
                'off',
                'on',
                'automatic'
            ]).optional(),
            searchThreshold: z.number().gte(0).lte(1)
        }),
        researcherModel: z.string().nullish().default(null),
        streamReasoning: z.boolean(),
        systemPrompt: z.string(),
        tools: z.array(z.object({
            category: z.enum([
                'shared',
                'assistant',
                'system-agent'
            ]),
            enabled: z.boolean(),
            language: z.string().min(2).max(10).optional(),
            name: z.enum([
                'getCurrentDatetime',
                'searchDocs',
                'getDocumentSchemas',
                'queryStructuredData',
                'scheduleEvent',
                'joinWaitlist',
                'modifyEvent',
                'cancelEvent',
                'getUserData',
                'getAvailableTimeSlots',
                'searchAvailableAppointments',
                'sendBusinessLocation',
                'sendInteractiveButtons',
                'sendInteractiveList',
                'requestPhoneNumber',
                'handoffToHuman',
                'saveFeedback',
                'collectLead',
                'scheduleEvents',
                'modifyEvents',
                'modifyEventRange',
                'cancelEvents',
                'cancelEventRange',
                'getEventSnapshots',
                'getAvailableSlotsBatch',
                'summarizeConversation',
                'getAnalytics',
                'getUsageBreakdown',
                'getKnowledgeGaps',
                'renderChart',
                'manageKnowledgeSource',
                'ingestUploadedFile',
                'triggerRetraining',
                'getAgentSettings',
                'getContactSnapshot',
                'manageContact',
                'manageBeneficiary',
                'queryConversations',
                'searchConversations',
                'getConversationMetrics',
                'manageAutomation',
                'startIntegrationConnection',
                'getChannelStatus',
                'generateInsightsReport'
            ]),
            requiresApproval: z.boolean()
        })),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        verifierMaxLoops: z.int().gte(1).lte(3).optional().default(2),
        verifierModel: z.string().nullish().default('google/gemini-3.1-flash-lite')
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerListAiPresetChannelBindingsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        activePresetId: z.string(),
        bindings: z.array(z.object({
            channel: z.enum([
                'whatsapp',
                'telegram',
                'instagram',
                'x'
            ]),
            presetId: z.string().min(1)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerListAiPresetsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        activePresetId: z.string(),
        limit: z.int().gte(0).lte(9007199254740991).nullable(),
        presets: z.array(z.object({
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            description: z.string().max(300).nullable(),
            id: z.string(),
            isActive: z.boolean(),
            llmModel: z.string().nullable(),
            name: z.string().min(1).max(60),
            position: z.int().gte(0).lte(9007199254740991),
            ragAgentMode: z.enum([
                '1',
                '4',
                '5'
            ]).optional().default('1'),
            ragDocScope: z.enum(['ALL', 'SELECTED']),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        })),
        used: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerListPromptVersionsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        versions: z.array(z.object({
            content: z.string(),
            createdAt: z.string(),
            createdById: z.string().nullable(),
            id: z.string(),
            kind: z.enum([
                'SYSTEM',
                'SYSTEM_AGENT',
                'RESEARCHER',
                'VERIFIER'
            ]),
            version: z.int().gte(1).lte(9007199254740991)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerResolveMapLocationBody = z.object({
    url: z.string().min(1).max(2048)
});

export const zConfigControllerResolveMapLocationResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        latitude: z.number().gte(-90).lte(90),
        longitude: z.number().gte(-180).lte(180),
        source: z.enum(['url', 'shortlink'])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerRevertPromptVersionBody = z.object({
    kind: z.enum([
        'SYSTEM',
        'SYSTEM_AGENT',
        'RESEARCHER',
        'VERIFIER'
    ]),
    presetId: z.string().min(1).optional(),
    version: z.int().gte(1).lte(9007199254740991)
});

export const zConfigControllerRevertPromptVersionResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ignoredKeys: z.array(z.string()).optional(),
        success: z.literal(true),
        value: z.object({
            activePresetId: z.string().nullish(),
            activePresetName: z.string().nullish(),
            agentMediaCapabilities: z.object({
                aiAssistant: z.object({
                    audio: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    document: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    image: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    pdf: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    video: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    })
                }),
                systemAgent: z.object({
                    audio: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    document: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    image: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    pdf: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    video: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    })
                })
            }).optional().default({ aiAssistant: {
                    audio: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    document: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    image: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    pdf: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    video: {
                        read: true,
                        receive: true,
                        send: true
                    }
                }, systemAgent: {
                    audio: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    document: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    image: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    pdf: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    video: {
                        read: true,
                        receive: true,
                        send: true
                    }
                } }),
            aiAssistantReceiveAudio: z.boolean().optional().default(true),
            aiAssistantReceiveImages: z.boolean().optional().default(true),
            aiAssistantSendAudio: z.boolean().optional().default(true),
            aiAssistantSendImages: z.boolean().optional().default(true),
            aiPromptPresets: z.array(z.object({
                content: z.string().min(1).max(20000),
                id: z.string().min(1).max(64),
                name: z.string().min(1).max(80)
            })).max(50).optional().default([]),
            availableCalendarLocales: z.array(z.enum(['gregorian', 'hijri'])),
            availableCalendarViews: z.array(z.enum([
                'timeGridWeek',
                'timeGridDay',
                'dayGridMonth',
                'listMonth',
                'multiMonthYear'
            ])),
            availableLanguages: z.array(z.string()),
            businessAddress: z.string().nullable(),
            businessFloorUnit: z.string().nullable(),
            businessGoogleMapsUrl: z.url().nullable(),
            businessLandmark: z.string().nullable(),
            businessLatitude: z.number().nullable(),
            businessLongitude: z.number().nullable(),
            businessName: z.string().nullable(),
            calendarColumns: z.array(z.object({
                databaseField: z.string(),
                dataType: z.enum([
                    'text',
                    'number',
                    'datetime',
                    'phone',
                    'name',
                    'dropdown',
                    'boolean'
                ]),
                editorMode: z.enum([
                    'input',
                    'dropdown',
                    'wheel',
                    'checkbox'
                ]),
                id: z.string(),
                isEditable: z.boolean(),
                isRequired: z.boolean(),
                metadata: z.object({
                    nameMinWords: z.int().gte(2).lte(3).nullish(),
                    numericRange: z.object({
                        max: z.number().nullish(),
                        min: z.number().nullish(),
                        step: z.number().nullish()
                    }).nullish(),
                    options: z.array(z.string()).nullish(),
                    optionsMeta: z.array(z.object({
                        i18nKey: z.string().nullish(),
                        label: z.string().nullish(),
                        value: z.string()
                    })).nullish(),
                    useWheel: z.boolean().nullish()
                }).nullish(),
                name: z.string(),
                title: z.string(),
                width: z.number()
            })),
            calendarDirection: z.enum([
                'ltr',
                'rtl',
                'auto'
            ]),
            calendarFirstDay: z.number().gte(0).lte(6),
            calendarMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish().default(null),
            createdAt: z.string().nullish(),
            customCalendarRanges: z.array(z.object({
                daySpecificHours: z.array(z.object({
                    day: z.number().gte(0).lte(6),
                    endTime: z.string(),
                    slotDurationHours: z.number().nullable(),
                    startTime: z.string()
                })),
                endDate: z.string(),
                endTime: z.string(),
                id: z.string(),
                name: z.string(),
                slotDurationHours: z.number().nullable(),
                startDate: z.string(),
                startTime: z.string(),
                workingDays: z.array(z.number().gte(0).lte(6))
            })),
            daySpecificHours: z.array(z.object({
                day: z.number().gte(0).lte(6),
                endTime: z.string(),
                startTime: z.string()
            })),
            daySpecificSlotDurations: z.array(z.object({
                dayOfWeek: z.number().gte(0).lte(6),
                durationMinutes: z.number().gt(0),
                id: z.string().nullish(),
                slotDurationHours: z.number().nullish()
            })),
            defaultCalendarView: z.string().nullable(),
            defaultCountryPrefix: z.string(),
            defaultWorkingHours: z.object({
                endTime: z.string(),
                startTime: z.string()
            }),
            documentsColumns: z.array(z.object({
                databaseField: z.string(),
                dataType: z.enum([
                    'text',
                    'number',
                    'datetime',
                    'phone',
                    'name',
                    'dropdown',
                    'boolean'
                ]),
                editorMode: z.enum([
                    'input',
                    'dropdown',
                    'wheel',
                    'checkbox'
                ]),
                id: z.string(),
                isEditable: z.boolean(),
                isRequired: z.boolean(),
                metadata: z.object({
                    nameMinWords: z.int().gte(2).lte(3).nullish(),
                    numericRange: z.object({
                        max: z.number().nullish(),
                        min: z.number().nullish(),
                        step: z.number().nullish()
                    }).nullish(),
                    options: z.array(z.string()).nullish(),
                    optionsMeta: z.array(z.object({
                        i18nKey: z.string().nullish(),
                        label: z.string().nullish(),
                        value: z.string()
                    })).nullish(),
                    useWheel: z.boolean().nullish()
                }).nullish(),
                name: z.string(),
                title: z.string(),
                width: z.number()
            })),
            documentSummaryModel: z.string().nullish().default(null),
            eventColors: z.object({
                defaultEventColor: z.string(),
                documentStrokeColor: z.string()
            }),
            eventTimeFormat: z.object({
                format: z.enum([
                    '12h',
                    '24h',
                    'hidden'
                ]),
                showMeridiem: z.boolean(),
                showMinutes: z.boolean()
            }),
            eventTypes: z.array(z.object({
                afterBufferMinutes: z.int().gte(0).lte(9007199254740991),
                allowMultipleEventsPerDay: z.boolean(),
                allowMultipleFutureEvents: z.boolean(),
                approvalTtlHours: z.int().gte(1).lte(9007199254740991).nullable(),
                beforeBufferMinutes: z.int().gte(0).lte(9007199254740991),
                bookingHorizonAgentDays: z.int().gte(1).lte(9007199254740991).nullable(),
                bookingHorizonSecretaryDays: z.int().gte(1).lte(9007199254740991).nullable(),
                description: z.string().max(2000).nullable(),
                durationMinutes: z.int().gte(1).lte(1440),
                id: z.string().min(1),
                maxFutureEventsPerType: z.int().gte(1).lte(20).nullable(),
                maxPerSlotAgent: z.int().gte(1).lte(9007199254740991).nullable(),
                maxPerSlotSecretary: z.int().gte(1).lte(9007199254740991).nullable(),
                maxSpanDays: z.int().gte(1).lte(732).nullable(),
                minimumBookingNotice: z.int().gte(0).lte(9007199254740991),
                name: z.string().min(1),
                requiresApproval: z.boolean(),
                resourceMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish(),
                resourceName: z.string().min(1).max(60).nullable()
            })).min(1),
            id: z.union([
                z.number(),
                z.string()
            ]).nullish(),
            llmContextLimit: z.number().nullable(),
            llmFallbackMaxOutputTokens: z.number().nullable(),
            llmFallbackReasoningEffort: z.enum([
                'off',
                'low',
                'medium',
                'high'
            ]),
            llmFallbackVerbosity: z.enum([
                'low',
                'medium',
                'high'
            ]),
            llmMaxOutputTokens: z.number(),
            llmModel: z.string().nullable(),
            llmModelFallback: z.string().nullable(),
            llmProvider: z.string(),
            llmReasoningEffort: z.enum([
                'off',
                'low',
                'medium',
                'high'
            ]),
            llmVerbosity: z.enum([
                'low',
                'medium',
                'high'
            ]),
            notificationPreferences: z.object({
                notifyOnCancellation: z.boolean(),
                remindersEnabled: z.boolean(),
                timezone: z.string()
            }),
            notificationRules: z.array(z.object({
                channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
                enabled: z.boolean(),
                eventTypeFilter: z.array(z.string()).optional(),
                id: z.string().min(1),
                language: z.string(),
                name: z.string().min(1).max(100),
                options: z.union([
                    z.object({
                        daysBefore: z.int().gte(1).lte(30),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                        type: z.enum(['UPCOMING_EVENT'])
                    }),
                    z.object({
                        hoursBefore: z.number().gte(0.5).lte(24),
                        type: z.enum(['SAME_DAY'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['EVENT_CONFIRMATION'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['CANCELLATION_NOTICE'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['EVENT_MODIFICATION'])
                    }),
                    z.object({
                        daysAfter: z.int().gte(1).lte(90),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                        type: z.enum(['POST_EVENT_FOLLOWUP'])
                    }),
                    z.object({
                        delayHours: z.number().gte(0.5).lte(168),
                        type: z.enum(['NO_SHOW_FOLLOWUP'])
                    }),
                    z.object({
                        inactiveDays: z.int().gte(7).lte(365).optional(),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/).optional(),
                        type: z.enum(['RE_ENGAGEMENT'])
                    }),
                    z.object({
                        type: z.enum(['CUSTOM'])
                    })
                ]),
                scheduledAt: z.string().optional(),
                targetPhones: z.array(z.string()).optional(),
                templateName: z.string(),
                variableMapping: z.record(z.string(), z.string())
            })).default([]),
            ragAgentMode: z.enum([
                '1',
                '4',
                '5'
            ]).optional().default('1'),
            ragSettings: z.object({
                autoRefresh: z.object({
                    enabled: z.boolean(),
                    intervalHours: z.union([
                        z.literal(24),
                        z.literal(168)
                    ])
                }).optional().default({ enabled: false, intervalHours: 168 }),
                embeddingModel: z.string().optional(),
                embeddingStrategy: z.enum([
                    'standard',
                    'contextual',
                    'late'
                ]).optional(),
                imagePolicy: z.enum([
                    'describe',
                    'attach',
                    'ocr',
                    'ignore'
                ]).optional(),
                rerankingMode: z.enum([
                    'off',
                    'on',
                    'automatic'
                ]).optional(),
                savedQueriesEnabled: z.boolean().optional(),
                savedQueriesOnly: z.boolean().optional(),
                searchThreshold: z.number().gte(0).lte(1),
                webSources: z.array(z.object({
                    crawlDepth: z.number().gte(1).lte(100),
                    enabled: z.boolean(),
                    schedule: z.string().optional(),
                    url: z.url()
                })).optional()
            }),
            ragToolsEnabled: z.boolean().optional().default(true),
            reminderTemplateConfig: z.array(z.object({
                channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
                language: z.string(),
                messageBody: z.string().optional(),
                name: z.string().min(1).max(50).regex(/^[\w-]+$/),
                sendTime: z.string().regex(/^\d{2}:\d{2}$/),
                templateName: z.string(),
                variableMapping: z.record(z.string(), z.string())
            })),
            requireNameForEvents: z.boolean().optional().default(true),
            requirePhoneForEvents: z.boolean().optional().default(true),
            researcherModel: z.string().nullish().default(null),
            researcherPrompt: z.string().nullish(),
            schedulingToolsEnabled: z.boolean().optional().default(true),
            sensitiveDataGuard: z.object({
                maskCards: z.boolean(),
                maskIbans: z.boolean(),
                maskNationalIds: z.boolean(),
                nationalIdCountry: z.enum(['SA', 'EG']).nullable()
            }).optional().default({
                maskCards: true,
                maskIbans: true,
                maskNationalIds: false,
                nationalIdCountry: null
            }),
            slotDurationHours: z.number().gt(0),
            streamReasoning: z.boolean(),
            systemAgentEnabled: z.boolean().optional().default(true),
            systemAgentPrompt: z.string(),
            systemAgentReceiveAudio: z.boolean().optional().default(true),
            systemAgentReceiveImages: z.boolean().optional().default(true),
            systemAgentSendAudio: z.boolean().optional().default(true),
            systemAgentSendImages: z.boolean().optional().default(true),
            systemPrompt: z.string(),
            timezone: z.string(),
            tools: z.array(z.object({
                category: z.enum([
                    'shared',
                    'assistant',
                    'system-agent'
                ]),
                enabled: z.boolean(),
                language: z.string().min(2).max(10).optional(),
                name: z.enum([
                    'getCurrentDatetime',
                    'searchDocs',
                    'getDocumentSchemas',
                    'queryStructuredData',
                    'scheduleEvent',
                    'joinWaitlist',
                    'modifyEvent',
                    'cancelEvent',
                    'getUserData',
                    'getAvailableTimeSlots',
                    'searchAvailableAppointments',
                    'sendBusinessLocation',
                    'sendInteractiveButtons',
                    'sendInteractiveList',
                    'requestPhoneNumber',
                    'handoffToHuman',
                    'saveFeedback',
                    'collectLead',
                    'scheduleEvents',
                    'modifyEvents',
                    'modifyEventRange',
                    'cancelEvents',
                    'cancelEventRange',
                    'getEventSnapshots',
                    'getAvailableSlotsBatch',
                    'summarizeConversation',
                    'getAnalytics',
                    'getUsageBreakdown',
                    'getKnowledgeGaps',
                    'renderChart',
                    'manageKnowledgeSource',
                    'ingestUploadedFile',
                    'triggerRetraining',
                    'getAgentSettings',
                    'getContactSnapshot',
                    'manageContact',
                    'manageBeneficiary',
                    'queryConversations',
                    'searchConversations',
                    'getConversationMetrics',
                    'manageAutomation',
                    'startIntegrationConnection',
                    'getChannelStatus',
                    'generateInsightsReport'
                ]),
                requiresApproval: z.boolean()
            })),
            updatedAt: z.string().nullish(),
            verifierMaxLoops: z.int().gte(1).lte(3).optional().default(2),
            verifierModel: z.string().nullish().default('google/gemini-3.1-flash-lite'),
            verifierPrompt: z.string().nullish(),
            version: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
            waitlistEnabled: z.boolean().optional().default(false),
            waitlistOfferBatchSize: z.int().gte(1).lte(10).optional().default(3),
            waitlistOfferTtlMinutes: z.int().gte(5).lte(1440).optional().default(15),
            workingDays: z.array(z.number().gte(0).lte(6))
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerSetAiPresetChannelBindingBody = z.object({
    channel: z.enum([
        'whatsapp',
        'telegram',
        'instagram',
        'x'
    ]),
    presetId: z.string().min(1).nullable()
});

export const zConfigControllerSetAiPresetChannelBindingResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        activePresetId: z.string(),
        bindings: z.array(z.object({
            channel: z.enum([
                'whatsapp',
                'telegram',
                'instagram',
                'x'
            ]),
            presetId: z.string().min(1)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerUpdateBody = z.object({
    agentMediaCapabilities: z.object({
        aiAssistant: z.object({
            audio: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            document: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            image: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            pdf: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            video: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            })
        }),
        systemAgent: z.object({
            audio: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            document: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            image: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            pdf: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            }),
            video: z.object({
                read: z.boolean(),
                receive: z.boolean(),
                send: z.boolean()
            })
        })
    }).optional().default({ aiAssistant: {
            audio: {
                read: true,
                receive: true,
                send: true
            },
            document: {
                read: true,
                receive: true,
                send: true
            },
            image: {
                read: true,
                receive: true,
                send: true
            },
            pdf: {
                read: true,
                receive: true,
                send: true
            },
            video: {
                read: true,
                receive: true,
                send: true
            }
        }, systemAgent: {
            audio: {
                read: true,
                receive: true,
                send: true
            },
            document: {
                read: true,
                receive: true,
                send: true
            },
            image: {
                read: true,
                receive: true,
                send: true
            },
            pdf: {
                read: true,
                receive: true,
                send: true
            },
            video: {
                read: true,
                receive: true,
                send: true
            }
        } }),
    aiAssistantReceiveAudio: z.boolean().optional().default(true),
    aiAssistantReceiveImages: z.boolean().optional().default(true),
    aiAssistantSendAudio: z.boolean().optional().default(true),
    aiAssistantSendImages: z.boolean().optional().default(true),
    aiPromptPresets: z.array(z.object({
        content: z.string().min(1).max(20000),
        id: z.string().min(1).max(64),
        name: z.string().min(1).max(80)
    })).max(50).optional().default([]),
    availableCalendarLocales: z.array(z.enum(['gregorian', 'hijri'])).optional(),
    availableCalendarViews: z.array(z.enum([
        'timeGridWeek',
        'timeGridDay',
        'dayGridMonth',
        'listMonth',
        'multiMonthYear'
    ])).optional(),
    availableLanguages: z.array(z.string()).optional(),
    businessAddress: z.string().nullish(),
    businessFloorUnit: z.string().nullish(),
    businessGoogleMapsUrl: z.string().min(1).nullish(),
    businessLandmark: z.string().nullish(),
    businessLatitude: z.number().nullish(),
    businessLongitude: z.number().nullish(),
    businessName: z.string().nullish(),
    calendarColumns: z.array(z.object({
        databaseField: z.string(),
        dataType: z.enum([
            'text',
            'number',
            'datetime',
            'phone',
            'name',
            'dropdown',
            'boolean'
        ]),
        editorMode: z.enum([
            'input',
            'dropdown',
            'wheel',
            'checkbox'
        ]),
        id: z.string(),
        isEditable: z.boolean(),
        isRequired: z.boolean(),
        metadata: z.object({
            nameMinWords: z.int().gte(2).lte(3).nullish(),
            numericRange: z.object({
                max: z.number().nullish(),
                min: z.number().nullish(),
                step: z.number().nullish()
            }).nullish(),
            options: z.array(z.string()).nullish(),
            optionsMeta: z.array(z.object({
                i18nKey: z.string().nullish(),
                label: z.string().nullish(),
                value: z.string()
            })).nullish(),
            useWheel: z.boolean().nullish()
        }).nullish(),
        name: z.string(),
        title: z.string(),
        width: z.number()
    })).optional(),
    calendarDirection: z.enum([
        'ltr',
        'rtl',
        'auto'
    ]).optional(),
    calendarFirstDay: z.number().gte(0).lte(6).optional(),
    calendarMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish().default(null),
    confirmedTypeRemovals: z.array(z.string().min(1).max(100)).max(50).optional(),
    customCalendarRanges: z.array(z.object({
        daySpecificHours: z.array(z.object({
            day: z.number().gte(0).lte(6),
            endTime: z.string(),
            slotDurationHours: z.number().nullable(),
            startTime: z.string()
        })),
        endDate: z.string(),
        endTime: z.string(),
        id: z.string(),
        name: z.string(),
        slotDurationHours: z.number().nullable(),
        startDate: z.string(),
        startTime: z.string(),
        workingDays: z.array(z.number().gte(0).lte(6))
    })).optional(),
    daySpecificHours: z.array(z.object({
        day: z.number().gte(0).lte(6),
        endTime: z.string(),
        startTime: z.string()
    })).optional(),
    daySpecificSlotDurations: z.array(z.object({
        dayOfWeek: z.number().gte(0).lte(6),
        durationMinutes: z.number().gt(0),
        id: z.string().nullish(),
        slotDurationHours: z.number().nullish()
    })).optional(),
    defaultCalendarView: z.string().nullish(),
    defaultCountryPrefix: z.string().optional(),
    defaultWorkingHours: z.object({
        endTime: z.string(),
        startTime: z.string()
    }).optional(),
    documentsColumns: z.array(z.object({
        databaseField: z.string(),
        dataType: z.enum([
            'text',
            'number',
            'datetime',
            'phone',
            'name',
            'dropdown',
            'boolean'
        ]),
        editorMode: z.enum([
            'input',
            'dropdown',
            'wheel',
            'checkbox'
        ]),
        id: z.string(),
        isEditable: z.boolean(),
        isRequired: z.boolean(),
        metadata: z.object({
            nameMinWords: z.int().gte(2).lte(3).nullish(),
            numericRange: z.object({
                max: z.number().nullish(),
                min: z.number().nullish(),
                step: z.number().nullish()
            }).nullish(),
            options: z.array(z.string()).nullish(),
            optionsMeta: z.array(z.object({
                i18nKey: z.string().nullish(),
                label: z.string().nullish(),
                value: z.string()
            })).nullish(),
            useWheel: z.boolean().nullish()
        }).nullish(),
        name: z.string(),
        title: z.string(),
        width: z.number()
    })).optional(),
    documentSummaryModel: z.string().nullish().default(null),
    eventColors: z.object({
        defaultEventColor: z.string(),
        documentStrokeColor: z.string()
    }).optional(),
    eventTimeFormat: z.object({
        format: z.enum([
            '12h',
            '24h',
            'hidden'
        ]),
        showMeridiem: z.boolean(),
        showMinutes: z.boolean()
    }).optional(),
    eventTypes: z.array(z.object({
        id: z.string().min(1),
        name: z.string().min(1),
        position: z.int().gte(0).lte(9007199254740991).optional()
    })).min(1).optional(),
    expectedVersion: z.int().gte(0).lte(9007199254740991).optional(),
    llmContextLimit: z.number().nullish(),
    llmFallbackMaxOutputTokens: z.number().nullish(),
    llmFallbackReasoningEffort: z.enum([
        'off',
        'low',
        'medium',
        'high'
    ]).optional(),
    llmFallbackVerbosity: z.enum([
        'low',
        'medium',
        'high'
    ]).optional(),
    llmMaxOutputTokens: z.number().optional(),
    llmModel: z.string().nullish(),
    llmModelFallback: z.string().nullish(),
    llmProvider: z.string().optional(),
    llmReasoningEffort: z.enum([
        'off',
        'low',
        'medium',
        'high'
    ]).optional(),
    llmVerbosity: z.enum([
        'low',
        'medium',
        'high'
    ]).optional(),
    notificationPreferences: z.object({
        notifyOnCancellation: z.boolean(),
        remindersEnabled: z.boolean(),
        timezone: z.string()
    }).optional(),
    notificationRules: z.array(z.object({
        channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
        enabled: z.boolean(),
        eventTypeFilter: z.array(z.string()).optional(),
        id: z.string().min(1),
        language: z.string(),
        name: z.string().min(1).max(100),
        options: z.union([
            z.object({
                daysBefore: z.int().gte(1).lte(30),
                sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                type: z.enum(['UPCOMING_EVENT'])
            }),
            z.object({
                hoursBefore: z.number().gte(0.5).lte(24),
                type: z.enum(['SAME_DAY'])
            }),
            z.object({
                delayMinutes: z.int().gte(0).lte(60),
                type: z.enum(['EVENT_CONFIRMATION'])
            }),
            z.object({
                delayMinutes: z.int().gte(0).lte(60),
                type: z.enum(['CANCELLATION_NOTICE'])
            }),
            z.object({
                delayMinutes: z.int().gte(0).lte(60),
                type: z.enum(['EVENT_MODIFICATION'])
            }),
            z.object({
                daysAfter: z.int().gte(1).lte(90),
                sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                type: z.enum(['POST_EVENT_FOLLOWUP'])
            }),
            z.object({
                delayHours: z.number().gte(0.5).lte(168),
                type: z.enum(['NO_SHOW_FOLLOWUP'])
            }),
            z.object({
                inactiveDays: z.int().gte(7).lte(365).optional(),
                sendAtTime: z.string().regex(/^\d{2}:\d{2}$/).optional(),
                type: z.enum(['RE_ENGAGEMENT'])
            }),
            z.object({
                type: z.enum(['CUSTOM'])
            })
        ]),
        scheduledAt: z.string().optional(),
        targetPhones: z.array(z.string()).optional(),
        templateName: z.string(),
        variableMapping: z.record(z.string(), z.string())
    })).optional().default([]),
    originClientId: z.string().min(1).max(200).optional(),
    ragAgentMode: z.enum([
        '1',
        '4',
        '5'
    ]).optional().default('1'),
    ragSettings: z.object({
        autoRefresh: z.object({
            enabled: z.boolean(),
            intervalHours: z.union([
                z.literal(24),
                z.literal(168)
            ])
        }).optional().default({ enabled: false, intervalHours: 168 }),
        embeddingModel: z.string().optional(),
        embeddingStrategy: z.enum([
            'standard',
            'contextual',
            'late'
        ]).optional(),
        imagePolicy: z.enum([
            'describe',
            'attach',
            'ocr',
            'ignore'
        ]).optional(),
        rerankingMode: z.enum([
            'off',
            'on',
            'automatic'
        ]).optional(),
        savedQueriesEnabled: z.boolean().optional(),
        savedQueriesOnly: z.boolean().optional(),
        searchThreshold: z.number().gte(0).lte(1),
        webSources: z.array(z.object({
            crawlDepth: z.number().gte(1).lte(100),
            enabled: z.boolean(),
            schedule: z.string().optional(),
            url: z.url()
        })).optional()
    }).optional(),
    ragToolsEnabled: z.boolean().optional().default(true),
    reembedConfirmed: z.boolean().optional(),
    reminderTemplateConfig: z.array(z.object({
        channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
        language: z.string(),
        messageBody: z.string().optional(),
        name: z.string().min(1).max(50).regex(/^[\w-]+$/),
        sendTime: z.string().regex(/^\d{2}:\d{2}$/),
        templateName: z.string(),
        variableMapping: z.record(z.string(), z.string())
    })).optional(),
    requireNameForEvents: z.boolean().optional().default(true),
    requirePhoneForEvents: z.boolean().optional().default(true),
    researcherModel: z.string().nullish().default(null),
    researcherPrompt: z.string().optional(),
    schedulingToolsEnabled: z.boolean().optional().default(true),
    sensitiveDataGuard: z.object({
        maskCards: z.boolean(),
        maskIbans: z.boolean(),
        maskNationalIds: z.boolean(),
        nationalIdCountry: z.enum(['SA', 'EG']).nullable()
    }).optional().default({
        maskCards: true,
        maskIbans: true,
        maskNationalIds: false,
        nationalIdCountry: null
    }),
    slotDurationHours: z.number().gt(0).optional(),
    streamReasoning: z.boolean().optional(),
    systemAgentEnabled: z.boolean().optional().default(true),
    systemAgentPrompt: z.string().optional(),
    systemAgentReceiveAudio: z.boolean().optional().default(true),
    systemAgentReceiveImages: z.boolean().optional().default(true),
    systemAgentSendAudio: z.boolean().optional().default(true),
    systemAgentSendImages: z.boolean().optional().default(true),
    systemPrompt: z.string().optional(),
    timezone: z.string().optional(),
    tools: z.array(z.object({
        category: z.enum([
            'shared',
            'assistant',
            'system-agent'
        ]),
        enabled: z.boolean(),
        language: z.string().min(2).max(10).optional(),
        name: z.enum([
            'getCurrentDatetime',
            'searchDocs',
            'getDocumentSchemas',
            'queryStructuredData',
            'scheduleEvent',
            'joinWaitlist',
            'modifyEvent',
            'cancelEvent',
            'getUserData',
            'getAvailableTimeSlots',
            'searchAvailableAppointments',
            'sendBusinessLocation',
            'sendInteractiveButtons',
            'sendInteractiveList',
            'requestPhoneNumber',
            'handoffToHuman',
            'saveFeedback',
            'collectLead',
            'scheduleEvents',
            'modifyEvents',
            'modifyEventRange',
            'cancelEvents',
            'cancelEventRange',
            'getEventSnapshots',
            'getAvailableSlotsBatch',
            'summarizeConversation',
            'getAnalytics',
            'getUsageBreakdown',
            'getKnowledgeGaps',
            'renderChart',
            'manageKnowledgeSource',
            'ingestUploadedFile',
            'triggerRetraining',
            'getAgentSettings',
            'getContactSnapshot',
            'manageContact',
            'manageBeneficiary',
            'queryConversations',
            'searchConversations',
            'getConversationMetrics',
            'manageAutomation',
            'startIntegrationConnection',
            'getChannelStatus',
            'generateInsightsReport'
        ]),
        requiresApproval: z.boolean()
    })).optional(),
    verifierMaxLoops: z.int().gte(1).lte(3).optional().default(2),
    verifierModel: z.string().nullish().default('google/gemini-3.1-flash-lite'),
    verifierPrompt: z.string().optional(),
    waitlistEnabled: z.boolean().optional().default(false),
    waitlistOfferBatchSize: z.int().gte(1).lte(10).optional().default(3),
    waitlistOfferTtlMinutes: z.int().gte(5).lte(1440).optional().default(15),
    workingDays: z.array(z.number().gte(0).lte(6)).optional()
});

export const zConfigControllerUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ignoredKeys: z.array(z.string()).optional(),
        success: z.literal(true),
        value: z.object({
            activePresetId: z.string().nullish(),
            activePresetName: z.string().nullish(),
            agentMediaCapabilities: z.object({
                aiAssistant: z.object({
                    audio: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    document: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    image: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    pdf: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    video: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    })
                }),
                systemAgent: z.object({
                    audio: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    document: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    image: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    pdf: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    }),
                    video: z.object({
                        read: z.boolean(),
                        receive: z.boolean(),
                        send: z.boolean()
                    })
                })
            }).optional().default({ aiAssistant: {
                    audio: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    document: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    image: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    pdf: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    video: {
                        read: true,
                        receive: true,
                        send: true
                    }
                }, systemAgent: {
                    audio: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    document: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    image: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    pdf: {
                        read: true,
                        receive: true,
                        send: true
                    },
                    video: {
                        read: true,
                        receive: true,
                        send: true
                    }
                } }),
            aiAssistantReceiveAudio: z.boolean().optional().default(true),
            aiAssistantReceiveImages: z.boolean().optional().default(true),
            aiAssistantSendAudio: z.boolean().optional().default(true),
            aiAssistantSendImages: z.boolean().optional().default(true),
            aiPromptPresets: z.array(z.object({
                content: z.string().min(1).max(20000),
                id: z.string().min(1).max(64),
                name: z.string().min(1).max(80)
            })).max(50).optional().default([]),
            availableCalendarLocales: z.array(z.enum(['gregorian', 'hijri'])),
            availableCalendarViews: z.array(z.enum([
                'timeGridWeek',
                'timeGridDay',
                'dayGridMonth',
                'listMonth',
                'multiMonthYear'
            ])),
            availableLanguages: z.array(z.string()),
            businessAddress: z.string().nullable(),
            businessFloorUnit: z.string().nullable(),
            businessGoogleMapsUrl: z.url().nullable(),
            businessLandmark: z.string().nullable(),
            businessLatitude: z.number().nullable(),
            businessLongitude: z.number().nullable(),
            businessName: z.string().nullable(),
            calendarColumns: z.array(z.object({
                databaseField: z.string(),
                dataType: z.enum([
                    'text',
                    'number',
                    'datetime',
                    'phone',
                    'name',
                    'dropdown',
                    'boolean'
                ]),
                editorMode: z.enum([
                    'input',
                    'dropdown',
                    'wheel',
                    'checkbox'
                ]),
                id: z.string(),
                isEditable: z.boolean(),
                isRequired: z.boolean(),
                metadata: z.object({
                    nameMinWords: z.int().gte(2).lte(3).nullish(),
                    numericRange: z.object({
                        max: z.number().nullish(),
                        min: z.number().nullish(),
                        step: z.number().nullish()
                    }).nullish(),
                    options: z.array(z.string()).nullish(),
                    optionsMeta: z.array(z.object({
                        i18nKey: z.string().nullish(),
                        label: z.string().nullish(),
                        value: z.string()
                    })).nullish(),
                    useWheel: z.boolean().nullish()
                }).nullish(),
                name: z.string(),
                title: z.string(),
                width: z.number()
            })),
            calendarDirection: z.enum([
                'ltr',
                'rtl',
                'auto'
            ]),
            calendarFirstDay: z.number().gte(0).lte(6),
            calendarMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish().default(null),
            createdAt: z.string().nullish(),
            customCalendarRanges: z.array(z.object({
                daySpecificHours: z.array(z.object({
                    day: z.number().gte(0).lte(6),
                    endTime: z.string(),
                    slotDurationHours: z.number().nullable(),
                    startTime: z.string()
                })),
                endDate: z.string(),
                endTime: z.string(),
                id: z.string(),
                name: z.string(),
                slotDurationHours: z.number().nullable(),
                startDate: z.string(),
                startTime: z.string(),
                workingDays: z.array(z.number().gte(0).lte(6))
            })),
            daySpecificHours: z.array(z.object({
                day: z.number().gte(0).lte(6),
                endTime: z.string(),
                startTime: z.string()
            })),
            daySpecificSlotDurations: z.array(z.object({
                dayOfWeek: z.number().gte(0).lte(6),
                durationMinutes: z.number().gt(0),
                id: z.string().nullish(),
                slotDurationHours: z.number().nullish()
            })),
            defaultCalendarView: z.string().nullable(),
            defaultCountryPrefix: z.string(),
            defaultWorkingHours: z.object({
                endTime: z.string(),
                startTime: z.string()
            }),
            documentsColumns: z.array(z.object({
                databaseField: z.string(),
                dataType: z.enum([
                    'text',
                    'number',
                    'datetime',
                    'phone',
                    'name',
                    'dropdown',
                    'boolean'
                ]),
                editorMode: z.enum([
                    'input',
                    'dropdown',
                    'wheel',
                    'checkbox'
                ]),
                id: z.string(),
                isEditable: z.boolean(),
                isRequired: z.boolean(),
                metadata: z.object({
                    nameMinWords: z.int().gte(2).lte(3).nullish(),
                    numericRange: z.object({
                        max: z.number().nullish(),
                        min: z.number().nullish(),
                        step: z.number().nullish()
                    }).nullish(),
                    options: z.array(z.string()).nullish(),
                    optionsMeta: z.array(z.object({
                        i18nKey: z.string().nullish(),
                        label: z.string().nullish(),
                        value: z.string()
                    })).nullish(),
                    useWheel: z.boolean().nullish()
                }).nullish(),
                name: z.string(),
                title: z.string(),
                width: z.number()
            })),
            documentSummaryModel: z.string().nullish().default(null),
            eventColors: z.object({
                defaultEventColor: z.string(),
                documentStrokeColor: z.string()
            }),
            eventTimeFormat: z.object({
                format: z.enum([
                    '12h',
                    '24h',
                    'hidden'
                ]),
                showMeridiem: z.boolean(),
                showMinutes: z.boolean()
            }),
            eventTypes: z.array(z.object({
                afterBufferMinutes: z.int().gte(0).lte(9007199254740991),
                allowMultipleEventsPerDay: z.boolean(),
                allowMultipleFutureEvents: z.boolean(),
                approvalTtlHours: z.int().gte(1).lte(9007199254740991).nullable(),
                beforeBufferMinutes: z.int().gte(0).lte(9007199254740991),
                bookingHorizonAgentDays: z.int().gte(1).lte(9007199254740991).nullable(),
                bookingHorizonSecretaryDays: z.int().gte(1).lte(9007199254740991).nullable(),
                description: z.string().max(2000).nullable(),
                durationMinutes: z.int().gte(1).lte(1440),
                id: z.string().min(1),
                maxFutureEventsPerType: z.int().gte(1).lte(20).nullable(),
                maxPerSlotAgent: z.int().gte(1).lte(9007199254740991).nullable(),
                maxPerSlotSecretary: z.int().gte(1).lte(9007199254740991).nullable(),
                maxSpanDays: z.int().gte(1).lte(732).nullable(),
                minimumBookingNotice: z.int().gte(0).lte(9007199254740991),
                name: z.string().min(1),
                requiresApproval: z.boolean(),
                resourceMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish(),
                resourceName: z.string().min(1).max(60).nullable()
            })).min(1),
            id: z.union([
                z.number(),
                z.string()
            ]).nullish(),
            llmContextLimit: z.number().nullable(),
            llmFallbackMaxOutputTokens: z.number().nullable(),
            llmFallbackReasoningEffort: z.enum([
                'off',
                'low',
                'medium',
                'high'
            ]),
            llmFallbackVerbosity: z.enum([
                'low',
                'medium',
                'high'
            ]),
            llmMaxOutputTokens: z.number(),
            llmModel: z.string().nullable(),
            llmModelFallback: z.string().nullable(),
            llmProvider: z.string(),
            llmReasoningEffort: z.enum([
                'off',
                'low',
                'medium',
                'high'
            ]),
            llmVerbosity: z.enum([
                'low',
                'medium',
                'high'
            ]),
            notificationPreferences: z.object({
                notifyOnCancellation: z.boolean(),
                remindersEnabled: z.boolean(),
                timezone: z.string()
            }),
            notificationRules: z.array(z.object({
                channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
                enabled: z.boolean(),
                eventTypeFilter: z.array(z.string()).optional(),
                id: z.string().min(1),
                language: z.string(),
                name: z.string().min(1).max(100),
                options: z.union([
                    z.object({
                        daysBefore: z.int().gte(1).lte(30),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                        type: z.enum(['UPCOMING_EVENT'])
                    }),
                    z.object({
                        hoursBefore: z.number().gte(0.5).lte(24),
                        type: z.enum(['SAME_DAY'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['EVENT_CONFIRMATION'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['CANCELLATION_NOTICE'])
                    }),
                    z.object({
                        delayMinutes: z.int().gte(0).lte(60),
                        type: z.enum(['EVENT_MODIFICATION'])
                    }),
                    z.object({
                        daysAfter: z.int().gte(1).lte(90),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/),
                        type: z.enum(['POST_EVENT_FOLLOWUP'])
                    }),
                    z.object({
                        delayHours: z.number().gte(0.5).lte(168),
                        type: z.enum(['NO_SHOW_FOLLOWUP'])
                    }),
                    z.object({
                        inactiveDays: z.int().gte(7).lte(365).optional(),
                        sendAtTime: z.string().regex(/^\d{2}:\d{2}$/).optional(),
                        type: z.enum(['RE_ENGAGEMENT'])
                    }),
                    z.object({
                        type: z.enum(['CUSTOM'])
                    })
                ]),
                scheduledAt: z.string().optional(),
                targetPhones: z.array(z.string()).optional(),
                templateName: z.string(),
                variableMapping: z.record(z.string(), z.string())
            })).default([]),
            ragAgentMode: z.enum([
                '1',
                '4',
                '5'
            ]).optional().default('1'),
            ragSettings: z.object({
                autoRefresh: z.object({
                    enabled: z.boolean(),
                    intervalHours: z.union([
                        z.literal(24),
                        z.literal(168)
                    ])
                }).optional().default({ enabled: false, intervalHours: 168 }),
                embeddingModel: z.string().optional(),
                embeddingStrategy: z.enum([
                    'standard',
                    'contextual',
                    'late'
                ]).optional(),
                imagePolicy: z.enum([
                    'describe',
                    'attach',
                    'ocr',
                    'ignore'
                ]).optional(),
                rerankingMode: z.enum([
                    'off',
                    'on',
                    'automatic'
                ]).optional(),
                savedQueriesEnabled: z.boolean().optional(),
                savedQueriesOnly: z.boolean().optional(),
                searchThreshold: z.number().gte(0).lte(1),
                webSources: z.array(z.object({
                    crawlDepth: z.number().gte(1).lte(100),
                    enabled: z.boolean(),
                    schedule: z.string().optional(),
                    url: z.url()
                })).optional()
            }),
            ragToolsEnabled: z.boolean().optional().default(true),
            reminderTemplateConfig: z.array(z.object({
                channels: z.array(z.enum(['WHATSAPP', 'EMAIL'])).optional(),
                language: z.string(),
                messageBody: z.string().optional(),
                name: z.string().min(1).max(50).regex(/^[\w-]+$/),
                sendTime: z.string().regex(/^\d{2}:\d{2}$/),
                templateName: z.string(),
                variableMapping: z.record(z.string(), z.string())
            })),
            requireNameForEvents: z.boolean().optional().default(true),
            requirePhoneForEvents: z.boolean().optional().default(true),
            researcherModel: z.string().nullish().default(null),
            researcherPrompt: z.string().nullish(),
            schedulingToolsEnabled: z.boolean().optional().default(true),
            sensitiveDataGuard: z.object({
                maskCards: z.boolean(),
                maskIbans: z.boolean(),
                maskNationalIds: z.boolean(),
                nationalIdCountry: z.enum(['SA', 'EG']).nullable()
            }).optional().default({
                maskCards: true,
                maskIbans: true,
                maskNationalIds: false,
                nationalIdCountry: null
            }),
            slotDurationHours: z.number().gt(0),
            streamReasoning: z.boolean(),
            systemAgentEnabled: z.boolean().optional().default(true),
            systemAgentPrompt: z.string(),
            systemAgentReceiveAudio: z.boolean().optional().default(true),
            systemAgentReceiveImages: z.boolean().optional().default(true),
            systemAgentSendAudio: z.boolean().optional().default(true),
            systemAgentSendImages: z.boolean().optional().default(true),
            systemPrompt: z.string(),
            timezone: z.string(),
            tools: z.array(z.object({
                category: z.enum([
                    'shared',
                    'assistant',
                    'system-agent'
                ]),
                enabled: z.boolean(),
                language: z.string().min(2).max(10).optional(),
                name: z.enum([
                    'getCurrentDatetime',
                    'searchDocs',
                    'getDocumentSchemas',
                    'queryStructuredData',
                    'scheduleEvent',
                    'joinWaitlist',
                    'modifyEvent',
                    'cancelEvent',
                    'getUserData',
                    'getAvailableTimeSlots',
                    'searchAvailableAppointments',
                    'sendBusinessLocation',
                    'sendInteractiveButtons',
                    'sendInteractiveList',
                    'requestPhoneNumber',
                    'handoffToHuman',
                    'saveFeedback',
                    'collectLead',
                    'scheduleEvents',
                    'modifyEvents',
                    'modifyEventRange',
                    'cancelEvents',
                    'cancelEventRange',
                    'getEventSnapshots',
                    'getAvailableSlotsBatch',
                    'summarizeConversation',
                    'getAnalytics',
                    'getUsageBreakdown',
                    'getKnowledgeGaps',
                    'renderChart',
                    'manageKnowledgeSource',
                    'ingestUploadedFile',
                    'triggerRetraining',
                    'getAgentSettings',
                    'getContactSnapshot',
                    'manageContact',
                    'manageBeneficiary',
                    'queryConversations',
                    'searchConversations',
                    'getConversationMetrics',
                    'manageAutomation',
                    'startIntegrationConnection',
                    'getChannelStatus',
                    'generateInsightsReport'
                ]),
                requiresApproval: z.boolean()
            })),
            updatedAt: z.string().nullish(),
            verifierMaxLoops: z.int().gte(1).lte(3).optional().default(2),
            verifierModel: z.string().nullish().default('google/gemini-3.1-flash-lite'),
            verifierPrompt: z.string().nullish(),
            version: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
            waitlistEnabled: z.boolean().optional().default(false),
            waitlistOfferBatchSize: z.int().gte(1).lte(10).optional().default(3),
            waitlistOfferTtlMinutes: z.int().gte(5).lte(1440).optional().default(15),
            workingDays: z.array(z.number().gte(0).lte(6))
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerUpdateAiPresetBody = z.object({
    aiAssistantReceiveAudio: z.boolean().optional().default(true),
    aiAssistantReceiveImages: z.boolean().optional().default(true),
    aiAssistantSendAudio: z.boolean().optional().default(true),
    aiAssistantSendImages: z.boolean().optional().default(true),
    description: z.string().max(300).nullish(),
    llmContextLimit: z.number().nullish(),
    llmFallbackMaxOutputTokens: z.number().nullish(),
    llmFallbackReasoningEffort: z.enum([
        'off',
        'low',
        'medium',
        'high'
    ]).optional(),
    llmFallbackVerbosity: z.enum([
        'low',
        'medium',
        'high'
    ]).optional(),
    llmMaxOutputTokens: z.number().optional(),
    llmModel: z.string().nullish(),
    llmModelFallback: z.string().nullish(),
    llmProvider: z.string().optional(),
    llmReasoningEffort: z.enum([
        'off',
        'low',
        'medium',
        'high'
    ]).optional(),
    llmVerbosity: z.enum([
        'low',
        'medium',
        'high'
    ]).optional(),
    name: z.string().min(1).max(60).optional(),
    position: z.int().gte(0).lte(9007199254740991).optional(),
    ragAgentMode: z.enum([
        '1',
        '4',
        '5'
    ]).optional().default('1'),
    ragSettings: z.object({
        embeddingModel: z.string().optional(),
        embeddingStrategy: z.enum([
            'standard',
            'contextual',
            'late'
        ]).optional(),
        rerankingMode: z.enum([
            'off',
            'on',
            'automatic'
        ]).optional(),
        searchThreshold: z.number().gte(0).lte(1)
    }).optional(),
    researcherModel: z.string().nullish().default(null),
    streamReasoning: z.boolean().optional(),
    systemPrompt: z.string().optional(),
    tools: z.array(z.object({
        category: z.enum([
            'shared',
            'assistant',
            'system-agent'
        ]),
        enabled: z.boolean(),
        language: z.string().min(2).max(10).optional(),
        name: z.enum([
            'getCurrentDatetime',
            'searchDocs',
            'getDocumentSchemas',
            'queryStructuredData',
            'scheduleEvent',
            'joinWaitlist',
            'modifyEvent',
            'cancelEvent',
            'getUserData',
            'getAvailableTimeSlots',
            'searchAvailableAppointments',
            'sendBusinessLocation',
            'sendInteractiveButtons',
            'sendInteractiveList',
            'requestPhoneNumber',
            'handoffToHuman',
            'saveFeedback',
            'collectLead',
            'scheduleEvents',
            'modifyEvents',
            'modifyEventRange',
            'cancelEvents',
            'cancelEventRange',
            'getEventSnapshots',
            'getAvailableSlotsBatch',
            'summarizeConversation',
            'getAnalytics',
            'getUsageBreakdown',
            'getKnowledgeGaps',
            'renderChart',
            'manageKnowledgeSource',
            'ingestUploadedFile',
            'triggerRetraining',
            'getAgentSettings',
            'getContactSnapshot',
            'manageContact',
            'manageBeneficiary',
            'queryConversations',
            'searchConversations',
            'getConversationMetrics',
            'manageAutomation',
            'startIntegrationConnection',
            'getChannelStatus',
            'generateInsightsReport'
        ]),
        requiresApproval: z.boolean()
    })).optional(),
    verifierMaxLoops: z.int().gte(1).lte(3).optional().default(2),
    verifierModel: z.string().nullish().default('google/gemini-3.1-flash-lite')
});

export const zConfigControllerUpdateAiPresetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        description: z.string().max(300).nullable(),
        id: z.string(),
        isActive: z.boolean(),
        llmModel: z.string().nullable(),
        name: z.string().min(1).max(60),
        position: z.int().gte(0).lte(9007199254740991),
        ragAgentMode: z.enum([
            '1',
            '4',
            '5'
        ]).optional().default('1'),
        ragDocScope: z.enum(['ALL', 'SELECTED']),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConfigControllerUpdateAiPresetRagDocumentsBody = z.object({
    documentIds: z.array(z.string().regex(/^\d+$/)),
    scope: z.enum(['ALL', 'SELECTED'])
});

export const zConfigControllerUpdateAiPresetRagDocumentsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerAppointmentsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            eventDateTime: z.string(),
            id: z.string(),
            status: z.string(),
            type: z.string()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerBeneficiariesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            bookingCount: z.int().gte(0).lte(9007199254740991),
            createdAt: z.string(),
            deletedAt: z.string().nullable(),
            id: z.string(),
            name: z.string().nullable(),
            phoneE164: z.string().nullable()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerBulkRestoreBody = z.object({
    ids: z.array(z.string().min(1)).min(1).max(500)
});

export const zContactsControllerBulkRestoreResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        count: z.int().gte(0).lte(9007199254740991),
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerBulkSoftDeleteBody = z.object({
    ids: z.array(z.string().min(1)).min(1).max(500)
});

export const zContactsControllerBulkSoftDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        count: z.int().gte(0).lte(9007199254740991),
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerConsolidateBody = z.object({
    winnerId: z.string().min(1)
});

export const zContactsControllerConsolidateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        alreadyCompleted: z.boolean(),
        completedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/),
        loserId: z.string().min(1),
        movedCounts: z.object({
            beneficiaries: z.int().gte(0).lte(9007199254740991),
            capturedLeads: z.int().gte(0).lte(9007199254740991),
            conversations: z.int().gte(0).lte(9007199254740991),
            events: z.int().gte(0).lte(9007199254740991),
            feedbacks: z.int().gte(0).lte(9007199254740991),
            identifiers: z.int().gte(0).lte(9007199254740991),
            messages: z.int().gte(0).lte(9007199254740991),
            slotOfferCandidates: z.int().gte(0).lte(9007199254740991),
            summaries: z.int().gte(0).lte(9007199254740991),
            waitlistEntries: z.int().gte(0).lte(9007199254740991)
        }),
        preview: z.object({
            fieldResolutions: z.object({
                channel: z.object({
                    loserValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    resolvedValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    winnerValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable()
                }),
                countryCode: z.object({
                    loserValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    resolvedValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    winnerValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable()
                }),
                isActive: z.object({
                    loserValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    resolvedValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    winnerValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable()
                }),
                name: z.object({
                    loserValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    resolvedValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    winnerValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable()
                }),
                nickname: z.object({
                    loserValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    resolvedValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    winnerValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable()
                }),
                phoneE164: z.object({
                    loserValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    resolvedValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable(),
                    winnerValue: z.union([
                        z.string(),
                        z.boolean()
                    ]).nullable()
                })
            }),
            identifiers: z.array(z.object({
                id: z.string().min(1),
                isPrimary: z.boolean(),
                retiredAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
                sourceContactId: z.string().min(1),
                type: z.string().min(1),
                value: z.string().min(1),
                willBePrimary: z.boolean()
            })),
            loser: z.object({
                bookingCount: z.int().gte(0).lte(9007199254740991),
                canonicalContactId: z.string().nullable(),
                channel: z.string().nullable(),
                countryCode: z.string(),
                createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/),
                deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
                id: z.string().min(1),
                isActive: z.boolean(),
                lastActivityAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
                name: z.string().nullable(),
                nickname: z.string().nullable(),
                phoneE164: z.string().nullable()
            }),
            movedCounts: z.object({
                beneficiaries: z.int().gte(0).lte(9007199254740991),
                capturedLeads: z.int().gte(0).lte(9007199254740991),
                conversations: z.int().gte(0).lte(9007199254740991),
                events: z.int().gte(0).lte(9007199254740991),
                feedbacks: z.int().gte(0).lte(9007199254740991),
                identifiers: z.int().gte(0).lte(9007199254740991),
                messages: z.int().gte(0).lte(9007199254740991),
                slotOfferCandidates: z.int().gte(0).lte(9007199254740991),
                summaries: z.int().gte(0).lte(9007199254740991),
                waitlistEntries: z.int().gte(0).lte(9007199254740991)
            }),
            primaryIdentifierId: z.string().nullable(),
            primaryIdentifierValue: z.string().nullable(),
            threads: z.array(z.object({
                address: z.string().min(1),
                channel: z.string().min(1),
                conversationId: z.string().min(1),
                identifierId: z.string().min(1),
                identifierType: z.string().min(1),
                lastActivityAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
                messageCount: z.int().gte(0).lte(9007199254740991),
                retiredAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
                sourceContactId: z.string().min(1)
            })),
            warnings: z.object({
                beneficiaryNameCollisions: z.array(z.string()),
                blockedStateMismatch: z.boolean(),
                eventTimeCollisions: z.array(z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/)),
                loserHasLegacyCluster: z.boolean()
            }),
            winner: z.object({
                bookingCount: z.int().gte(0).lte(9007199254740991),
                canonicalContactId: z.string().nullable(),
                channel: z.string().nullable(),
                countryCode: z.string(),
                createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/),
                deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
                id: z.string().min(1),
                isActive: z.boolean(),
                lastActivityAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
                name: z.string().nullable(),
                nickname: z.string().nullable(),
                phoneE164: z.string().nullable()
            })
        }),
        winnerId: z.string().min(1)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerConsolidationPreviewResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        fieldResolutions: z.object({
            channel: z.object({
                loserValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                resolvedValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                winnerValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable()
            }),
            countryCode: z.object({
                loserValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                resolvedValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                winnerValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable()
            }),
            isActive: z.object({
                loserValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                resolvedValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                winnerValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable()
            }),
            name: z.object({
                loserValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                resolvedValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                winnerValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable()
            }),
            nickname: z.object({
                loserValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                resolvedValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                winnerValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable()
            }),
            phoneE164: z.object({
                loserValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                resolvedValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable(),
                winnerValue: z.union([
                    z.string(),
                    z.boolean()
                ]).nullable()
            })
        }),
        identifiers: z.array(z.object({
            id: z.string().min(1),
            isPrimary: z.boolean(),
            retiredAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
            sourceContactId: z.string().min(1),
            type: z.string().min(1),
            value: z.string().min(1),
            willBePrimary: z.boolean()
        })),
        loser: z.object({
            bookingCount: z.int().gte(0).lte(9007199254740991),
            canonicalContactId: z.string().nullable(),
            channel: z.string().nullable(),
            countryCode: z.string(),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/),
            deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
            id: z.string().min(1),
            isActive: z.boolean(),
            lastActivityAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
            name: z.string().nullable(),
            nickname: z.string().nullable(),
            phoneE164: z.string().nullable()
        }),
        movedCounts: z.object({
            beneficiaries: z.int().gte(0).lte(9007199254740991),
            capturedLeads: z.int().gte(0).lte(9007199254740991),
            conversations: z.int().gte(0).lte(9007199254740991),
            events: z.int().gte(0).lte(9007199254740991),
            feedbacks: z.int().gte(0).lte(9007199254740991),
            identifiers: z.int().gte(0).lte(9007199254740991),
            messages: z.int().gte(0).lte(9007199254740991),
            slotOfferCandidates: z.int().gte(0).lte(9007199254740991),
            summaries: z.int().gte(0).lte(9007199254740991),
            waitlistEntries: z.int().gte(0).lte(9007199254740991)
        }),
        primaryIdentifierId: z.string().nullable(),
        primaryIdentifierValue: z.string().nullable(),
        threads: z.array(z.object({
            address: z.string().min(1),
            channel: z.string().min(1),
            conversationId: z.string().min(1),
            identifierId: z.string().min(1),
            identifierType: z.string().min(1),
            lastActivityAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
            messageCount: z.int().gte(0).lte(9007199254740991),
            retiredAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
            sourceContactId: z.string().min(1)
        })),
        warnings: z.object({
            beneficiaryNameCollisions: z.array(z.string()),
            blockedStateMismatch: z.boolean(),
            eventTimeCollisions: z.array(z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/)),
            loserHasLegacyCluster: z.boolean()
        }),
        winner: z.object({
            bookingCount: z.int().gte(0).lte(9007199254740991),
            canonicalContactId: z.string().nullable(),
            channel: z.string().nullable(),
            countryCode: z.string(),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/),
            deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
            id: z.string().min(1),
            isActive: z.boolean(),
            lastActivityAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
            name: z.string().nullable(),
            nickname: z.string().nullable(),
            phoneE164: z.string().nullable()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerCreateBody = z.object({
    channel: z.string().max(64).nullish(),
    isActive: z.boolean().optional(),
    managedByContactId: z.string().min(1).nullish(),
    name: z.string().max(120).nullish(),
    phoneE164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).nullish()
});

export const zContactsControllerCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        contact: z.object({
            aiEnabled: z.boolean(),
            bookingCount: z.int().gte(0).lte(9007199254740991).optional(),
            canonicalContactId: z.string().nullable(),
            channel: z.string().nullable(),
            countryCode: z.string(),
            createdAt: z.string(),
            deletedAt: z.string().nullable(),
            id: z.string(),
            isActive: z.boolean(),
            isFavorite: z.boolean(),
            managedByContactId: z.string().nullable(),
            matchedBeneficiaries: z.array(z.object({
                id: z.string(),
                name: z.string().nullable()
            })),
            name: z.string().nullable(),
            nickname: z.string().nullable(),
            phoneE164: z.string().nullable(),
            preferredLang: z.string().nullable(),
            updatedAt: z.string(),
            version: z.number()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerEventsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        events: z.array(z.object({
            cancelled: z.boolean(),
            contact_id: z.string().min(1).optional(),
            contactor_name: z.string().nullish(),
            customFieldValues: z.record(z.string(), z.unknown()).nullish(),
            endsAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
            eventDateTime: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            has_document: z.boolean(),
            id: z.string(),
            is_beneficiary: z.boolean().nullish(),
            phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).nullish(),
            status: z.string().min(1).max(64).regex(/^[A-Z][A-Z0-9_]*$/),
            type: z.string().min(1),
            user_id: z.string(),
            user_name: z.string().nullish()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerFacetOptionsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        bookings: z.object({
            any: z.int().gte(0).lte(9007199254740991),
            none: z.int().gte(0).lte(9007199254740991),
            upcoming: z.int().gte(0).lte(9007199254740991)
        }),
        countries: z.record(z.string(), z.int().gte(0).lte(9007199254740991)),
        dates: z.object({
            activity: z.object({
                count: z.int().gte(0).lte(9007199254740991),
                max: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
                min: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable()
            }),
            created: z.object({
                count: z.int().gte(0).lte(9007199254740991),
                max: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
                min: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable()
            }),
            events: z.object({
                count: z.int().gte(0).lte(9007199254740991),
                max: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable(),
                min: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).nullable()
            })
        }),
        flags: z.object({
            favorite: z.int().gte(0).lte(9007199254740991)
        }),
        states: z.object({
            active: z.int().gte(0).lte(9007199254740991),
            ai: z.int().gte(0).lte(9007199254740991),
            blocked: z.int().gte(0).lte(9007199254740991),
            manual: z.int().gte(0).lte(9007199254740991)
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerHistoryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            actorEmail: z.string().nullable(),
            actorName: z.string().nullable(),
            actorUserId: z.string().nullable(),
            after: z.object({
                channel: z.string().nullable(),
                deletedAt: z.string().nullable(),
                isActive: z.boolean(),
                name: z.string().nullable(),
                phoneE164: z.string().nullable()
            }).nullable(),
            before: z.object({
                channel: z.string().nullable(),
                deletedAt: z.string().nullable(),
                isActive: z.boolean(),
                name: z.string().nullable(),
                phoneE164: z.string().nullable()
            }).nullable(),
            contactId: z.string(),
            eventId: z.string(),
            eventType: z.enum([
                'ContactCreated',
                'ContactUpdated',
                'ContactSoftDeleted',
                'ContactRestored',
                'ContactReverted',
                'ContactMergedIn',
                'ContactMergedAway'
            ]),
            intoContactId: z.string().nullable(),
            mergedContactId: z.string().nullable(),
            mergedPhoneE164: z.string().nullable(),
            movedCounts: z.object({
                beneficiaries: z.int().gte(0).lte(9007199254740991),
                capturedLeads: z.int().gte(0).lte(9007199254740991),
                conversations: z.int().gte(0).lte(9007199254740991),
                events: z.int().gte(0).lte(9007199254740991),
                feedbacks: z.int().gte(0).lte(9007199254740991),
                identifiers: z.int().gte(0).lte(9007199254740991),
                messages: z.int().gte(0).lte(9007199254740991),
                slotOfferCandidates: z.int().gte(0).lte(9007199254740991),
                summaries: z.int().gte(0).lte(9007199254740991),
                waitlistEntries: z.int().gte(0).lte(9007199254740991)
            }).nullable(),
            occurredOn: z.string(),
            originalEventId: z.string().nullable()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerLinkBody = z.object({
    winnerId: z.string().min(1)
});

export const zContactsControllerLinkResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            aiEnabled: z.boolean(),
            bookingCount: z.int().gte(0).lte(9007199254740991).optional(),
            canonicalContactId: z.string().nullable(),
            channel: z.string().nullable(),
            countryCode: z.string(),
            createdAt: z.string(),
            deletedAt: z.string().nullable(),
            id: z.string(),
            isActive: z.boolean(),
            isFavorite: z.boolean(),
            managedByContactId: z.string().nullable(),
            matchedBeneficiaries: z.array(z.object({
                id: z.string(),
                name: z.string().nullable()
            })),
            name: z.string().nullable(),
            nickname: z.string().nullable(),
            phoneE164: z.string().nullable(),
            preferredLang: z.string().nullable(),
            updatedAt: z.string(),
            version: z.number()
        })),
        total: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerMergeIntoBeneficiaryBody = z.object({
    winnerId: z.string().min(1)
});

export const zContactsControllerMergeIntoBeneficiaryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerMergeIntoParentBody = z.object({
    targetContactId: z.string().min(1).optional()
}).default({});

export const zContactsControllerMergeIntoParentResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerRestoreResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerRevertEventBody = z.object({
    eventId: z.string().min(1)
});

export const zContactsControllerRevertEventResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        contact: z.object({
            aiEnabled: z.boolean(),
            bookingCount: z.int().gte(0).lte(9007199254740991).optional(),
            canonicalContactId: z.string().nullable(),
            channel: z.string().nullable(),
            countryCode: z.string(),
            createdAt: z.string(),
            deletedAt: z.string().nullable(),
            id: z.string(),
            isActive: z.boolean(),
            isFavorite: z.boolean(),
            managedByContactId: z.string().nullable(),
            matchedBeneficiaries: z.array(z.object({
                id: z.string(),
                name: z.string().nullable()
            })),
            name: z.string().nullable(),
            nickname: z.string().nullable(),
            phoneE164: z.string().nullable(),
            preferredLang: z.string().nullable(),
            updatedAt: z.string(),
            version: z.number()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerSoftDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerStatsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        activeLast30d: z.int().gte(0).lte(9007199254740991),
        newThisMonth: z.int().gte(0).lte(9007199254740991),
        total: z.int().gte(0).lte(9007199254740991),
        withUpcomingBookings: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerUnlinkResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zContactsControllerUpdateBody = z.object({
    channel: z.string().max(64).nullish(),
    isActive: z.boolean().optional(),
    managedByContactId: z.string().min(1).nullish(),
    name: z.string().max(120).nullish(),
    phoneE164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).nullish()
});

export const zContactsControllerUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        contact: z.object({
            aiEnabled: z.boolean(),
            bookingCount: z.int().gte(0).lte(9007199254740991).optional(),
            canonicalContactId: z.string().nullable(),
            channel: z.string().nullable(),
            countryCode: z.string(),
            createdAt: z.string(),
            deletedAt: z.string().nullable(),
            id: z.string(),
            isActive: z.boolean(),
            isFavorite: z.boolean(),
            managedByContactId: z.string().nullable(),
            matchedBeneficiaries: z.array(z.object({
                id: z.string(),
                name: z.string().nullable()
            })),
            name: z.string().nullable(),
            nickname: z.string().nullable(),
            phoneE164: z.string().nullable(),
            preferredLang: z.string().nullable(),
            updatedAt: z.string(),
            version: z.number()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerAppendMessageBody = z.object({
    channel: z.enum([
        'whatsapp',
        'sms',
        'email',
        'telegram',
        'instagram',
        'x',
        'messenger',
        'system_agent'
    ]),
    message: z.string().min(1).max(100000),
    parts: z.array(z.union([
        z.object({
            text: z.string().max(100000),
            type: z.enum(['text'])
        }),
        z.object({
            text: z.string().max(100000),
            type: z.enum(['reasoning'])
        }),
        z.object({
            filename: z.string().nullish(),
            id: z.string().nullish(),
            mediaType: z.string().min(1),
            size: z.int().lte(9007199254740991).nullish(),
            type: z.enum(['file']),
            url: z.string().min(1)
        }),
        z.object({
            citationIndex: z.int().gte(0).lte(9007199254740991).nullish(),
            source: z.object({
                description: z.string().nullish(),
                title: z.string().nullish(),
                url: z.url()
            }),
            type: z.enum(['source'])
        }),
        z.object({
            approval: z.object({
                approved: z.boolean().nullish(),
                id: z.string().max(200),
                reason: z.string().max(1000).nullish()
            }).nullish(),
            errorText: z.string().nullish(),
            input: z.unknown().optional(),
            output: z.unknown().optional(),
            selectedOptionId: z.string().max(256).nullish(),
            state: z.enum([
                'input-streaming',
                'input-available',
                'output-available',
                'approval-requested',
                'output-denied',
                'approval-responded',
                'output-error'
            ]),
            toolCallId: z.string(),
            type: z.string()
        }),
        z.object({
            approval: z.object({
                approved: z.boolean().nullish(),
                id: z.string().max(200),
                reason: z.string().max(1000).nullish()
            }).nullish(),
            errorText: z.string().nullish(),
            input: z.unknown().optional(),
            output: z.unknown().optional(),
            selectedOptionId: z.string().max(256).nullish(),
            state: z.enum([
                'input-streaming',
                'input-available',
                'output-available',
                'approval-requested',
                'output-denied',
                'approval-responded',
                'output-error'
            ]),
            toolCallId: z.string(),
            toolName: z.string(),
            type: z.enum(['dynamic-tool'])
        }),
        z.object({
            data: z.object({
                elapsedMs: z.int().gte(0).lte(9007199254740991).optional(),
                id: z.string().min(1).max(64),
                mode: z.enum(['4', '5']),
                startedAt: z.string(),
                status: z.enum([
                    'running',
                    'completed',
                    'failed'
                ]),
                steps: z.array(z.object({
                    evidenceCount: z.int().gte(0).lte(9007199254740991).optional(),
                    id: z.string().min(1).max(64),
                    kind: z.enum([
                        'research',
                        'draft',
                        'verify',
                        'revise'
                    ]),
                    loop: z.int().gte(1).lte(9).optional(),
                    problemCount: z.int().gte(0).lte(9007199254740991).optional(),
                    status: z.enum([
                        'pending',
                        'in-progress',
                        'completed',
                        'failed'
                    ]),
                    verdict: z.enum(['PASS', 'NEEDS_REVISION']).optional()
                })).max(32),
                workflow: z.enum(['rag-answer'])
            }),
            id: z.string().max(64).optional(),
            type: z.enum(['data-agent-workflow'])
        })
    ])).max(100).optional(),
    reasoning: z.string().max(100000).optional(),
    role: z.string().min(1).max(20),
    sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    tool_call: z.object({
        tool_args: z.record(z.string(), z.unknown()).optional(),
        tool_call_id: z.string().max(200).optional(),
        tool_error: z.union([
            z.string(),
            z.record(z.string(), z.unknown())
        ]).optional(),
        tool_name: z.string().max(200),
        tool_result: z.record(z.string(), z.unknown()).optional()
    }).optional(),
    toolInvocations: z.array(z.object({
        approval: z.object({
            approved: z.boolean().nullish(),
            id: z.string().max(200),
            reason: z.string().max(1000).nullish()
        }).nullish(),
        errorText: z.string().max(1000).nullish(),
        input: z.unknown().optional(),
        output: z.unknown().optional(),
        selectedOptionId: z.string().max(256).nullish(),
        sequence: z.number().nullish(),
        state: z.enum([
            'input-streaming',
            'input-available',
            'output-available',
            'output-error',
            'approval-requested',
            'approval-responded',
            'output-denied'
        ]),
        toolCallId: z.string().max(200),
        toolName: z.string().max(200)
    })).max(50).optional()
});

export const zConversationsControllerAppendMessageResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerAssignLabelBody = z.object({
    channel: z.enum([
        'whatsapp',
        'sms',
        'email',
        'telegram',
        'instagram',
        'x',
        'messenger',
        'system_agent'
    ]).optional(),
    labelId: z.string().min(1).max(200)
});

export const zConversationsControllerAssignLabelResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerClearConversationResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        deleted: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerClearConversationByIdResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        deleted: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerCreateLabelBody = z.object({
    color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
    name: z.string().min(1).max(40)
});

export const zConversationsControllerCreateLabelResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        color: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        id: z.string(),
        name: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerDeleteLabelResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        deleted: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerGetAiEnabledResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        aiEnabled: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerListContactMessagesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            aiMetrics: z.object({
                agents: z.array(z.object({
                    calls: z.int().gte(0).lte(9007199254740991).optional(),
                    costUsd: z.number().gte(0).optional(),
                    inputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    latencyMs: z.number().gte(0).optional(),
                    loops: z.int().gte(0).lte(9007199254740991).optional(),
                    model: z.string().max(200),
                    outputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    role: z.enum([
                        'main',
                        'researcher',
                        'verifier'
                    ]),
                    toolCalls: z.int().gte(0).lte(9007199254740991).optional(),
                    totalTokens: z.int().gte(0).lte(9007199254740991).optional()
                })).max(8).optional(),
                audioTranscriptions: z.array(z.object({
                    costSource: z.enum(['estimated']),
                    costUsd: z.number().gte(0),
                    durationSeconds: z.number().gte(0),
                    latencyMs: z.number().gte(0),
                    model: z.string().max(200),
                    provider: z.string().max(200)
                })).max(8).optional(),
                cachedInputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                cacheWriteInputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                context: z.object({
                    combinedMax: z.number().optional(),
                    inputMax: z.number().optional(),
                    outputMax: z.number().optional(),
                    totalMax: z.number().optional()
                }).optional(),
                costUSD: z.object({
                    cacheReadUSD: z.number().optional(),
                    inputUSD: z.number().optional(),
                    outputUSD: z.number().optional(),
                    reasoningUSD: z.number().optional(),
                    totalUSD: z.number().optional()
                }).optional(),
                finishReason: z.string().max(200).nullish(),
                hasPerformance: z.boolean().optional(),
                hasUsage: z.boolean().optional(),
                inputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                matchScore: z.number().gte(0).lte(1).optional(),
                mode: z.enum([
                    '1',
                    '4',
                    '5'
                ]).optional(),
                modelId: z.string().max(200).optional(),
                noCacheInputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                outputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                performance: z.object({
                    effectiveOutputTokensPerSecond: z.number().optional(),
                    effectiveTotalTokensPerSecond: z.number().optional(),
                    inputTokensPerSecond: z.number().optional(),
                    outputTokensPerSecond: z.number().optional(),
                    responseTimeMs: z.number().optional(),
                    stepTimeMs: z.number().optional(),
                    timeBetweenOutputChunksMs: z.object({
                        avg: z.number().optional(),
                        max: z.number().optional(),
                        median: z.number().optional(),
                        min: z.number().optional(),
                        p10: z.number().optional(),
                        p90: z.number().optional()
                    }).optional(),
                    timeToFirstOutputMs: z.number().optional(),
                    toolExecutionMaxMs: z.number().optional(),
                    toolExecutionMs: z.record(z.string(), z.number()).optional(),
                    toolExecutionTotalMs: z.number().optional()
                }).optional(),
                provider: z.string().max(200).optional(),
                qaPairId: z.string().max(64).optional(),
                reasoningTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                status: z.enum([
                    'success',
                    'error',
                    'aborted'
                ]).optional(),
                stepCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                steps: z.array(z.object({
                    finishReason: z.string().max(200).optional(),
                    inputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    modelId: z.string().max(200).optional(),
                    outputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    performance: z.object({
                        effectiveOutputTokensPerSecond: z.number().optional(),
                        effectiveTotalTokensPerSecond: z.number().optional(),
                        inputTokensPerSecond: z.number().optional(),
                        outputTokensPerSecond: z.number().optional(),
                        responseTimeMs: z.number().optional(),
                        stepTimeMs: z.number().optional(),
                        timeBetweenOutputChunksMs: z.object({
                            avg: z.number().optional(),
                            max: z.number().optional(),
                            median: z.number().optional(),
                            min: z.number().optional(),
                            p10: z.number().optional(),
                            p90: z.number().optional()
                        }).optional(),
                        timeToFirstOutputMs: z.number().optional(),
                        toolExecutionMaxMs: z.number().optional(),
                        toolExecutionMs: z.record(z.string(), z.number()).optional(),
                        toolExecutionTotalMs: z.number().optional()
                    }).optional(),
                    provider: z.string().max(200).optional(),
                    rawFinishReason: z.string().max(200).optional(),
                    stepNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
                    toolCallCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    toolErrorCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    toolNames: z.array(z.string().max(200)).max(50).optional(),
                    toolResultCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    totalTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional()
                })).max(50).optional(),
                superseded: z.object({
                    costUsd: z.number().gte(0).optional(),
                    count: z.int().gte(0).lte(9007199254740991),
                    inputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    outputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    totalTokens: z.int().gte(0).lte(9007199254740991).optional()
                }).optional(),
                textOutputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                toolCallCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                toolErrorCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                toolResultCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                totalTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional()
            }).nullish(),
            buttonReply: z.object({
                contextExternalMessageId: z.string().nullish(),
                description: z.string().nullish(),
                id: z.string(),
                inReplyToMessageId: z.string().nullish(),
                kind: z.enum([
                    'interactive_button',
                    'interactive_list',
                    'template_button'
                ]),
                title: z.string()
            }).nullish(),
            channel: z.enum([
                'whatsapp',
                'sms',
                'email',
                'telegram',
                'instagram',
                'x',
                'messenger',
                'system_agent'
            ]).nullish(),
            conversationId: z.string().max(200).nullish(),
            deliveryStatus: z.enum([
                'pending',
                'sending',
                'sent',
                'delivered',
                'read',
                'failed'
            ]).nullish(),
            externalMessageId: z.string().max(255).nullish(),
            id: z.string().max(200).nullish(),
            instagram: z.object({
                attachmentType: z.string().nullish(),
                isEcho: z.boolean().nullish(),
                isUnsupported: z.boolean().nullish(),
                postbackPayload: z.string().nullish(),
                referralSource: z.string().nullish(),
                storyId: z.string().nullish(),
                type: z.string().min(1)
            }).nullish(),
            interactiveButtons: z.object({
                bodyText: z.string(),
                buttons: z.array(z.object({
                    id: z.string(),
                    title: z.string()
                })).min(1).max(3),
                footerText: z.string().nullish(),
                headerText: z.string().nullish()
            }).nullish(),
            message: z.string().max(100000),
            parts: z.array(z.union([
                z.object({
                    text: z.string().max(100000),
                    type: z.enum(['text'])
                }),
                z.object({
                    text: z.string().max(100000),
                    type: z.enum(['reasoning'])
                }),
                z.object({
                    filename: z.string().nullish(),
                    id: z.string().nullish(),
                    mediaType: z.string().min(1),
                    size: z.int().lte(9007199254740991).nullish(),
                    type: z.enum(['file']),
                    url: z.string().min(1)
                }),
                z.object({
                    citationIndex: z.int().gte(0).lte(9007199254740991).nullish(),
                    source: z.object({
                        description: z.string().nullish(),
                        title: z.string().nullish(),
                        url: z.url()
                    }),
                    type: z.enum(['source'])
                }),
                z.object({
                    approval: z.object({
                        approved: z.boolean().nullish(),
                        id: z.string().max(200),
                        reason: z.string().max(1000).nullish()
                    }).nullish(),
                    errorText: z.string().nullish(),
                    input: z.unknown().optional(),
                    output: z.unknown().optional(),
                    selectedOptionId: z.string().max(256).nullish(),
                    state: z.enum([
                        'input-streaming',
                        'input-available',
                        'output-available',
                        'approval-requested',
                        'output-denied',
                        'approval-responded',
                        'output-error'
                    ]),
                    toolCallId: z.string(),
                    type: z.string()
                }),
                z.object({
                    approval: z.object({
                        approved: z.boolean().nullish(),
                        id: z.string().max(200),
                        reason: z.string().max(1000).nullish()
                    }).nullish(),
                    errorText: z.string().nullish(),
                    input: z.unknown().optional(),
                    output: z.unknown().optional(),
                    selectedOptionId: z.string().max(256).nullish(),
                    state: z.enum([
                        'input-streaming',
                        'input-available',
                        'output-available',
                        'approval-requested',
                        'output-denied',
                        'approval-responded',
                        'output-error'
                    ]),
                    toolCallId: z.string(),
                    toolName: z.string(),
                    type: z.enum(['dynamic-tool'])
                }),
                z.object({
                    data: z.object({
                        elapsedMs: z.int().gte(0).lte(9007199254740991).optional(),
                        id: z.string().min(1).max(64),
                        mode: z.enum(['4', '5']),
                        startedAt: z.string(),
                        status: z.enum([
                            'running',
                            'completed',
                            'failed'
                        ]),
                        steps: z.array(z.object({
                            evidenceCount: z.int().gte(0).lte(9007199254740991).optional(),
                            id: z.string().min(1).max(64),
                            kind: z.enum([
                                'research',
                                'draft',
                                'verify',
                                'revise'
                            ]),
                            loop: z.int().gte(1).lte(9).optional(),
                            problemCount: z.int().gte(0).lte(9007199254740991).optional(),
                            status: z.enum([
                                'pending',
                                'in-progress',
                                'completed',
                                'failed'
                            ]),
                            verdict: z.enum(['PASS', 'NEEDS_REVISION']).optional()
                        })).max(32),
                        workflow: z.enum(['rag-answer'])
                    }),
                    id: z.string().max(64).optional(),
                    type: z.enum(['data-agent-workflow'])
                })
            ])).max(100).nullish(),
            reactions: z.array(z.object({
                direction: z.enum(['INBOUND', 'OUTBOUND']),
                emoji: z.string().min(1),
                externalMessageId: z.string().nullish(),
                sentAt: z.string()
            })).max(2).nullish(),
            reasoning: z.string().max(100000).nullish(),
            reminder: z.object({
                content: z.string().nullable(),
                label: z.string().min(1).nullable(),
                language: z.string().min(1).nullable(),
                templateName: z.string().min(1).nullable()
            }).nullish(),
            replyTo: z.object({
                externalMessageId: z.string().nullish(),
                messageId: z.string().nullish(),
                preview: z.string().max(140),
                role: z.string().nullish()
            }).nullish(),
            role: z.enum([
                'user',
                'assistant',
                'secretary',
                'admin',
                'tool',
                'system'
            ]),
            sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            sources: z.array(z.object({
                description: z.string().max(2000).nullish(),
                title: z.string().max(500).nullish(),
                url: z.url().max(2048)
            })).max(20).nullish(),
            telegram: z.object({
                contact: z.object({
                    firstName: z.string(),
                    lastName: z.string().nullish(),
                    phoneNumber: z.string(),
                    userId: z.string().nullish()
                }).nullish(),
                deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
                editedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
                forward: z.object({
                    date: z.int().gte(0).lte(9007199254740991),
                    kind: z.string()
                }).nullish(),
                location: z.object({
                    latitude: z.number(),
                    longitude: z.number()
                }).nullish(),
                media: z.object({
                    duration: z.int().gte(0).lte(9007199254740991).nullish(),
                    emoji: z.string().nullish(),
                    filename: z.string().nullish(),
                    fileSize: z.int().gte(0).lte(9007199254740991).nullish(),
                    height: z.int().gte(0).lte(9007199254740991).nullish(),
                    kind: z.enum([
                        'image',
                        'document',
                        'video',
                        'animation',
                        'audio',
                        'voice',
                        'video_note',
                        'sticker'
                    ]),
                    mediaType: z.string().nullish(),
                    stickerSetName: z.string().nullish(),
                    width: z.int().gte(0).lte(9007199254740991).nullish()
                }).nullish(),
                mediaGroupId: z.string().nullish(),
                messageThreadId: z.string().nullish(),
                poll: z.object({
                    id: z.string(),
                    isClosed: z.boolean(),
                    options: z.array(z.object({
                        text: z.string(),
                        voterCount: z.int().gte(0).lte(9007199254740991)
                    })),
                    question: z.string()
                }).nullish(),
                quote: z.object({
                    position: z.int().gte(0).lte(9007199254740991),
                    text: z.string()
                }).nullish(),
                reactions: z.array(z.object({
                    customEmojiId: z.string().nullish(),
                    emoji: z.string().nullish(),
                    kind: z.enum([
                        'emoji',
                        'custom_emoji',
                        'paid'
                    ]),
                    totalCount: z.int().gte(0).lte(9007199254740991).nullish()
                })).nullish(),
                type: z.string().min(1),
                updateId: z.string().nullish(),
                venue: z.object({
                    address: z.string(),
                    location: z.object({
                        latitude: z.number(),
                        longitude: z.number()
                    }),
                    title: z.string()
                }).nullish()
            }).nullish(),
            tool_call: z.object({
                tool_args: z.record(z.string(), z.unknown()).nullish(),
                tool_call_id: z.string().max(200),
                tool_error: z.union([
                    z.string(),
                    z.record(z.string(), z.unknown())
                ]).nullish(),
                tool_name: z.string().max(200),
                tool_result: z.record(z.string(), z.unknown()).nullish()
            }).nullish(),
            toolInvocations: z.array(z.object({
                approval: z.object({
                    approved: z.boolean().nullish(),
                    id: z.string().max(200),
                    reason: z.string().max(1000).nullish()
                }).nullish(),
                errorText: z.string().max(1000).nullish(),
                input: z.unknown().optional(),
                output: z.unknown().optional(),
                selectedOptionId: z.string().max(256).nullish(),
                sequence: z.number().nullish(),
                state: z.enum([
                    'input-streaming',
                    'input-available',
                    'output-available',
                    'output-error',
                    'approval-requested',
                    'approval-responded',
                    'output-denied'
                ]),
                toolCallId: z.string().max(200),
                toolName: z.string().max(200)
            })).max(50).nullish(),
            x: z.object({
                attachmentType: z.string().nullish(),
                conversationId: z.string().max(128).nullish(),
                conversationKeyVersion: z.string().max(128).nullish(),
                encodedEvent: z.string().nullish(),
                eventType: z.string().nullish(),
                expiresAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
                reaction: z.object({
                    action: z.enum(['add', 'remove']),
                    emoji: z.string().min(1).max(32),
                    targetSequenceId: z.string().min(1).max(128)
                }).nullish(),
                recipientId: z.string().min(1),
                replyToSequenceId: z.string().max(128).nullish(),
                senderDisplayName: z.string().max(255).nullish(),
                senderUsername: z.string().max(64).nullish(),
                sequenceId: z.string().max(128).nullish(),
                sharedPostId: z.string().nullish(),
                stack: z.enum(['legacy_dm', 'x_chat']).nullish(),
                ttlMsec: z.int().lte(9007199254740991).nullish(),
                verified: z.boolean().nullish()
            }).nullish()
        })),
        total: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerListConversationChannelsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        channels: z.array(z.string())
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerListConversationMetaResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        meta: z.array(z.object({
            archivedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            channel: z.string(),
            contactId: z.string(),
            conversationId: z.string(),
            labelIds: z.array(z.string()),
            phoneE164: z.string().nullable()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerListInboxConversationsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        conversations: z.array(z.object({
            address: z.string(),
            aiEnabled: z.boolean(),
            archivedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            channel: z.enum([
                'whatsapp',
                'sms',
                'email',
                'telegram',
                'instagram',
                'x',
                'messenger',
                'system_agent'
            ]),
            contactId: z.string(),
            conversationId: z.string(),
            displayName: z.string().nullable(),
            firstName: z.string().nullable(),
            hasPendingApproval: z.boolean(),
            isActive: z.boolean(),
            isFavorite: z.boolean(),
            labels: z.array(z.object({
                color: z.string(),
                id: z.string(),
                name: z.string()
            })),
            lastMessage: z.object({
                direction: z.enum(['INBOUND', 'OUTBOUND']),
                id: z.string(),
                message: z.string(),
                sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
            }).nullable(),
            lastName: z.string().nullable(),
            nickname: z.string().nullable(),
            phoneE164: z.string().nullable(),
            profilePhotoUrl: z.string().nullable(),
            unreadCount: z.int().gte(0).lte(9007199254740991),
            username: z.string().nullable()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerListLabelsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        labels: z.array(z.object({
            color: z.string(),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            id: z.string(),
            name: z.string()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerListMessagesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        hasMore: z.boolean(),
        messages: z.array(z.object({
            aiMetrics: z.object({
                agents: z.array(z.object({
                    calls: z.int().gte(0).lte(9007199254740991).optional(),
                    costUsd: z.number().gte(0).optional(),
                    inputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    latencyMs: z.number().gte(0).optional(),
                    loops: z.int().gte(0).lte(9007199254740991).optional(),
                    model: z.string().max(200),
                    outputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    role: z.enum([
                        'main',
                        'researcher',
                        'verifier'
                    ]),
                    toolCalls: z.int().gte(0).lte(9007199254740991).optional(),
                    totalTokens: z.int().gte(0).lte(9007199254740991).optional()
                })).max(8).optional(),
                audioTranscriptions: z.array(z.object({
                    costSource: z.enum(['estimated']),
                    costUsd: z.number().gte(0),
                    durationSeconds: z.number().gte(0),
                    latencyMs: z.number().gte(0),
                    model: z.string().max(200),
                    provider: z.string().max(200)
                })).max(8).optional(),
                cachedInputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                cacheWriteInputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                context: z.object({
                    combinedMax: z.number().optional(),
                    inputMax: z.number().optional(),
                    outputMax: z.number().optional(),
                    totalMax: z.number().optional()
                }).optional(),
                costUSD: z.object({
                    cacheReadUSD: z.number().optional(),
                    inputUSD: z.number().optional(),
                    outputUSD: z.number().optional(),
                    reasoningUSD: z.number().optional(),
                    totalUSD: z.number().optional()
                }).optional(),
                finishReason: z.string().max(200).nullish(),
                hasPerformance: z.boolean().optional(),
                hasUsage: z.boolean().optional(),
                inputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                matchScore: z.number().gte(0).lte(1).optional(),
                mode: z.enum([
                    '1',
                    '4',
                    '5'
                ]).optional(),
                modelId: z.string().max(200).optional(),
                noCacheInputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                outputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                performance: z.object({
                    effectiveOutputTokensPerSecond: z.number().optional(),
                    effectiveTotalTokensPerSecond: z.number().optional(),
                    inputTokensPerSecond: z.number().optional(),
                    outputTokensPerSecond: z.number().optional(),
                    responseTimeMs: z.number().optional(),
                    stepTimeMs: z.number().optional(),
                    timeBetweenOutputChunksMs: z.object({
                        avg: z.number().optional(),
                        max: z.number().optional(),
                        median: z.number().optional(),
                        min: z.number().optional(),
                        p10: z.number().optional(),
                        p90: z.number().optional()
                    }).optional(),
                    timeToFirstOutputMs: z.number().optional(),
                    toolExecutionMaxMs: z.number().optional(),
                    toolExecutionMs: z.record(z.string(), z.number()).optional(),
                    toolExecutionTotalMs: z.number().optional()
                }).optional(),
                provider: z.string().max(200).optional(),
                qaPairId: z.string().max(64).optional(),
                reasoningTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                status: z.enum([
                    'success',
                    'error',
                    'aborted'
                ]).optional(),
                stepCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                steps: z.array(z.object({
                    finishReason: z.string().max(200).optional(),
                    inputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    modelId: z.string().max(200).optional(),
                    outputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    performance: z.object({
                        effectiveOutputTokensPerSecond: z.number().optional(),
                        effectiveTotalTokensPerSecond: z.number().optional(),
                        inputTokensPerSecond: z.number().optional(),
                        outputTokensPerSecond: z.number().optional(),
                        responseTimeMs: z.number().optional(),
                        stepTimeMs: z.number().optional(),
                        timeBetweenOutputChunksMs: z.object({
                            avg: z.number().optional(),
                            max: z.number().optional(),
                            median: z.number().optional(),
                            min: z.number().optional(),
                            p10: z.number().optional(),
                            p90: z.number().optional()
                        }).optional(),
                        timeToFirstOutputMs: z.number().optional(),
                        toolExecutionMaxMs: z.number().optional(),
                        toolExecutionMs: z.record(z.string(), z.number()).optional(),
                        toolExecutionTotalMs: z.number().optional()
                    }).optional(),
                    provider: z.string().max(200).optional(),
                    rawFinishReason: z.string().max(200).optional(),
                    stepNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
                    toolCallCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    toolErrorCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    toolNames: z.array(z.string().max(200)).max(50).optional(),
                    toolResultCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    totalTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional()
                })).max(50).optional(),
                superseded: z.object({
                    costUsd: z.number().gte(0).optional(),
                    count: z.int().gte(0).lte(9007199254740991),
                    inputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    outputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    totalTokens: z.int().gte(0).lte(9007199254740991).optional()
                }).optional(),
                textOutputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                toolCallCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                toolErrorCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                toolResultCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                totalTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional()
            }).nullish(),
            buttonReply: z.object({
                contextExternalMessageId: z.string().nullish(),
                description: z.string().nullish(),
                id: z.string(),
                inReplyToMessageId: z.string().nullish(),
                kind: z.enum([
                    'interactive_button',
                    'interactive_list',
                    'template_button'
                ]),
                title: z.string()
            }).nullish(),
            channel: z.enum([
                'whatsapp',
                'sms',
                'email',
                'telegram',
                'instagram',
                'x',
                'messenger',
                'system_agent'
            ]).nullish(),
            conversationId: z.string().max(200).nullish(),
            deliveryStatus: z.enum([
                'pending',
                'sending',
                'sent',
                'delivered',
                'read',
                'failed'
            ]).nullish(),
            externalMessageId: z.string().max(255).nullish(),
            id: z.string().max(200).nullish(),
            instagram: z.object({
                attachmentType: z.string().nullish(),
                isEcho: z.boolean().nullish(),
                isUnsupported: z.boolean().nullish(),
                postbackPayload: z.string().nullish(),
                referralSource: z.string().nullish(),
                storyId: z.string().nullish(),
                type: z.string().min(1)
            }).nullish(),
            interactiveButtons: z.object({
                bodyText: z.string(),
                buttons: z.array(z.object({
                    id: z.string(),
                    title: z.string()
                })).min(1).max(3),
                footerText: z.string().nullish(),
                headerText: z.string().nullish()
            }).nullish(),
            message: z.string().max(100000),
            parts: z.array(z.union([
                z.object({
                    text: z.string().max(100000),
                    type: z.enum(['text'])
                }),
                z.object({
                    text: z.string().max(100000),
                    type: z.enum(['reasoning'])
                }),
                z.object({
                    filename: z.string().nullish(),
                    id: z.string().nullish(),
                    mediaType: z.string().min(1),
                    size: z.int().lte(9007199254740991).nullish(),
                    type: z.enum(['file']),
                    url: z.string().min(1)
                }),
                z.object({
                    citationIndex: z.int().gte(0).lte(9007199254740991).nullish(),
                    source: z.object({
                        description: z.string().nullish(),
                        title: z.string().nullish(),
                        url: z.url()
                    }),
                    type: z.enum(['source'])
                }),
                z.object({
                    approval: z.object({
                        approved: z.boolean().nullish(),
                        id: z.string().max(200),
                        reason: z.string().max(1000).nullish()
                    }).nullish(),
                    errorText: z.string().nullish(),
                    input: z.unknown().optional(),
                    output: z.unknown().optional(),
                    selectedOptionId: z.string().max(256).nullish(),
                    state: z.enum([
                        'input-streaming',
                        'input-available',
                        'output-available',
                        'approval-requested',
                        'output-denied',
                        'approval-responded',
                        'output-error'
                    ]),
                    toolCallId: z.string(),
                    type: z.string()
                }),
                z.object({
                    approval: z.object({
                        approved: z.boolean().nullish(),
                        id: z.string().max(200),
                        reason: z.string().max(1000).nullish()
                    }).nullish(),
                    errorText: z.string().nullish(),
                    input: z.unknown().optional(),
                    output: z.unknown().optional(),
                    selectedOptionId: z.string().max(256).nullish(),
                    state: z.enum([
                        'input-streaming',
                        'input-available',
                        'output-available',
                        'approval-requested',
                        'output-denied',
                        'approval-responded',
                        'output-error'
                    ]),
                    toolCallId: z.string(),
                    toolName: z.string(),
                    type: z.enum(['dynamic-tool'])
                }),
                z.object({
                    data: z.object({
                        elapsedMs: z.int().gte(0).lte(9007199254740991).optional(),
                        id: z.string().min(1).max(64),
                        mode: z.enum(['4', '5']),
                        startedAt: z.string(),
                        status: z.enum([
                            'running',
                            'completed',
                            'failed'
                        ]),
                        steps: z.array(z.object({
                            evidenceCount: z.int().gte(0).lte(9007199254740991).optional(),
                            id: z.string().min(1).max(64),
                            kind: z.enum([
                                'research',
                                'draft',
                                'verify',
                                'revise'
                            ]),
                            loop: z.int().gte(1).lte(9).optional(),
                            problemCount: z.int().gte(0).lte(9007199254740991).optional(),
                            status: z.enum([
                                'pending',
                                'in-progress',
                                'completed',
                                'failed'
                            ]),
                            verdict: z.enum(['PASS', 'NEEDS_REVISION']).optional()
                        })).max(32),
                        workflow: z.enum(['rag-answer'])
                    }),
                    id: z.string().max(64).optional(),
                    type: z.enum(['data-agent-workflow'])
                })
            ])).max(100).nullish(),
            reactions: z.array(z.object({
                direction: z.enum(['INBOUND', 'OUTBOUND']),
                emoji: z.string().min(1),
                externalMessageId: z.string().nullish(),
                sentAt: z.string()
            })).max(2).nullish(),
            reasoning: z.string().max(100000).nullish(),
            reminder: z.object({
                content: z.string().nullable(),
                label: z.string().min(1).nullable(),
                language: z.string().min(1).nullable(),
                templateName: z.string().min(1).nullable()
            }).nullish(),
            replyTo: z.object({
                externalMessageId: z.string().nullish(),
                messageId: z.string().nullish(),
                preview: z.string().max(140),
                role: z.string().nullish()
            }).nullish(),
            role: z.enum([
                'user',
                'assistant',
                'secretary',
                'admin',
                'tool',
                'system'
            ]),
            sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            sources: z.array(z.object({
                description: z.string().max(2000).nullish(),
                title: z.string().max(500).nullish(),
                url: z.url().max(2048)
            })).max(20).nullish(),
            telegram: z.object({
                contact: z.object({
                    firstName: z.string(),
                    lastName: z.string().nullish(),
                    phoneNumber: z.string(),
                    userId: z.string().nullish()
                }).nullish(),
                deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
                editedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
                forward: z.object({
                    date: z.int().gte(0).lte(9007199254740991),
                    kind: z.string()
                }).nullish(),
                location: z.object({
                    latitude: z.number(),
                    longitude: z.number()
                }).nullish(),
                media: z.object({
                    duration: z.int().gte(0).lte(9007199254740991).nullish(),
                    emoji: z.string().nullish(),
                    filename: z.string().nullish(),
                    fileSize: z.int().gte(0).lte(9007199254740991).nullish(),
                    height: z.int().gte(0).lte(9007199254740991).nullish(),
                    kind: z.enum([
                        'image',
                        'document',
                        'video',
                        'animation',
                        'audio',
                        'voice',
                        'video_note',
                        'sticker'
                    ]),
                    mediaType: z.string().nullish(),
                    stickerSetName: z.string().nullish(),
                    width: z.int().gte(0).lte(9007199254740991).nullish()
                }).nullish(),
                mediaGroupId: z.string().nullish(),
                messageThreadId: z.string().nullish(),
                poll: z.object({
                    id: z.string(),
                    isClosed: z.boolean(),
                    options: z.array(z.object({
                        text: z.string(),
                        voterCount: z.int().gte(0).lte(9007199254740991)
                    })),
                    question: z.string()
                }).nullish(),
                quote: z.object({
                    position: z.int().gte(0).lte(9007199254740991),
                    text: z.string()
                }).nullish(),
                reactions: z.array(z.object({
                    customEmojiId: z.string().nullish(),
                    emoji: z.string().nullish(),
                    kind: z.enum([
                        'emoji',
                        'custom_emoji',
                        'paid'
                    ]),
                    totalCount: z.int().gte(0).lte(9007199254740991).nullish()
                })).nullish(),
                type: z.string().min(1),
                updateId: z.string().nullish(),
                venue: z.object({
                    address: z.string(),
                    location: z.object({
                        latitude: z.number(),
                        longitude: z.number()
                    }),
                    title: z.string()
                }).nullish()
            }).nullish(),
            tool_call: z.object({
                tool_args: z.record(z.string(), z.unknown()).nullish(),
                tool_call_id: z.string().max(200),
                tool_error: z.union([
                    z.string(),
                    z.record(z.string(), z.unknown())
                ]).nullish(),
                tool_name: z.string().max(200),
                tool_result: z.record(z.string(), z.unknown()).nullish()
            }).nullish(),
            toolInvocations: z.array(z.object({
                approval: z.object({
                    approved: z.boolean().nullish(),
                    id: z.string().max(200),
                    reason: z.string().max(1000).nullish()
                }).nullish(),
                errorText: z.string().max(1000).nullish(),
                input: z.unknown().optional(),
                output: z.unknown().optional(),
                selectedOptionId: z.string().max(256).nullish(),
                sequence: z.number().nullish(),
                state: z.enum([
                    'input-streaming',
                    'input-available',
                    'output-available',
                    'output-error',
                    'approval-requested',
                    'approval-responded',
                    'output-denied'
                ]),
                toolCallId: z.string().max(200),
                toolName: z.string().max(200)
            })).max(50).nullish(),
            x: z.object({
                attachmentType: z.string().nullish(),
                conversationId: z.string().max(128).nullish(),
                conversationKeyVersion: z.string().max(128).nullish(),
                encodedEvent: z.string().nullish(),
                eventType: z.string().nullish(),
                expiresAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
                reaction: z.object({
                    action: z.enum(['add', 'remove']),
                    emoji: z.string().min(1).max(32),
                    targetSequenceId: z.string().min(1).max(128)
                }).nullish(),
                recipientId: z.string().min(1),
                replyToSequenceId: z.string().max(128).nullish(),
                senderDisplayName: z.string().max(255).nullish(),
                senderUsername: z.string().max(64).nullish(),
                sequenceId: z.string().max(128).nullish(),
                sharedPostId: z.string().nullish(),
                stack: z.enum(['legacy_dm', 'x_chat']).nullish(),
                ttlMsec: z.int().lte(9007199254740991).nullish(),
                verified: z.boolean().nullish()
            }).nullish()
        })),
        nextCursor: z.string().nullish(),
        totalCount: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerListMessagesByConversationIdResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        hasMore: z.boolean(),
        messages: z.array(z.object({
            aiMetrics: z.object({
                agents: z.array(z.object({
                    calls: z.int().gte(0).lte(9007199254740991).optional(),
                    costUsd: z.number().gte(0).optional(),
                    inputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    latencyMs: z.number().gte(0).optional(),
                    loops: z.int().gte(0).lte(9007199254740991).optional(),
                    model: z.string().max(200),
                    outputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    role: z.enum([
                        'main',
                        'researcher',
                        'verifier'
                    ]),
                    toolCalls: z.int().gte(0).lte(9007199254740991).optional(),
                    totalTokens: z.int().gte(0).lte(9007199254740991).optional()
                })).max(8).optional(),
                audioTranscriptions: z.array(z.object({
                    costSource: z.enum(['estimated']),
                    costUsd: z.number().gte(0),
                    durationSeconds: z.number().gte(0),
                    latencyMs: z.number().gte(0),
                    model: z.string().max(200),
                    provider: z.string().max(200)
                })).max(8).optional(),
                cachedInputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                cacheWriteInputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                context: z.object({
                    combinedMax: z.number().optional(),
                    inputMax: z.number().optional(),
                    outputMax: z.number().optional(),
                    totalMax: z.number().optional()
                }).optional(),
                costUSD: z.object({
                    cacheReadUSD: z.number().optional(),
                    inputUSD: z.number().optional(),
                    outputUSD: z.number().optional(),
                    reasoningUSD: z.number().optional(),
                    totalUSD: z.number().optional()
                }).optional(),
                finishReason: z.string().max(200).nullish(),
                hasPerformance: z.boolean().optional(),
                hasUsage: z.boolean().optional(),
                inputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                matchScore: z.number().gte(0).lte(1).optional(),
                mode: z.enum([
                    '1',
                    '4',
                    '5'
                ]).optional(),
                modelId: z.string().max(200).optional(),
                noCacheInputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                outputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                performance: z.object({
                    effectiveOutputTokensPerSecond: z.number().optional(),
                    effectiveTotalTokensPerSecond: z.number().optional(),
                    inputTokensPerSecond: z.number().optional(),
                    outputTokensPerSecond: z.number().optional(),
                    responseTimeMs: z.number().optional(),
                    stepTimeMs: z.number().optional(),
                    timeBetweenOutputChunksMs: z.object({
                        avg: z.number().optional(),
                        max: z.number().optional(),
                        median: z.number().optional(),
                        min: z.number().optional(),
                        p10: z.number().optional(),
                        p90: z.number().optional()
                    }).optional(),
                    timeToFirstOutputMs: z.number().optional(),
                    toolExecutionMaxMs: z.number().optional(),
                    toolExecutionMs: z.record(z.string(), z.number()).optional(),
                    toolExecutionTotalMs: z.number().optional()
                }).optional(),
                provider: z.string().max(200).optional(),
                qaPairId: z.string().max(64).optional(),
                reasoningTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                status: z.enum([
                    'success',
                    'error',
                    'aborted'
                ]).optional(),
                stepCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                steps: z.array(z.object({
                    finishReason: z.string().max(200).optional(),
                    inputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    modelId: z.string().max(200).optional(),
                    outputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    performance: z.object({
                        effectiveOutputTokensPerSecond: z.number().optional(),
                        effectiveTotalTokensPerSecond: z.number().optional(),
                        inputTokensPerSecond: z.number().optional(),
                        outputTokensPerSecond: z.number().optional(),
                        responseTimeMs: z.number().optional(),
                        stepTimeMs: z.number().optional(),
                        timeBetweenOutputChunksMs: z.object({
                            avg: z.number().optional(),
                            max: z.number().optional(),
                            median: z.number().optional(),
                            min: z.number().optional(),
                            p10: z.number().optional(),
                            p90: z.number().optional()
                        }).optional(),
                        timeToFirstOutputMs: z.number().optional(),
                        toolExecutionMaxMs: z.number().optional(),
                        toolExecutionMs: z.record(z.string(), z.number()).optional(),
                        toolExecutionTotalMs: z.number().optional()
                    }).optional(),
                    provider: z.string().max(200).optional(),
                    rawFinishReason: z.string().max(200).optional(),
                    stepNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
                    toolCallCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    toolErrorCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    toolNames: z.array(z.string().max(200)).max(50).optional(),
                    toolResultCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                    totalTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional()
                })).max(50).optional(),
                superseded: z.object({
                    costUsd: z.number().gte(0).optional(),
                    count: z.int().gte(0).lte(9007199254740991),
                    inputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    outputTokens: z.int().gte(0).lte(9007199254740991).optional(),
                    totalTokens: z.int().gte(0).lte(9007199254740991).optional()
                }).optional(),
                textOutputTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                toolCallCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                toolErrorCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                toolResultCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
                totalTokens: z.int().gte(-9007199254740991).lte(9007199254740991).optional()
            }).nullish(),
            buttonReply: z.object({
                contextExternalMessageId: z.string().nullish(),
                description: z.string().nullish(),
                id: z.string(),
                inReplyToMessageId: z.string().nullish(),
                kind: z.enum([
                    'interactive_button',
                    'interactive_list',
                    'template_button'
                ]),
                title: z.string()
            }).nullish(),
            channel: z.enum([
                'whatsapp',
                'sms',
                'email',
                'telegram',
                'instagram',
                'x',
                'messenger',
                'system_agent'
            ]).nullish(),
            conversationId: z.string().max(200).nullish(),
            deliveryStatus: z.enum([
                'pending',
                'sending',
                'sent',
                'delivered',
                'read',
                'failed'
            ]).nullish(),
            externalMessageId: z.string().max(255).nullish(),
            id: z.string().max(200).nullish(),
            instagram: z.object({
                attachmentType: z.string().nullish(),
                isEcho: z.boolean().nullish(),
                isUnsupported: z.boolean().nullish(),
                postbackPayload: z.string().nullish(),
                referralSource: z.string().nullish(),
                storyId: z.string().nullish(),
                type: z.string().min(1)
            }).nullish(),
            interactiveButtons: z.object({
                bodyText: z.string(),
                buttons: z.array(z.object({
                    id: z.string(),
                    title: z.string()
                })).min(1).max(3),
                footerText: z.string().nullish(),
                headerText: z.string().nullish()
            }).nullish(),
            message: z.string().max(100000),
            parts: z.array(z.union([
                z.object({
                    text: z.string().max(100000),
                    type: z.enum(['text'])
                }),
                z.object({
                    text: z.string().max(100000),
                    type: z.enum(['reasoning'])
                }),
                z.object({
                    filename: z.string().nullish(),
                    id: z.string().nullish(),
                    mediaType: z.string().min(1),
                    size: z.int().lte(9007199254740991).nullish(),
                    type: z.enum(['file']),
                    url: z.string().min(1)
                }),
                z.object({
                    citationIndex: z.int().gte(0).lte(9007199254740991).nullish(),
                    source: z.object({
                        description: z.string().nullish(),
                        title: z.string().nullish(),
                        url: z.url()
                    }),
                    type: z.enum(['source'])
                }),
                z.object({
                    approval: z.object({
                        approved: z.boolean().nullish(),
                        id: z.string().max(200),
                        reason: z.string().max(1000).nullish()
                    }).nullish(),
                    errorText: z.string().nullish(),
                    input: z.unknown().optional(),
                    output: z.unknown().optional(),
                    selectedOptionId: z.string().max(256).nullish(),
                    state: z.enum([
                        'input-streaming',
                        'input-available',
                        'output-available',
                        'approval-requested',
                        'output-denied',
                        'approval-responded',
                        'output-error'
                    ]),
                    toolCallId: z.string(),
                    type: z.string()
                }),
                z.object({
                    approval: z.object({
                        approved: z.boolean().nullish(),
                        id: z.string().max(200),
                        reason: z.string().max(1000).nullish()
                    }).nullish(),
                    errorText: z.string().nullish(),
                    input: z.unknown().optional(),
                    output: z.unknown().optional(),
                    selectedOptionId: z.string().max(256).nullish(),
                    state: z.enum([
                        'input-streaming',
                        'input-available',
                        'output-available',
                        'approval-requested',
                        'output-denied',
                        'approval-responded',
                        'output-error'
                    ]),
                    toolCallId: z.string(),
                    toolName: z.string(),
                    type: z.enum(['dynamic-tool'])
                }),
                z.object({
                    data: z.object({
                        elapsedMs: z.int().gte(0).lte(9007199254740991).optional(),
                        id: z.string().min(1).max(64),
                        mode: z.enum(['4', '5']),
                        startedAt: z.string(),
                        status: z.enum([
                            'running',
                            'completed',
                            'failed'
                        ]),
                        steps: z.array(z.object({
                            evidenceCount: z.int().gte(0).lte(9007199254740991).optional(),
                            id: z.string().min(1).max(64),
                            kind: z.enum([
                                'research',
                                'draft',
                                'verify',
                                'revise'
                            ]),
                            loop: z.int().gte(1).lte(9).optional(),
                            problemCount: z.int().gte(0).lte(9007199254740991).optional(),
                            status: z.enum([
                                'pending',
                                'in-progress',
                                'completed',
                                'failed'
                            ]),
                            verdict: z.enum(['PASS', 'NEEDS_REVISION']).optional()
                        })).max(32),
                        workflow: z.enum(['rag-answer'])
                    }),
                    id: z.string().max(64).optional(),
                    type: z.enum(['data-agent-workflow'])
                })
            ])).max(100).nullish(),
            reactions: z.array(z.object({
                direction: z.enum(['INBOUND', 'OUTBOUND']),
                emoji: z.string().min(1),
                externalMessageId: z.string().nullish(),
                sentAt: z.string()
            })).max(2).nullish(),
            reasoning: z.string().max(100000).nullish(),
            reminder: z.object({
                content: z.string().nullable(),
                label: z.string().min(1).nullable(),
                language: z.string().min(1).nullable(),
                templateName: z.string().min(1).nullable()
            }).nullish(),
            replyTo: z.object({
                externalMessageId: z.string().nullish(),
                messageId: z.string().nullish(),
                preview: z.string().max(140),
                role: z.string().nullish()
            }).nullish(),
            role: z.enum([
                'user',
                'assistant',
                'secretary',
                'admin',
                'tool',
                'system'
            ]),
            sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            sources: z.array(z.object({
                description: z.string().max(2000).nullish(),
                title: z.string().max(500).nullish(),
                url: z.url().max(2048)
            })).max(20).nullish(),
            telegram: z.object({
                contact: z.object({
                    firstName: z.string(),
                    lastName: z.string().nullish(),
                    phoneNumber: z.string(),
                    userId: z.string().nullish()
                }).nullish(),
                deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
                editedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
                forward: z.object({
                    date: z.int().gte(0).lte(9007199254740991),
                    kind: z.string()
                }).nullish(),
                location: z.object({
                    latitude: z.number(),
                    longitude: z.number()
                }).nullish(),
                media: z.object({
                    duration: z.int().gte(0).lte(9007199254740991).nullish(),
                    emoji: z.string().nullish(),
                    filename: z.string().nullish(),
                    fileSize: z.int().gte(0).lte(9007199254740991).nullish(),
                    height: z.int().gte(0).lte(9007199254740991).nullish(),
                    kind: z.enum([
                        'image',
                        'document',
                        'video',
                        'animation',
                        'audio',
                        'voice',
                        'video_note',
                        'sticker'
                    ]),
                    mediaType: z.string().nullish(),
                    stickerSetName: z.string().nullish(),
                    width: z.int().gte(0).lte(9007199254740991).nullish()
                }).nullish(),
                mediaGroupId: z.string().nullish(),
                messageThreadId: z.string().nullish(),
                poll: z.object({
                    id: z.string(),
                    isClosed: z.boolean(),
                    options: z.array(z.object({
                        text: z.string(),
                        voterCount: z.int().gte(0).lte(9007199254740991)
                    })),
                    question: z.string()
                }).nullish(),
                quote: z.object({
                    position: z.int().gte(0).lte(9007199254740991),
                    text: z.string()
                }).nullish(),
                reactions: z.array(z.object({
                    customEmojiId: z.string().nullish(),
                    emoji: z.string().nullish(),
                    kind: z.enum([
                        'emoji',
                        'custom_emoji',
                        'paid'
                    ]),
                    totalCount: z.int().gte(0).lte(9007199254740991).nullish()
                })).nullish(),
                type: z.string().min(1),
                updateId: z.string().nullish(),
                venue: z.object({
                    address: z.string(),
                    location: z.object({
                        latitude: z.number(),
                        longitude: z.number()
                    }),
                    title: z.string()
                }).nullish()
            }).nullish(),
            tool_call: z.object({
                tool_args: z.record(z.string(), z.unknown()).nullish(),
                tool_call_id: z.string().max(200),
                tool_error: z.union([
                    z.string(),
                    z.record(z.string(), z.unknown())
                ]).nullish(),
                tool_name: z.string().max(200),
                tool_result: z.record(z.string(), z.unknown()).nullish()
            }).nullish(),
            toolInvocations: z.array(z.object({
                approval: z.object({
                    approved: z.boolean().nullish(),
                    id: z.string().max(200),
                    reason: z.string().max(1000).nullish()
                }).nullish(),
                errorText: z.string().max(1000).nullish(),
                input: z.unknown().optional(),
                output: z.unknown().optional(),
                selectedOptionId: z.string().max(256).nullish(),
                sequence: z.number().nullish(),
                state: z.enum([
                    'input-streaming',
                    'input-available',
                    'output-available',
                    'output-error',
                    'approval-requested',
                    'approval-responded',
                    'output-denied'
                ]),
                toolCallId: z.string().max(200),
                toolName: z.string().max(200)
            })).max(50).nullish(),
            x: z.object({
                attachmentType: z.string().nullish(),
                conversationId: z.string().max(128).nullish(),
                conversationKeyVersion: z.string().max(128).nullish(),
                encodedEvent: z.string().nullish(),
                eventType: z.string().nullish(),
                expiresAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
                reaction: z.object({
                    action: z.enum(['add', 'remove']),
                    emoji: z.string().min(1).max(32),
                    targetSequenceId: z.string().min(1).max(128)
                }).nullish(),
                recipientId: z.string().min(1),
                replyToSequenceId: z.string().max(128).nullish(),
                senderDisplayName: z.string().max(255).nullish(),
                senderUsername: z.string().max(64).nullish(),
                sequenceId: z.string().max(128).nullish(),
                sharedPostId: z.string().nullish(),
                stack: z.enum(['legacy_dm', 'x_chat']).nullish(),
                ttlMsec: z.int().lte(9007199254740991).nullish(),
                verified: z.boolean().nullish()
            }).nullish()
        })),
        nextCursor: z.string().nullish(),
        totalCount: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerMarkConversationReadResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        lastReadAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerRecordMessageResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        messageId: z.string().max(200),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerSearchMessagesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        matches: z.array(z.object({
            id: z.string(),
            occurrences: z.int().gte(1).lte(9007199254740991),
            sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        })),
        totalMessages: z.int().gte(0).lte(9007199254740991),
        totalOccurrences: z.int().gte(0).lte(9007199254740991),
        truncated: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerSendReactionBody = z.object({
    emoji: z.string().max(64),
    messageId: z.string().min(1).max(255)
});

export const zConversationsControllerSendReactionResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerSetArchivedBody = z.object({
    archived: z.boolean(),
    channel: z.enum([
        'whatsapp',
        'sms',
        'email',
        'telegram',
        'instagram',
        'x',
        'messenger',
        'system_agent'
    ]).optional()
});

export const zConversationsControllerSetArchivedResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        archived: z.boolean(),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerToggleAiResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        aiEnabled: z.boolean(),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zConversationsControllerUnassignLabelResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCreateBookingDto = z.object({
    eventDateTime: z.string(),
    eventTypeId: z.string(),
    hijri: z.boolean().optional(),
    language: z.enum(['ar', 'en']).optional(),
    phoneE164: z.string(),
    userName: z.string().min(2)
});

export const zCreateBookingResponseDto = z.object({
    endsAt: z.string().nullable(),
    eventDateTime: z.string(),
    eventId: z.string(),
    phoneE164: z.string().optional(),
    uid: z.string().nullable()
});

export const zCustomToolsControllerCreateBody = z.object({
    name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{2,63}$/),
    requiresApproval: z.boolean().optional(),
    target: z.enum([
        'assistant',
        'system-agent',
        'both'
    ]).optional(),
    whenToUse: z.string().min(1).max(4000)
});

export const zCustomToolsControllerCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        allowedResponsePaths: z.array(z.string().min(1).max(500)).max(200).nullable(),
        bodyTemplate: z.string().max(20000).nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdByUserId: z.string(),
        dataAccess: z.enum(['FULL', 'LIMITED']),
        enabled: z.boolean(),
        exampleResponse: z.unknown(),
        headers: z.array(z.object({
            key: z.string().min(1).max(200),
            secret: z.boolean().optional().default(false),
            value: z.string().max(2000)
        })).max(50),
        id: z.uuid().regex(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/),
        inputs: z.array(z.object({
            description: z.string().min(1).max(500),
            enumValues: z.array(z.string().min(1)).min(1).max(50).optional(),
            name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{0,63}$/),
            required: z.boolean().optional().default(true),
            type: z.enum([
                'text',
                'number',
                'boolean',
                'date'
            ])
        })).max(20),
        isComplete: z.boolean(),
        kind: z.enum(['server']),
        lastTestedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        method: z.enum([
            'GET',
            'POST',
            'PUT',
            'PATCH',
            'DELETE'
        ]).nullable(),
        name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{2,63}$/),
        orgId: z.string(),
        queryParams: z.array(z.object({
            key: z.string().min(1).max(200),
            value: z.string().max(2000)
        })).max(50),
        requiresApproval: z.boolean(),
        target: z.enum([
            'assistant',
            'system-agent',
            'both'
        ]).optional().default('assistant'),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        url: z.url().max(2000).regex(/^https:\/\/.*/).nullable(),
        whenToUse: z.string().min(1).max(4000)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCustomToolsControllerExportDefinitionResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        allowedResponsePaths: z.array(z.string().min(1).max(500)).max(200).nullable(),
        bodyTemplate: z.string().max(20000).nullable(),
        dataAccess: z.enum(['FULL', 'LIMITED']),
        exampleResponse: z.unknown(),
        headers: z.array(z.object({
            key: z.string().min(1).max(200),
            needsValue: z.boolean().optional(),
            secret: z.boolean().optional().default(false),
            value: z.string().max(2000)
        })).max(50),
        inputs: z.array(z.object({
            description: z.string().min(1).max(500),
            enumValues: z.array(z.string().min(1)).min(1).max(50).optional(),
            name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{0,63}$/),
            required: z.boolean().optional().default(true),
            type: z.enum([
                'text',
                'number',
                'boolean',
                'date'
            ])
        })).max(20),
        method: z.enum([
            'GET',
            'POST',
            'PUT',
            'PATCH',
            'DELETE'
        ]).nullable(),
        name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{2,63}$/),
        queryParams: z.array(z.object({
            key: z.string().min(1).max(200),
            value: z.string().max(2000)
        })).max(50),
        requiresApproval: z.boolean(),
        target: z.enum([
            'assistant',
            'system-agent',
            'both'
        ]).optional().default('assistant'),
        url: z.url().max(2000).regex(/^https:\/\/.*/).nullable(),
        version: z.literal(1),
        whenToUse: z.string().min(1).max(4000)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCustomToolsControllerGetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        allowedResponsePaths: z.array(z.string().min(1).max(500)).max(200).nullable(),
        bodyTemplate: z.string().max(20000).nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdByUserId: z.string(),
        dataAccess: z.enum(['FULL', 'LIMITED']),
        enabled: z.boolean(),
        exampleResponse: z.unknown(),
        headers: z.array(z.object({
            key: z.string().min(1).max(200),
            secret: z.boolean().optional().default(false),
            value: z.string().max(2000)
        })).max(50),
        id: z.uuid().regex(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/),
        inputs: z.array(z.object({
            description: z.string().min(1).max(500),
            enumValues: z.array(z.string().min(1)).min(1).max(50).optional(),
            name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{0,63}$/),
            required: z.boolean().optional().default(true),
            type: z.enum([
                'text',
                'number',
                'boolean',
                'date'
            ])
        })).max(20),
        isComplete: z.boolean(),
        kind: z.enum(['server']),
        lastTestedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        method: z.enum([
            'GET',
            'POST',
            'PUT',
            'PATCH',
            'DELETE'
        ]).nullable(),
        name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{2,63}$/),
        orgId: z.string(),
        queryParams: z.array(z.object({
            key: z.string().min(1).max(200),
            value: z.string().max(2000)
        })).max(50),
        requiresApproval: z.boolean(),
        target: z.enum([
            'assistant',
            'system-agent',
            'both'
        ]).optional().default('assistant'),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        url: z.url().max(2000).regex(/^https:\/\/.*/).nullable(),
        whenToUse: z.string().min(1).max(4000)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCustomToolsControllerImportDefinitionBody = z.object({
    allowedResponsePaths: z.array(z.string().min(1).max(500)).max(200).nullable(),
    bodyTemplate: z.string().max(20000).nullable(),
    dataAccess: z.enum(['FULL', 'LIMITED']),
    exampleResponse: z.unknown(),
    headers: z.array(z.object({
        key: z.string().min(1).max(200),
        needsValue: z.boolean().optional(),
        secret: z.boolean().optional().default(false),
        value: z.string().max(2000)
    })).max(50),
    inputs: z.array(z.object({
        description: z.string().min(1).max(500),
        enumValues: z.array(z.string().min(1)).min(1).max(50).optional(),
        name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{0,63}$/),
        required: z.boolean().optional().default(true),
        type: z.enum([
            'text',
            'number',
            'boolean',
            'date'
        ])
    })).max(20),
    method: z.enum([
        'GET',
        'POST',
        'PUT',
        'PATCH',
        'DELETE'
    ]).nullable(),
    name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{2,63}$/),
    queryParams: z.array(z.object({
        key: z.string().min(1).max(200),
        value: z.string().max(2000)
    })).max(50),
    requiresApproval: z.boolean(),
    target: z.enum([
        'assistant',
        'system-agent',
        'both'
    ]).optional().default('assistant'),
    url: z.url().max(2000).regex(/^https:\/\/.*/).nullable(),
    version: z.literal(1),
    whenToUse: z.string().min(1).max(4000)
});

export const zCustomToolsControllerImportDefinitionResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        allowedResponsePaths: z.array(z.string().min(1).max(500)).max(200).nullable(),
        bodyTemplate: z.string().max(20000).nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdByUserId: z.string(),
        dataAccess: z.enum(['FULL', 'LIMITED']),
        enabled: z.boolean(),
        exampleResponse: z.unknown(),
        headers: z.array(z.object({
            key: z.string().min(1).max(200),
            secret: z.boolean().optional().default(false),
            value: z.string().max(2000)
        })).max(50),
        id: z.uuid().regex(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/),
        inputs: z.array(z.object({
            description: z.string().min(1).max(500),
            enumValues: z.array(z.string().min(1)).min(1).max(50).optional(),
            name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{0,63}$/),
            required: z.boolean().optional().default(true),
            type: z.enum([
                'text',
                'number',
                'boolean',
                'date'
            ])
        })).max(20),
        isComplete: z.boolean(),
        kind: z.enum(['server']),
        lastTestedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        method: z.enum([
            'GET',
            'POST',
            'PUT',
            'PATCH',
            'DELETE'
        ]).nullable(),
        name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{2,63}$/),
        orgId: z.string(),
        queryParams: z.array(z.object({
            key: z.string().min(1).max(200),
            value: z.string().max(2000)
        })).max(50),
        requiresApproval: z.boolean(),
        target: z.enum([
            'assistant',
            'system-agent',
            'both'
        ]).optional().default('assistant'),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        url: z.url().max(2000).regex(/^https:\/\/.*/).nullable(),
        whenToUse: z.string().min(1).max(4000)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCustomToolsControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.array(z.object({
        allowedResponsePaths: z.array(z.string().min(1).max(500)).max(200).nullable(),
        bodyTemplate: z.string().max(20000).nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdByUserId: z.string(),
        dataAccess: z.enum(['FULL', 'LIMITED']),
        enabled: z.boolean(),
        exampleResponse: z.unknown(),
        headers: z.array(z.object({
            key: z.string().min(1).max(200),
            secret: z.boolean().optional().default(false),
            value: z.string().max(2000)
        })).max(50),
        id: z.uuid().regex(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/),
        inputs: z.array(z.object({
            description: z.string().min(1).max(500),
            enumValues: z.array(z.string().min(1)).min(1).max(50).optional(),
            name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{0,63}$/),
            required: z.boolean().optional().default(true),
            type: z.enum([
                'text',
                'number',
                'boolean',
                'date'
            ])
        })).max(20),
        isComplete: z.boolean(),
        kind: z.enum(['server']),
        lastTestedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        method: z.enum([
            'GET',
            'POST',
            'PUT',
            'PATCH',
            'DELETE'
        ]).nullable(),
        name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{2,63}$/),
        orgId: z.string(),
        queryParams: z.array(z.object({
            key: z.string().min(1).max(200),
            value: z.string().max(2000)
        })).max(50),
        requiresApproval: z.boolean(),
        target: z.enum([
            'assistant',
            'system-agent',
            'both'
        ]).optional().default('assistant'),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        url: z.url().max(2000).regex(/^https:\/\/.*/).nullable(),
        whenToUse: z.string().min(1).max(4000)
    })).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCustomToolsControllerQuotaResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        enabledCount: z.number(),
        limit: z.number(),
        plan: z.enum([
            'chat',
            'standard',
            'premium'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCustomToolsControllerRemoveResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        allowedResponsePaths: z.array(z.string().min(1).max(500)).max(200).nullable(),
        bodyTemplate: z.string().max(20000).nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdByUserId: z.string(),
        dataAccess: z.enum(['FULL', 'LIMITED']),
        enabled: z.boolean(),
        exampleResponse: z.unknown(),
        headers: z.array(z.object({
            key: z.string().min(1).max(200),
            secret: z.boolean().optional().default(false),
            value: z.string().max(2000)
        })).max(50),
        id: z.uuid().regex(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/),
        inputs: z.array(z.object({
            description: z.string().min(1).max(500),
            enumValues: z.array(z.string().min(1)).min(1).max(50).optional(),
            name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{0,63}$/),
            required: z.boolean().optional().default(true),
            type: z.enum([
                'text',
                'number',
                'boolean',
                'date'
            ])
        })).max(20),
        isComplete: z.boolean(),
        kind: z.enum(['server']),
        lastTestedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        method: z.enum([
            'GET',
            'POST',
            'PUT',
            'PATCH',
            'DELETE'
        ]).nullable(),
        name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{2,63}$/),
        orgId: z.string(),
        queryParams: z.array(z.object({
            key: z.string().min(1).max(200),
            value: z.string().max(2000)
        })).max(50),
        requiresApproval: z.boolean(),
        target: z.enum([
            'assistant',
            'system-agent',
            'both'
        ]).optional().default('assistant'),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        url: z.url().max(2000).regex(/^https:\/\/.*/).nullable(),
        whenToUse: z.string().min(1).max(4000)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCustomToolsControllerSetEnabledBody = z.object({
    enabled: z.boolean()
});

export const zCustomToolsControllerSetEnabledResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        allowedResponsePaths: z.array(z.string().min(1).max(500)).max(200).nullable(),
        bodyTemplate: z.string().max(20000).nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdByUserId: z.string(),
        dataAccess: z.enum(['FULL', 'LIMITED']),
        enabled: z.boolean(),
        exampleResponse: z.unknown(),
        headers: z.array(z.object({
            key: z.string().min(1).max(200),
            secret: z.boolean().optional().default(false),
            value: z.string().max(2000)
        })).max(50),
        id: z.uuid().regex(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/),
        inputs: z.array(z.object({
            description: z.string().min(1).max(500),
            enumValues: z.array(z.string().min(1)).min(1).max(50).optional(),
            name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{0,63}$/),
            required: z.boolean().optional().default(true),
            type: z.enum([
                'text',
                'number',
                'boolean',
                'date'
            ])
        })).max(20),
        isComplete: z.boolean(),
        kind: z.enum(['server']),
        lastTestedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        method: z.enum([
            'GET',
            'POST',
            'PUT',
            'PATCH',
            'DELETE'
        ]).nullable(),
        name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{2,63}$/),
        orgId: z.string(),
        queryParams: z.array(z.object({
            key: z.string().min(1).max(200),
            value: z.string().max(2000)
        })).max(50),
        requiresApproval: z.boolean(),
        target: z.enum([
            'assistant',
            'system-agent',
            'both'
        ]).optional().default('assistant'),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        url: z.url().max(2000).regex(/^https:\/\/.*/).nullable(),
        whenToUse: z.string().min(1).max(4000)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCustomToolsControllerTestBody = z.object({
    sampleInputs: z.record(z.string(), z.unknown())
});

export const zCustomToolsControllerTestResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        bytes: z.number().optional(),
        durationMs: z.number().optional(),
        error: z.string().optional(),
        ok: z.boolean(),
        response: z.unknown().optional(),
        status: z.number().optional(),
        suggestedPaths: z.array(z.string()).optional()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zCustomToolsControllerUpdateBody = z.object({
    allowedResponsePaths: z.array(z.string().min(1).max(500)).max(200).nullish(),
    bodyTemplate: z.string().max(20000).nullish(),
    dataAccess: z.enum(['FULL', 'LIMITED']).optional(),
    exampleResponse: z.unknown().optional(),
    headers: z.array(z.object({
        key: z.string().min(1).max(200),
        secret: z.boolean().optional().default(false),
        value: z.string().max(2000)
    })).max(50).optional(),
    inputs: z.array(z.object({
        description: z.string().min(1).max(500),
        enumValues: z.array(z.string().min(1)).min(1).max(50).optional(),
        name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{0,63}$/),
        required: z.boolean().optional().default(true),
        type: z.enum([
            'text',
            'number',
            'boolean',
            'date'
        ])
    })).max(20).optional(),
    method: z.enum([
        'GET',
        'POST',
        'PUT',
        'PATCH',
        'DELETE'
    ]).nullish(),
    name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{2,63}$/).optional(),
    queryParams: z.array(z.object({
        key: z.string().min(1).max(200),
        value: z.string().max(2000)
    })).max(50).optional(),
    requiresApproval: z.boolean().optional(),
    target: z.enum([
        'assistant',
        'system-agent',
        'both'
    ]).optional(),
    url: z.url().max(2000).regex(/^https:\/\/.*/).nullish(),
    whenToUse: z.string().min(1).max(4000).optional()
});

export const zCustomToolsControllerUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        allowedResponsePaths: z.array(z.string().min(1).max(500)).max(200).nullable(),
        bodyTemplate: z.string().max(20000).nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdByUserId: z.string(),
        dataAccess: z.enum(['FULL', 'LIMITED']),
        enabled: z.boolean(),
        exampleResponse: z.unknown(),
        headers: z.array(z.object({
            key: z.string().min(1).max(200),
            secret: z.boolean().optional().default(false),
            value: z.string().max(2000)
        })).max(50),
        id: z.uuid().regex(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/),
        inputs: z.array(z.object({
            description: z.string().min(1).max(500),
            enumValues: z.array(z.string().min(1)).min(1).max(50).optional(),
            name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{0,63}$/),
            required: z.boolean().optional().default(true),
            type: z.enum([
                'text',
                'number',
                'boolean',
                'date'
            ])
        })).max(20),
        isComplete: z.boolean(),
        kind: z.enum(['server']),
        lastTestedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        method: z.enum([
            'GET',
            'POST',
            'PUT',
            'PATCH',
            'DELETE'
        ]).nullable(),
        name: z.string().regex(/^[a-zA-Z][a-zA-Z0-9_]{2,63}$/),
        orgId: z.string(),
        queryParams: z.array(z.object({
            key: z.string().min(1).max(200),
            value: z.string().max(2000)
        })).max(50),
        requiresApproval: z.boolean(),
        target: z.enum([
            'assistant',
            'system-agent',
            'both'
        ]).optional().default('assistant'),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        url: z.url().max(2000).regex(/^https:\/\/.*/).nullable(),
        whenToUse: z.string().min(1).max(4000)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zDashboardControllerGetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        _isMockData: z.boolean().nullish(),
        aiAssistant: z.object({
            actions: z.array(z.object({
                count: z.int().gte(0).lte(9007199254740991),
                errorCount: z.int().gte(0).lte(9007199254740991),
                tool: z.string()
            })),
            costPerAiEventUsd: z.number().gte(0).nullable(),
            coverage: z.object({
                generations: z.int().gte(0).lte(9007199254740991),
                missingCount: z.int().gte(0).lte(9007199254740991)
            }),
            knowledgeBase: z.object({
                answeredShare: z.number().gte(0).lte(1),
                generationsWithKnowledgeBase: z.int().gte(0).lte(9007199254740991),
                topDocuments: z.array(z.object({
                    citations: z.int().gte(0).lte(9007199254740991),
                    documentId: z.string(),
                    title: z.string()
                }))
            }),
            totalCostUsd: z.number().gte(0)
        }).nullish(),
        aiStats: z.object({
            aiCreatedEvents: z.int().gte(0).lte(9007199254740991),
            aiCreatedShare: z.number().gte(0).lte(100),
            assistantMessages: z.int().gte(0).lte(9007199254740991),
            externalCreatedEvents: z.int().gte(0).lte(9007199254740991),
            inboundMessages: z.int().gte(0).lte(9007199254740991),
            memberCreatedEvents: z.int().gte(0).lte(9007199254740991),
            totalEvents: z.int().gte(0).lte(9007199254740991),
            unattributedEvents: z.int().gte(0).lte(9007199254740991)
        }).nullish(),
        avgEventsPerType: z.array(z.object({
            avgPerUser: z.number(),
            total: z.number(),
            type: z.string()
        })),
        captureSummary: z.object({
            leadsCollected: z.number(),
            negativeFeedback: z.number(),
            neutralFeedback: z.number(),
            positiveFeedback: z.number()
        }).nullish(),
        channelBreakdown: z.object({
            instagram: z.object({
                inboundMessages: z.int().gte(0).lte(9007199254740991),
                outboundMessages: z.int().gte(0).lte(9007199254740991),
                totalConversations: z.int().gte(0).lte(9007199254740991),
                totalMessages: z.int().gte(0).lte(9007199254740991)
            }),
            telegram: z.object({
                inboundMessages: z.int().gte(0).lte(9007199254740991),
                outboundMessages: z.int().gte(0).lte(9007199254740991),
                totalConversations: z.int().gte(0).lte(9007199254740991),
                totalMessages: z.int().gte(0).lte(9007199254740991)
            }),
            whatsapp: z.object({
                inboundMessages: z.int().gte(0).lte(9007199254740991),
                outboundMessages: z.int().gte(0).lte(9007199254740991),
                totalConversations: z.int().gte(0).lte(9007199254740991),
                totalMessages: z.int().gte(0).lte(9007199254740991)
            }),
            x: z.object({
                inboundMessages: z.int().gte(0).lte(9007199254740991),
                outboundMessages: z.int().gte(0).lte(9007199254740991),
                totalConversations: z.int().gte(0).lte(9007199254740991),
                totalMessages: z.int().gte(0).lte(9007199254740991)
            })
        }),
        conversationAnalysis: z.object({
            avgMessagesPerConversation: z.number(),
            avgResponseMinutes: z.number().nullish(),
            avgResponseTimeSeconds: z.number(),
            maxMessagesPerConversation: z.number().nullish(),
            maxResponseMinutes: z.number().nullish(),
            medianMessagesPerConversation: z.number().nullish(),
            medianResponseMinutes: z.number().nullish(),
            resolutionRate: z.number().nullable(),
            responseSamples: z.number().nullish(),
            totalConversations: z.number()
        }),
        dailyTrends: z.array(z.object({
            activeBookingCustomers: z.number(),
            bookingCustomers: z.number(),
            cancellations: z.number().nullish(),
            date: z.string(),
            events: z.number(),
            messages: z.number(),
            modifications: z.number().nullish()
        })),
        dayOfWeekData: z.array(z.object({
            day: z.string(),
            dayIndex: z.number(),
            events: z.number(),
            messages: z.number()
        })),
        funnelData: z.array(z.object({
            count: z.number(),
            percentage: z.number(),
            stage: z.string()
        })),
        messageHeatmap: z.array(z.array(z.number())),
        monthlyTrends: z.array(z.object({
            events: z.number(),
            messages: z.number(),
            month: z.string(),
            users: z.number()
        })),
        operationOrigin: z.object({
            aiByModel: z.array(z.object({
                count: z.int().gte(0).lte(9007199254740991),
                modelId: z.string()
            })).optional(),
            aiOperations: z.int().gte(0).lte(9007199254740991),
            aiShare: z.number().gte(0).lte(100),
            externalOperations: z.int().gte(0).lte(9007199254740991).optional(),
            memberOperations: z.int().gte(0).lte(9007199254740991),
            memberShare: z.number().gte(0).lte(100),
            totalOperations: z.int().gte(0).lte(9007199254740991),
            unattributedOperations: z.int().gte(0).lte(9007199254740991).optional()
        }),
        outcomes: z.object({
            containment: z.object({
                aiEngagedConversations: z.int().gt(0).lte(9007199254740991),
                comparison: z.object({
                    delta: z.number().nullable(),
                    direction: z.enum([
                        'improved',
                        'worsened',
                        'flat'
                    ]).nullable(),
                    previousValue: z.number().gte(0).nullable()
                }),
                handoffRequestedConversations: z.int().gte(0).lte(9007199254740991),
                rate: z.number().gte(0).lte(100)
            }).nullable(),
            noShow: z.object({
                byEventType: z.array(z.object({
                    completed: z.int().gte(0).lte(9007199254740991),
                    eventType: z.string().min(1),
                    noShows: z.int().gte(0).lte(9007199254740991),
                    rate: z.number().gte(0).lte(100),
                    resolved: z.int().gt(0).lte(9007199254740991)
                })),
                comparison: z.object({
                    delta: z.number().nullable(),
                    direction: z.enum([
                        'improved',
                        'worsened',
                        'flat'
                    ]).nullable(),
                    previousValue: z.number().gte(0).nullable()
                }),
                completed: z.int().gte(0).lte(9007199254740991),
                noShows: z.int().gte(0).lte(9007199254740991),
                rate: z.number().gte(0).lte(100),
                resolved: z.int().gt(0).lte(9007199254740991)
            }).nullable(),
            timeToBooking: z.object({
                comparison: z.object({
                    delta: z.number().nullable(),
                    direction: z.enum([
                        'improved',
                        'worsened',
                        'flat'
                    ]).nullable(),
                    previousValue: z.number().gte(0).nullable()
                }),
                medianMinutes: z.number().gte(0),
                sampleCount: z.int().gt(0).lte(9007199254740991)
            }).nullable()
        }),
        prometheusMetrics: z.string(),
        stats: z.object({
            activeUsers: z.object({
                change: z.number(),
                changePercent: z.number(),
                value: z.number()
            }),
            avgFollowups: z.number().nullish(),
            avgResponseTime: z.object({
                change: z.number(),
                changePercent: z.number(),
                value: z.number()
            }),
            cancelledEvents: z.object({
                change: z.number(),
                changePercent: z.number(),
                value: z.number()
            }),
            conversionRate: z.object({
                change: z.number(),
                changePercent: z.number(),
                value: z.number()
            }),
            returningRate: z.number().nullish(),
            returningUsers: z.number().nullish(),
            totalCancellations: z.number().nullish(),
            totalEvents: z.object({
                change: z.number(),
                changePercent: z.number(),
                value: z.number()
            }),
            totalMessages: z.object({
                change: z.number(),
                changePercent: z.number(),
                value: z.number()
            }),
            totalUsers: z.object({
                change: z.number(),
                changePercent: z.number(),
                value: z.number()
            }),
            trends: z.object({
                avgFollowups: z.object({
                    direction: z.enum([
                        'up',
                        'down',
                        'flat'
                    ]).nullish(),
                    percentage: z.number().nullish()
                }).nullish(),
                avgResponseTime: z.object({
                    direction: z.enum([
                        'up',
                        'down',
                        'flat'
                    ]).nullish(),
                    percentage: z.number().nullish()
                }).nullish(),
                cancellations: z.object({
                    direction: z.enum([
                        'up',
                        'down',
                        'flat'
                    ]).nullish(),
                    percentage: z.number().nullish()
                }).nullish(),
                conversionRate: z.object({
                    direction: z.enum([
                        'up',
                        'down',
                        'flat'
                    ]).nullish(),
                    percentage: z.number().nullish()
                }).nullish(),
                totalEvents: z.object({
                    direction: z.enum([
                        'up',
                        'down',
                        'flat'
                    ]).nullish(),
                    percentage: z.number().nullish()
                }).nullish(),
                uniqueUsers: z.object({
                    direction: z.enum([
                        'up',
                        'down',
                        'flat'
                    ]).nullish(),
                    percentage: z.number().nullish()
                }).nullish()
            }).nullish(),
            uniqueUsers: z.number().nullish(),
            upcomingEvents: z.object({
                change: z.number(),
                changePercent: z.number(),
                value: z.number()
            })
        }),
        statusDistribution: z.array(z.object({
            color: z.string(),
            count: z.int().gte(0).lte(9007199254740991),
            label: z.string(),
            status: z.string()
        })),
        timeSlots: z.record(z.string(), z.number()),
        topUsers: z.array(z.object({
            address: z.string(),
            channel: z.enum([
                'whatsapp',
                'telegram',
                'instagram',
                'x'
            ]),
            eventCount: z.number(),
            lastActive: z.string().nullable(),
            messageCount: z.number(),
            name: z.string().nullable(),
            phone: z.string().nullable(),
            userId: z.string()
        })),
        typeDistribution: z.record(z.string(), z.number()),
        userSegments: z.array(z.object({
            count: z.number(),
            percentage: z.number(),
            segment: z.string()
        })),
        wordFrequency: z.array(z.object({
            count: z.number(),
            word: z.string()
        })),
        wordFrequencyByRole: z.record(z.string(), z.array(z.object({
            count: z.number(),
            word: z.string()
        }))).nullish()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zDocumentsControllerRecordMetricEventBody = z.object({
    event: z.enum([
        'connection_lost_while_dirty',
        'recovery_from_local_storage',
        'recovery_from_trash'
    ])
});

export const zDocumentsControllerRecordMetricEventResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zDocumentsControllerSyncManifestResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            hasDocument: z.boolean(),
            name: z.string().nullable(),
            phoneE164: z.string(),
            updatedAt: z.string(),
            version: z.int().gte(0).lte(9007199254740991)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEmailTemplatesControllerCancelScheduledResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEmailTemplatesControllerCreateBody = z.object({
    bodyHtml: z.string().min(1),
    name: z.string().min(1).max(200),
    subject: z.string().min(1).max(500),
    variables: z.array(z.object({
        key: z.string().max(64),
        label: z.string().max(128)
    })).optional().default([])
});

export const zEmailTemplatesControllerCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        bodyHtml: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdBy: z.string(),
        id: z.string(),
        name: z.string().max(200),
        orgId: z.string(),
        subject: z.string().max(500),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        variables: z.array(z.object({
            key: z.string().max(64),
            label: z.string().max(128)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEmailTemplatesControllerDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEmailTemplatesControllerGetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        bodyHtml: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdBy: z.string(),
        id: z.string(),
        name: z.string().max(200),
        orgId: z.string(),
        subject: z.string().max(500),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        variables: z.array(z.object({
            key: z.string().max(64),
            label: z.string().max(128)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEmailTemplatesControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.array(z.object({
        bodyHtml: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdBy: z.string(),
        id: z.string(),
        name: z.string().max(200),
        orgId: z.string(),
        subject: z.string().max(500),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        variables: z.array(z.object({
            key: z.string().max(64),
            label: z.string().max(128)
        }))
    })).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEmailTemplatesControllerListScheduledResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.array(z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdBy: z.string(),
        cronPattern: z.string().nullish(),
        error: z.string().nullish(),
        extraData: z.record(z.string(), z.string()).nullish(),
        id: z.string(),
        orgId: z.string(),
        recipientIds: z.array(z.string()),
        scheduledAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
        status: z.enum([
            'pending',
            'sent',
            'failed',
            'cancelled'
        ]),
        templateId: z.string(),
        templateName: z.string().nullish()
    })).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEmailTemplatesControllerScheduleBody = z.object({
    cronPattern: z.string().max(128).optional(),
    extraData: z.record(z.string(), z.string()).optional(),
    recipientIds: z.array(z.string()).min(1).max(10000),
    scheduledAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    templateId: z.string()
});

export const zEmailTemplatesControllerScheduleResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdBy: z.string(),
        cronPattern: z.string().nullish(),
        error: z.string().nullish(),
        extraData: z.record(z.string(), z.string()).nullish(),
        id: z.string(),
        orgId: z.string(),
        recipientIds: z.array(z.string()),
        scheduledAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        sentAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
        status: z.enum([
            'pending',
            'sent',
            'failed',
            'cancelled'
        ]),
        templateId: z.string(),
        templateName: z.string().nullish()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEmailTemplatesControllerSendBody = z.object({
    extraData: z.record(z.string(), z.string()).optional(),
    recipientIds: z.array(z.string()).min(1).max(10000),
    templateId: z.string()
});

export const zEmailTemplatesControllerSendResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        failed: z.int().gte(-9007199254740991).lte(9007199254740991),
        sent: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEmailTemplatesControllerUpdateBody = z.object({
    bodyHtml: z.string().min(1),
    name: z.string().min(1).max(200),
    subject: z.string().min(1).max(500),
    variables: z.array(z.object({
        key: z.string().max(64),
        label: z.string().max(128)
    })).optional().default([])
});

export const zEmailTemplatesControllerUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        bodyHtml: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        createdBy: z.string(),
        id: z.string(),
        name: z.string().max(200),
        orgId: z.string(),
        subject: z.string().max(500),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        variables: z.array(z.object({
            key: z.string().max(64),
            label: z.string().max(128)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerCancelResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        cancelled: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerCompleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        completed: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerCountByTypeBody = z.object({
    types: z.array(z.string().min(1).max(100)).max(50).optional()
});

export const zEventsControllerCountByTypeResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        counts: z.record(z.string(), z.number())
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerCreateBody = z.object({
    beneficiaryContactId: z.string().min(1).optional(),
    beneficiaryName: z.string().min(2).max(200).optional(),
    contactId: z.string().min(1).optional(),
    endsAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    eventDateTime: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    hijri: z.boolean().optional(),
    language: z.enum(['ar', 'en']).optional(),
    phoneE164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).optional(),
    source: z.enum(['local', 'external_user']).optional(),
    type: z.string().min(1).max(100),
    userName: z.string().min(1).max(200).optional()
});

export const zEventsControllerCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        contactId: z.string().min(1),
        eventDateTime: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        eventId: z.string(),
        phoneE164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).optional(),
        status: z.string().min(1).max(64).regex(/^[A-Z][A-Z0-9_]*$/).optional()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerFindUpcomingResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        eventId: z.string().nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerGetAvailableSlotsBody = z.object({
    dates: z.array(z.string().regex(/^\d{4}-\d{2}-\d{2}$/)).min(1).max(90),
    hijri: z.boolean().optional()
});

export const zEventsControllerGetAvailableSlotsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        dates: z.array(z.object({
            date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
            time_slots: z.array(z.string())
        })),
        note: z.string().optional()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerGetByIdResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        cancelledAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        eventDateTime: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        id: z.string(),
        status: z.string().min(1).max(64).regex(/^[A-Z][A-Z0-9_]*$/),
        type: z.string(),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        userId: z.string().nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerGetByPhoneResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        events: z.array(z.object({
            cancelled: z.boolean(),
            contact_id: z.string().min(1).optional(),
            contactor_name: z.string().nullish(),
            customFieldValues: z.record(z.string(), z.unknown()).nullish(),
            endsAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
            eventDateTime: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            has_document: z.boolean(),
            id: z.string(),
            is_beneficiary: z.boolean().nullish(),
            phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).nullish(),
            status: z.string().min(1).max(64).regex(/^[A-Z][A-Z0-9_]*$/),
            type: z.string().min(1),
            user_id: z.string(),
            user_name: z.string().nullish()
        })),
        hasMore: z.boolean(),
        nextCursor: z.string().nullish(),
        total_count: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerGetHistoryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        entries: z.array(z.object({
            action: z.enum([
                'created',
                'rescheduled',
                'updated',
                'cancelled',
                'reinstated',
                'completed',
                'no_show'
            ]),
            actor: z.object({
                name: z.string().nullable(),
                source: z.string().nullable(),
                userId: z.string().nullable()
            }),
            changes: z.array(z.object({
                field: z.enum([
                    'eventDateTime',
                    'type',
                    'userName'
                ]),
                from: z.string().nullable(),
                to: z.string().nullable()
            })),
            eventDateTime: z.string().nullable(),
            id: z.string(),
            occurredAt: z.string()
        })),
        subject: z.object({
            contactId: z.string(),
            contactorContactId: z.string().nullable(),
            contactorName: z.string().nullable(),
            isBeneficiary: z.boolean(),
            name: z.string().nullable()
        }).nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerGetNotesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        customFieldValues: z.record(z.string(), z.unknown()).nullable(),
        eventId: z.string(),
        noteCanvas: z.record(z.string(), z.unknown()).nullable(),
        noteFields: z.record(z.string(), z.string().max(2000)).nullable(),
        notes: z.string().nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        events: z.array(z.object({
            cancelled: z.boolean(),
            contact_id: z.string().min(1).optional(),
            contactor_name: z.string().nullish(),
            customFieldValues: z.record(z.string(), z.unknown()).nullish(),
            endsAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
            eventDateTime: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            has_document: z.boolean(),
            id: z.string(),
            is_beneficiary: z.boolean().nullish(),
            phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).nullish(),
            status: z.string().min(1).max(64).regex(/^[A-Z][A-Z0-9_]*$/),
            type: z.string().min(1),
            user_id: z.string(),
            user_name: z.string().nullish()
        })),
        hasMore: z.boolean(),
        nextCursor: z.string().nullish(),
        total_count: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerModifyBody = z.object({
    approximate: z.boolean().optional(),
    bookingBeneficiaryContactId: z.string().min(1).optional(),
    bookingBeneficiaryName: z.string().min(2).max(200).optional(),
    bookingNewContactName: z.string().min(2).max(200).optional(),
    bookingPhoneE164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).optional(),
    contactId: z.string().min(1).optional(),
    newEndsAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    newEventDateTime: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    newName: z.string().max(200).optional(),
    newType: z.string().min(1).max(100).optional(),
    phoneE164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).optional(),
    previousPhoneE164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).optional()
});

export const zEventsControllerModifyResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        eventId: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerNoShowResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        markedNoShow: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerReinstateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        reinstated: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerUpdateNotesBody = z.object({
    customFieldValues: z.record(z.string(), z.unknown()).nullish(),
    noteCanvas: z.record(z.string(), z.unknown()).nullish(),
    noteFields: z.record(z.string(), z.string().max(2000)).nullish(),
    notes: z.string().max(20000).nullish()
});

export const zEventsControllerUpdateNotesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        customFieldValues: z.record(z.string(), z.unknown()).nullable(),
        eventId: z.string(),
        noteCanvas: z.record(z.string(), z.unknown()).nullable(),
        noteFields: z.record(z.string(), z.string().max(2000)).nullable(),
        notes: z.string().nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventsControllerUpdateStatusBody = z.object({
    status: z.string().min(1).max(64).regex(/^[A-Z][A-Z0-9_]*$/)
});

export const zEventStatusesControllerReorderBody = z.object({
    items: z.array(z.object({
        id: z.string().min(1),
        position: z.int().gte(0).lte(9007199254740991)
    }))
});

export const zEventStatusesControllerUpsertBody = z.object({
    color: z.string().regex(/^#[0-9a-fA-F]{6}$/),
    id: z.string().optional(),
    label: z.string().min(1).max(80),
    position: z.int().gte(0).lte(9007199254740991).optional(),
    slug: z.string().min(1).max(64).regex(/^[A-Z][A-Z0-9_]*$/).optional()
});

export const zEventTypeDto = z.object({
    afterBufferMinutes: z.number(),
    allowMultipleEventsPerDay: z.boolean(),
    allowMultipleFutureEvents: z.boolean(),
    approvalTtlHours: z.number().nullable(),
    beforeBufferMinutes: z.number(),
    bookingHorizonAgentDays: z.number().nullable(),
    bookingHorizonSecretaryDays: z.number().nullable(),
    colorBackground: z.string().nullable(),
    colorRing: z.string().nullable(),
    colorText: z.string().nullable(),
    createdAt: z.string().nullable(),
    deletedAt: z.string().nullable(),
    description: z.string().nullable(),
    durationMinutes: z.number(),
    durationStrategy: z.enum(['auto', 'manual']),
    id: z.string(),
    isActive: z.boolean(),
    kind: z.enum(['scheduled', 'conversation']),
    label: z.string(),
    maxFutureEventsPerType: z.number().nullable(),
    maxPerSlotAgent: z.number().nullable(),
    maxPerSlotSecretary: z.number().nullable(),
    maxSpanDays: z.number().nullable(),
    minimumBookingNotice: z.number(),
    orgId: z.string(),
    periodDays: z.number().nullable(),
    periodEndDate: z.string().nullable(),
    periodStartDate: z.string().nullable(),
    periodType: z.string(),
    position: z.number(),
    requiresApproval: z.boolean(),
    resourceMaxOccupancy: z.number().nullish(),
    resourceName: z.string().nullable(),
    schedulingType: z.string(),
    seatsPerTimeSlot: z.number().nullable(),
    slug: z.string(),
    updatedAt: z.string().nullable()
});

export const zEventTypesControllerDeactivateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        deactivated: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventTypesControllerFieldsAddBody = z.object({
    gridVisible: z.boolean().optional().default(true),
    gridWidth: z.int().gte(40).lte(1000).optional(),
    label: z.string().min(1).max(200),
    name: z.string().min(1).max(60).regex(/^[a-z][a-z0-9_]*$/),
    options: z.array(z.object({
        i18nKey: z.string().max(200).optional(),
        label: z.string().min(1).max(200),
        value: z.string().min(1).max(100)
    })).optional(),
    position: z.int().gte(0).lte(9007199254740991).optional().default(0),
    required: z.boolean().optional().default(false),
    type: z.enum([
        'TEXT',
        'NUMBER',
        'DATE',
        'BOOL',
        'SELECT',
        'MULTI_SELECT'
    ]),
    validation: z.object({
        max: z.number().optional(),
        min: z.number().optional(),
        pattern: z.string().max(500).optional(),
        step: z.number().optional()
    }).optional()
});

export const zEventTypesControllerFieldsAddResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        eventTypeId: z.string(),
        gridVisible: z.boolean(),
        gridWidth: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
        id: z.string(),
        label: z.string(),
        name: z.string(),
        options: z.array(z.object({
            i18nKey: z.string().max(200).optional(),
            label: z.string().min(1).max(200),
            value: z.string().min(1).max(100)
        })).nullable(),
        orgId: z.string(),
        position: z.int().gte(-9007199254740991).lte(9007199254740991),
        required: z.boolean(),
        type: z.enum([
            'TEXT',
            'NUMBER',
            'DATE',
            'BOOL',
            'SELECT',
            'MULTI_SELECT'
        ]),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        validation: z.object({
            max: z.number().optional(),
            min: z.number().optional(),
            pattern: z.string().max(500).optional(),
            step: z.number().optional()
        }).nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventTypesControllerFieldsListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        fields: z.array(z.object({
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            eventTypeId: z.string(),
            gridVisible: z.boolean(),
            gridWidth: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
            id: z.string(),
            label: z.string(),
            name: z.string(),
            options: z.array(z.object({
                i18nKey: z.string().max(200).optional(),
                label: z.string().min(1).max(200),
                value: z.string().min(1).max(100)
            })).nullable(),
            orgId: z.string(),
            position: z.int().gte(-9007199254740991).lte(9007199254740991),
            required: z.boolean(),
            type: z.enum([
                'TEXT',
                'NUMBER',
                'DATE',
                'BOOL',
                'SELECT',
                'MULTI_SELECT'
            ]),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            validation: z.object({
                max: z.number().optional(),
                min: z.number().optional(),
                pattern: z.string().max(500).optional(),
                step: z.number().optional()
            }).nullable()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventTypesControllerFieldsRemoveResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        removed: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventTypesControllerFieldsReorderBody = z.object({
    items: z.array(z.object({
        fieldId: z.string().min(1),
        position: z.int().gte(0).lte(9007199254740991)
    })).max(100)
});

export const zEventTypesControllerFieldsReorderResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        reordered: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventTypesControllerFieldsUpdateBody = z.object({
    gridVisible: z.boolean().optional().default(true),
    gridWidth: z.int().gte(40).lte(1000).optional(),
    label: z.string().min(1).max(200).optional(),
    name: z.string().min(1).max(60).regex(/^[a-z][a-z0-9_]*$/).optional(),
    options: z.array(z.object({
        i18nKey: z.string().max(200).optional(),
        label: z.string().min(1).max(200),
        value: z.string().min(1).max(100)
    })).optional(),
    position: z.int().gte(0).lte(9007199254740991).optional().default(0),
    required: z.boolean().optional().default(false),
    type: z.enum([
        'TEXT',
        'NUMBER',
        'DATE',
        'BOOL',
        'SELECT',
        'MULTI_SELECT'
    ]).optional(),
    validation: z.object({
        max: z.number().optional(),
        min: z.number().optional(),
        pattern: z.string().max(500).optional(),
        step: z.number().optional()
    }).optional()
});

export const zEventTypesControllerFieldsUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        eventTypeId: z.string(),
        gridVisible: z.boolean(),
        gridWidth: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
        id: z.string(),
        label: z.string(),
        name: z.string(),
        options: z.array(z.object({
            i18nKey: z.string().max(200).optional(),
            label: z.string().min(1).max(200),
            value: z.string().min(1).max(100)
        })).nullable(),
        orgId: z.string(),
        position: z.int().gte(-9007199254740991).lte(9007199254740991),
        required: z.boolean(),
        type: z.enum([
            'TEXT',
            'NUMBER',
            'DATE',
            'BOOL',
            'SELECT',
            'MULTI_SELECT'
        ]),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        validation: z.object({
            max: z.number().optional(),
            min: z.number().optional(),
            pattern: z.string().max(500).optional(),
            step: z.number().optional()
        }).nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventTypesControllerGetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        afterBufferMinutes: z.int().gte(0).lte(9007199254740991),
        allowMultipleEventsPerDay: z.boolean(),
        allowMultipleFutureEvents: z.boolean(),
        approvalTtlHours: z.int().gte(1).lte(9007199254740991).nullable(),
        beforeBufferMinutes: z.int().gte(0).lte(9007199254740991),
        bookingHorizonAgentDays: z.int().gte(1).lte(9007199254740991).nullable(),
        bookingHorizonSecretaryDays: z.int().gte(1).lte(9007199254740991).nullable(),
        bookingLimits: z.record(z.string(), z.unknown()).nullable(),
        colorBackground: z.string().nullable(),
        colorRing: z.string().nullable(),
        colorText: z.string().nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        description: z.string().max(2000).nullable(),
        durationMinutes: z.int().gte(1).lte(1440),
        durationStrategy: z.enum(['auto', 'manual']),
        fieldDefinitions: z.array(z.object({
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            eventTypeId: z.string(),
            gridVisible: z.boolean(),
            gridWidth: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
            id: z.string(),
            label: z.string(),
            name: z.string(),
            options: z.array(z.object({
                i18nKey: z.string().max(200).optional(),
                label: z.string().min(1).max(200),
                value: z.string().min(1).max(100)
            })).nullable(),
            orgId: z.string(),
            position: z.int().gte(-9007199254740991).lte(9007199254740991),
            required: z.boolean(),
            type: z.enum([
                'TEXT',
                'NUMBER',
                'DATE',
                'BOOL',
                'SELECT',
                'MULTI_SELECT'
            ]),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            validation: z.object({
                max: z.number().optional(),
                min: z.number().optional(),
                pattern: z.string().max(500).optional(),
                step: z.number().optional()
            }).nullable()
        })).optional(),
        id: z.string(),
        isActive: z.boolean(),
        kind: z.enum(['scheduled', 'conversation']),
        label: z.string(),
        maxFutureEventsPerType: z.int().gte(1).lte(20).nullable(),
        maxPerSlotAgent: z.int().gte(1).lte(9007199254740991).nullable(),
        maxPerSlotSecretary: z.int().gte(1).lte(9007199254740991).nullable(),
        maxSpanDays: z.int().gte(1).lte(732).nullable(),
        metadata: z.record(z.string(), z.unknown()).nullable(),
        minimumBookingNotice: z.int().gte(0).lte(9007199254740991),
        orgId: z.string(),
        periodDays: z.int().gte(0).lte(9007199254740991).nullable(),
        periodEndDate: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        periodStartDate: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        periodType: z.enum([
            'UNLIMITED',
            'ROLLING',
            'RANGE',
            'FIXED_RANGE'
        ]),
        position: z.int().gte(-9007199254740991).lte(9007199254740991),
        recurringRule: z.record(z.string(), z.unknown()).nullable(),
        requiresApproval: z.boolean(),
        resourceMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish(),
        resourceName: z.string().min(1).max(60).nullable(),
        schedulingType: z.enum([
            'SOLO',
            'ROUND_ROBIN',
            'COLLECTIVE',
            'MANAGED'
        ]),
        seatsPerTimeSlot: z.int().gte(1).lte(9007199254740991).nullable(),
        slug: z.string().min(1).max(64).regex(/^[A-Z][A-Z0-9_]*$/),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventTypesControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        eventTypes: z.array(z.object({
            afterBufferMinutes: z.int().gte(0).lte(9007199254740991),
            allowMultipleEventsPerDay: z.boolean(),
            allowMultipleFutureEvents: z.boolean(),
            approvalTtlHours: z.int().gte(1).lte(9007199254740991).nullable(),
            beforeBufferMinutes: z.int().gte(0).lte(9007199254740991),
            bookingHorizonAgentDays: z.int().gte(1).lte(9007199254740991).nullable(),
            bookingHorizonSecretaryDays: z.int().gte(1).lte(9007199254740991).nullable(),
            bookingLimits: z.record(z.string(), z.unknown()).nullable(),
            colorBackground: z.string().nullable(),
            colorRing: z.string().nullable(),
            colorText: z.string().nullable(),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            description: z.string().max(2000).nullable(),
            durationMinutes: z.int().gte(1).lte(1440),
            durationStrategy: z.enum(['auto', 'manual']),
            fieldDefinitions: z.array(z.object({
                createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
                deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
                eventTypeId: z.string(),
                gridVisible: z.boolean(),
                gridWidth: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
                id: z.string(),
                label: z.string(),
                name: z.string(),
                options: z.array(z.object({
                    i18nKey: z.string().max(200).optional(),
                    label: z.string().min(1).max(200),
                    value: z.string().min(1).max(100)
                })).nullable(),
                orgId: z.string(),
                position: z.int().gte(-9007199254740991).lte(9007199254740991),
                required: z.boolean(),
                type: z.enum([
                    'TEXT',
                    'NUMBER',
                    'DATE',
                    'BOOL',
                    'SELECT',
                    'MULTI_SELECT'
                ]),
                updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
                validation: z.object({
                    max: z.number().optional(),
                    min: z.number().optional(),
                    pattern: z.string().max(500).optional(),
                    step: z.number().optional()
                }).nullable()
            })).optional(),
            id: z.string(),
            isActive: z.boolean(),
            kind: z.enum(['scheduled', 'conversation']),
            label: z.string(),
            maxFutureEventsPerType: z.int().gte(1).lte(20).nullable(),
            maxPerSlotAgent: z.int().gte(1).lte(9007199254740991).nullable(),
            maxPerSlotSecretary: z.int().gte(1).lte(9007199254740991).nullable(),
            maxSpanDays: z.int().gte(1).lte(732).nullable(),
            metadata: z.record(z.string(), z.unknown()).nullable(),
            minimumBookingNotice: z.int().gte(0).lte(9007199254740991),
            orgId: z.string(),
            periodDays: z.int().gte(0).lte(9007199254740991).nullable(),
            periodEndDate: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            periodStartDate: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            periodType: z.enum([
                'UNLIMITED',
                'ROLLING',
                'RANGE',
                'FIXED_RANGE'
            ]),
            position: z.int().gte(-9007199254740991).lte(9007199254740991),
            recurringRule: z.record(z.string(), z.unknown()).nullable(),
            requiresApproval: z.boolean(),
            resourceMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish(),
            resourceName: z.string().min(1).max(60).nullable(),
            schedulingType: z.enum([
                'SOLO',
                'ROUND_ROBIN',
                'COLLECTIVE',
                'MANAGED'
            ]),
            seatsPerTimeSlot: z.int().gte(1).lte(9007199254740991).nullable(),
            slug: z.string().min(1).max(64).regex(/^[A-Z][A-Z0-9_]*$/),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventTypesControllerReorderBody = z.object({
    items: z.array(z.object({
        id: z.string().min(1),
        position: z.int().gte(0).lte(9007199254740991)
    })).max(100)
});

export const zEventTypesControllerReorderResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        reordered: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zEventTypesControllerUpsertBody = z.object({
    afterBufferMinutes: z.int().gte(0).lte(9007199254740991).optional(),
    allowMultipleEventsPerDay: z.boolean().optional(),
    allowMultipleFutureEvents: z.boolean().optional(),
    approvalTtlHours: z.int().gte(1).lte(9007199254740991).nullish(),
    beforeBufferMinutes: z.int().gte(0).lte(9007199254740991).optional(),
    bookingHorizonAgentDays: z.int().gte(1).lte(9007199254740991).nullish(),
    bookingHorizonSecretaryDays: z.int().gte(1).lte(9007199254740991).nullish(),
    bookingLimits: z.record(z.string(), z.unknown()).nullish(),
    colorBackground: z.string().regex(/^#[0-9a-fA-F]{6}$/).nullish(),
    colorRing: z.string().regex(/^#[0-9a-fA-F]{6}$/).nullish(),
    colorText: z.string().regex(/^#[0-9a-fA-F]{6}$/).nullish(),
    description: z.string().max(2000).nullish(),
    durationMinutes: z.int().gte(1).lte(1440),
    durationStrategy: z.enum(['auto', 'manual']).optional(),
    id: z.string().optional(),
    isActive: z.boolean().optional(),
    kind: z.enum(['scheduled', 'conversation']).optional(),
    label: z.string().min(1).max(200),
    maxFutureEventsPerType: z.int().gte(1).lte(20).nullish(),
    maxPerSlotAgent: z.int().gte(1).lte(9007199254740991).nullish(),
    maxPerSlotSecretary: z.int().gte(1).lte(9007199254740991).nullish(),
    maxSpanDays: z.int().gte(1).lte(732).nullish(),
    metadata: z.record(z.string(), z.unknown()).nullish(),
    minimumBookingNotice: z.int().gte(0).lte(9007199254740991).optional(),
    periodDays: z.int().gte(0).lte(9007199254740991).nullish(),
    periodEndDate: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
    periodStartDate: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
    periodType: z.enum([
        'UNLIMITED',
        'ROLLING',
        'RANGE',
        'FIXED_RANGE'
    ]).optional(),
    position: z.int().gte(0).lte(9007199254740991).optional(),
    recurringRule: z.record(z.string(), z.unknown()).nullish(),
    requiresApproval: z.boolean().optional(),
    resourceMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish(),
    resourceName: z.string().min(1).max(60).nullish(),
    schedulingType: z.enum([
        'SOLO',
        'ROUND_ROBIN',
        'COLLECTIVE',
        'MANAGED'
    ]).optional(),
    seatsPerTimeSlot: z.int().gte(1).lte(9007199254740991).nullish(),
    slug: z.string().min(1).max(64).regex(/^[A-Z][A-Z0-9_]*$/).optional()
});

export const zEventTypesControllerUpsertResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        afterBufferMinutes: z.int().gte(0).lte(9007199254740991),
        allowMultipleEventsPerDay: z.boolean(),
        allowMultipleFutureEvents: z.boolean(),
        approvalTtlHours: z.int().gte(1).lte(9007199254740991).nullable(),
        beforeBufferMinutes: z.int().gte(0).lte(9007199254740991),
        bookingHorizonAgentDays: z.int().gte(1).lte(9007199254740991).nullable(),
        bookingHorizonSecretaryDays: z.int().gte(1).lte(9007199254740991).nullable(),
        bookingLimits: z.record(z.string(), z.unknown()).nullable(),
        colorBackground: z.string().nullable(),
        colorRing: z.string().nullable(),
        colorText: z.string().nullable(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        description: z.string().max(2000).nullable(),
        durationMinutes: z.int().gte(1).lte(1440),
        durationStrategy: z.enum(['auto', 'manual']),
        fieldDefinitions: z.array(z.object({
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            deletedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            eventTypeId: z.string(),
            gridVisible: z.boolean(),
            gridWidth: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
            id: z.string(),
            label: z.string(),
            name: z.string(),
            options: z.array(z.object({
                i18nKey: z.string().max(200).optional(),
                label: z.string().min(1).max(200),
                value: z.string().min(1).max(100)
            })).nullable(),
            orgId: z.string(),
            position: z.int().gte(-9007199254740991).lte(9007199254740991),
            required: z.boolean(),
            type: z.enum([
                'TEXT',
                'NUMBER',
                'DATE',
                'BOOL',
                'SELECT',
                'MULTI_SELECT'
            ]),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            validation: z.object({
                max: z.number().optional(),
                min: z.number().optional(),
                pattern: z.string().max(500).optional(),
                step: z.number().optional()
            }).nullable()
        })).optional(),
        id: z.string(),
        isActive: z.boolean(),
        kind: z.enum(['scheduled', 'conversation']),
        label: z.string(),
        maxFutureEventsPerType: z.int().gte(1).lte(20).nullable(),
        maxPerSlotAgent: z.int().gte(1).lte(9007199254740991).nullable(),
        maxPerSlotSecretary: z.int().gte(1).lte(9007199254740991).nullable(),
        maxSpanDays: z.int().gte(1).lte(732).nullable(),
        metadata: z.record(z.string(), z.unknown()).nullable(),
        minimumBookingNotice: z.int().gte(0).lte(9007199254740991),
        orgId: z.string(),
        periodDays: z.int().gte(0).lte(9007199254740991).nullable(),
        periodEndDate: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        periodStartDate: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        periodType: z.enum([
            'UNLIMITED',
            'ROLLING',
            'RANGE',
            'FIXED_RANGE'
        ]),
        position: z.int().gte(-9007199254740991).lte(9007199254740991),
        recurringRule: z.record(z.string(), z.unknown()).nullable(),
        requiresApproval: z.boolean(),
        resourceMaxOccupancy: z.int().gte(1).lte(9007199254740991).nullish(),
        resourceName: z.string().min(1).max(60).nullable(),
        schedulingType: z.enum([
            'SOLO',
            'ROUND_ROBIN',
            'COLLECTIVE',
            'MANAGED'
        ]),
        seatsPerTimeSlot: z.int().gte(1).lte(9007199254740991).nullable(),
        slug: z.string().min(1).max(64).regex(/^[A-Z][A-Z0-9_]*$/),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zHealthControllerDoclingResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        baseUrl: z.string().nullish(),
        checkedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
        configured: z.boolean(),
        detail: z.string().nullish(),
        mode: z.enum(['local', 'managed']).nullish(),
        reachable: z.boolean(),
        status: z.enum([
            'ok',
            'unreachable',
            'misconfigured',
            'error',
            'unknown'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zHealthControllerHealthResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        alive: z.boolean(),
        timestamp: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zHealthControllerLivenessResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        alive: z.boolean(),
        timestamp: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zHealthControllerReadinessResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        debug: z.object({
            hasRedisClient: z.boolean(),
            redisBlockedClients: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
            redisClients: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
            redisConnectedProp: z.boolean().nullish(),
            redisMemory: z.string().nullish(),
            redisMemoryPeak: z.string().nullish(),
            redisPingError: z.string().nullish(),
            redisPingResult: z.string().nullish(),
            redisUptimeSeconds: z.int().gte(-9007199254740991).lte(9007199254740991).nullish()
        }).nullish(),
        ready: z.boolean(),
        services: z.object({
            email: z.boolean().optional(),
            redis: z.boolean()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zHealthControllerSecretsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        available: z.boolean(),
        healthy: z.boolean(),
        prefix: z.string().nullish(),
        totalSecrets: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
        type: z.enum(['aws-secrets-manager', 'environment-variables']).nullish()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zInstagramOperatorControllerMarkSeenResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zInstagramOperatorControllerSendMessageBody = z.object({
    attachments: z.array(z.object({
        filename: z.string().max(255).optional(),
        mediaType: z.string().min(1).max(255),
        url: z.string().min(1).max(10000)
    })).max(20).optional().default([]),
    message: z.string().max(100000).optional().default(''),
    replyToMessageId: z.string().min(1).max(255).optional()
});

export const zInstagramOperatorControllerSendMessageResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        messageId: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zInstagramOperatorControllerSendReactionBody = z.object({
    emoji: z.union([
        z.enum(['❤️']),
        z.enum(['❤']),
        z.enum([''])
    ]),
    messageId: z.string().min(1).max(255)
});

export const zInstagramOperatorControllerSendReactionResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zJobsControllerGetJobSchedulerResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        scheduler: z.object({
            endDate: z.number().nullish(),
            every: z.number().nullish(),
            id: z.string().nullish(),
            key: z.string().nullish(),
            name: z.string().nullish(),
            next: z.number().nullish(),
            pattern: z.string().nullish(),
            tz: z.string().nullish()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zJobsControllerGetMetricsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.string().nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zJobsControllerListJobSchedulersResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        schedulers: z.array(z.object({
            endDate: z.number().nullish(),
            every: z.number().nullish(),
            id: z.string().nullish(),
            key: z.string().nullish(),
            name: z.string().nullish(),
            next: z.number().nullish(),
            pattern: z.string().nullish(),
            tz: z.string().nullish()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zJobsControllerRemoveJobSchedulerResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        removed: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zLeadsControllerSubmitBody = z.object({
    email: z.email().max(320).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
    message: z.string().max(2000).optional(),
    name: z.string().min(1).max(200)
});

export const zLeadsControllerSubmitResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        id: z.string(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zListBookingsResponseDto = z.object({
    events: z.array(zBookingItemDto),
    hasMore: z.boolean(),
    nextCursor: z.string().nullish(),
    totalCount: z.number()
});

export const zListEventTypesResponseDto = z.object({
    eventTypes: z.array(zEventTypeDto)
});

export const zMeControllerGetOrgContextResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        orgCreatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        orgId: z.string().nullable(),
        orgName: z.string().nullable(),
        orgPlan: z.string(),
        orgRole: z.string().nullable(),
        permissions: z.record(z.string(), z.boolean())
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zMessageCitationsControllerCheckCitationsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        citations: z.array(z.object({
            chunkId: z.string().nullable(),
            citationKey: z.string(),
            conversationId: z.string(),
            createdAt: z.string(),
            displayNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
            documentId: z.string().nullable(),
            filename: z.string().nullable(),
            id: z.string(),
            messageId: z.string(),
            orgId: z.string(),
            problemNote: z.string().nullable(),
            quote: z.string(),
            status: z.enum([
                'unverified',
                'verified',
                'partially_supported',
                'not_verified',
                'contradicted',
                'verification_failed'
            ]),
            supportScore: z.number().nullable(),
            target: z.unknown(),
            targetKind: z.enum([
                'pdf_bbox',
                'charspan',
                'sheet_rows',
                'image',
                'web_snapshot',
                'none'
            ]),
            verifiedAt: z.string().nullable()
        })),
        groupsChecked: z.int().gte(-9007199254740991).lte(9007199254740991),
        groupsFailed: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zMessageCitationsControllerGetCitationsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        citations: z.array(z.object({
            chunkId: z.string().nullable(),
            citationKey: z.string(),
            conversationId: z.string(),
            createdAt: z.string(),
            displayNumber: z.int().gte(-9007199254740991).lte(9007199254740991),
            documentId: z.string().nullable(),
            filename: z.string().nullable(),
            id: z.string(),
            messageId: z.string(),
            orgId: z.string(),
            problemNote: z.string().nullable(),
            quote: z.string(),
            status: z.enum([
                'unverified',
                'verified',
                'partially_supported',
                'not_verified',
                'contradicted',
                'verification_failed'
            ]),
            supportScore: z.number().nullable(),
            target: z.unknown(),
            targetKind: z.enum([
                'pdf_bbox',
                'charspan',
                'sheet_rows',
                'image',
                'web_snapshot',
                'none'
            ]),
            verifiedAt: z.string().nullable()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zMessageControllerGetTranslationResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        error: z.string().optional(),
        message: z.string().optional(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zNotificationsControllerGetHistoryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean(),
        value: z.object({
            data: z.array(z.object({
                data: z.record(z.string(), z.unknown()),
                id: z.string(),
                timestamp: z.string(),
                type: z.string()
            })),
            nextCursor: z.string().nullable()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zNotificationsControllerGetVapidPublicKeyResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        publicKey: z.string().nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zNotificationsControllerListPushSubscriptionsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        devices: z.array(z.object({
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            endpoint: z.url(),
            expirationTime: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            id: z.string(),
            lastUsedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            userAgent: z.string().nullable()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zNotificationsControllerPushSubscribeBody = z.object({
    endpoint: z.url(),
    expirationTime: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
    keys: z.object({
        auth: z.string().min(1),
        p256dh: z.string().min(1)
    }),
    replacesEndpoint: z.url().optional(),
    userAgent: z.string().optional()
});

export const zNotificationsControllerPushSubscribeResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        id: z.string(),
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zNotificationsControllerPushUnsubscribeBody = z.object({
    endpoint: z.url()
});

export const zNotificationsControllerPushUnsubscribeResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true),
        removed: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zNotificationsControllerRevokePushSubscriptionResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true),
        removed: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOnboardingControllerAssignUserToExistingOrgBody = z.object({
    orgId: z.string().min(1),
    role: z.enum([
        'owner',
        'admin',
        'secretary',
        'guest'
    ]).optional().default('secretary'),
    userId: z.string().min(1)
});

export const zOnboardingControllerAssignUserToExistingOrgResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        memberId: z.string(),
        orgId: z.string(),
        role: z.enum([
            'owner',
            'admin',
            'secretary',
            'guest'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOnboardingControllerAssignUserToNewOrgBody = z.object({
    billing: z.enum(['monthly', 'yearly']),
    name: z.string().min(1).max(120).optional(),
    plan: z.enum([
        'chat',
        'standard',
        'premium'
    ]),
    slug: z.string().min(1).max(50).regex(/^[a-z0-9-]+$/),
    userId: z.string().min(1)
});

export const zOnboardingControllerAssignUserToNewOrgResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        orgId: z.string(),
        slug: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOnboardingControllerCompleteSetupResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOnboardingControllerGetSetupStatusResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        gated: z.boolean(),
        plan: z.enum([
            'chat',
            'standard',
            'premium'
        ]),
        requirementsMet: z.boolean(),
        setupComplete: z.boolean(),
        steps: z.object({
            aiModel: z.boolean(),
            businessProfile: z.boolean(),
            messaging: z.boolean(),
            schedule: z.boolean().optional(),
            systemPrompt: z.boolean()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOnboardingControllerListWaitingUsersResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        users: z.array(z.object({
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            email: z.string().nullable(),
            id: z.string(),
            intendedBilling: z.enum(['monthly', 'yearly']).nullable(),
            intendedPlan: z.enum([
                'chat',
                'standard',
                'premium'
            ]).nullable(),
            name: z.string().nullable()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOnboardingControllerSetIntentBody = z.object({
    billing: z.enum(['monthly', 'yearly']).optional(),
    plan: z.enum([
        'chat',
        'standard',
        'premium'
    ]).optional(),
    waiting: z.boolean()
});

export const zOnboardingControllerSetIntentResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        intendedBilling: z.enum(['monthly', 'yearly']).nullable(),
        intendedPlan: z.enum([
            'chat',
            'standard',
            'premium'
        ]).nullable(),
        ok: z.literal(true),
        waitingForAssignment: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOrganizationBalanceControllerAdminCreditBody = z.object({
    creditDelta: z.int().gt(0).lte(9007199254740991),
    description: z.string().max(500).optional()
});

export const zOrganizationBalanceControllerAdminCreditResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        creditsAfter: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOrganizationBalanceControllerGetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        credits: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOrganizationBalanceControllerGetSpendPolicyResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        period: z.object({
            capCredits: z.int().lte(9007199254740991).nullable(),
            periodEnd: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            periodKey: z.string().min(1),
            periodStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            spentCredits: z.int().gte(0).lte(9007199254740991)
        }),
        policy: z.object({
            capBehavior: z.enum(['HARD_STOP', 'DEGRADE_TO_FALLBACK']),
            capCredits: z.int().lte(9007199254740991).nullable(),
            capFallbackMessage: z.string().min(1).max(500).nullable(),
            thresholdsBps: z.array(z.int().gte(0).lte(10000)).max(6)
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOrganizationBalanceControllerGetUsdLedgerResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        credits: z.int().gte(-9007199254740991).lte(9007199254740991),
        usdMicrosThisMonth: z.string(),
        usdMicrosTotal: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOrganizationBalanceControllerListTransactionFacetsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        kinds: z.array(z.object({
            count: z.int().gte(-9007199254740991).lte(9007199254740991),
            kind: z.enum([
                'CREDIT_MANUAL',
                'CREDIT_PAYMENT',
                'CREDIT_ADJUSTMENT',
                'DEBIT_AI_USAGE',
                'DEBIT_ADJUSTMENT',
                'REFUND'
            ])
        })),
        models: z.array(z.object({
            count: z.int().gte(-9007199254740991).lte(9007199254740991),
            modelId: z.string()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOrganizationBalanceControllerListTransactionsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            createdByUserId: z.string().nullable(),
            creditDelta: z.int().gte(-9007199254740991).lte(9007199254740991),
            creditsAfter: z.int().gte(-9007199254740991).lte(9007199254740991),
            description: z.string().nullable(),
            id: z.string(),
            kind: z.enum([
                'CREDIT_MANUAL',
                'CREDIT_PAYMENT',
                'CREDIT_ADJUSTMENT',
                'DEBIT_AI_USAGE',
                'DEBIT_ADJUSTMENT',
                'REFUND'
            ]),
            modelId: z.string().nullable(),
            orgId: z.string(),
            usdMicrosDelta: z.string().nullable()
        })),
        nextCursor: z.string().nullable(),
        total: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOrganizationBalanceControllerUpdateSpendPolicyBody = z.object({
    capBehavior: z.enum(['HARD_STOP', 'DEGRADE_TO_FALLBACK']),
    capCredits: z.int().lte(9007199254740991).nullable(),
    capFallbackMessage: z.string().min(1).max(500).nullable(),
    thresholdsBps: z.array(z.int().gte(0).lte(10000)).max(6)
});

export const zOrganizationBalanceControllerUpdateSpendPolicyResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        period: z.object({
            capCredits: z.int().lte(9007199254740991).nullable(),
            periodEnd: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            periodKey: z.string().min(1),
            periodStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            spentCredits: z.int().gte(0).lte(9007199254740991)
        }),
        policy: z.object({
            capBehavior: z.enum(['HARD_STOP', 'DEGRADE_TO_FALLBACK']),
            capCredits: z.int().lte(9007199254740991).nullable(),
            capFallbackMessage: z.string().min(1).max(500).nullable(),
            thresholdsBps: z.array(z.int().gte(0).lte(10000)).max(6)
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOrganizationsControllerGetByIdResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        balanceCredits: z.number(),
        billingInterval: z.string().nullable(),
        cancelAtPeriodEnd: z.boolean(),
        country: z.string().nullable(),
        currentPeriodEnd: z.string().nullable(),
        customMonthlyMessageLimit: z.number().nullable(),
        customStaffSeatLimit: z.number().nullable(),
        customStorageLimitBytes: z.string().nullable(),
        id: z.string(),
        isActive: z.boolean(),
        name: z.string(),
        plan: z.string(),
        planVersion: z.number(),
        slug: z.string(),
        subscriptionStatus: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOrganizationsControllerSoftDeleteBody = z.object({
    organizationId: z.string().min(1).max(128)
});

export const zOrganizationsControllerSoftDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.unknown().nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOrgRetentionControllerGetRetentionRulesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        canEdit: z.boolean(),
        rules: z.object({
            audit_log: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            captured_leads: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            chat_media: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            conversations: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            deleted_items: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            documents: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            notifications: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zOrgRetentionControllerUpdateRetentionRulesBody = z.object({
    rules: z.object({
        audit_log: z.union([
            z.literal(30),
            z.literal(90),
            z.literal(180),
            z.literal(365)
        ]).nullish(),
        captured_leads: z.union([
            z.literal(30),
            z.literal(90),
            z.literal(180),
            z.literal(365)
        ]).nullish(),
        chat_media: z.union([
            z.literal(30),
            z.literal(90),
            z.literal(180),
            z.literal(365)
        ]).nullish(),
        conversations: z.union([
            z.literal(30),
            z.literal(90),
            z.literal(180),
            z.literal(365)
        ]).nullish(),
        deleted_items: z.union([
            z.literal(30),
            z.literal(90),
            z.literal(180),
            z.literal(365)
        ]).nullish(),
        documents: z.union([
            z.literal(30),
            z.literal(90),
            z.literal(180),
            z.literal(365)
        ]).nullish(),
        notifications: z.union([
            z.literal(30),
            z.literal(90),
            z.literal(180),
            z.literal(365)
        ]).nullish()
    })
});

export const zOrgRetentionControllerUpdateRetentionRulesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        rules: z.object({
            audit_log: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            captured_leads: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            chat_media: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            conversations: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            deleted_items: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            documents: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish(),
            notifications: z.union([
                z.literal(30),
                z.literal(90),
                z.literal(180),
                z.literal(365)
            ]).nullish()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zPermissionsControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            createdAt: z.string(),
            description: z.string().nullable(),
            id: z.string(),
            key: z.string().min(1).max(64)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zPhoneControllerGetRecentResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.array(z.object({
        ai_enabled: z.boolean(),
        beneficiaries: z.array(z.object({
            id: z.string(),
            name: z.string().nullable()
        })).nullish(),
        channel: z.string().nullish(),
        conversation_id: z.string().nullish(),
        has_pending_approval: z.boolean().optional(),
        is_active: z.boolean(),
        is_favorite: z.boolean(),
        last_event_at: z.string().nullish(),
        last_message_at: z.string().nullish(),
        nickname: z.string().nullish(),
        phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/),
        similarity: z.number().nullish(),
        updated_at: z.string().nullish(),
        user_id: z.string(),
        user_name: z.string().nullish()
    })).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zPhoneControllerGetStatsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        countries: z.record(z.string(), z.int().gte(0).lte(9007199254740991)),
        status: z.object({
            inactive: z.int().gte(0).lte(9007199254740991),
            registered: z.int().gte(0).lte(9007199254740991),
            unknown: z.int().gte(0).lte(9007199254740991),
            withDocument: z.int().gte(0).lte(9007199254740991)
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zPhoneControllerListAllResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.array(z.object({
            ai_enabled: z.boolean(),
            beneficiaries: z.array(z.object({
                id: z.string(),
                name: z.string().nullable()
            })).nullish(),
            channel: z.string().nullish(),
            conversation_id: z.string().nullish(),
            has_pending_approval: z.boolean().optional(),
            is_active: z.boolean(),
            is_favorite: z.boolean(),
            last_event_at: z.string().nullish(),
            last_message_at: z.string().nullish(),
            nickname: z.string().nullish(),
            phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/),
            similarity: z.number().nullish(),
            updated_at: z.string().nullish(),
            user_id: z.string(),
            user_name: z.string().nullish()
        })),
        hasMore: z.boolean(),
        nextCursor: z.string().nullish(),
        pagination: z.object({
            limit: z.int().lte(9007199254740991).nullish(),
            offset: z.int().gte(0).lte(9007199254740991).nullish(),
            page: z.int().gt(0).lte(9007199254740991),
            page_size: z.int().gt(0).lte(9007199254740991),
            total: z.int().gte(0).lte(9007199254740991),
            total_pages: z.int().gte(0).lte(9007199254740991)
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zPhoneControllerSearchResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.array(z.object({
        address: z.string().nullable(),
        ai_enabled: z.boolean(),
        beneficiaries: z.array(z.object({
            id: z.string(),
            name: z.string().nullable()
        })).nullish(),
        channel: z.string().nullish(),
        conversation_id: z.string().nullish(),
        has_pending_approval: z.boolean().optional(),
        is_active: z.boolean(),
        is_favorite: z.boolean(),
        last_event_at: z.string().nullish(),
        last_message_at: z.string().nullish(),
        nickname: z.string().nullish(),
        phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).nullable(),
        similarity: z.number().nullish(),
        updated_at: z.string().nullish(),
        user_id: z.string(),
        user_name: z.string().nullish()
    })).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zPlansControllerCreateDraftBody = z.object({
    notes: z.string().max(2000).optional(),
    slug: z.string().min(1).max(64).regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)
});

export const zPlansControllerCreateDraftResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        id: z.string(),
        modelPricing: z.array(z.object({
            creditCost: z.int().gte(0).lte(9007199254740991),
            modelId: z.string().min(1),
            usdMicrosCost: z.string().regex(/^\d+$/)
        })),
        notes: z.string().nullable(),
        phasedOutAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        publishedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        slug: z.string(),
        status: z.enum([
            'DRAFT',
            'PUBLISHED',
            'PHASED_OUT'
        ]),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        version: z.int().gt(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zPlansControllerListAllResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            id: z.string(),
            modelPricing: z.array(z.object({
                creditCost: z.int().gte(0).lte(9007199254740991),
                modelId: z.string().min(1),
                usdMicrosCost: z.string().regex(/^\d+$/)
            })),
            notes: z.string().nullable(),
            phasedOutAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            publishedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            slug: z.string(),
            status: z.enum([
                'DRAFT',
                'PUBLISHED',
                'PHASED_OUT'
            ]),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            version: z.int().gt(0).lte(9007199254740991)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zPlansControllerPhaseOutBody = z.object({
    planId: z.string()
});

export const zPlansControllerPhaseOutResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        id: z.string(),
        modelPricing: z.array(z.object({
            creditCost: z.int().gte(0).lte(9007199254740991),
            modelId: z.string().min(1),
            usdMicrosCost: z.string().regex(/^\d+$/)
        })),
        notes: z.string().nullable(),
        phasedOutAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        publishedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        slug: z.string(),
        status: z.enum([
            'DRAFT',
            'PUBLISHED',
            'PHASED_OUT'
        ]),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        version: z.int().gt(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zPlansControllerPublishBody = z.object({
    planId: z.string()
});

export const zPlansControllerPublishResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        id: z.string(),
        modelPricing: z.array(z.object({
            creditCost: z.int().gte(0).lte(9007199254740991),
            modelId: z.string().min(1),
            usdMicrosCost: z.string().regex(/^\d+$/)
        })),
        notes: z.string().nullable(),
        phasedOutAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        publishedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        slug: z.string(),
        status: z.enum([
            'DRAFT',
            'PUBLISHED',
            'PHASED_OUT'
        ]),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        version: z.int().gt(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zPlansControllerSetDraftPricingBody = z.object({
    planId: z.string(),
    pricing: z.array(z.object({
        creditCost: z.int().gte(0).lte(9007199254740991),
        modelId: z.string().min(1),
        usdMicrosCost: z.string().regex(/^\d+$/)
    }))
});

export const zPlansControllerSetDraftPricingResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        id: z.string(),
        modelPricing: z.array(z.object({
            creditCost: z.int().gte(0).lte(9007199254740991),
            modelId: z.string().min(1),
            usdMicrosCost: z.string().regex(/^\d+$/)
        })),
        notes: z.string().nullable(),
        phasedOutAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        publishedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        slug: z.string(),
        status: z.enum([
            'DRAFT',
            'PUBLISHED',
            'PHASED_OUT'
        ]),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        version: z.int().gt(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQaPairsControllerCreateBody = z.object({
    answerHtml: z.string().min(1).max(100000),
    questions: z.array(z.string().min(1).max(2000)).min(1).max(20),
    title: z.string().min(1).max(200)
});

export const zQaPairsControllerCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        answerHtml: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        enabled: z.boolean(),
        errorMessage: z.string().nullable(),
        id: z.string(),
        lastAskedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        questions: z.array(z.string()),
        sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ]),
        timesAsked: z.int().gte(-9007199254740991).lte(9007199254740991),
        title: z.string(),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQaPairsControllerImportXlsxResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        created: z.int().gte(-9007199254740991).lte(9007199254740991),
        skipped: z.array(z.object({
            reason: z.string(),
            row: z.int().gte(-9007199254740991).lte(9007199254740991)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQaPairsControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.array(z.object({
        answerHtml: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        enabled: z.boolean(),
        errorMessage: z.string().nullable(),
        id: z.string(),
        lastAskedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        questions: z.array(z.string()),
        sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ]),
        timesAsked: z.int().gte(-9007199254740991).lte(9007199254740991),
        title: z.string(),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    })).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQaPairsControllerRemoveResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        deleted: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQaPairsControllerRemoveManyBody = z.union([
    z.object({
        ids: z.array(z.string()).min(1)
    }),
    z.object({
        all: z.literal(true)
    })
]);

export const zQaPairsControllerRemoveManyResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        deletedCount: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQaPairsControllerStatsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        lastAskedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        series: z.array(z.object({
            count: z.int().gte(-9007199254740991).lte(9007199254740991),
            day: z.string()
        })),
        timesAsked: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQaPairsControllerUpdateBody = z.object({
    answerHtml: z.string().min(1).max(100000).optional(),
    questions: z.array(z.string().min(1).max(2000)).min(1).max(20).optional(),
    title: z.string().min(1).max(200).optional()
});

export const zQaPairsControllerUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        answerHtml: z.string(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        enabled: z.boolean(),
        errorMessage: z.string().nullable(),
        id: z.string(),
        lastAskedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        questions: z.array(z.string()),
        sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ]),
        timesAsked: z.int().gte(-9007199254740991).lte(9007199254740991),
        title: z.string(),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQrControllerCreateBody = z.object({
    data: z.string().min(1),
    description: z.string().nullish(),
    name: z.string().nullish()
});

export const zQrControllerCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        data: z.string(),
        id: z.string(),
        name: z.string().nullish()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQrControllerDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQrControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
            data: z.string(),
            description: z.string().nullish(),
            id: z.string(),
            name: z.string().nullish(),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish()
        })),
        total: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQrControllerUpdateBody = z.object({
    data: z.string().nullish(),
    description: z.string().nullish(),
    name: z.string().nullish()
});

export const zQrControllerUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.string(),
        id: z.string(),
        name: z.string().nullish(),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQuickRepliesControllerGetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        replies: z.array(z.object({
            id: z.string(),
            label: z.string(),
            order: z.int().gte(-9007199254740991).lte(9007199254740991),
            sectionId: z.string(),
            text: z.string()
        })),
        sections: z.array(z.object({
            color: z.string(),
            id: z.string(),
            name: z.string(),
            order: z.int().gte(-9007199254740991).lte(9007199254740991)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zQuickRepliesControllerSaveBody = z.object({
    replies: z.array(z.object({
        id: z.string(),
        label: z.string(),
        order: z.int().gte(-9007199254740991).lte(9007199254740991),
        sectionId: z.string(),
        text: z.string()
    })),
    sections: z.array(z.object({
        color: z.string(),
        id: z.string(),
        name: z.string(),
        order: z.int().gte(-9007199254740991).lte(9007199254740991)
    }))
});

export const zQuickRepliesControllerSaveResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        replies: z.array(z.object({
            id: z.string(),
            label: z.string(),
            order: z.int().gte(-9007199254740991).lte(9007199254740991),
            sectionId: z.string(),
            text: z.string()
        })),
        sections: z.array(z.object({
            color: z.string(),
            id: z.string(),
            name: z.string(),
            order: z.int().gte(-9007199254740991).lte(9007199254740991)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerApplyEmbeddingStrategyBody = z.object({
    strategy: z.enum([
        'standard',
        'contextual',
        'late'
    ])
});

export const zRagDocumentsControllerApplyEmbeddingStrategyResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        embeddingStrategy: z.enum([
            'standard',
            'contextual',
            'late'
        ]),
        id: z.int().gte(-9007199254740991).lte(9007199254740991),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerDebugEmbeddingBody = z.object({
    query: z.string().min(1),
    text: z.string().min(1)
});

export const zRagDocumentsControllerDebugEmbeddingResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        model: z.string(),
        querySample: z.string(),
        similarity: z.number(),
        textSample: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerDeleteSavedQueryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerDemoSearchBody = z.object({
    limit: z.int().gte(1).lte(20).optional().default(5),
    query: z.string().min(1).max(500),
    threshold: z.number().gte(0).lte(1).optional()
});

export const zRagDocumentsControllerDemoSearchResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        embeddingModel: z.string(),
        queryTimeMs: z.number(),
        results: z.array(z.object({
            content: z.string(),
            documentId: z.int().gte(-9007199254740991).lte(9007199254740991),
            enabled: z.boolean(),
            filename: z.string(),
            similarity: z.number()
        })),
        tokensUsed: z.int().gte(-9007199254740991).lte(9007199254740991),
        totalDocuments: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerDocumentStatsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        lastRetrievedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        series: z.array(z.object({
            count: z.int().gte(-9007199254740991).lte(9007199254740991),
            day: z.string()
        })),
        timesRetrieved: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerFlushCacheResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        evicted: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerGenerateSavedQueryBody = z.object({
    description: z.string().min(1).max(500)
});

export const zRagDocumentsControllerGenerateSavedQueryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        draft: z.object({
            description: z.string().optional().default(''),
            key: z.string().regex(/^[a-z0-9-]{3,64}$/),
            label: z.string().min(1).max(120),
            params: z.array(z.object({
                description: z.string().optional().default(''),
                name: z.string().regex(/^[a-zA-Z_][a-zA-Z0-9_]*$/),
                type: z.enum([
                    'string',
                    'number',
                    'date'
                ])
            })).max(8).optional().default([]),
            sqlTemplate: z.string().min(1)
        }),
        dryRunError: z.string().optional(),
        dryRunOk: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerGetChunksResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        chunks: z.array(z.object({
            chunkIndex: z.int().gte(-9007199254740991).lte(9007199254740991),
            chunkType: z.enum([
                'TEXT',
                'TABLE',
                'MIXED',
                'SECTION',
                'CODE_BLOCK'
            ]),
            content: z.string(),
            contextPrefix: z.string().nullable(),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            embeddingDimensions: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
            id: z.int().gte(-9007199254740991).lte(9007199254740991),
            metadata: z.unknown(),
            pageNumber: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
            rowRange: z.string().nullable(),
            sheetName: z.string().nullable(),
            tokenCount: z.int().gte(-9007199254740991).lte(9007199254740991).nullable()
        })),
        documentId: z.int().gte(-9007199254740991).lte(9007199254740991),
        filename: z.string(),
        total: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerGetStatusResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        chunkCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        embeddingModel: z.string().nullish(),
        enabled: z.boolean(),
        errorMessage: z.string().nullable(),
        figureCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
        filename: z.string(),
        hasColumnSchema: z.boolean().optional(),
        id: z.int().gte(-9007199254740991).lte(9007199254740991),
        imagePolicy: z.enum([
            'describe',
            'attach',
            'ocr',
            'ignore'
        ]).optional(),
        includeImagesInAnswers: z.boolean().optional(),
        lastRetrievedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
        mimeType: z.string(),
        retryable: z.boolean().optional(),
        schemaPreload: z.boolean().optional(),
        sensitiveDataTypes: z.array(z.enum([
            'card',
            'iban',
            'national_id'
        ])).optional(),
        sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ]),
        timesRetrieved: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        defaultImagePolicy: z.enum([
            'describe',
            'attach',
            'ocr',
            'ignore'
        ]),
        documents: z.array(z.object({
            chunkCount: z.int().gte(-9007199254740991).lte(9007199254740991),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            embeddingModel: z.string().nullish(),
            enabled: z.boolean(),
            errorMessage: z.string().nullable(),
            figureCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
            filename: z.string(),
            hasColumnSchema: z.boolean().optional(),
            id: z.int().gte(-9007199254740991).lte(9007199254740991),
            imagePolicy: z.enum([
                'describe',
                'attach',
                'ocr',
                'ignore'
            ]).optional(),
            includeImagesInAnswers: z.boolean().optional(),
            lastRetrievedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
            mimeType: z.string(),
            retryable: z.boolean().optional(),
            schemaPreload: z.boolean().optional(),
            sensitiveDataTypes: z.array(z.enum([
                'card',
                'iban',
                'national_id'
            ])).optional(),
            sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
            status: z.enum([
                'PENDING',
                'PROCESSING',
                'COMPLETED',
                'FAILED'
            ]),
            timesRetrieved: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        })),
        structuredTotal: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
        total: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerListEmbeddingModelsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        models: z.array(z.object({
            architecture: z.object({
                inputModalities: z.array(z.string()).optional(),
                modality: z.string().optional(),
                outputModalities: z.array(z.string()).optional()
            }).optional(),
            contextLength: z.number().nullable(),
            description: z.string().optional(),
            id: z.string(),
            name: z.string(),
            pricing: z.object({
                prompt: z.number()
            }).optional(),
            supportedParameters: z.array(z.string()).optional()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerListNoHitQueriesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        events: z.array(z.object({
            conversationId: z.string().nullable(),
            createdAt: z.string(),
            id: z.int().gte(-9007199254740991).lte(9007199254740991),
            kind: z.string(),
            localDate: z.string(),
            payload: z.record(z.string(), z.unknown()).nullable(),
            query: z.string().nullable()
        })),
        nextCursor: z.int().gte(-9007199254740991).lte(9007199254740991).nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerListSavedQueriesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        savedQueries: z.array(z.object({
            createdAt: z.string(),
            description: z.string().optional().default(''),
            documentId: z.int().gte(-9007199254740991).lte(9007199254740991),
            key: z.string().regex(/^[a-z0-9-]{3,64}$/),
            label: z.string().min(1).max(120),
            params: z.array(z.object({
                description: z.string().optional().default(''),
                name: z.string().regex(/^[a-zA-Z_][a-zA-Z0-9_]*$/),
                type: z.enum([
                    'string',
                    'number',
                    'date'
                ])
            })).max(8).optional().default([]),
            sqlTemplate: z.string().min(1),
            updatedAt: z.string()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerModelSwitchEstimateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        chunkCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        documentCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        estimatedSeconds: z.number(),
        estimatedUsd: z.number(),
        isEstimate: z.literal(true),
        qaVariantCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        targetModel: z.string(),
        tokensTotal: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerModelSwitchProgressResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        inProgress: z.boolean(),
        pending: z.int().gte(-9007199254740991).lte(9007199254740991),
        targetModel: z.string(),
        total: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerPreUploadEstimateBody = z.object({
    mimeType: z.string(),
    sizeBytes: z.int().gt(0).lte(10485760)
});

export const zRagDocumentsControllerPreUploadEstimateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        estimates: z.array(z.object({
            available: z.boolean(),
            breakdown: z.object({
                cachedInputUsd: z.number(),
                embeddingUsd: z.number(),
                llmInputUsd: z.number(),
                llmOutputUsd: z.number()
            }),
            chunkCount: z.int().gte(-9007199254740991).lte(9007199254740991),
            current: z.boolean(),
            estimatedSeconds: z.number(),
            estimatedUsd: z.number(),
            isEstimate: z.boolean(),
            strategy: z.enum([
                'standard',
                'contextual',
                'late'
            ]),
            tokensTotal: z.int().gte(-9007199254740991).lte(9007199254740991)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerReembedAllResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        documentsQueued: z.int().gte(-9007199254740991).lte(9007199254740991),
        message: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerRefreshNowResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        enqueued: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerReplaceResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        filename: z.string(),
        id: z.int().gte(-9007199254740991).lte(9007199254740991),
        staged: z.boolean().optional(),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerRetryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        id: z.int().gte(-9007199254740991).lte(9007199254740991),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerScrapeUrlBody = z.object({
    crawlDepth: z.int().gte(1).lte(100).optional().default(50),
    url: z.url()
});

export const zRagDocumentsControllerScrapeUrlResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        message: z.string(),
        pagesQueued: z.int().gte(-9007199254740991).lte(9007199254740991),
        pagesSkipped: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerSetSchemaPreloadBody = z.object({
    schemaPreload: z.boolean(),
    schemaPreloadCuration: z.object({
        excludedColumns: z.record(z.string(), z.array(z.string())).optional().default({}),
        excludedSheets: z.array(z.string()).optional().default([])
    }).optional()
});

export const zRagDocumentsControllerSetSchemaPreloadResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        id: z.int().gte(-9007199254740991).lte(9007199254740991),
        schemaPreload: z.boolean(),
        tokenEstimate: z.int().gte(-9007199254740991).lte(9007199254740991),
        warnThreshold: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerSourcesSummaryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        files: z.object({
            count: z.int().gte(-9007199254740991).lte(9007199254740991),
            sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        lastRefreshedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        needsRefresh: z.boolean(),
        qaPairs: z.object({
            count: z.int().gte(-9007199254740991).lte(9007199254740991),
            sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        staleUrlCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        urls: z.object({
            count: z.int().gte(-9007199254740991).lte(9007199254740991),
            sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991)
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerStrategyEstimateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        estimates: z.array(z.object({
            available: z.boolean(),
            breakdown: z.object({
                cachedInputUsd: z.number(),
                embeddingUsd: z.number(),
                llmInputUsd: z.number(),
                llmOutputUsd: z.number()
            }),
            chunkCount: z.int().gte(-9007199254740991).lte(9007199254740991),
            current: z.boolean(),
            estimatedSeconds: z.number(),
            estimatedUsd: z.number(),
            isEstimate: z.boolean(),
            strategy: z.enum([
                'standard',
                'contextual',
                'late'
            ]),
            tokensTotal: z.int().gte(-9007199254740991).lte(9007199254740991)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerToggleEnabledBody = z.object({
    enabled: z.boolean()
});

export const zRagDocumentsControllerToggleEnabledResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        chunkCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        embeddingModel: z.string().nullish(),
        enabled: z.boolean(),
        errorMessage: z.string().nullable(),
        figureCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
        filename: z.string(),
        hasColumnSchema: z.boolean().optional(),
        id: z.int().gte(-9007199254740991).lte(9007199254740991),
        imagePolicy: z.enum([
            'describe',
            'attach',
            'ocr',
            'ignore'
        ]).optional(),
        includeImagesInAnswers: z.boolean().optional(),
        lastRetrievedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
        mimeType: z.string(),
        retryable: z.boolean().optional(),
        schemaPreload: z.boolean().optional(),
        sensitiveDataTypes: z.array(z.enum([
            'card',
            'iban',
            'national_id'
        ])).optional(),
        sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ]),
        timesRetrieved: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerUpdateMetaBody = z.object({
    imagePolicy: z.enum([
        'describe',
        'attach',
        'ocr',
        'ignore'
    ]).optional(),
    includeImagesInAnswers: z.boolean().optional()
});

export const zRagDocumentsControllerUpdateMetaResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        id: z.int().gte(-9007199254740991).lte(9007199254740991),
        imagePolicy: z.enum([
            'describe',
            'attach',
            'ocr',
            'ignore'
        ]),
        includeImagesInAnswers: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerUploadBody = z.object({
    file: z.unknown(),
    staged: z.union([
        z.boolean(),
        z.enum(['true', 'false'])
    ]).optional()
});

export const zRagDocumentsControllerUploadResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        filename: z.string(),
        id: z.int().gte(-9007199254740991).lte(9007199254740991),
        staged: z.boolean().optional(),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagDocumentsControllerUpsertSavedQueryBody = z.object({
    description: z.string().optional().default(''),
    key: z.string().regex(/^[a-z0-9-]{3,64}$/),
    label: z.string().min(1).max(120),
    params: z.array(z.object({
        description: z.string().optional().default(''),
        name: z.string().regex(/^[a-zA-Z_][a-zA-Z0-9_]*$/),
        type: z.enum([
            'string',
            'number',
            'date'
        ])
    })).max(8).optional().default([]),
    sqlTemplate: z.string().min(1)
});

export const zRagDocumentsControllerUpsertSavedQueryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        savedQuery: z.object({
            createdAt: z.string(),
            description: z.string().optional().default(''),
            documentId: z.int().gte(-9007199254740991).lte(9007199254740991),
            key: z.string().regex(/^[a-z0-9-]{3,64}$/),
            label: z.string().min(1).max(120),
            params: z.array(z.object({
                description: z.string().optional().default(''),
                name: z.string().regex(/^[a-zA-Z_][a-zA-Z0-9_]*$/),
                type: z.enum([
                    'string',
                    'number',
                    'date'
                ])
            })).max(8).optional().default([]),
            sqlTemplate: z.string().min(1),
            updatedAt: z.string()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagPlaygroundControllerAgentRunBody = z.object({
    agentModel: z.string().min(1),
    attachments: z.array(z.object({
        filename: z.string().min(1).max(255),
        mediaType: z.string().min(1),
        url: z.url()
    })).max(8).optional(),
    contextLimit: z.int().gte(0).lte(50).nullish(),
    documentIds: z.array(z.int().gte(1).lte(9007199254740991)).max(500).optional(),
    embeddingModel: z.string().optional(),
    includeDisabled: z.boolean().optional().default(true),
    maxOutputTokens: z.int().gte(1).lte(32000).nullish(),
    messages: z.array(z.object({
        content: z.string(),
        role: z.enum(['user', 'assistant'])
    })).max(50).optional(),
    reasoningEffort: z.enum([
        'off',
        'low',
        'medium',
        'high'
    ]).optional(),
    systemPrompt: z.string().max(8000).optional(),
    threshold: z.number().gte(0).lte(1).optional(),
    topK: z.int().gte(0).lte(10).optional().default(5),
    userPrompt: z.string().min(1).max(4000),
    verbosity: z.enum([
        'low',
        'medium',
        'high'
    ]).optional()
});

export const zRagPlaygroundControllerAgentRunResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        answer: z.string(),
        completionTokens: z.int().gte(-9007199254740991).lte(9007199254740991),
        finalPrompt: z.string(),
        latencyMs: z.int().gte(-9007199254740991).lte(9007199254740991),
        model: z.string(),
        promptTokens: z.int().gte(-9007199254740991).lte(9007199254740991),
        queryEmbeddingTokens: z.int().gte(-9007199254740991).lte(9007199254740991),
        retrievedChunks: z.array(z.object({
            content: z.string(),
            documentId: z.int().gte(-9007199254740991).lte(9007199254740991),
            filename: z.string(),
            marker: z.string().optional(),
            similarity: z.number()
        })),
        totalTokens: z.int().gte(-9007199254740991).lte(9007199254740991),
        warning: z.string().optional()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagPlaygroundControllerAgentRunStreamBody = z.object({
    agentMode: z.enum([
        '1',
        '4',
        '5'
    ]).optional(),
    agentModel: z.string().min(1),
    attachments: z.array(z.object({
        filename: z.string().min(1).max(255),
        mediaType: z.string().min(1),
        url: z.url()
    })).max(8).optional(),
    calendarEvents: z.array(z.object({
        eventDateTime: z.string(),
        id: z.int().gte(1).lte(9007199254740991),
        phoneE164: z.string().optional(),
        status: z.enum(['active', 'cancelled']),
        type: z.string().min(1),
        userName: z.string().optional()
    })).max(500).optional(),
    contextLimit: z.int().gte(0).lte(50).nullish(),
    documentIds: z.array(z.int().gte(1).lte(9007199254740991)).max(500).optional(),
    embeddingModel: z.string().optional(),
    enabledTools: z.array(z.string().min(1).max(64)).max(64).optional(),
    includeDisabled: z.boolean().optional().default(true),
    maxOutputTokens: z.int().gte(1).lte(32000).nullish(),
    messages: z.array(z.object({
        content: z.string(),
        role: z.enum(['user', 'assistant'])
    })).max(50).optional(),
    reasoningEffort: z.enum([
        'off',
        'low',
        'medium',
        'high'
    ]).optional(),
    systemPrompt: z.string().max(8000).optional(),
    threshold: z.number().gte(0).lte(1).optional(),
    toolApprovals: z.array(z.object({
        decision: z.enum(['approved', 'denied']),
        input: z.unknown(),
        toolCallId: z.string().min(1),
        toolName: z.string().min(1)
    })).max(64).optional(),
    topK: z.int().gte(0).lte(10).optional().default(5),
    userPrompt: z.string().min(1).max(4000),
    verbosity: z.enum([
        'low',
        'medium',
        'high'
    ]).optional()
});

export const zRagPlaygroundControllerClearAllResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        deleted: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagPlaygroundControllerDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagPlaygroundControllerGetChunksResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        chunks: z.array(z.object({
            chunkIndex: z.int().gte(-9007199254740991).lte(9007199254740991),
            chunkType: z.enum([
                'TEXT',
                'TABLE',
                'MIXED',
                'SECTION',
                'CODE_BLOCK'
            ]),
            content: z.string(),
            contextPrefix: z.string().nullable(),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            embeddingDimensions: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
            id: z.int().gte(-9007199254740991).lte(9007199254740991),
            metadata: z.unknown(),
            pageNumber: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
            rowRange: z.string().nullable(),
            sheetName: z.string().nullable(),
            tokenCount: z.int().gte(-9007199254740991).lte(9007199254740991).nullable()
        })),
        documentId: z.int().gte(-9007199254740991).lte(9007199254740991),
        filename: z.string(),
        total: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagPlaygroundControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        documents: z.array(z.object({
            chunkCount: z.int().gte(-9007199254740991).lte(9007199254740991),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            embeddingModel: z.string().nullish(),
            enabled: z.boolean(),
            errorMessage: z.string().nullable(),
            figureCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
            filename: z.string(),
            hasColumnSchema: z.boolean().optional(),
            id: z.int().gte(-9007199254740991).lte(9007199254740991),
            imagePolicy: z.enum([
                'describe',
                'attach',
                'ocr',
                'ignore'
            ]).optional(),
            includeImagesInAnswers: z.boolean().optional(),
            lastRetrievedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
            mimeType: z.string(),
            retryable: z.boolean().optional(),
            schemaPreload: z.boolean().optional(),
            sensitiveDataTypes: z.array(z.enum([
                'card',
                'iban',
                'national_id'
            ])).optional(),
            sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
            status: z.enum([
                'PENDING',
                'PROCESSING',
                'COMPLETED',
                'FAILED'
            ]),
            timesRetrieved: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
            updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        })),
        total: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagPlaygroundControllerListPromptVersionsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        versions: z.array(z.object({
            content: z.string(),
            createdAt: z.string(),
            createdById: z.string().nullable(),
            id: z.string(),
            kind: z.enum(['SYSTEM', 'SYSTEM_AGENT']),
            orgId: z.string(),
            orgName: z.string(),
            presetId: z.string().nullable(),
            version: z.int().gte(1).lte(9007199254740991)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagPlaygroundControllerRetryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        id: z.int().gte(-9007199254740991).lte(9007199254740991),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagPlaygroundControllerToggleEnabledBody = z.object({
    enabled: z.boolean()
});

export const zRagPlaygroundControllerToggleEnabledResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        chunkCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        embeddingModel: z.string().nullish(),
        enabled: z.boolean(),
        errorMessage: z.string().nullable(),
        figureCount: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
        filename: z.string(),
        hasColumnSchema: z.boolean().optional(),
        id: z.int().gte(-9007199254740991).lte(9007199254740991),
        imagePolicy: z.enum([
            'describe',
            'attach',
            'ocr',
            'ignore'
        ]).optional(),
        includeImagesInAnswers: z.boolean().optional(),
        lastRetrievedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
        mimeType: z.string(),
        retryable: z.boolean().optional(),
        schemaPreload: z.boolean().optional(),
        sensitiveDataTypes: z.array(z.enum([
            'card',
            'iban',
            'national_id'
        ])).optional(),
        sizeBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ]),
        timesRetrieved: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
        updatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRagPlaygroundControllerUploadBody = z.object({
    embeddingModel: z.string().optional(),
    embeddingStrategy: z.enum([
        'standard',
        'contextual',
        'late'
    ]).optional(),
    file: z.unknown()
});

export const zRagPlaygroundControllerUploadResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        filename: z.string(),
        id: z.int().gte(-9007199254740991).lte(9007199254740991),
        status: z.enum([
            'PENDING',
            'PROCESSING',
            'COMPLETED',
            'FAILED'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRealtimeControllerGetConnectionInfoResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        connectedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        connectionId: z.string(),
        rooms: z.array(z.string().min(1)),
        userId: z.string().nullish()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRealtimeControllerGetServiceStatusResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        services: z.array(z.object({
            actor_name: z.string().nullish(),
            actor_user_id: z.string().nullish(),
            attemptNumber: z.number().nullish(),
            message: z.string().nullish(),
            reason: z.string().nullish(),
            retryInSeconds: z.number().nullish(),
            service: z.enum([
                'database',
                'redis',
                'backend'
            ]),
            status: z.enum([
                'connected',
                'disconnected',
                'connecting',
                'degraded'
            ])
        })),
        timestamp: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRealtimeControllerGetSnapshotResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.record(z.string(), z.unknown()).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRealtimeControllerJoinRoomBody = z.object({
    room: z.string().min(1)
});

export const zRealtimeControllerJoinRoomResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        joined: z.boolean(),
        memberCount: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
        room: z.string().min(1)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRealtimeControllerLeaveRoomBody = z.object({
    room: z.string().min(1)
});

export const zRealtimeControllerLeaveRoomResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        joined: z.boolean(),
        memberCount: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
        room: z.string().min(1)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRealtimeControllerSetFiltersBody = z.object({
    entities: z.array(z.string()).nullish(),
    types: z.array(z.string()).nullish()
});

export const zRealtimeControllerSetFiltersResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        applied: z.boolean(),
        filters: z.object({
            entities: z.array(z.string()).nullish(),
            types: z.array(z.enum([
                'event_created',
                'event_updated',
                'event_cancelled',
                'event_reinstated',
                'event_completed',
                'event_no_show',
                'conversation_new_message',
                'conversation_message_sync',
                'conversation_read',
                'conversation_cleared',
                'conversation_message_edited',
                'conversation_message_status',
                'conversation_message_deleted',
                'conversation_ai_toggled',
                'conversation_tool_approval_pending',
                'conversation_feedback',
                'vacation_period_updated',
                'user_document_updated',
                'user_favorite_updated',
                'user_active_updated',
                'user_phone_e164_changed',
                'user_name_updated',
                'contact_merged',
                'contact_created',
                'contact_updated',
                'contact_deleted',
                'contact_restored',
                'conversation_typing',
                'conversation_stream_start',
                'conversation_stream_chunk',
                'conversation_stream_sse',
                'conversation_stream_reasoning',
                'conversation_stream_end',
                'conversation_workflow_progress',
                'conversation_tool_call_started',
                'conversation_tool_call_completed',
                'conversation_tool_approval_requested',
                'conversation_tool_approval_responded',
                'config_updated',
                'ai_preset_updated',
                'snapshot',
                'metrics_updated',
                'service_status',
                'permissions_changed',
                'data_export_updated',
                'billing_status_updated',
                'org_activated',
                'org_assigned',
                'org_scope_changed',
                'whatsapp_template_status',
                'waitlist_updated',
                'waiting_users_updated',
                'campaign_updated'
            ])).nullish()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRealtimeControllerSubscribeResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.unknown(),
        entities: z.array(z.string()).nullish(),
        timestamp: z.string().nullish(),
        type: z.enum([
            'event_created',
            'event_updated',
            'event_cancelled',
            'event_reinstated',
            'event_completed',
            'event_no_show',
            'conversation_new_message',
            'conversation_message_sync',
            'conversation_read',
            'conversation_cleared',
            'conversation_message_edited',
            'conversation_message_status',
            'conversation_message_deleted',
            'conversation_ai_toggled',
            'conversation_tool_approval_pending',
            'conversation_feedback',
            'vacation_period_updated',
            'user_document_updated',
            'user_favorite_updated',
            'user_active_updated',
            'user_phone_e164_changed',
            'user_name_updated',
            'contact_merged',
            'contact_created',
            'contact_updated',
            'contact_deleted',
            'contact_restored',
            'conversation_typing',
            'conversation_stream_start',
            'conversation_stream_chunk',
            'conversation_stream_sse',
            'conversation_stream_reasoning',
            'conversation_stream_end',
            'conversation_workflow_progress',
            'conversation_tool_call_started',
            'conversation_tool_call_completed',
            'conversation_tool_approval_requested',
            'conversation_tool_approval_responded',
            'config_updated',
            'ai_preset_updated',
            'snapshot',
            'metrics_updated',
            'service_status',
            'permissions_changed',
            'data_export_updated',
            'billing_status_updated',
            'org_activated',
            'org_assigned',
            'org_scope_changed',
            'whatsapp_template_status',
            'waitlist_updated',
            'waiting_users_updated',
            'campaign_updated'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRealtimeControllerSubscribeToConversationResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.unknown(),
        entities: z.array(z.string()).nullish(),
        timestamp: z.string().nullish(),
        type: z.enum([
            'event_created',
            'event_updated',
            'event_cancelled',
            'event_reinstated',
            'event_completed',
            'event_no_show',
            'conversation_new_message',
            'conversation_message_sync',
            'conversation_read',
            'conversation_cleared',
            'conversation_message_edited',
            'conversation_message_status',
            'conversation_message_deleted',
            'conversation_ai_toggled',
            'conversation_tool_approval_pending',
            'conversation_feedback',
            'vacation_period_updated',
            'user_document_updated',
            'user_favorite_updated',
            'user_active_updated',
            'user_phone_e164_changed',
            'user_name_updated',
            'contact_merged',
            'contact_created',
            'contact_updated',
            'contact_deleted',
            'contact_restored',
            'conversation_typing',
            'conversation_stream_start',
            'conversation_stream_chunk',
            'conversation_stream_sse',
            'conversation_stream_reasoning',
            'conversation_stream_end',
            'conversation_workflow_progress',
            'conversation_tool_call_started',
            'conversation_tool_call_completed',
            'conversation_tool_approval_requested',
            'conversation_tool_approval_responded',
            'config_updated',
            'ai_preset_updated',
            'snapshot',
            'metrics_updated',
            'service_status',
            'permissions_changed',
            'data_export_updated',
            'billing_status_updated',
            'org_activated',
            'org_assigned',
            'org_scope_changed',
            'whatsapp_template_status',
            'waitlist_updated',
            'waiting_users_updated',
            'campaign_updated'
        ])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRolesControllerAssignMemberBody = z.object({
    memberId: z.string().min(1),
    roleId: z.string().min(1)
});

export const zRolesControllerAssignMemberResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        memberId: z.string(),
        roleId: z.string().nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRolesControllerCreateBody = z.object({
    description: z.string().max(256).optional(),
    name: z.string().min(1).max(64),
    organizationId: z.string().nullable(),
    permissions: z.record(z.string(), z.boolean())
});

export const zRolesControllerCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.string(),
        description: z.string().nullable(),
        id: z.string(),
        isSystem: z.boolean(),
        memberCount: z.int().gte(0).lte(9007199254740991),
        name: z.string().min(1).max(64),
        organizationId: z.string().nullable(),
        permissions: z.record(z.string(), z.boolean()),
        updatedAt: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRolesControllerDeleteBody = z.object({
    id: z.string().min(1)
});

export const zRolesControllerDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        deleted: z.boolean(),
        id: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRolesControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            createdAt: z.string(),
            description: z.string().nullable(),
            id: z.string(),
            isSystem: z.boolean(),
            memberCount: z.int().gte(0).lte(9007199254740991),
            name: z.string().min(1).max(64),
            organizationId: z.string().nullable(),
            permissions: z.record(z.string(), z.boolean()),
            updatedAt: z.string()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRolesControllerListOrgMembersResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            customRoleId: z.string().nullable(),
            email: z.string().nullable(),
            id: z.string(),
            name: z.string().nullable(),
            orgRole: z.string(),
            userId: z.string()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRolesControllerUnassignMemberBody = z.object({
    memberId: z.string().min(1)
});

export const zRolesControllerUnassignMemberResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        memberId: z.string(),
        roleId: z.unknown()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zRolesControllerUpdateBody = z.object({
    description: z.string().max(256).nullish(),
    id: z.string().min(1),
    name: z.string().min(1).max(64).optional(),
    permissions: z.record(z.string(), z.boolean()).optional()
});

export const zRolesControllerUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        createdAt: z.string(),
        description: z.string().nullable(),
        id: z.string(),
        isSystem: z.boolean(),
        memberCount: z.int().gte(0).lte(9007199254740991),
        name: z.string().min(1).max(64),
        organizationId: z.string().nullable(),
        permissions: z.record(z.string(), z.boolean()),
        updatedAt: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSummaryControllerAddFeedbackCommentBody = z.object({
    body: z.string().min(1).max(1000)
});

export const zSummaryControllerAddFeedbackCommentResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        authorId: z.string().nullable(),
        authorImage: z.string().nullable(),
        authorName: z.string().nullable(),
        body: z.string(),
        createdAt: z.string(),
        id: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSummaryControllerDeleteFeedbackResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSummaryControllerDeleteSummaryResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSummaryControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            channel: z.string(),
            contactId: z.string(),
            generatedAt: z.string(),
            id: z.string(),
            payload: z.object({
                channel: z.string(),
                clientName: z.string(),
                dateRange: z.object({
                    from: z.string(),
                    to: z.string()
                }),
                feedback: z.array(z.object({
                    quote: z.string().optional(),
                    sentiment: z.enum([
                        'positive',
                        'negative',
                        'neutral'
                    ]),
                    summary: z.string()
                })),
                issues: z.array(z.string()),
                metadata: z.object({
                    generatedAt: z.string(),
                    messageCount: z.int().gte(-9007199254740991).lte(9007199254740991)
                }),
                notes: z.array(z.string()),
                overview: z.string(),
                phoneE164: z.string().optional(),
                reservations: z.array(z.object({
                    date: z.string(),
                    notes: z.string().optional(),
                    status: z.string().optional(),
                    time: z.string().optional(),
                    type: z.string().optional()
                }))
            }),
            savedById: z.string().nullable()
        })),
        total: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSummaryControllerListFeedbackResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            channel: z.string(),
            commentCount: z.int().gte(0).lte(9007199254740991),
            contactId: z.string().nullable(),
            conversationId: z.string().nullable(),
            createdAt: z.string(),
            id: z.string(),
            quote: z.string().nullable(),
            sentiment: z.enum([
                'POSITIVE',
                'NEGATIVE',
                'NEUTRAL'
            ]),
            source: z.enum(['AGENT', 'MANUAL']),
            sourceMessageId: z.string().nullable(),
            summary: z.string()
        })),
        total: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSummaryControllerListFeedbackCommentsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            authorId: z.string().nullable(),
            authorImage: z.string().nullable(),
            authorName: z.string().nullable(),
            body: z.string(),
            createdAt: z.string(),
            id: z.string()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSummaryControllerSaveBody = z.object({
    channel: z.string().min(1),
    contactId: z.string().optional(),
    contactPhoneE164: z.string().optional(),
    payload: z.object({
        channel: z.string(),
        clientName: z.string(),
        dateRange: z.object({
            from: z.string(),
            to: z.string()
        }),
        feedback: z.array(z.object({
            quote: z.string().optional(),
            sentiment: z.enum([
                'positive',
                'negative',
                'neutral'
            ]),
            summary: z.string()
        })),
        issues: z.array(z.string()),
        metadata: z.object({
            generatedAt: z.string(),
            messageCount: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        notes: z.array(z.string()),
        overview: z.string(),
        phoneE164: z.string().optional(),
        reservations: z.array(z.object({
            date: z.string(),
            notes: z.string().optional(),
            status: z.string().optional(),
            time: z.string().optional(),
            type: z.string().optional()
        }))
    })
});

export const zSummaryControllerSaveResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        generatedAt: z.string(),
        id: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSummaryControllerStreamBody = z.object({
    channel: z.string().optional(),
    contactId: z.string().optional(),
    contactPhoneE164: z.string().optional(),
    firstMessageId: z.string().regex(/^\d+$/).optional(),
    fromDate: z.string().optional(),
    language: z.string().min(2).max(10).optional(),
    lastMessageId: z.string().regex(/^\d+$/).optional(),
    messageLimit: z.int().gte(1).lte(200).optional(),
    toDate: z.string().optional()
});

export const zSuperadminControllerCreateMemberBody = z.object({
    email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
    isSuperuser: z.boolean().optional(),
    name: z.string().max(200).optional(),
    orgId: z.string().min(1).optional(),
    password: z.string().min(8).max(128),
    role: z.enum([
        'admin',
        'secretary',
        'guest'
    ]).optional().default('admin')
});

export const zSuperadminControllerCreateMemberResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        customRoleId: z.string().nullable(),
        customRoleName: z.string().nullable(),
        email: z.string(),
        id: z.string(),
        isActive: z.boolean(),
        isSuperuser: z.boolean(),
        joinedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        lastSignInAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        memberId: z.string().nullable(),
        name: z.string().nullable(),
        orgId: z.string(),
        orgName: z.string(),
        role: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerCreateOrganizationBody = z.object({
    initialCredits: z.int().gte(0).lte(1000000000).optional().default(0),
    name: z.string().min(1).max(200),
    plan: z.enum([
        'chat',
        'standard',
        'premium'
    ]).optional(),
    slug: z.string().min(1).max(120)
});

export const zSuperadminControllerCreateOrganizationResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        id: z.string(),
        initialCredits: z.int().gte(0).lte(9007199254740991),
        name: z.string(),
        plan: z.enum([
            'chat',
            'standard',
            'premium'
        ]),
        slug: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerDeleteMemberResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerDeleteMembersBody = z.object({
    ids: z.array(z.string().min(1)).min(1).max(500)
});

export const zSuperadminControllerDeleteMembersResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        count: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerDeleteOrganizationResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerEnterOrgBody = z.object({
    orgId: z.string().min(1),
    reason: z.string().min(1).max(500).optional()
});

export const zSuperadminControllerEnterOrgResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        impersonationId: z.string(),
        orgId: z.string(),
        orgName: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerExitOrgResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        durationMs: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
        impersonationId: z.string().nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerGetDashboardResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        activeOrgs: z.int().gte(-9007199254740991).lte(9007199254740991),
        aiObservability: z.object({
            byModel: z.array(z.object({
                actualCostUsd: z.number(),
                averageOutputTokensPerSecond: z.number().nullable(),
                cacheHitRate: z.number().nullable(),
                costDriftPct: z.number().nullable(),
                costPer1kTokensUsd: z.number().nullable(),
                estimatedCostUsd: z.number(),
                generationCount: z.int().gte(-9007199254740991).lte(9007199254740991),
                model: z.string(),
                p95ResponseTimeMs: z.number().nullable(),
                p95TimeToFirstOutputMs: z.number().nullable(),
                provider: z.string(),
                reasoningTokenRate: z.number().nullable(),
                toolErrorRate: z.number().nullable()
            })),
            byOrg: z.array(z.object({
                generationCount: z.int().gte(-9007199254740991).lte(9007199254740991),
                orgId: z.string(),
                orgName: z.string(),
                orgSlug: z.string(),
                p95ResponseTimeMs: z.number().nullable(),
                toolErrorRate: z.number().nullable(),
                totalCostUsd: z.number(),
                wastedSpendUsd: z.number()
            })),
            dailyTrend: z.array(z.object({
                averageOutputTokensPerSecond: z.number().nullable(),
                date: z.string(),
                generationCount: z.int().gte(-9007199254740991).lte(9007199254740991),
                p95ResponseTimeMs: z.number().nullable(),
                toolErrorRate: z.number().nullable(),
                totalCostUsd: z.number()
            })),
            finishReasonBreakdown: z.array(z.object({
                count: z.int().gte(-9007199254740991).lte(9007199254740991),
                rate: z.number(),
                value: z.string()
            })),
            statusBreakdown: z.array(z.object({
                count: z.int().gte(-9007199254740991).lte(9007199254740991),
                rate: z.number(),
                value: z.string()
            })),
            summary: z.object({
                averageResponseTimeMs: z.number().nullable(),
                cacheHitRate: z.number().nullable(),
                cacheReadTokens: z.int().gte(-9007199254740991).lte(9007199254740991),
                cacheSavingsUsd: z.number(),
                cacheWriteInputTokens: z.int().gte(-9007199254740991).lte(9007199254740991),
                costPer1kTokensUsd: z.number().nullable(),
                costPerResponseUsd: z.number().nullable(),
                missingPerformanceCount: z.int().gte(-9007199254740991).lte(9007199254740991),
                missingPerformanceRate: z.number(),
                missingUsageCount: z.int().gte(-9007199254740991).lte(9007199254740991),
                missingUsageRate: z.number(),
                p95ResponseTimeMs: z.number().nullable(),
                reasoningTokenRate: z.number().nullable(),
                reasoningTokens: z.int().gte(-9007199254740991).lte(9007199254740991),
                toolCallCount: z.int().gte(-9007199254740991).lte(9007199254740991),
                toolErrorCount: z.int().gte(-9007199254740991).lte(9007199254740991),
                toolErrorRate: z.number().nullable(),
                totalGenerations: z.int().gte(-9007199254740991).lte(9007199254740991),
                warningCount: z.int().gte(-9007199254740991).lte(9007199254740991),
                wastedSpendUsd: z.number()
            }),
            windowDays: z.int().gte(-9007199254740991).lte(9007199254740991)
        }),
        memberRoleBreakdown: z.array(z.object({
            count: z.int().gte(0).lte(9007199254740991),
            role: z.string()
        })),
        perOrgBreakdown: z.array(z.object({
            eventCount: z.int().gte(-9007199254740991).lte(9007199254740991),
            id: z.string(),
            isActive: z.boolean(),
            messageCount: z.int().gte(-9007199254740991).lte(9007199254740991),
            name: z.string(),
            plan: z.enum([
                'chat',
                'standard',
                'premium'
            ]),
            slug: z.string(),
            userCount: z.int().gte(-9007199254740991).lte(9007199254740991)
        })),
        totalConversations: z.int().gte(-9007199254740991).lte(9007199254740991),
        totalEvents: z.int().gte(-9007199254740991).lte(9007199254740991),
        totalMessages: z.int().gte(-9007199254740991).lte(9007199254740991),
        totalOrgs: z.int().gte(-9007199254740991).lte(9007199254740991),
        totalUsers: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerGetOrganizationResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        balanceCredits: z.int().gte(-9007199254740991).lte(9007199254740991),
        billingInterval: z.string().nullish(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        customAiPresetLimit: z.int().gte(-9007199254740991).lte(9007199254740991).nullish().default(null),
        customMonthlyMessageLimit: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
        customStaffSeatLimit: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
        customStorageLimitBytes: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
        customToolLimitOverride: z.int().gte(-9007199254740991).lte(9007199254740991).nullish().default(null),
        eventCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        hasSecrets: z.boolean(),
        id: z.string(),
        isActive: z.boolean(),
        isPastDue: z.boolean(),
        isQuarantined: z.boolean(),
        isSuspended: z.boolean(),
        lastActivityAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        messageCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        messagesThisMonth: z.int().gte(-9007199254740991).lte(9007199254740991),
        name: z.string(),
        plan: z.enum([
            'chat',
            'standard',
            'premium'
        ]),
        quarantinedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        secretKeys: z.array(z.string()),
        slug: z.string(),
        statusReason: z.string().nullable(),
        storageUsedBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
        subscriptionStatus: z.string().optional(),
        suspendedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        userCount: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerGetOrgKeyBalanceResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        hasKey: z.boolean(),
        label: z.string().optional(),
        limit: z.number().nullish(),
        usage: z.number().optional()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerGetSystemHealthResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        jobQueues: z.array(z.object({
            active: z.int().gte(-9007199254740991).lte(9007199254740991),
            completed: z.int().gte(-9007199254740991).lte(9007199254740991),
            delayed: z.int().gte(-9007199254740991).lte(9007199254740991),
            failed: z.int().gte(-9007199254740991).lte(9007199254740991),
            name: z.string(),
            waiting: z.int().gte(-9007199254740991).lte(9007199254740991)
        })),
        uptime: z.number(),
        wsConnections: z.object({
            authenticated: z.int().gte(-9007199254740991).lte(9007199254740991),
            rooms: z.int().gte(-9007199254740991).lte(9007199254740991),
            total: z.int().gte(-9007199254740991).lte(9007199254740991)
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerListChannelContactsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        contacts: z.array(z.object({
            channel: z.string().nullable(),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            id: z.string(),
            lastMessageAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            name: z.string().nullable(),
            orgId: z.string(),
            orgName: z.string(),
            phoneE164: z.string().nullable()
        })),
        total: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerListMembersResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        members: z.array(z.object({
            customRoleId: z.string().nullable(),
            customRoleName: z.string().nullable(),
            email: z.string(),
            id: z.string(),
            isActive: z.boolean(),
            isSuperuser: z.boolean(),
            joinedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            lastSignInAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            memberId: z.string().nullable(),
            name: z.string().nullable(),
            orgId: z.string(),
            orgName: z.string(),
            role: z.string()
        })),
        total: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerListOrganizationsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            balanceCredits: z.int().gte(-9007199254740991).lte(9007199254740991),
            billingInterval: z.string().nullish(),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            customAiPresetLimit: z.int().gte(-9007199254740991).lte(9007199254740991).nullish().default(null),
            customMonthlyMessageLimit: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
            customStaffSeatLimit: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
            customStorageLimitBytes: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
            customToolLimitOverride: z.int().gte(-9007199254740991).lte(9007199254740991).nullish().default(null),
            eventCount: z.int().gte(-9007199254740991).lte(9007199254740991),
            hasSecrets: z.boolean(),
            id: z.string(),
            isActive: z.boolean(),
            isPastDue: z.boolean(),
            isQuarantined: z.boolean(),
            isSuspended: z.boolean(),
            lastActivityAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            messageCount: z.int().gte(-9007199254740991).lte(9007199254740991),
            messagesThisMonth: z.int().gte(-9007199254740991).lte(9007199254740991),
            name: z.string(),
            plan: z.enum([
                'chat',
                'standard',
                'premium'
            ]),
            quarantinedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            secretKeys: z.array(z.string()),
            slug: z.string(),
            statusReason: z.string().nullable(),
            storageUsedBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
            subscriptionStatus: z.string().optional(),
            suspendedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
            userCount: z.int().gte(-9007199254740991).lte(9007199254740991)
        })),
        total: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerToggleOrganizationBody = z.object({
    isActive: z.boolean()
});

export const zSuperadminControllerToggleOrganizationResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        id: z.string(),
        isActive: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerUpdateMemberBody = z.object({
    email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).optional(),
    isActive: z.boolean().optional(),
    isSuperuser: z.boolean().optional(),
    name: z.string().max(200).optional(),
    orgId: z.string().min(1).optional(),
    role: z.enum([
        'owner',
        'admin',
        'secretary',
        'guest'
    ]).optional()
});

export const zSuperadminControllerUpdateMemberResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        customRoleId: z.string().nullable(),
        customRoleName: z.string().nullable(),
        email: z.string(),
        id: z.string(),
        isActive: z.boolean(),
        isSuperuser: z.boolean(),
        joinedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        lastSignInAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        memberId: z.string().nullable(),
        name: z.string().nullable(),
        orgId: z.string(),
        orgName: z.string(),
        role: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerUpdateOrganizationBody = z.object({
    customAiPresetLimit: z.int().gte(1).lte(10000).nullish(),
    customMonthlyMessageLimit: z.int().gte(1).lte(10000000).nullish(),
    customStaffSeatLimit: z.int().gte(1).lte(10000).nullish(),
    customStorageLimitBytes: z.int().gte(1).lte(9000000000000000).nullish(),
    customToolLimitOverride: z.int().gte(1).lte(1000).nullish(),
    isQuarantined: z.boolean().optional(),
    isSuspended: z.boolean().optional(),
    name: z.string().min(1).max(200).optional(),
    plan: z.enum([
        'chat',
        'standard',
        'premium'
    ]).optional(),
    slug: z.string().min(1).max(120).optional(),
    statusReason: z.string().max(500).nullish()
});

export const zSuperadminControllerUpdateOrganizationResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        balanceCredits: z.int().gte(-9007199254740991).lte(9007199254740991),
        billingInterval: z.string().nullish(),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        customAiPresetLimit: z.int().gte(-9007199254740991).lte(9007199254740991).nullish().default(null),
        customMonthlyMessageLimit: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
        customStaffSeatLimit: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
        customStorageLimitBytes: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
        customToolLimitOverride: z.int().gte(-9007199254740991).lte(9007199254740991).nullish().default(null),
        eventCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        hasSecrets: z.boolean(),
        id: z.string(),
        isActive: z.boolean(),
        isPastDue: z.boolean(),
        isQuarantined: z.boolean(),
        isSuspended: z.boolean(),
        lastActivityAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        messageCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        messagesThisMonth: z.int().gte(-9007199254740991).lte(9007199254740991),
        name: z.string(),
        plan: z.enum([
            'chat',
            'standard',
            'premium'
        ]),
        quarantinedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        secretKeys: z.array(z.string()),
        slug: z.string(),
        statusReason: z.string().nullable(),
        storageUsedBytes: z.int().gte(-9007199254740991).lte(9007199254740991),
        subscriptionStatus: z.string().optional(),
        suspendedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        userCount: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSuperadminControllerUpdateOrganizationSecretsBody = z.object({
    secrets: z.record(z.string(), z.string())
});

export const zSuperadminControllerUpdateOrganizationSecretsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        secretKeys: z.array(z.string()),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSystemAgentControllerCancelStreamResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        cancelled: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSystemAgentControllerChatBody = z.object({
    attachments: z.array(z.object({
        filename: z.string().min(1).max(255),
        stagedDocumentId: z.string().regex(/^\d+$/)
    })).max(5).optional(),
    id: z.string().min(1),
    message: z.object({
        id: z.string().min(1),
        parts: z.array(z.union([z.object({
                text: z.string().min(1).max(10000),
                type: z.enum(['text'])
            }), z.object({
                filename: z.string().max(255).nullish(),
                mediaType: z.string().max(255).regex(/^[a-z\d!#$&^_.+-]+\/[a-z\d!#$&^_.+-]+$/),
                type: z.enum(['file']),
                url: z.string().min(1)
            })])),
        role: z.enum(['user'])
    }).nullish(),
    messages: z.array(z.object({
        id: z.string(),
        parts: z.array(z.object({
            type: z.string()
        })),
        role: z.string()
    })).nullish(),
    model: z.string().nullish(),
    newUserMessageId: z.string().nullish(),
    reasoningEffort: z.enum([
        'off',
        'low',
        'medium',
        'high'
    ]).nullish(),
    selectedChatModel: z.string().nullish(),
    stream_id: z.string().nullish()
});

export const zSystemAgentControllerCheckAvailabilityResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        available: z.boolean(),
        reason: z.string().optional()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSystemAgentControllerDeleteTrailingMessagesBody = z.object({
    editedContent: z.string().optional(),
    messageId: z.string().min(1)
});

export const zSystemAgentControllerDeleteTrailingMessagesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        deleted: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSystemAgentControllerGetActiveStreamSnapshotResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        active: z.boolean(),
        messageId: z.string().optional(),
        parts: z.array(z.object({
            type: z.string()
        })).optional(),
        seq: z.int().gte(-9007199254740991).lte(9007199254740991).optional(),
        streamId: z.string().optional()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSystemAgentControllerPersistToolDenialBody = z.object({
    input: z.record(z.string(), z.unknown()).nullish(),
    messageId: z.string().min(1),
    toolCallId: z.string().min(1),
    toolName: z.string().min(1)
});

export const zSystemAgentControllerPersistToolDenialResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        persisted: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSystemAgentControllerResumeStreamResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        resumed: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zSystemAgentControllerRewriteTextBody = z.object({
    context: z.array(z.object({
        role: z.enum(['user', 'assistant']),
        text: z.string().min(1).max(4000)
    })).max(100).optional(),
    documentContext: z.string().max(40000).optional(),
    history: z.array(z.object({
        instruction: z.string().min(1).max(2000),
        result: z.string().min(1).max(20000)
    })).max(20).optional(),
    instruction: z.string().min(1).max(2000),
    language: z.enum(['en', 'ar']).optional(),
    mode: z.enum(['rewrite', 'generate']).optional(),
    preserveVoice: z.boolean().optional(),
    text: z.string().min(1).max(40000)
});

export const zSystemAgentControllerRewriteTextResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        rewrittenText: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTeamControllerGetActivityResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            actor: z.string().nullable(),
            detail: z.string().nullable(),
            id: z.string(),
            kind: z.enum([
                'signed_in',
                'joined',
                'role',
                'notice',
                'event',
                'message',
                'other'
            ]),
            occurredOn: z.string(),
            severity: z.enum(['info', 'warning']).nullable(),
            title: z.string()
        })),
        nextCursor: z.string().nullable(),
        total: z.int().gte(-9007199254740991).lte(9007199254740991).nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTeamControllerGetMemberResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        activeSessionCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        banned: z.boolean(),
        banReason: z.string().nullable(),
        createdAt: z.string(),
        customRoleId: z.string().nullable(),
        customRoleName: z.string().nullable(),
        email: z.string().nullable(),
        emailVerified: z.boolean(),
        image: z.string().nullable(),
        isActive: z.boolean(),
        isVerified: z.boolean(),
        joinedAt: z.string().nullable(),
        lastActiveAt: z.string().nullable(),
        lastSignInAt: z.string().nullable(),
        memberId: z.string().nullable(),
        name: z.string().nullable(),
        phoneE164: z.string().nullable(),
        presence: z.enum([
            'online',
            'idle',
            'offline'
        ]),
        role: z.string(),
        userId: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTeamControllerGetMemberActivityResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            actor: z.string().nullable(),
            detail: z.string().nullable(),
            id: z.string(),
            kind: z.enum([
                'signed_in',
                'joined',
                'role',
                'notice',
                'event',
                'message',
                'other'
            ]),
            occurredOn: z.string(),
            severity: z.enum(['info', 'warning']).nullable(),
            title: z.string()
        })),
        nextCursor: z.string().nullable(),
        total: z.int().gte(-9007199254740991).lte(9007199254740991).nullable()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTeamControllerGetMemberSessionsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        sessions: z.array(z.object({
            createdAt: z.string(),
            expiresAt: z.string(),
            id: z.string(),
            impersonated: z.boolean(),
            ipAddress: z.string().nullable(),
            label: z.string(),
            lastSeenAt: z.string(),
            userAgent: z.string().nullable()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTeamControllerGetOverviewResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        activeThisWeek: z.int().gte(-9007199254740991).lte(9007199254740991),
        dormantCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        onlineNow: z.int().gte(-9007199254740991).lte(9007199254740991),
        pendingInvites: z.int().gte(-9007199254740991).lte(9007199254740991),
        seatLimit: z.int().gte(-9007199254740991).lte(9007199254740991).nullable(),
        seatsUsed: z.int().gte(-9007199254740991).lte(9007199254740991),
        totalMembers: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTeamControllerGetRosterResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        members: z.array(z.object({
            banned: z.boolean(),
            customRoleName: z.string().nullable(),
            email: z.string().nullable(),
            image: z.string().nullable(),
            isActive: z.boolean(),
            joinedAt: z.string().nullable(),
            lastActiveAt: z.string().nullable(),
            memberId: z.string().nullable(),
            name: z.string().nullable(),
            presence: z.enum([
                'online',
                'idle',
                'offline'
            ]),
            role: z.string(),
            userId: z.string()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTeamControllerNotifyMemberBody = z.object({
    message: z.string().min(1).max(1000),
    severity: z.enum(['info', 'warning']).optional().default('info'),
    title: z.string().min(1).max(120)
});

export const zTeamControllerNotifyMemberResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        delivered: z.int().gte(-9007199254740991).lte(9007199254740991),
        ok: z.literal(true),
        recorded: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTeamControllerRemoveMemberResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        ok: z.literal(true),
        userId: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTeamControllerSetMemberActiveBody = z.object({
    isActive: z.boolean()
});

export const zTeamControllerSetMemberActiveResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        isActive: z.boolean(),
        ok: z.literal(true),
        userId: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTelegramOperatorControllerSendMessageBody = z.object({
    attachments: z.array(z.object({
        filename: z.string().max(255).optional(),
        mediaType: z.string().min(1).max(255),
        url: z.url().max(10000)
    })).max(20).optional(),
    message: z.string().max(100000).optional().default(''),
    replyToExternalMessageId: z.string().max(255).optional()
});

export const zTelegramOperatorControllerSendMessageResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        messageId: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTelegramOperatorControllerSendReactionBody = z.object({
    emoji: z.string().max(64),
    messageId: z.string().min(1).max(255)
});

export const zTelegramOperatorControllerSendReactionResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTelegramOperatorControllerSendTypingBody = z.object({
    typing: z.boolean()
});

export const zTelegramOperatorControllerSendTypingResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zToolsControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.array(z.object({
        category: z.enum([
            'assistant',
            'system-agent',
            'shared'
        ]),
        channels: z.array(z.string()).optional(),
        customToolId: z.string().optional(),
        description: z.string(),
        enabled: z.boolean().optional(),
        isComplete: z.boolean().optional(),
        name: z.string(),
        requiresApproval: z.boolean().optional(),
        source: z.enum(['native', 'custom']).optional()
    })).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zTypingControllerSendBody = z.object({
    _call_source: z.string().max(50).optional(),
    message_id: z.string().max(255).nullish(),
    phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/),
    typing: z.boolean()
});

export const zTypingControllerSendResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        typing: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUserProfileControllerGetProfileResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        displayName: z.string(),
        email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).nullish(),
        id: z.string(),
        isActive: z.boolean(),
        isVerified: z.boolean(),
        name: z.string().nullish(),
        role: z.enum(['superuser', 'user'])
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUserProfileControllerGetStatsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        cancelledEvents: z.int().gte(-9007199254740991).lte(9007199254740991),
        completedEvents: z.int().gte(-9007199254740991).lte(9007199254740991),
        createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
        lastSignInAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullable(),
        pendingEvents: z.int().gte(-9007199254740991).lte(9007199254740991),
        totalConversations: z.int().gte(-9007199254740991).lte(9007199254740991),
        totalEvents: z.int().gte(-9007199254740991).lte(9007199254740991),
        totalMessagesReceived: z.int().gte(-9007199254740991).lte(9007199254740991),
        totalMessagesSent: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUserProfileControllerUpdateNameBody = z.object({
    name: z.string().max(100)
});

export const zUserProfileControllerUpdateNameResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUserProfileControllerUpdateProfileBody = z.object({
    name: z.string().max(100).nullish()
});

export const zUserProfileControllerUpdateProfileResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerAdminCreateBody = z.object({
    email: z.email().max(320).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/),
    isActive: z.boolean().optional(),
    isVerified: z.boolean().optional(),
    password: z.string().min(8).max(128),
    role: z.enum(['superuser', 'user']).optional()
});

export const zUsersControllerAdminCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.object({
            email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).nullish(),
            id: z.uuid().regex(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/),
            isActive: z.boolean().nullish(),
            isVerified: z.boolean().nullish(),
            name: z.string().nullish(),
            phoneE164: z.string().nullish(),
            role: z.enum(['superuser', 'user'])
        }),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerAdminDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerAdminGetResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.object({
            email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).nullish(),
            id: z.uuid().regex(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/),
            isActive: z.boolean().nullish(),
            isVerified: z.boolean().nullish(),
            name: z.string().nullish(),
            phoneE164: z.string().nullish(),
            role: z.enum(['superuser', 'user'])
        }),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerAdminListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.array(z.object({
            email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).nullish(),
            id: z.uuid().regex(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/),
            isActive: z.boolean().nullish(),
            isVerified: z.boolean().nullish(),
            name: z.string().nullish(),
            phoneE164: z.string().nullish(),
            role: z.enum(['superuser', 'user'])
        })),
        meta: z.object({
            nextCursor: z.string().nullish()
        }).nullish(),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerAdminUpdateBody = z.object({
    email: z.email().max(320).regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).optional(),
    isActive: z.boolean().optional(),
    isVerified: z.boolean().optional(),
    name: z.string().max(200).nullish(),
    password: z.string().min(8).max(128).optional(),
    phoneE164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).nullish(),
    role: z.enum(['superuser', 'user']).optional()
});

export const zUsersControllerAdminUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.object({
            email: z.email().regex(/^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/).nullish(),
            id: z.uuid().regex(/^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/),
            isActive: z.boolean().nullish(),
            isVerified: z.boolean().nullish(),
            name: z.string().nullish(),
            phoneE164: z.string().nullish(),
            role: z.enum(['superuser', 'user'])
        }),
        success: z.literal(true)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerEnsureDocumentResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        code: z.string().nullish(),
        data: z.object({
            age: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
            document: z.record(z.string(), z.unknown()).nullish(),
            metadata: z.record(z.string(), z.unknown()).nullish(),
            name: z.string().nullish(),
            version: z.int().gte(-9007199254740991).lte(9007199254740991).nullish()
        }).nullish(),
        error: z.string().nullish(),
        message: z.string().nullish(),
        modified: z.boolean().nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerGetDocumentResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        code: z.string().nullish(),
        data: z.object({
            age: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
            document: z.record(z.string(), z.unknown()).nullish(),
            metadata: z.record(z.string(), z.unknown()).nullish(),
            name: z.string().nullish(),
            version: z.int().gte(-9007199254740991).lte(9007199254740991).nullish()
        }).nullish(),
        error: z.string().nullish(),
        message: z.string().nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerGetDocumentMetaResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        code: z.string().nullish(),
        data: z.object({
            age: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
            metadata: z.record(z.string(), z.unknown()).nullish(),
            name: z.string().nullish(),
            version: z.int().gte(-9007199254740991).lte(9007199254740991).nullish()
        }).nullish(),
        error: z.string().nullish(),
        message: z.string().nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerGetNamesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.record(z.string(), z.object({
        is_active: z.boolean(),
        is_favorite: z.boolean(),
        phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/),
        user_name: z.string().nullish()
    })).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerGetOrCreateBody = z.object({
    name: z.string().max(200).optional(),
    phoneE164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/)
});

export const zUsersControllerGetOrCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        created: z.boolean(),
        id: z.string(),
        isActive: z.boolean(),
        isFavorite: z.boolean(),
        name: z.string().nullish(),
        phoneE164: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerGetStatsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        event_count: z.int().gte(-9007199254740991).lte(9007199254740991),
        events: z.array(z.object({
            cancelled: z.boolean(),
            eventDateTime: z.string(),
            id: z.int().gte(-9007199254740991).lte(9007199254740991),
            status: z.string(),
            type: z.string()
        })),
        first_message: z.object({
            date: z.string().nullish(),
            time: z.string().nullish()
        }).nullish(),
        last_message: z.object({
            date: z.string().nullish(),
            time: z.string().nullish()
        }).nullish(),
        message_count: z.int().gte(-9007199254740991).lte(9007199254740991),
        phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/),
        user_name: z.string().nullish()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerModifyPhoneBody = z.object({
    newPhoneE164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/),
    userName: z.string().max(200).nullish()
});

export const zUsersControllerModifyPhoneResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        error: z.string().nullish(),
        phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerSaveDocumentBody = z.object({
    _call_source: z.string().max(50).optional(),
    age: z.int().gte(0).lte(200).nullish(),
    document: z.record(z.string(), z.unknown()).nullish(),
    metadata: z.record(z.string(), z.unknown()).nullish(),
    name: z.string().max(200).nullish(),
    version: z.int().gte(0).lte(9007199254740991).optional()
});

export const zUsersControllerSaveDocumentResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        code: z.string().nullish(),
        data: z.object({
            age: z.int().gte(-9007199254740991).lte(9007199254740991).nullish(),
            document: z.record(z.string(), z.unknown()).nullish(),
            metadata: z.record(z.string(), z.unknown()).nullish(),
            name: z.string().nullish(),
            version: z.int().gte(-9007199254740991).lte(9007199254740991).nullish()
        }).nullish(),
        error: z.string().nullish(),
        message: z.string().nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerSaveViewportBody = z.object({
    editorCamera: z.object({
        x: z.number(),
        y: z.number(),
        z: z.number()
    }).optional(),
    editorCamerasByPage: z.record(z.string(), z.object({
        x: z.number(),
        y: z.number(),
        z: z.number()
    })).optional(),
    editorPageId: z.string().optional(),
    editorStyles: z.record(z.string(), z.unknown()).optional(),
    viewerCamera: z.object({
        x: z.number(),
        y: z.number(),
        z: z.number()
    }).optional(),
    viewerCamerasByPage: z.record(z.string(), z.object({
        x: z.number(),
        y: z.number(),
        z: z.number()
    })).optional(),
    viewerPageId: z.string().optional()
});

export const zUsersControllerSaveViewportResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        code: z.string().nullish(),
        error: z.string().nullish(),
        message: z.string().nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerSetActiveBody = z.object({
    active: z.boolean().optional()
});

export const zUsersControllerSetActiveResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        error: z.string().nullish(),
        is_active: z.boolean().nullish(),
        phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zUsersControllerSetFavoriteBody = z.object({
    favorite: z.boolean().optional()
});

export const zUsersControllerSetFavoriteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        error: z.string().nullish(),
        is_favorite: z.boolean().nullish(),
        phone_e164: z.string().max(16).regex(/^\+[1-9]\d{1,14}$/).nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zVacationsControllerDeleteBody = z.object({
    source: z.string().optional()
});

export const zVacationsControllerDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        message: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zVacationsControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.array(z.object({
        endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
        id: z.string(),
        note: z.string().nullish(),
        startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/)
    })).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zVacationsControllerRestoreBody = z.object({
    periods: z.array(z.object({
        endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
        id: z.string().nullish(),
        note: z.string().nullish(),
        startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/)
    })),
    source: z.string().optional()
});

export const zVacationsControllerRestoreResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        message: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zVacationsControllerUpdateBody = z.object({
    periods: z.array(z.object({
        endDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
        id: z.string().nullish(),
        note: z.string().nullish(),
        startDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/)
    })),
    source: z.string().optional()
});

export const zVacationsControllerUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        message: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zVacationTemplatesControllerCreateBody = z.object({
    message: z.string(),
    name: z.string().min(1).max(120)
});

export const zVacationTemplatesControllerCreateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        id: z.string(),
        message: z.string(),
        name: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zVacationTemplatesControllerDeleteResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        message: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zVacationTemplatesControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.array(z.object({
        id: z.string(),
        message: z.string(),
        name: z.string()
    })).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zVacationTemplatesControllerUpdateBody = z.object({
    message: z.string(),
    name: z.string().min(1).max(120)
});

export const zVacationTemplatesControllerUpdateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        id: z.string(),
        message: z.string(),
        name: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWaitlistControllerCancelBody = z.object({
    contactId: z.string().min(1)
});

export const zWaitlistControllerCancelResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.record(z.string(), z.unknown()).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWaitlistControllerCountsResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        activeEntries: z.int().gte(0).lte(9007199254740991),
        bookingsThisWeek: z.int().gte(0).lte(9007199254740991),
        openOffers: z.array(z.object({
            contactId: z.string().optional(),
            eventTypeId: z.string(),
            expiresAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            id: z.string().regex(/^\d+$/),
            slotStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWaitlistControllerJoinBody = z.object({
    contactId: z.string().min(1),
    desiredUntil: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    desiredWhen: z.union([
        z.object({
            kind: z.enum(['slot']),
            slotStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
        }),
        z.object({
            dateEnd: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
            dateStart: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
            kind: z.enum(['window']),
            timeEnd: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).optional(),
            timeStart: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).optional(),
            weekdays: z.array(z.int().gte(0).lte(6)).max(7).optional()
        })
    ]),
    eventTypeId: z.string().min(1),
    note: z.string().max(1000).nullish()
});

export const zWaitlistControllerJoinResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.record(z.string(), z.unknown()).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWaitlistControllerListResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        items: z.array(z.object({
            contact: z.object({
                id: z.string(),
                name: z.string().nullable(),
                nickname: z.string().nullable(),
                phoneE164: z.string().nullable()
            }),
            createdAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
            desiredWhen: z.union([
                z.object({
                    kind: z.enum(['slot']),
                    slotStart: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
                }),
                z.object({
                    dateEnd: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
                    dateStart: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
                    kind: z.enum(['window']),
                    timeEnd: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).optional(),
                    timeStart: z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/).optional(),
                    weekdays: z.array(z.int().gte(0).lte(6)).max(7).optional()
                })
            ]),
            eventType: z.object({
                colorBackground: z.string().nullable(),
                id: z.string(),
                label: z.string()
            }),
            id: z.string().regex(/^\d+$/),
            offeredCount: z.int().gte(0).lte(9007199254740991),
            position: z.int().lte(9007199254740991).nullable(),
            source: z.enum(['agent', 'local']),
            status: z.enum([
                'ACTIVE',
                'OFFERED',
                'FULFILLED',
                'CANCELLED',
                'LAPSED'
            ])
        })),
        total: z.int().gte(0).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerBlockUsersBody = z.object({
    phoneE164s: z.array(z.string().min(1)).min(1)
});

export const zWhatsappControllerBlockUsersResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        blockedCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerBroadcastBody = z.object({
    message: z.string().min(1),
    phoneE164s: z.array(z.string().min(1)).min(1)
});

export const zWhatsappControllerBroadcastResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        sentCount: z.int().gte(-9007199254740991).lte(9007199254740991),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerCancelReplyBody = z.object({
    phone_e164: z.string().min(1)
});

export const zWhatsappControllerCancelReplyResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean(),
        value: z.unknown().nullish()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerCheckAvailabilityResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        available: z.boolean(),
        reason: z.string().optional()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerCreateTemplateBody = z.object({
    category: z.enum([
        'UTILITY',
        'MARKETING',
        'AUTHENTICATION'
    ]),
    components: z.array(z.union([
        z.object({
            example: z.object({
                header_handle: z.array(z.string().min(1)).min(1).optional(),
                header_text: z.array(z.string().min(1)).min(1).optional()
            }).optional(),
            format: z.enum([
                'TEXT',
                'IMAGE',
                'VIDEO',
                'DOCUMENT',
                'LOCATION'
            ]),
            text: z.string().min(1).max(60).optional(),
            type: z.enum(['HEADER'])
        }),
        z.object({
            example: z.object({
                body_text: z.array(z.array(z.string().min(1))).min(1).optional(),
                body_text_named_params: z.array(z.object({
                    example: z.string().min(1),
                    param_name: z.string().regex(/^[a-z_]{1,20}$/)
                })).min(1).optional()
            }).optional(),
            text: z.string().min(1).max(1024),
            type: z.enum(['BODY'])
        }),
        z.object({
            text: z.string().min(1).max(60),
            type: z.enum(['FOOTER'])
        }),
        z.object({
            buttons: z.array(z.union([
                z.object({
                    text: z.string().min(1).max(25),
                    type: z.enum(['QUICK_REPLY'])
                }),
                z.object({
                    example: z.array(z.string().min(1)).max(1).optional(),
                    text: z.string().min(1).max(25),
                    type: z.enum(['URL']),
                    url: z.url()
                }),
                z.object({
                    phone_number: z.string().regex(/^\+[1-9]\d{6,14}$/),
                    text: z.string().min(1).max(25),
                    type: z.enum(['PHONE_NUMBER'])
                }),
                z.object({
                    example: z.string().min(1).optional(),
                    type: z.enum(['COPY_CODE'])
                })
            ])).min(1).max(10),
            type: z.enum(['BUTTONS'])
        })
    ])).min(1).max(4),
    language: z.string().min(2).max(16),
    name: z.string().regex(/^[a-z0-9_]{1,512}$/),
    parameterFormat: z.enum(['POSITIONAL', 'NAMED']).optional().default('POSITIONAL')
});

export const zWhatsappControllerCreateTemplateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        template: z.object({
            canDelete: z.boolean().optional(),
            canEdit: z.boolean().optional(),
            category: z.string(),
            components: z.array(z.object({
                buttons: z.array(z.object({
                    phone_number: z.string().optional(),
                    text: z.string(),
                    type: z.string(),
                    url: z.string().optional()
                })).optional(),
                format: z.string().optional(),
                text: z.string().optional(),
                type: z.enum([
                    'HEADER',
                    'BODY',
                    'FOOTER',
                    'BUTTONS'
                ])
            })),
            coveredByPlan: z.boolean().optional(),
            id: z.string(),
            language: z.string(),
            lastSyncedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
            metaTemplateId: z.string().nullish(),
            name: z.string(),
            parameterFormat: z.enum(['POSITIONAL', 'NAMED']).nullish(),
            qualityScore: z.string().nullish(),
            rejectionReason: z.string().nullish(),
            status: z.string(),
            statusUpdatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerDeleteTemplateBody = z.object({
    force: z.boolean().optional().default(false),
    language: z.string().min(2).max(16).optional(),
    name: z.string().regex(/^[a-z0-9_]{1,512}$/)
});

export const zWhatsappControllerDeleteTemplateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        templates: z.array(z.object({
            canDelete: z.boolean().optional(),
            canEdit: z.boolean().optional(),
            category: z.string(),
            components: z.array(z.object({
                buttons: z.array(z.object({
                    phone_number: z.string().optional(),
                    text: z.string(),
                    type: z.string(),
                    url: z.string().optional()
                })).optional(),
                format: z.string().optional(),
                text: z.string().optional(),
                type: z.enum([
                    'HEADER',
                    'BODY',
                    'FOOTER',
                    'BUTTONS'
                ])
            })),
            coveredByPlan: z.boolean().optional(),
            id: z.string(),
            language: z.string(),
            lastSyncedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
            metaTemplateId: z.string().nullish(),
            name: z.string(),
            parameterFormat: z.enum(['POSITIONAL', 'NAMED']).nullish(),
            qualityScore: z.string().nullish(),
            rejectionReason: z.string().nullish(),
            status: z.string(),
            statusUpdatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerEditTemplateBody = z.object({
    category: z.enum([
        'UTILITY',
        'MARKETING',
        'AUTHENTICATION'
    ]).optional(),
    components: z.array(z.union([
        z.object({
            example: z.object({
                header_handle: z.array(z.string().min(1)).min(1).optional(),
                header_text: z.array(z.string().min(1)).min(1).optional()
            }).optional(),
            format: z.enum([
                'TEXT',
                'IMAGE',
                'VIDEO',
                'DOCUMENT',
                'LOCATION'
            ]),
            text: z.string().min(1).max(60).optional(),
            type: z.enum(['HEADER'])
        }),
        z.object({
            example: z.object({
                body_text: z.array(z.array(z.string().min(1))).min(1).optional(),
                body_text_named_params: z.array(z.object({
                    example: z.string().min(1),
                    param_name: z.string().regex(/^[a-z_]{1,20}$/)
                })).min(1).optional()
            }).optional(),
            text: z.string().min(1).max(1024),
            type: z.enum(['BODY'])
        }),
        z.object({
            text: z.string().min(1).max(60),
            type: z.enum(['FOOTER'])
        }),
        z.object({
            buttons: z.array(z.union([
                z.object({
                    text: z.string().min(1).max(25),
                    type: z.enum(['QUICK_REPLY'])
                }),
                z.object({
                    example: z.array(z.string().min(1)).max(1).optional(),
                    text: z.string().min(1).max(25),
                    type: z.enum(['URL']),
                    url: z.url()
                }),
                z.object({
                    phone_number: z.string().regex(/^\+[1-9]\d{6,14}$/),
                    text: z.string().min(1).max(25),
                    type: z.enum(['PHONE_NUMBER'])
                }),
                z.object({
                    example: z.string().min(1).optional(),
                    type: z.enum(['COPY_CODE'])
                })
            ])).min(1).max(10),
            type: z.enum(['BUTTONS'])
        })
    ])).min(1).max(4).optional(),
    parameterFormat: z.enum(['POSITIONAL', 'NAMED']).optional()
});

export const zWhatsappControllerEditTemplateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        template: z.object({
            canDelete: z.boolean().optional(),
            canEdit: z.boolean().optional(),
            category: z.string(),
            components: z.array(z.object({
                buttons: z.array(z.object({
                    phone_number: z.string().optional(),
                    text: z.string(),
                    type: z.string(),
                    url: z.string().optional()
                })).optional(),
                format: z.string().optional(),
                text: z.string().optional(),
                type: z.enum([
                    'HEADER',
                    'BODY',
                    'FOOTER',
                    'BUTTONS'
                ])
            })),
            coveredByPlan: z.boolean().optional(),
            id: z.string(),
            language: z.string(),
            lastSyncedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
            metaTemplateId: z.string().nullish(),
            name: z.string(),
            parameterFormat: z.enum(['POSITIONAL', 'NAMED']).nullish(),
            qualityScore: z.string().nullish(),
            rejectionReason: z.string().nullish(),
            status: z.string(),
            statusUpdatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish()
        })
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerFetchMediaResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        contentLength: z.int().gte(-9007199254740991).lte(9007199254740991),
        contentType: z.string()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerListTemplatesResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        stale: z.boolean().optional(),
        success: z.boolean(),
        templates: z.array(z.object({
            canDelete: z.boolean().optional(),
            canEdit: z.boolean().optional(),
            category: z.string(),
            components: z.array(z.object({
                buttons: z.array(z.object({
                    phone_number: z.string().optional(),
                    text: z.string(),
                    type: z.string(),
                    url: z.string().optional()
                })).optional(),
                format: z.string().optional(),
                text: z.string().optional(),
                type: z.enum([
                    'HEADER',
                    'BODY',
                    'FOOTER',
                    'BUTTONS'
                ])
            })),
            coveredByPlan: z.boolean().optional(),
            id: z.string(),
            language: z.string(),
            lastSyncedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish(),
            metaTemplateId: z.string().nullish(),
            name: z.string(),
            parameterFormat: z.enum(['POSITIONAL', 'NAMED']).nullish(),
            qualityScore: z.string().nullish(),
            rejectionReason: z.string().nullish(),
            status: z.string(),
            statusUpdatedAt: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).nullish()
        }))
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerMarkAsReadBody = z.object({
    messageId: z.string().optional(),
    phone_e164: z.string().min(1)
});

export const zWhatsappControllerMarkAsReadResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerSendLocationBody = z.object({
    address: z.string().optional(),
    latitude: z.number(),
    longitude: z.number(),
    name: z.string().optional(),
    phone_e164: z.string().min(1)
});

export const zWhatsappControllerSendLocationResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        error: z.string().nullish(),
        message: z.string().nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerSendMessageBody = z.object({
    _call_source: z.string().optional(),
    attachments: z.array(z.object({
        caption: z.string().max(1024).nullish(),
        mediaType: z.string().min(1).max(200).nullish(),
        name: z.string().min(1).max(200).nullish(),
        type: z.enum([
            'image',
            'document',
            'audio',
            'video'
        ]),
        url: z.string().min(1)
    })).max(20).optional(),
    message: z.string().min(1),
    phone_e164: z.string().min(1),
    replyToMessageId: z.string().min(1).max(255).optional()
});

export const zWhatsappControllerSendMessageResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        data: z.object({
            message_id: z.string().min(1),
            request_timestamp: z.string().nullish()
        }).nullish(),
        error: z.string().nullish(),
        message: z.string().nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerSendReactionBody = z.object({
    emoji: z.string().min(1),
    messageId: z.string().min(1),
    phone_e164: z.string().min(1)
});

export const zWhatsappControllerSendReactionResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerSendTemplateBody = z.object({
    components: z.array(z.record(z.string(), z.unknown())).optional(),
    language: z.string().optional(),
    phone_e164: z.string().regex(/^\+[1-9]\d{1,14}$/),
    template_name: z.string().min(1)
});

export const zWhatsappControllerSendTemplateResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        error: z.string().nullish(),
        message: z.string().nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerSendTypingIndicatorBody = z.object({
    message_id: z.string().optional(),
    phone_e164: z.string().min(1),
    typing: z.boolean()
});

export const zWhatsappControllerSendTypingIndicatorResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean(),
        value: z.unknown().nullish()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerTemplateCapabilityResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        manageable: z.boolean(),
        reason: z.enum([
            'missing_permission',
            'invalid_token',
            'not_configured'
        ]).optional()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerTestConfigResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        details: z.unknown().optional(),
        error: z.string().nullish(),
        message: z.string().nullish(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerUnblockUsersBody = z.object({
    phoneE164s: z.array(z.string().min(1)).min(1)
});

export const zWhatsappControllerUnblockUsersResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        success: z.boolean(),
        unblockedCount: z.int().gte(-9007199254740991).lte(9007199254740991)
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zWhatsappControllerUploadMediaBody = z.object({
    file: z.string().min(1),
    mimeType: z.string().min(1)
});

export const zWhatsappControllerUploadMediaResponse = z.object({
    code: z.string().optional(),
    details: z.unknown().optional(),
    errors: z.array(z.string()),
    payload: z.object({
        mediaId: z.string(),
        success: z.boolean()
    }).nullable(),
    statusCode: z.number(),
    success: z.boolean()
});

export const zAccountNotificationsControllerGetResponse2 = zAccountNotificationsControllerGetResponse;

export const zAccountNotificationsControllerUpdateBody2 = zAccountNotificationsControllerUpdateBody;

export const zAccountNotificationsControllerUpdateResponse2 = zAccountNotificationsControllerUpdateResponse;

export const zAccountPrivacyControllerCancelDeletionResponse2 = zAccountPrivacyControllerCancelDeletionResponse;

export const zAccountPrivacyControllerGetDeletionRequestResponse2 = zAccountPrivacyControllerGetDeletionRequestResponse;

export const zAccountPrivacyControllerRequestDeletionBody2 = zAccountPrivacyControllerRequestDeletionBody;

export const zAccountPrivacyControllerRequestDeletionResponse2 = zAccountPrivacyControllerRequestDeletionResponse;

export const zAccountPrivacyControllerExportCountsQuery = z.object({
    from: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/),
    to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/)
});

export const zAccountPrivacyControllerExportCountsResponse2 = zAccountPrivacyControllerExportCountsResponse;

export const zAccountPrivacyControllerListExportsResponse2 = zAccountPrivacyControllerListExportsResponse;

export const zAccountPrivacyControllerRequestExportBody2 = zAccountPrivacyControllerRequestExportBody;

export const zAccountPrivacyControllerRequestExportResponse2 = zAccountPrivacyControllerRequestExportResponse;

export const zDataExportDownloadControllerDownloadPath = z.object({
    id: z.string()
});

export const zOnboardingControllerAssignUserToExistingOrgBody2 = zOnboardingControllerAssignUserToExistingOrgBody;

export const zOnboardingControllerAssignUserToExistingOrgResponse2 = zOnboardingControllerAssignUserToExistingOrgResponse;

export const zOnboardingControllerAssignUserToNewOrgBody2 = zOnboardingControllerAssignUserToNewOrgBody;

export const zOnboardingControllerAssignUserToNewOrgResponse2 = zOnboardingControllerAssignUserToNewOrgResponse;

export const zOnboardingControllerListWaitingUsersResponse2 = zOnboardingControllerListWaitingUsersResponse;

export const zJobsControllerListJobSchedulersQuery = z.object({
    start: z.string(),
    end: z.string(),
    asc: z.string()
});

export const zJobsControllerListJobSchedulersResponse2 = zJobsControllerListJobSchedulersResponse;

export const zJobsControllerRemoveJobSchedulerPath = z.object({
    id: z.string()
});

export const zJobsControllerRemoveJobSchedulerResponse2 = zJobsControllerRemoveJobSchedulerResponse;

export const zJobsControllerGetJobSchedulerPath = z.object({
    id: z.string()
});

export const zJobsControllerGetJobSchedulerResponse2 = zJobsControllerGetJobSchedulerResponse;

export const zUsersControllerAdminListQuery = z.object({
    limit: z.int().gte(1).lte(100).optional(),
    cursor: z.string().max(255).optional(),
    search: z.string().max(200).optional()
});

export const zUsersControllerAdminListResponse2 = zUsersControllerAdminListResponse;

export const zUsersControllerAdminCreateBody2 = zUsersControllerAdminCreateBody;

export const zUsersControllerAdminCreateResponse2 = zUsersControllerAdminCreateResponse;

export const zUsersControllerAdminDeletePath = z.object({
    id: z.string()
});

export const zUsersControllerAdminDeleteResponse2 = zUsersControllerAdminDeleteResponse;

export const zUsersControllerAdminGetPath = z.object({
    id: z.string()
});

export const zUsersControllerAdminGetResponse2 = zUsersControllerAdminGetResponse;

export const zUsersControllerAdminUpdateBody2 = zUsersControllerAdminUpdateBody;

export const zUsersControllerAdminUpdatePath = z.object({
    id: z.string()
});

export const zUsersControllerAdminUpdateResponse2 = zUsersControllerAdminUpdateResponse;

export const zCampaignsControllerListQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(50),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
    search: z.string().min(1).max(120).optional(),
    status: z.union([
        z.object({
            op: z.enum([
                'is',
                'isNot',
                'blank',
                'notBlank'
            ]),
            value: z.enum([
                'DRAFT',
                'SENDING',
                'COMPLETED',
                'FAILED',
                'CANCELLED'
            ]).optional()
        }),
        z.enum([
            'DRAFT',
            'SENDING',
            'COMPLETED',
            'FAILED',
            'CANCELLED'
        ])
    ]).optional()
});

export const zCampaignsControllerListResponse2 = zCampaignsControllerListResponse;

export const zCampaignsControllerCreateBody2 = zCampaignsControllerCreateBody;

export const zCampaignsControllerCreateResponse2 = zCampaignsControllerCreateResponse;

export const zCampaignsControllerDeletePath = z.object({
    campaignId: z.string()
});

export const zCampaignsControllerDeleteResponse2 = zCampaignsControllerDeleteResponse;

export const zCampaignsControllerGetPath = z.object({
    campaignId: z.string()
});

export const zCampaignsControllerGetResponse2 = zCampaignsControllerGetResponse;

export const zCampaignsControllerUpdateBody2 = zCampaignsControllerUpdateBody;

export const zCampaignsControllerUpdatePath = z.object({
    campaignId: z.string()
});

export const zCampaignsControllerUpdateResponse2 = zCampaignsControllerUpdateResponse;

export const zCampaignsControllerCancelPath = z.object({
    campaignId: z.string()
});

export const zCampaignsControllerCancelResponse2 = zCampaignsControllerCancelResponse;

export const zCampaignsControllerRecipientsPath = z.object({
    campaignId: z.string()
});

export const zCampaignsControllerRecipientsQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(50),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
    search: z.string().min(1).max(120).optional(),
    status: z.union([
        z.object({
            op: z.enum([
                'is',
                'isNot',
                'blank',
                'notBlank'
            ]),
            value: z.enum([
                'QUEUED',
                'SENDING',
                'SENT',
                'DELIVERED',
                'READ',
                'REPLIED',
                'FAILED'
            ]).optional()
        }),
        z.enum([
            'QUEUED',
            'SENDING',
            'SENT',
            'DELIVERED',
            'READ',
            'REPLIED',
            'FAILED'
        ])
    ]).optional()
});

export const zCampaignsControllerRecipientsResponse2 = zCampaignsControllerRecipientsResponse;

export const zCampaignsControllerLaunchPath = z.object({
    campaignId: z.string()
});

export const zCampaignsControllerLaunchResponse2 = zCampaignsControllerLaunchResponse;

export const zCampaignsControllerPreviewCapacityBody2 = zCampaignsControllerPreviewCapacityBody;

export const zCampaignsControllerPreviewCapacityResponse2 = zCampaignsControllerPreviewCapacityResponse;

export const zCampaignsControllerMetaLimitsResponse2 = zCampaignsControllerMetaLimitsResponse;

export const zChartsControllerOpenPath = z.object({
    contactId: z.string()
});

export const zChartsControllerOpenResponse2 = zChartsControllerOpenResponse;

export const zChartsControllerPatchBody2 = zChartsControllerPatchBody;

export const zChartsControllerPatchPath = z.object({
    contactId: z.string()
});

export const zChartsControllerPatchResponse2 = zChartsControllerPatchResponse;

export const zChartsControllerDeletePagePath = z.object({
    contactId: z.string(),
    pageId: z.string()
});

export const zChartsControllerDeletePageResponse2 = zChartsControllerDeletePageResponse;

export const zChartsControllerGetPagePath = z.object({
    contactId: z.string(),
    pageId: z.string()
});

export const zChartsControllerGetPageResponse2 = zChartsControllerGetPageResponse;

export const zChartsControllerSavePageBody2 = zChartsControllerSavePageBody;

export const zChartsControllerSavePagePath = z.object({
    contactId: z.string(),
    pageId: z.string()
});

export const zChartsControllerSavePageResponse2 = zChartsControllerSavePageResponse;

export const zChartsControllerReassignBody2 = zChartsControllerReassignBody;

export const zChartsControllerReassignPath = z.object({
    contactId: z.string(),
    pageId: z.string()
});

export const zChartsControllerReassignResponse2 = zChartsControllerReassignResponse;

export const zHealthControllerHealthResponse2 = zHealthControllerHealthResponse;

export const zHealthControllerDoclingResponse2 = zHealthControllerDoclingResponse;

export const zHealthControllerLivenessResponse2 = zHealthControllerLivenessResponse;

export const zHealthControllerReadinessResponse2 = zHealthControllerReadinessResponse;

export const zHealthControllerSecretsResponse2 = zHealthControllerSecretsResponse;

export const zLeadsControllerSubmitBody2 = zLeadsControllerSubmitBody;

export const zLeadsControllerSubmitResponse2 = zLeadsControllerSubmitResponse;

export const zMeControllerGetOrgContextResponse2 = zMeControllerGetOrgContextResponse;

export const zUserProfileControllerGetProfileResponse2 = zUserProfileControllerGetProfileResponse;

export const zUserProfileControllerUpdateProfileBody2 = zUserProfileControllerUpdateProfileBody;

export const zUserProfileControllerUpdateProfileResponse2 = zUserProfileControllerUpdateProfileResponse;

export const zUserProfileControllerUpdateNameBody2 = zUserProfileControllerUpdateNameBody;

export const zUserProfileControllerUpdateNameResponse2 = zUserProfileControllerUpdateNameResponse;

export const zUserProfileControllerGetStatsResponse2 = zUserProfileControllerGetStatsResponse;

export const zMessageControllerGetTranslationQuery = z.object({
    key: z.string().min(1).max(200),
    ar: z.string().max(5).optional()
});

export const zMessageControllerGetTranslationResponse2 = zMessageControllerGetTranslationResponse;

export const zNotificationsControllerGetHistoryQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(50),
    cursor: z.string().optional()
});

export const zNotificationsControllerGetHistoryResponse2 = zNotificationsControllerGetHistoryResponse;

export const zNotificationsControllerPushUnsubscribeBody2 = zNotificationsControllerPushUnsubscribeBody;

export const zNotificationsControllerPushUnsubscribeResponse2 = zNotificationsControllerPushUnsubscribeResponse;

export const zNotificationsControllerPushSubscribeBody2 = zNotificationsControllerPushSubscribeBody;

export const zNotificationsControllerPushSubscribeResponse2 = zNotificationsControllerPushSubscribeResponse;

export const zNotificationsControllerListPushSubscriptionsResponse2 = zNotificationsControllerListPushSubscriptionsResponse;

export const zNotificationsControllerRevokePushSubscriptionPath = z.object({
    id: z.string()
});

export const zNotificationsControllerRevokePushSubscriptionResponse2 = zNotificationsControllerRevokePushSubscriptionResponse;

export const zNotificationsControllerGetVapidPublicKeyResponse2 = zNotificationsControllerGetVapidPublicKeyResponse;

export const zOnboardingControllerCompleteSetupResponse2 = zOnboardingControllerCompleteSetupResponse;

export const zOnboardingControllerSetIntentBody2 = zOnboardingControllerSetIntentBody;

export const zOnboardingControllerSetIntentResponse2 = zOnboardingControllerSetIntentResponse;

export const zOnboardingControllerGetSetupStatusResponse2 = zOnboardingControllerGetSetupStatusResponse;

export const zOrganizationsControllerGetByIdPath = z.object({
    id: z.string()
});

export const zOrganizationsControllerGetByIdResponse2 = zOrganizationsControllerGetByIdResponse;

export const zOrganizationsControllerSoftDeleteBody2 = zOrganizationsControllerSoftDeleteBody;

export const zOrganizationsControllerSoftDeleteResponse2 = zOrganizationsControllerSoftDeleteResponse;

export const zAdminSchedulersControllerListJobSchedulersPath = z.object({
    orgId: z.string()
});

export const zAdminSchedulersControllerListJobSchedulersQuery = z.object({
    start: z.int().gte(0).lte(9007199254740991).optional().default(0),
    end: z.int().gte(0).lte(9007199254740991).optional().default(50),
    asc: z.string().optional()
});

export const zAdminSchedulersControllerListJobSchedulersResponse2 = zAdminSchedulersControllerListJobSchedulersResponse;

export const zAdminSchedulersControllerRemoveJobSchedulerPath = z.object({
    orgId: z.string()
});

export const zAdminSchedulersControllerRemoveJobSchedulerResponse2 = zAdminSchedulersControllerRemoveJobSchedulerResponse;

export const zAdminSchedulersControllerGetJobSchedulerPath = z.object({
    orgId: z.string()
});

export const zAdminSchedulersControllerGetJobSchedulerResponse2 = zAdminSchedulersControllerGetJobSchedulerResponse;

export const zAdminSecretsControllerListSecretsPath = z.object({
    orgId: z.string()
});

export const zAdminSecretsControllerListSecretsQuery = z.object({
    prefix: z.string().max(200).optional()
});

export const zAdminSecretsControllerListSecretsResponse2 = zAdminSecretsControllerListSecretsResponse;

export const zAdminSecretsControllerCheckSecretExistsPath = z.object({
    orgId: z.string()
});

export const zAdminSecretsControllerCheckSecretExistsResponse2 = zAdminSecretsControllerCheckSecretExistsResponse;

export const zAdminWebhooksControllerRetryWebhookDeliveryPath = z.object({
    orgId: z.string()
});

export const zAdminWebhooksControllerRetryWebhookDeliveryResponse2 = zAdminWebhooksControllerRetryWebhookDeliveryResponse;

export const zAiModelsControllerListBenchmarksPath = z.object({
    orgId: z.string()
});

export const zAiModelsControllerListBenchmarksResponse2 = zAiModelsControllerListBenchmarksResponse;

export const zAiModelsControllerListPath = z.object({
    orgId: z.string()
});

export const zAiModelsControllerListResponse2 = zAiModelsControllerListResponse;

export const zAiModelsControllerListProvidersPath = z.object({
    orgId: z.string()
});

export const zAiModelsControllerListProvidersResponse2 = zAiModelsControllerListProvidersResponse;

export const zAiUsageControllerGetPath = z.object({
    orgId: z.string()
});

export const zAiUsageControllerGetQuery = z.object({
    period: z.string().optional().default('month'),
    from: z.string().max(30).optional(),
    to: z.string().max(30).optional(),
    channel: z.string().optional(),
    groupBy: z.object({
        day: z.boolean().optional(),
        user: z.boolean().optional()
    }).optional(),
    userLimit: z.int().gte(1).lte(100).optional().default(5),
    userOffset: z.int().gte(0).lte(9007199254740991).optional().default(0)
});

export const zAiUsageControllerGetResponse2 = zAiUsageControllerGetResponse;

export const zApiKeysControllerListMinePath = z.object({
    orgId: z.string()
});

export const zApiKeysControllerListMineQuery = z.object({
    limit: z.int().gte(1).lte(200).optional().default(50),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
    withinDays: z.int().gte(1).lte(365).optional().default(14)
});

export const zApiKeysControllerListMineResponse2 = zApiKeysControllerListMineResponse;

export const zAppFeedbackControllerListPath = z.object({
    orgId: z.string()
});

export const zAppFeedbackControllerListQuery = z.object({
    category: z.string().optional(),
    status: z.string().optional(),
    limit: z.int().gte(1).lte(200).optional()
});

export const zAppFeedbackControllerListResponse2 = zAppFeedbackControllerListResponse;

export const zAppFeedbackControllerSubmitBody2 = zAppFeedbackControllerSubmitBody;

export const zAppFeedbackControllerSubmitPath = z.object({
    orgId: z.string()
});

export const zAppFeedbackControllerSubmitResponse2 = zAppFeedbackControllerSubmitResponse;

export const zAppFeedbackControllerUpdateStatusBody2 = zAppFeedbackControllerUpdateStatusBody;

export const zAppFeedbackControllerUpdateStatusPath = z.object({
    orgId: z.string()
});

export const zAppFeedbackControllerUpdateStatusResponse2 = zAppFeedbackControllerUpdateStatusResponse;

export const zBillingControllerGetCheckoutSessionStatusBody2 = zBillingControllerGetCheckoutSessionStatusBody;

export const zBillingControllerGetCheckoutSessionStatusResponse2 = zBillingControllerGetCheckoutSessionStatusResponse;

export const zBillingControllerListInvoicesPath = z.object({
    orgId: z.string()
});

export const zBillingControllerListInvoicesResponse2 = zBillingControllerListInvoicesResponse;

export const zBillingControllerGetPricingResponse2 = zBillingControllerGetPricingResponse;

export const zBillingControllerGetStatusPath = z.object({
    orgId: z.string()
});

export const zBillingControllerGetStatusResponse2 = zBillingControllerGetStatusResponse;

export const zBillingControllerSyncAfterCheckoutPath = z.object({
    orgId: z.string()
});

export const zBillingControllerSyncAfterCheckoutResponse2 = zBillingControllerSyncAfterCheckoutResponse;

export const zBillingControllerGetUpcomingInvoicePath = z.object({
    orgId: z.string()
});

export const zBillingControllerGetUpcomingInvoiceResponse2 = zBillingControllerGetUpcomingInvoiceResponse;

export const zBillingControllerGetUsagePath = z.object({
    orgId: z.string()
});

export const zBillingControllerGetUsageResponse2 = zBillingControllerGetUsageResponse;

export const zCapturedLeadsControllerListLeadsPath = z.object({
    orgId: z.string()
});

export const zCapturedLeadsControllerListLeadsQuery = z.object({
    contactId: z.string().optional(),
    channel: z.string().optional(),
    includeDeleted: z.boolean().default(false),
    limit: z.int().gte(1).lte(500).optional(),
    offset: z.int().gte(0).lte(9007199254740991).optional(),
    from: z.string().max(30).optional(),
    to: z.string().max(30).optional()
});

export const zCapturedLeadsControllerListLeadsResponse2 = zCapturedLeadsControllerListLeadsResponse;

export const zCapturedLeadsControllerSoftDeleteLeadPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zCapturedLeadsControllerSoftDeleteLeadResponse2 = zCapturedLeadsControllerSoftDeleteLeadResponse;

export const zCapturedLeadsControllerUpdateLeadBody2 = zCapturedLeadsControllerUpdateLeadBody;

export const zCapturedLeadsControllerUpdateLeadPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zCapturedLeadsControllerUpdateLeadResponse2 = zCapturedLeadsControllerUpdateLeadResponse;

export const zCapturedLeadsControllerHardDeleteLeadPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zCapturedLeadsControllerHardDeleteLeadResponse2 = zCapturedLeadsControllerHardDeleteLeadResponse;

export const zCapturedLeadsControllerRestoreLeadPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zCapturedLeadsControllerRestoreLeadResponse2 = zCapturedLeadsControllerRestoreLeadResponse;

export const zCapturedLeadsControllerListFieldDefinitionsPath = z.object({
    orgId: z.string()
});

export const zCapturedLeadsControllerListFieldDefinitionsResponse2 = zCapturedLeadsControllerListFieldDefinitionsResponse;

export const zCapturedLeadsControllerUpsertFieldDefinitionsBody2 = zCapturedLeadsControllerUpsertFieldDefinitionsBody;

export const zCapturedLeadsControllerUpsertFieldDefinitionsPath = z.object({
    orgId: z.string()
});

export const zCapturedLeadsControllerUpsertFieldDefinitionsResponse2 = zCapturedLeadsControllerUpsertFieldDefinitionsResponse;

export const zConfigControllerGetPath = z.object({
    orgId: z.string()
});

export const zConfigControllerGetResponse2 = zConfigControllerGetResponse;

export const zConfigControllerCreateBody2 = zConfigControllerCreateBody;

export const zConfigControllerCreatePath = z.object({
    orgId: z.string()
});

export const zConfigControllerCreateResponse2 = zConfigControllerCreateResponse;

export const zConfigControllerUpdateBody2 = zConfigControllerUpdateBody;

export const zConfigControllerUpdatePath = z.object({
    orgId: z.string()
});

export const zConfigControllerUpdateResponse2 = zConfigControllerUpdateResponse;

export const zConfigControllerListAiPresetsPath = z.object({
    orgId: z.string()
});

export const zConfigControllerListAiPresetsResponse2 = zConfigControllerListAiPresetsResponse;

export const zConfigControllerCreateAiPresetBody2 = zConfigControllerCreateAiPresetBody;

export const zConfigControllerCreateAiPresetPath = z.object({
    orgId: z.string()
});

export const zConfigControllerCreateAiPresetResponse2 = zConfigControllerCreateAiPresetResponse;

export const zConfigControllerDeleteAiPresetPath = z.object({
    orgId: z.string(),
    presetId: z.string()
});

export const zConfigControllerDeleteAiPresetResponse2 = zConfigControllerDeleteAiPresetResponse;

export const zConfigControllerGetAiPresetPath = z.object({
    orgId: z.string(),
    presetId: z.string()
});

export const zConfigControllerGetAiPresetResponse2 = zConfigControllerGetAiPresetResponse;

export const zConfigControllerUpdateAiPresetBody2 = zConfigControllerUpdateAiPresetBody;

export const zConfigControllerUpdateAiPresetPath = z.object({
    orgId: z.string(),
    presetId: z.string()
});

export const zConfigControllerUpdateAiPresetResponse2 = zConfigControllerUpdateAiPresetResponse;

export const zConfigControllerActivateAiPresetPath = z.object({
    orgId: z.string(),
    presetId: z.string()
});

export const zConfigControllerActivateAiPresetResponse2 = zConfigControllerActivateAiPresetResponse;

export const zConfigControllerUpdateAiPresetRagDocumentsBody2 = zConfigControllerUpdateAiPresetRagDocumentsBody;

export const zConfigControllerUpdateAiPresetRagDocumentsPath = z.object({
    orgId: z.string(),
    presetId: z.string()
});

export const zConfigControllerUpdateAiPresetRagDocumentsResponse2 = zConfigControllerUpdateAiPresetRagDocumentsResponse;

export const zConfigControllerListAiPresetChannelBindingsPath = z.object({
    orgId: z.string()
});

export const zConfigControllerListAiPresetChannelBindingsResponse2 = zConfigControllerListAiPresetChannelBindingsResponse;

export const zConfigControllerSetAiPresetChannelBindingBody2 = zConfigControllerSetAiPresetChannelBindingBody;

export const zConfigControllerSetAiPresetChannelBindingPath = z.object({
    orgId: z.string()
});

export const zConfigControllerSetAiPresetChannelBindingResponse2 = zConfigControllerSetAiPresetChannelBindingResponse;

export const zConfigControllerClearCachePath = z.object({
    orgId: z.string()
});

export const zConfigControllerClearCacheResponse2 = zConfigControllerClearCacheResponse;

export const zConfigControllerListPromptVersionsPath = z.object({
    orgId: z.string(),
    kind: z.enum([
        'SYSTEM',
        'SYSTEM_AGENT',
        'RESEARCHER',
        'VERIFIER'
    ])
});

export const zConfigControllerListPromptVersionsQuery = z.object({
    presetId: z.string().min(1).optional()
});

export const zConfigControllerListPromptVersionsResponse2 = zConfigControllerListPromptVersionsResponse;

export const zConfigControllerRevertPromptVersionBody2 = zConfigControllerRevertPromptVersionBody;

export const zConfigControllerRevertPromptVersionPath = z.object({
    orgId: z.string()
});

export const zConfigControllerRevertPromptVersionResponse2 = zConfigControllerRevertPromptVersionResponse;

export const zConfigControllerResolveMapLocationBody2 = zConfigControllerResolveMapLocationBody;

export const zConfigControllerResolveMapLocationPath = z.object({
    orgId: z.string()
});

export const zConfigControllerResolveMapLocationResponse2 = zConfigControllerResolveMapLocationResponse;

export const zContactsControllerListPath = z.object({
    orgId: z.string()
});

export const zContactsControllerListQuery = z.object({
    includeDeleted: z.boolean().default(false),
    search: z.string().max(120),
    filters: z.object({
        channel: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional(),
        isActive: z.object({
            value: z.boolean()
        }).optional(),
        name: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional(),
        phoneE164: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional()
    }).optional(),
    facets: z.object({
        activity: z.object({
            from: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
            op: z.enum([
                'before',
                'after',
                'between',
                'blank',
                'notBlank'
            ]),
            to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional()
        }).optional(),
        activityFrom: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        activityTo: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        bookings: z.union([
            z.object({
                op: z.enum([
                    'is',
                    'isNot',
                    'blank',
                    'notBlank'
                ]),
                value: z.enum([
                    'any',
                    'upcoming',
                    'none'
                ]).optional()
            }),
            z.enum([
                'any',
                'upcoming',
                'none'
            ])
        ]).optional(),
        country: z.object({
            op: z.enum([
                'isAnyOf',
                'isNotAnyOf',
                'includesAll',
                'blank'
            ]),
            values: z.array(z.string().max(12)).max(50).optional()
        }).optional(),
        created: z.object({
            from: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
            op: z.enum([
                'before',
                'after',
                'between',
                'blank',
                'notBlank'
            ]),
            to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional()
        }).optional(),
        createdFrom: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        createdTo: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        events: z.object({
            from: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
            op: z.enum([
                'before',
                'after',
                'between',
                'blank',
                'notBlank'
            ]),
            to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional()
        }).optional(),
        eventsFrom: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        eventsTo: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        favorite: z.union([
            z.object({
                op: z.enum([
                    'is',
                    'isNot',
                    'blank',
                    'notBlank'
                ]),
                value: z.enum(['true', 'false']).optional()
            }),
            z.boolean()
        ]).optional(),
        state: z.union([
            z.object({
                op: z.enum([
                    'is',
                    'isNot',
                    'blank',
                    'notBlank'
                ]),
                value: z.enum([
                    'active',
                    'blocked',
                    'ai',
                    'manual'
                ]).optional()
            }),
            z.enum([
                'active',
                'blocked',
                'ai',
                'manual'
            ])
        ]).optional()
    }).optional(),
    sort: z.array(z.object({
        colId: z.enum([
            'name',
            'phoneE164',
            'channel',
            'isActive'
        ]),
        sort: z.enum(['asc', 'desc'])
    })).optional(),
    limit: z.int().gte(1).lte(1000),
    offset: z.int().gte(0).lte(9007199254740991),
    managedByContactId: z.string().max(120).optional()
});

export const zContactsControllerListResponse2 = zContactsControllerListResponse;

export const zContactsControllerCreateBody2 = zContactsControllerCreateBody;

export const zContactsControllerCreatePath = z.object({
    orgId: z.string()
});

export const zContactsControllerCreateResponse2 = zContactsControllerCreateResponse;

export const zContactsControllerAppointmentsPath = z.object({
    orgId: z.string(),
    contactId: z.string()
});

export const zContactsControllerAppointmentsResponse2 = zContactsControllerAppointmentsResponse;

export const zContactsControllerBeneficiariesPath = z.object({
    orgId: z.string(),
    contactId: z.string()
});

export const zContactsControllerBeneficiariesResponse2 = zContactsControllerBeneficiariesResponse;

export const zContactsControllerEventsPath = z.object({
    orgId: z.string(),
    contactId: z.string()
});

export const zContactsControllerEventsResponse2 = zContactsControllerEventsResponse;

export const zContactsControllerHistoryPath = z.object({
    orgId: z.string(),
    contactId: z.string()
});

export const zContactsControllerHistoryQuery = z.object({
    limit: z.int().gte(1).lte(200)
});

export const zContactsControllerHistoryResponse2 = zContactsControllerHistoryResponse;

export const zContactsControllerRevertEventBody2 = zContactsControllerRevertEventBody;

export const zContactsControllerRevertEventPath = z.object({
    orgId: z.string(),
    contactId: z.string()
});

export const zContactsControllerRevertEventResponse2 = zContactsControllerRevertEventResponse;

export const zContactsControllerSoftDeletePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zContactsControllerSoftDeleteResponse2 = zContactsControllerSoftDeleteResponse;

export const zContactsControllerUpdateBody2 = zContactsControllerUpdateBody;

export const zContactsControllerUpdatePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zContactsControllerUpdateResponse2 = zContactsControllerUpdateResponse;

export const zContactsControllerConsolidateBody2 = zContactsControllerConsolidateBody;

export const zContactsControllerConsolidatePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zContactsControllerConsolidateResponse2 = zContactsControllerConsolidateResponse;

export const zContactsControllerConsolidationPreviewPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zContactsControllerConsolidationPreviewQuery = z.object({
    winnerId: z.string().min(1)
});

export const zContactsControllerConsolidationPreviewResponse2 = zContactsControllerConsolidationPreviewResponse;

export const zContactsControllerLinkBody2 = zContactsControllerLinkBody;

export const zContactsControllerLinkPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zContactsControllerLinkResponse2 = zContactsControllerLinkResponse;

export const zContactsControllerMergeIntoBeneficiaryBody2 = zContactsControllerMergeIntoBeneficiaryBody;

export const zContactsControllerMergeIntoBeneficiaryPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zContactsControllerMergeIntoBeneficiaryResponse2 = zContactsControllerMergeIntoBeneficiaryResponse;

export const zContactsControllerMergeIntoParentBody2 = zContactsControllerMergeIntoParentBody;

export const zContactsControllerMergeIntoParentPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zContactsControllerMergeIntoParentResponse2 = zContactsControllerMergeIntoParentResponse;

export const zContactsControllerRestorePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zContactsControllerRestoreResponse2 = zContactsControllerRestoreResponse;

export const zContactsControllerUnlinkPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zContactsControllerUnlinkResponse2 = zContactsControllerUnlinkResponse;

export const zContactsControllerBulkRestoreBody2 = zContactsControllerBulkRestoreBody;

export const zContactsControllerBulkRestorePath = z.object({
    orgId: z.string()
});

export const zContactsControllerBulkRestoreResponse2 = zContactsControllerBulkRestoreResponse;

export const zContactsControllerBulkSoftDeleteBody2 = zContactsControllerBulkSoftDeleteBody;

export const zContactsControllerBulkSoftDeletePath = z.object({
    orgId: z.string()
});

export const zContactsControllerBulkSoftDeleteResponse2 = zContactsControllerBulkSoftDeleteResponse;

export const zContactsControllerFacetOptionsPath = z.object({
    orgId: z.string()
});

export const zContactsControllerFacetOptionsQuery = z.object({
    includeDeleted: z.boolean().default(false),
    search: z.string().max(120),
    filters: z.object({
        channel: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional(),
        isActive: z.object({
            value: z.boolean()
        }).optional(),
        name: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional(),
        phoneE164: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional()
    }).optional(),
    facets: z.object({
        activity: z.object({
            from: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
            op: z.enum([
                'before',
                'after',
                'between',
                'blank',
                'notBlank'
            ]),
            to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional()
        }).optional(),
        activityFrom: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        activityTo: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        bookings: z.union([
            z.object({
                op: z.enum([
                    'is',
                    'isNot',
                    'blank',
                    'notBlank'
                ]),
                value: z.enum([
                    'any',
                    'upcoming',
                    'none'
                ]).optional()
            }),
            z.enum([
                'any',
                'upcoming',
                'none'
            ])
        ]).optional(),
        country: z.object({
            op: z.enum([
                'isAnyOf',
                'isNotAnyOf',
                'includesAll',
                'blank'
            ]),
            values: z.array(z.string().max(12)).max(50).optional()
        }).optional(),
        created: z.object({
            from: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
            op: z.enum([
                'before',
                'after',
                'between',
                'blank',
                'notBlank'
            ]),
            to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional()
        }).optional(),
        createdFrom: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        createdTo: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        events: z.object({
            from: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
            op: z.enum([
                'before',
                'after',
                'between',
                'blank',
                'notBlank'
            ]),
            to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional()
        }).optional(),
        eventsFrom: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        eventsTo: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        favorite: z.union([
            z.object({
                op: z.enum([
                    'is',
                    'isNot',
                    'blank',
                    'notBlank'
                ]),
                value: z.enum(['true', 'false']).optional()
            }),
            z.boolean()
        ]).optional(),
        state: z.union([
            z.object({
                op: z.enum([
                    'is',
                    'isNot',
                    'blank',
                    'notBlank'
                ]),
                value: z.enum([
                    'active',
                    'blocked',
                    'ai',
                    'manual'
                ]).optional()
            }),
            z.enum([
                'active',
                'blocked',
                'ai',
                'manual'
            ])
        ]).optional()
    }).optional(),
    managedByContactId: z.string().max(120).optional()
});

export const zContactsControllerFacetOptionsResponse2 = zContactsControllerFacetOptionsResponse;

export const zContactsControllerStatsPath = z.object({
    orgId: z.string()
});

export const zContactsControllerStatsResponse2 = zContactsControllerStatsResponse;

export const zConversationsControllerListMessagesByConversationIdPath = z.object({
    orgId: z.string(),
    conversationId: z.string()
});

export const zConversationsControllerListMessagesByConversationIdQuery = z.object({
    limit: z.string(),
    startingAfter: z.string(),
    endingBefore: z.string()
});

export const zConversationsControllerListMessagesByConversationIdResponse2 = zConversationsControllerListMessagesByConversationIdResponse;

export const zConversationsControllerClearConversationPath = z.object({
    orgId: z.string(),
    phoneE164: z.string()
});

export const zConversationsControllerClearConversationResponse2 = zConversationsControllerClearConversationResponse;

export const zConversationsControllerListMessagesPath = z.object({
    orgId: z.string(),
    phoneE164: z.string()
});

export const zConversationsControllerListMessagesQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(50),
    fromDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    toDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    startingAfter: z.string().max(255).optional(),
    endingBefore: z.string().max(255).optional()
});

export const zConversationsControllerListMessagesResponse2 = zConversationsControllerListMessagesResponse;

export const zConversationsControllerAppendMessageBody2 = zConversationsControllerAppendMessageBody;

export const zConversationsControllerAppendMessagePath = z.object({
    orgId: z.string(),
    phoneE164: z.string()
});

export const zConversationsControllerAppendMessageResponse2 = zConversationsControllerAppendMessageResponse;

export const zConversationsControllerGetAiEnabledPath = z.object({
    orgId: z.string(),
    phoneE164: z.string()
});

export const zConversationsControllerGetAiEnabledResponse2 = zConversationsControllerGetAiEnabledResponse;

export const zConversationsControllerToggleAiPath = z.object({
    orgId: z.string(),
    phoneE164: z.string()
});

export const zConversationsControllerToggleAiResponse2 = zConversationsControllerToggleAiResponse;

export const zConversationsControllerSetArchivedBody2 = zConversationsControllerSetArchivedBody;

export const zConversationsControllerSetArchivedPath = z.object({
    orgId: z.string(),
    phoneE164: z.string()
});

export const zConversationsControllerSetArchivedResponse2 = zConversationsControllerSetArchivedResponse;

export const zConversationsControllerListContactMessagesPath = z.object({
    orgId: z.string(),
    phoneE164: z.string()
});

export const zConversationsControllerListContactMessagesQuery = z.object({
    search: z.string().max(200).optional(),
    dateFrom: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
    dateTo: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
    kinds: z.string().regex(/^(image|video|audio|pdf|spreadsheet|text|document|other)(,(image|video|audio|pdf|spreadsheet|text|document|other))*$/).optional(),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
    limit: z.int().gte(1).lte(100).optional().default(25)
});

export const zConversationsControllerListContactMessagesResponse2 = zConversationsControllerListContactMessagesResponse;

export const zConversationsControllerAssignLabelBody2 = zConversationsControllerAssignLabelBody;

export const zConversationsControllerAssignLabelPath = z.object({
    orgId: z.string(),
    phoneE164: z.string()
});

export const zConversationsControllerAssignLabelResponse2 = zConversationsControllerAssignLabelResponse;

export const zConversationsControllerUnassignLabelPath = z.object({
    orgId: z.string(),
    phoneE164: z.string(),
    labelId: z.string()
});

export const zConversationsControllerUnassignLabelQuery = z.object({
    channel: z.string()
});

export const zConversationsControllerUnassignLabelResponse2 = zConversationsControllerUnassignLabelResponse;

export const zConversationsControllerSendReactionBody2 = zConversationsControllerSendReactionBody;

export const zConversationsControllerSendReactionPath = z.object({
    orgId: z.string(),
    phoneE164: z.string()
});

export const zConversationsControllerSendReactionResponse2 = zConversationsControllerSendReactionResponse;

export const zConversationsControllerRecordMessagePath = z.object({
    orgId: z.string(),
    phoneE164: z.string()
});

export const zConversationsControllerRecordMessageResponse2 = zConversationsControllerRecordMessageResponse;

export const zConversationsControllerSearchMessagesPath = z.object({
    orgId: z.string(),
    phoneE164: z.string()
});

export const zConversationsControllerSearchMessagesQuery = z.object({
    q: z.string().max(200).optional().default(''),
    dateFrom: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
    dateTo: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
    kinds: z.string().regex(/^(image|video|audio|pdf|spreadsheet|text|document|other)(,(image|video|audio|pdf|spreadsheet|text|document|other))*$/).optional()
});

export const zConversationsControllerSearchMessagesResponse2 = zConversationsControllerSearchMessagesResponse;

export const zConversationsControllerClearConversationByIdPath = z.object({
    orgId: z.string(),
    conversationId: z.string()
});

export const zConversationsControllerClearConversationByIdResponse2 = zConversationsControllerClearConversationByIdResponse;

export const zCalendarControllerListPath = z.object({
    orgId: z.string()
});

export const zCalendarControllerListQuery = z.object({
    fromDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    toDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional()
});

export const zCalendarControllerListResponse2 = zCalendarControllerListResponse;

export const zCalendarControllerGetByPhonePath = z.object({
    orgId: z.string(),
    phoneE164: z.string().regex(/^\+[1-9]\d{1,14}$/)
});

export const zCalendarControllerGetByPhoneQuery = z.object({
    fromDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    toDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional()
});

export const zCalendarControllerGetByPhoneResponse2 = zCalendarControllerGetByPhoneResponse;

export const zConversationsControllerListConversationChannelsPath = z.object({
    orgId: z.string()
});

export const zConversationsControllerListConversationChannelsResponse2 = zConversationsControllerListConversationChannelsResponse;

export const zConversationsControllerListInboxConversationsPath = z.object({
    orgId: z.string()
});

export const zConversationsControllerListInboxConversationsResponse2 = zConversationsControllerListInboxConversationsResponse;

export const zConversationsControllerMarkConversationReadPath = z.object({
    orgId: z.string(),
    conversationId: z.string()
});

export const zConversationsControllerMarkConversationReadResponse2 = zConversationsControllerMarkConversationReadResponse;

export const zConversationsControllerListLabelsPath = z.object({
    orgId: z.string()
});

export const zConversationsControllerListLabelsResponse2 = zConversationsControllerListLabelsResponse;

export const zConversationsControllerCreateLabelBody2 = zConversationsControllerCreateLabelBody;

export const zConversationsControllerCreateLabelPath = z.object({
    orgId: z.string()
});

export const zConversationsControllerCreateLabelResponse2 = zConversationsControllerCreateLabelResponse;

export const zConversationsControllerDeleteLabelPath = z.object({
    orgId: z.string(),
    labelId: z.string()
});

export const zConversationsControllerDeleteLabelResponse2 = zConversationsControllerDeleteLabelResponse;

export const zConversationsControllerListConversationMetaPath = z.object({
    orgId: z.string()
});

export const zConversationsControllerListConversationMetaResponse2 = zConversationsControllerListConversationMetaResponse;

export const zCustomToolsControllerListPath = z.object({
    orgId: z.string()
});

export const zCustomToolsControllerListResponse2 = zCustomToolsControllerListResponse;

export const zCustomToolsControllerCreateBody2 = zCustomToolsControllerCreateBody;

export const zCustomToolsControllerCreatePath = z.object({
    orgId: z.string()
});

export const zCustomToolsControllerCreateResponse2 = zCustomToolsControllerCreateResponse;

export const zCustomToolsControllerRemovePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zCustomToolsControllerRemoveResponse2 = zCustomToolsControllerRemoveResponse;

export const zCustomToolsControllerGetPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zCustomToolsControllerGetResponse2 = zCustomToolsControllerGetResponse;

export const zCustomToolsControllerUpdateBody2 = zCustomToolsControllerUpdateBody;

export const zCustomToolsControllerUpdatePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zCustomToolsControllerUpdateResponse2 = zCustomToolsControllerUpdateResponse;

export const zCustomToolsControllerSetEnabledBody2 = zCustomToolsControllerSetEnabledBody;

export const zCustomToolsControllerSetEnabledPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zCustomToolsControllerSetEnabledResponse2 = zCustomToolsControllerSetEnabledResponse;

export const zCustomToolsControllerExportDefinitionPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zCustomToolsControllerExportDefinitionResponse2 = zCustomToolsControllerExportDefinitionResponse;

export const zCustomToolsControllerTestBody2 = zCustomToolsControllerTestBody;

export const zCustomToolsControllerTestPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zCustomToolsControllerTestResponse2 = zCustomToolsControllerTestResponse;

export const zCustomToolsControllerImportDefinitionBody2 = zCustomToolsControllerImportDefinitionBody;

export const zCustomToolsControllerImportDefinitionPath = z.object({
    orgId: z.string()
});

export const zCustomToolsControllerImportDefinitionResponse2 = zCustomToolsControllerImportDefinitionResponse;

export const zCustomToolsControllerQuotaPath = z.object({
    orgId: z.string()
});

export const zCustomToolsControllerQuotaResponse2 = zCustomToolsControllerQuotaResponse;

export const zDashboardControllerGetPath = z.object({
    orgId: z.string()
});

export const zDashboardControllerGetQuery = z.object({
    from: z.string().max(30).optional(),
    to: z.string().max(30).optional(),
    locale: z.string().max(10).optional(),
    channel: z.string().optional()
});

export const zDashboardControllerGetResponse2 = zDashboardControllerGetResponse;

export const zDocumentsControllerSyncManifestPath = z.object({
    orgId: z.string()
});

export const zDocumentsControllerSyncManifestResponse2 = zDocumentsControllerSyncManifestResponse;

export const zEmailTemplatesControllerListPath = z.object({
    orgId: z.string()
});

export const zEmailTemplatesControllerListResponse2 = zEmailTemplatesControllerListResponse;

export const zEmailTemplatesControllerCreateBody2 = zEmailTemplatesControllerCreateBody;

export const zEmailTemplatesControllerCreatePath = z.object({
    orgId: z.string()
});

export const zEmailTemplatesControllerCreateResponse2 = zEmailTemplatesControllerCreateResponse;

export const zEmailTemplatesControllerDeletePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zEmailTemplatesControllerDeleteResponse2 = zEmailTemplatesControllerDeleteResponse;

export const zEmailTemplatesControllerGetPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zEmailTemplatesControllerGetResponse2 = zEmailTemplatesControllerGetResponse;

export const zEmailTemplatesControllerUpdateBody2 = zEmailTemplatesControllerUpdateBody;

export const zEmailTemplatesControllerUpdatePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zEmailTemplatesControllerUpdateResponse2 = zEmailTemplatesControllerUpdateResponse;

export const zEmailTemplatesControllerScheduleBody2 = zEmailTemplatesControllerScheduleBody;

export const zEmailTemplatesControllerSchedulePath = z.object({
    orgId: z.string()
});

export const zEmailTemplatesControllerScheduleResponse2 = zEmailTemplatesControllerScheduleResponse;

export const zEmailTemplatesControllerListScheduledPath = z.object({
    orgId: z.string()
});

export const zEmailTemplatesControllerListScheduledResponse2 = zEmailTemplatesControllerListScheduledResponse;

export const zEmailTemplatesControllerCancelScheduledPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zEmailTemplatesControllerCancelScheduledResponse2 = zEmailTemplatesControllerCancelScheduledResponse;

export const zEmailTemplatesControllerSendBody2 = zEmailTemplatesControllerSendBody;

export const zEmailTemplatesControllerSendPath = z.object({
    orgId: z.string()
});

export const zEmailTemplatesControllerSendResponse2 = zEmailTemplatesControllerSendResponse;

export const zEventStatusesControllerListPath = z.object({
    orgId: z.string()
});

export const zEventStatusesControllerListQuery = z.object({
    includeInactive: z.string()
});

export const zEventStatusesControllerUpsertBody2 = zEventStatusesControllerUpsertBody;

export const zEventStatusesControllerUpsertPath = z.object({
    orgId: z.string()
});

export const zEventStatusesControllerDeactivatePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zEventStatusesControllerReorderBody2 = zEventStatusesControllerReorderBody;

export const zEventStatusesControllerReorderPath = z.object({
    orgId: z.string()
});

export const zEventTypesControllerListPath = z.object({
    orgId: z.string()
});

export const zEventTypesControllerListQuery = z.object({
    includeInactive: z.string().regex(/^(true|false)$/).optional(),
    includeFields: z.string().regex(/^(true|false)$/).optional()
});

export const zEventTypesControllerListResponse2 = zEventTypesControllerListResponse;

export const zEventTypesControllerUpsertBody2 = zEventTypesControllerUpsertBody;

export const zEventTypesControllerUpsertPath = z.object({
    orgId: z.string()
});

export const zEventTypesControllerUpsertResponse2 = zEventTypesControllerUpsertResponse;

export const zEventTypesControllerGetPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zEventTypesControllerGetQuery = z.object({
    includeFields: z.string().regex(/^(true|false)$/).optional()
});

export const zEventTypesControllerGetResponse2 = zEventTypesControllerGetResponse;

export const zEventTypesControllerDeactivatePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zEventTypesControllerDeactivateResponse2 = zEventTypesControllerDeactivateResponse;

export const zEventTypesControllerFieldsListPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zEventTypesControllerFieldsListResponse2 = zEventTypesControllerFieldsListResponse;

export const zEventTypesControllerFieldsAddBody2 = zEventTypesControllerFieldsAddBody;

export const zEventTypesControllerFieldsAddPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zEventTypesControllerFieldsAddResponse2 = zEventTypesControllerFieldsAddResponse;

export const zEventTypesControllerFieldsRemovePath = z.object({
    orgId: z.string(),
    id: z.string(),
    fieldId: z.string()
});

export const zEventTypesControllerFieldsRemoveResponse2 = zEventTypesControllerFieldsRemoveResponse;

export const zEventTypesControllerFieldsUpdateBody2 = zEventTypesControllerFieldsUpdateBody;

export const zEventTypesControllerFieldsUpdatePath = z.object({
    orgId: z.string(),
    id: z.string(),
    fieldId: z.string()
});

export const zEventTypesControllerFieldsUpdateResponse2 = zEventTypesControllerFieldsUpdateResponse;

export const zEventTypesControllerFieldsReorderBody2 = zEventTypesControllerFieldsReorderBody;

export const zEventTypesControllerFieldsReorderPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zEventTypesControllerFieldsReorderResponse2 = zEventTypesControllerFieldsReorderResponse;

export const zEventTypesControllerReorderBody2 = zEventTypesControllerReorderBody;

export const zEventTypesControllerReorderPath = z.object({
    orgId: z.string()
});

export const zEventTypesControllerReorderResponse2 = zEventTypesControllerReorderResponse;

export const zEventsControllerListPath = z.object({
    orgId: z.string()
});

export const zEventsControllerListQuery = z.object({
    fromDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    toDate: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
    eventType: z.string().max(100).optional(),
    includeCancelled: z.string().regex(/^(true|false)$/).optional(),
    future: z.string().regex(/^(true|false)$/).optional(),
    limit: z.string().regex(/^\d+$/).optional(),
    startingAfter: z.string().min(1).max(255).optional(),
    endingBefore: z.string().min(1).max(255).optional()
});

export const zEventsControllerListResponse2 = zEventsControllerListResponse;

export const zEventsControllerCreateBody2 = zEventsControllerCreateBody;

export const zEventsControllerCreatePath = z.object({
    orgId: z.string()
});

export const zEventsControllerCreateResponse2 = zEventsControllerCreateResponse;

export const zEventsControllerModifyBody2 = zEventsControllerModifyBody;

export const zEventsControllerModifyPath = z.object({
    orgId: z.string()
});

export const zEventsControllerModifyResponse2 = zEventsControllerModifyResponse;

export const zEventsControllerCancelPath = z.object({
    orgId: z.string()
});

export const zEventsControllerCancelResponse2 = zEventsControllerCancelResponse;

export const zEventsControllerCompletePath = z.object({
    orgId: z.string()
});

export const zEventsControllerCompleteResponse2 = zEventsControllerCompleteResponse;

export const zEventsControllerGetHistoryPath = z.object({
    orgId: z.string()
});

export const zEventsControllerGetHistoryResponse2 = zEventsControllerGetHistoryResponse;

export const zEventsControllerNoShowPath = z.object({
    orgId: z.string()
});

export const zEventsControllerNoShowResponse2 = zEventsControllerNoShowResponse;

export const zEventsControllerGetNotesPath = z.object({
    orgId: z.string()
});

export const zEventsControllerGetNotesResponse2 = zEventsControllerGetNotesResponse;

export const zEventsControllerUpdateNotesBody2 = zEventsControllerUpdateNotesBody;

export const zEventsControllerUpdateNotesPath = z.object({
    orgId: z.string()
});

export const zEventsControllerUpdateNotesResponse2 = zEventsControllerUpdateNotesResponse;

export const zEventsControllerReinstatePath = z.object({
    orgId: z.string()
});

export const zEventsControllerReinstateResponse2 = zEventsControllerReinstateResponse;

export const zEventsControllerUpdateStatusBody2 = zEventsControllerUpdateStatusBody;

export const zEventsControllerUpdateStatusPath = z.object({
    orgId: z.string()
});

export const zEventsControllerGetByPhonePath = z.object({
    orgId: z.string()
});

export const zEventsControllerGetByPhoneQuery = z.object({
    includePast: z.string()
});

export const zEventsControllerGetByPhoneResponse2 = zEventsControllerGetByPhoneResponse;

export const zEventsControllerGetAvailableSlotsBody2 = zEventsControllerGetAvailableSlotsBody;

export const zEventsControllerGetAvailableSlotsPath = z.object({
    orgId: z.string()
});

export const zEventsControllerGetAvailableSlotsResponse2 = zEventsControllerGetAvailableSlotsResponse;

export const zEventsControllerCountByTypeBody2 = zEventsControllerCountByTypeBody;

export const zEventsControllerCountByTypePath = z.object({
    orgId: z.string()
});

export const zEventsControllerCountByTypeResponse2 = zEventsControllerCountByTypeResponse;

export const zEventsControllerGetByIdPath = z.object({
    orgId: z.string()
});

export const zEventsControllerGetByIdResponse2 = zEventsControllerGetByIdResponse;

export const zEventsControllerFindUpcomingPath = z.object({
    orgId: z.string()
});

export const zEventsControllerFindUpcomingResponse2 = zEventsControllerFindUpcomingResponse;

export const zSummaryControllerListFeedbackPath = z.object({
    orgId: z.string()
});

export const zSummaryControllerListFeedbackQuery = z.object({
    contactId: z.string().optional(),
    channel: z.string().optional(),
    sentiment: z.string().optional(),
    limit: z.int().gte(1).lte(200).optional(),
    offset: z.int().gte(0).lte(9007199254740991).optional(),
    from: z.string().max(30).optional(),
    to: z.string().max(30).optional()
});

export const zSummaryControllerListFeedbackResponse2 = zSummaryControllerListFeedbackResponse;

export const zSummaryControllerDeleteFeedbackPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zSummaryControllerDeleteFeedbackResponse2 = zSummaryControllerDeleteFeedbackResponse;

export const zSummaryControllerListFeedbackCommentsPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zSummaryControllerListFeedbackCommentsResponse2 = zSummaryControllerListFeedbackCommentsResponse;

export const zSummaryControllerAddFeedbackCommentBody2 = zSummaryControllerAddFeedbackCommentBody;

export const zSummaryControllerAddFeedbackCommentPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zSummaryControllerAddFeedbackCommentResponse2 = zSummaryControllerAddFeedbackCommentResponse;

export const zInstagramOperatorControllerSendMessageBody2 = zInstagramOperatorControllerSendMessageBody;

export const zInstagramOperatorControllerSendMessagePath = z.object({
    orgId: z.string(),
    conversationId: z.string()
});

export const zInstagramOperatorControllerSendMessageResponse2 = zInstagramOperatorControllerSendMessageResponse;

export const zInstagramOperatorControllerSendReactionBody2 = zInstagramOperatorControllerSendReactionBody;

export const zInstagramOperatorControllerSendReactionPath = z.object({
    orgId: z.string(),
    conversationId: z.string()
});

export const zInstagramOperatorControllerSendReactionResponse2 = zInstagramOperatorControllerSendReactionResponse;

export const zInstagramOperatorControllerMarkSeenPath = z.object({
    orgId: z.string(),
    conversationId: z.string()
});

export const zInstagramOperatorControllerMarkSeenResponse2 = zInstagramOperatorControllerMarkSeenResponse;

export const zMediaControllerUploadPath = z.object({
    orgId: z.string()
});

export const zMediaControllerUploadQuery = z.object({
    scope: z.string(),
    actor: z.string()
});

export const zMediaControllerStreamPath = z.object({
    orgId: z.string(),
    assetId: z.string()
});

export const zMessageCitationsControllerCheckCitationsPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zMessageCitationsControllerCheckCitationsResponse2 = zMessageCitationsControllerCheckCitationsResponse;

export const zMessageCitationsControllerGetCitationsPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zMessageCitationsControllerGetCitationsResponse2 = zMessageCitationsControllerGetCitationsResponse;

export const zDocumentsControllerRecordMetricEventBody2 = zDocumentsControllerRecordMetricEventBody;

export const zDocumentsControllerRecordMetricEventPath = z.object({
    orgId: z.string()
});

export const zDocumentsControllerRecordMetricEventResponse2 = zDocumentsControllerRecordMetricEventResponse;

export const zOrganizationBalanceControllerGetPath = z.object({
    orgId: z.string()
});

export const zOrganizationBalanceControllerGetResponse2 = zOrganizationBalanceControllerGetResponse;

export const zOrganizationBalanceControllerAdminCreditBody2 = zOrganizationBalanceControllerAdminCreditBody;

export const zOrganizationBalanceControllerAdminCreditPath = z.object({
    orgId: z.string()
});

export const zOrganizationBalanceControllerAdminCreditResponse2 = zOrganizationBalanceControllerAdminCreditResponse;

export const zOrganizationBalanceControllerGetSpendPolicyPath = z.object({
    orgId: z.string()
});

export const zOrganizationBalanceControllerGetSpendPolicyResponse2 = zOrganizationBalanceControllerGetSpendPolicyResponse;

export const zOrganizationBalanceControllerUpdateSpendPolicyBody2 = zOrganizationBalanceControllerUpdateSpendPolicyBody;

export const zOrganizationBalanceControllerUpdateSpendPolicyPath = z.object({
    orgId: z.string()
});

export const zOrganizationBalanceControllerUpdateSpendPolicyResponse2 = zOrganizationBalanceControllerUpdateSpendPolicyResponse;

export const zOrganizationBalanceControllerListTransactionsPath = z.object({
    orgId: z.string()
});

export const zOrganizationBalanceControllerListTransactionsQuery = z.object({
    cursor: z.string().nullish(),
    dateFrom: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    dateTo: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    kinds: z.union([
        z.object({
            op: z.enum([
                'isAnyOf',
                'isNotAnyOf',
                'includesAll',
                'blank'
            ]),
            values: z.array(z.enum([
                'CREDIT_MANUAL',
                'CREDIT_PAYMENT',
                'CREDIT_ADJUSTMENT',
                'DEBIT_AI_USAGE',
                'DEBIT_ADJUSTMENT',
                'REFUND'
            ])).max(50).optional()
        }),
        z.string().max(2000)
    ]).optional(),
    limit: z.int().gte(1).lte(100).optional().default(20),
    models: z.union([
        z.object({
            op: z.enum([
                'isAnyOf',
                'isNotAnyOf',
                'includesAll',
                'blank'
            ]),
            values: z.array(z.string().max(200)).max(50).optional()
        }),
        z.string().max(2000)
    ]).optional(),
    offset: z.int().gte(0).lte(9007199254740991).optional(),
    search: z.string().max(200).optional()
});

export const zOrganizationBalanceControllerListTransactionsResponse2 = zOrganizationBalanceControllerListTransactionsResponse;

export const zOrganizationBalanceControllerListTransactionFacetsPath = z.object({
    orgId: z.string()
});

export const zOrganizationBalanceControllerListTransactionFacetsResponse2 = zOrganizationBalanceControllerListTransactionFacetsResponse;

export const zOrganizationBalanceControllerGetUsdLedgerPath = z.object({
    orgId: z.string()
});

export const zOrganizationBalanceControllerGetUsdLedgerResponse2 = zOrganizationBalanceControllerGetUsdLedgerResponse;

export const zPhoneControllerListAllPath = z.object({
    orgId: z.string()
});

export const zPhoneControllerListAllQuery = z.object({
    offset: z.int().gte(0).lte(9007199254740991).optional(),
    limit: z.int().gte(1).lte(1000).optional(),
    startingAfter: z.string().max(255).optional(),
    endingBefore: z.string().max(255).optional(),
    status: z.string().optional(),
    statuses: z.array(z.enum([
        'registered',
        'unregistered',
        'inactive',
        'active',
        'has_document',
        'no_document'
    ])).max(6).optional(),
    countries: z.array(z.string().max(10)).max(50).optional(),
    date_range_type: z.string().optional(),
    date_from: z.string().max(30).optional(),
    date_to: z.string().max(30).optional(),
    reachable_on: z.string().optional(),
    exclude: z.string().max(10000).optional()
});

export const zPhoneControllerListAllResponse2 = zPhoneControllerListAllResponse;

export const zPhoneControllerGetRecentPath = z.object({
    orgId: z.string()
});

export const zPhoneControllerGetRecentQuery = z.object({
    limit: z.int().gte(1).lte(1000).optional().default(50)
});

export const zPhoneControllerGetRecentResponse2 = zPhoneControllerGetRecentResponse;

export const zPhoneControllerSearchPath = z.object({
    orgId: z.string()
});

export const zPhoneControllerSearchQuery = z.object({
    q: z.string().max(500).optional(),
    limit: z.int().gte(1).lte(1000).optional().default(100),
    status: z.string().optional(),
    statuses: z.array(z.enum([
        'registered',
        'unregistered',
        'inactive',
        'active',
        'has_document',
        'no_document'
    ])).max(6).optional(),
    countries: z.array(z.string().max(10)).max(50).optional(),
    date_range_type: z.string().optional(),
    date_from: z.string().max(30).optional(),
    date_to: z.string().max(30).optional(),
    reachable_on: z.string().optional()
});

export const zPhoneControllerSearchResponse2 = zPhoneControllerSearchResponse;

export const zPhoneControllerGetStatsPath = z.object({
    orgId: z.string()
});

export const zPhoneControllerGetStatsResponse2 = zPhoneControllerGetStatsResponse;

export const zRagPlaygroundControllerAgentRunBody2 = zRagPlaygroundControllerAgentRunBody;

export const zRagPlaygroundControllerAgentRunPath = z.object({
    orgId: z.string()
});

export const zRagPlaygroundControllerAgentRunResponse2 = zRagPlaygroundControllerAgentRunResponse;

export const zRagPlaygroundControllerAgentRunStreamBody2 = zRagPlaygroundControllerAgentRunStreamBody;

export const zRagPlaygroundControllerAgentRunStreamPath = z.object({
    orgId: z.string()
});

export const zRagPlaygroundControllerListPromptVersionsPath = z.object({
    orgId: z.string()
});

export const zRagPlaygroundControllerListPromptVersionsResponse2 = zRagPlaygroundControllerListPromptVersionsResponse;

export const zRagPlaygroundControllerListPath = z.object({
    orgId: z.string()
});

export const zRagPlaygroundControllerListQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(50),
    cursor: z.int().gte(0).lte(9007199254740991).optional().default(0)
});

export const zRagPlaygroundControllerListResponse2 = zRagPlaygroundControllerListResponse;

export const zRagPlaygroundControllerDeletePath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagPlaygroundControllerDeleteResponse2 = zRagPlaygroundControllerDeleteResponse;

export const zRagPlaygroundControllerGetChunksPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagPlaygroundControllerGetChunksQuery = z.object({
    limit: z.int().gte(1).lte(500).optional().default(100),
    cursor: z.int().gte(0).lte(9007199254740991).optional().default(0)
});

export const zRagPlaygroundControllerGetChunksResponse2 = zRagPlaygroundControllerGetChunksResponse;

export const zRagPlaygroundControllerToggleEnabledBody2 = zRagPlaygroundControllerToggleEnabledBody;

export const zRagPlaygroundControllerToggleEnabledPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagPlaygroundControllerToggleEnabledResponse2 = zRagPlaygroundControllerToggleEnabledResponse;

export const zRagPlaygroundControllerRetryPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagPlaygroundControllerRetryResponse2 = zRagPlaygroundControllerRetryResponse;

export const zRagPlaygroundControllerClearAllPath = z.object({
    orgId: z.string()
});

export const zRagPlaygroundControllerClearAllResponse2 = zRagPlaygroundControllerClearAllResponse;

export const zRagPlaygroundControllerUploadBody2 = zRagPlaygroundControllerUploadBody;

export const zRagPlaygroundControllerUploadPath = z.object({
    orgId: z.string()
});

export const zRagPlaygroundControllerUploadResponse2 = zRagPlaygroundControllerUploadResponse;

export const zOrgRetentionControllerGetRetentionRulesPath = z.object({
    orgId: z.string()
});

export const zOrgRetentionControllerGetRetentionRulesResponse2 = zOrgRetentionControllerGetRetentionRulesResponse;

export const zOrgRetentionControllerUpdateRetentionRulesBody2 = zOrgRetentionControllerUpdateRetentionRulesBody;

export const zOrgRetentionControllerUpdateRetentionRulesPath = z.object({
    orgId: z.string()
});

export const zOrgRetentionControllerUpdateRetentionRulesResponse2 = zOrgRetentionControllerUpdateRetentionRulesResponse;

export const zQaPairsControllerRemoveManyBody2 = zQaPairsControllerRemoveManyBody;

export const zQaPairsControllerRemoveManyPath = z.object({
    orgId: z.string()
});

export const zQaPairsControllerRemoveManyResponse2 = zQaPairsControllerRemoveManyResponse;

export const zQaPairsControllerListPath = z.object({
    orgId: z.string()
});

export const zQaPairsControllerListResponse2 = zQaPairsControllerListResponse;

export const zQaPairsControllerCreateBody2 = zQaPairsControllerCreateBody;

export const zQaPairsControllerCreatePath = z.object({
    orgId: z.string()
});

export const zQaPairsControllerCreateResponse2 = zQaPairsControllerCreateResponse;

export const zQaPairsControllerRemovePath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zQaPairsControllerRemoveResponse2 = zQaPairsControllerRemoveResponse;

export const zQaPairsControllerUpdateBody2 = zQaPairsControllerUpdateBody;

export const zQaPairsControllerUpdatePath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zQaPairsControllerUpdateResponse2 = zQaPairsControllerUpdateResponse;

export const zQaPairsControllerStatsPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zQaPairsControllerStatsQuery = z.object({
    days: z.int().gte(1).lte(365).optional().default(90)
});

export const zQaPairsControllerStatsResponse2 = zQaPairsControllerStatsResponse;

export const zQaPairsControllerImportXlsxPath = z.object({
    orgId: z.string()
});

export const zQaPairsControllerImportXlsxResponse2 = zQaPairsControllerImportXlsxResponse;

export const zQrControllerListPath = z.object({
    orgId: z.string()
});

export const zQrControllerListQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(20),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0)
});

export const zQrControllerListResponse2 = zQrControllerListResponse;

export const zQrControllerCreateBody2 = zQrControllerCreateBody;

export const zQrControllerCreatePath = z.object({
    orgId: z.string()
});

export const zQrControllerCreateResponse2 = zQrControllerCreateResponse;

export const zQrControllerDeletePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zQrControllerDeleteResponse2 = zQrControllerDeleteResponse;

export const zQrControllerUpdateBody2 = zQrControllerUpdateBody;

export const zQrControllerUpdatePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zQrControllerUpdateResponse2 = zQrControllerUpdateResponse;

export const zQuickRepliesControllerGetPath = z.object({
    orgId: z.string()
});

export const zQuickRepliesControllerGetResponse2 = zQuickRepliesControllerGetResponse;

export const zQuickRepliesControllerSaveBody2 = zQuickRepliesControllerSaveBody;

export const zQuickRepliesControllerSavePath = z.object({
    orgId: z.string()
});

export const zQuickRepliesControllerSaveResponse2 = zQuickRepliesControllerSaveResponse;

export const zRagDocumentsControllerFlushCachePath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerFlushCacheResponse2 = zRagDocumentsControllerFlushCacheResponse;

export const zRagDocumentsControllerDebugEmbeddingBody2 = zRagDocumentsControllerDebugEmbeddingBody;

export const zRagDocumentsControllerDebugEmbeddingPath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerDebugEmbeddingResponse2 = zRagDocumentsControllerDebugEmbeddingResponse;

export const zRagDocumentsControllerListPath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerListQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(50),
    cursor: z.int().gte(0).lte(9007199254740991).optional().default(0)
});

export const zRagDocumentsControllerListResponse2 = zRagDocumentsControllerListResponse;

export const zRagDocumentsControllerDeletePath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerDeleteResponse2 = zRagDocumentsControllerDeleteResponse;

export const zRagDocumentsControllerGetChunksPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerGetChunksQuery = z.object({
    limit: z.int().gte(1).lte(500).optional().default(100),
    cursor: z.int().gte(0).lte(9007199254740991).optional().default(0)
});

export const zRagDocumentsControllerGetChunksResponse2 = zRagDocumentsControllerGetChunksResponse;

export const zRagDocumentsControllerApplyEmbeddingStrategyBody2 = zRagDocumentsControllerApplyEmbeddingStrategyBody;

export const zRagDocumentsControllerApplyEmbeddingStrategyPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerApplyEmbeddingStrategyResponse2 = zRagDocumentsControllerApplyEmbeddingStrategyResponse;

export const zRagDocumentsControllerToggleEnabledBody2 = zRagDocumentsControllerToggleEnabledBody;

export const zRagDocumentsControllerToggleEnabledPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerToggleEnabledResponse2 = zRagDocumentsControllerToggleEnabledResponse;

export const zRagDocumentsControllerGetFigurePath = z.object({
    orgId: z.string(),
    id: z.number(),
    figureId: z.number()
});

export const zRagDocumentsControllerGetFilePath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerGetLayoutPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerUpdateMetaBody2 = zRagDocumentsControllerUpdateMetaBody;

export const zRagDocumentsControllerUpdateMetaPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerUpdateMetaResponse2 = zRagDocumentsControllerUpdateMetaResponse;

export const zRagDocumentsControllerReplacePath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerReplaceResponse2 = zRagDocumentsControllerReplaceResponse;

export const zRagDocumentsControllerRetryPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerRetryResponse2 = zRagDocumentsControllerRetryResponse;

export const zRagDocumentsControllerListSavedQueriesPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerListSavedQueriesResponse2 = zRagDocumentsControllerListSavedQueriesResponse;

export const zRagDocumentsControllerUpsertSavedQueryBody2 = zRagDocumentsControllerUpsertSavedQueryBody;

export const zRagDocumentsControllerUpsertSavedQueryPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerUpsertSavedQueryResponse2 = zRagDocumentsControllerUpsertSavedQueryResponse;

export const zRagDocumentsControllerDeleteSavedQueryPath = z.object({
    orgId: z.string(),
    id: z.number(),
    key: z.string()
});

export const zRagDocumentsControllerDeleteSavedQueryResponse2 = zRagDocumentsControllerDeleteSavedQueryResponse;

export const zRagDocumentsControllerGenerateSavedQueryBody2 = zRagDocumentsControllerGenerateSavedQueryBody;

export const zRagDocumentsControllerGenerateSavedQueryPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerGenerateSavedQueryResponse2 = zRagDocumentsControllerGenerateSavedQueryResponse;

export const zRagDocumentsControllerSetSchemaPreloadBody2 = zRagDocumentsControllerSetSchemaPreloadBody;

export const zRagDocumentsControllerSetSchemaPreloadPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerSetSchemaPreloadResponse2 = zRagDocumentsControllerSetSchemaPreloadResponse;

export const zRagDocumentsControllerDocumentStatsPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerDocumentStatsQuery = z.object({
    days: z.int().gte(1).lte(365).optional().default(90)
});

export const zRagDocumentsControllerDocumentStatsResponse2 = zRagDocumentsControllerDocumentStatsResponse;

export const zRagDocumentsControllerGetStatusPath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerGetStatusResponse2 = zRagDocumentsControllerGetStatusResponse;

export const zRagDocumentsControllerStrategyEstimatePath = z.object({
    orgId: z.string(),
    id: z.number()
});

export const zRagDocumentsControllerStrategyEstimateResponse2 = zRagDocumentsControllerStrategyEstimateResponse;

export const zRagDocumentsControllerDemoSearchBody2 = zRagDocumentsControllerDemoSearchBody;

export const zRagDocumentsControllerDemoSearchPath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerDemoSearchResponse2 = zRagDocumentsControllerDemoSearchResponse;

export const zRagDocumentsControllerReembedAllPath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerReembedAllResponse2 = zRagDocumentsControllerReembedAllResponse;

export const zRagDocumentsControllerScrapeUrlBody2 = zRagDocumentsControllerScrapeUrlBody;

export const zRagDocumentsControllerScrapeUrlPath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerScrapeUrlResponse2 = zRagDocumentsControllerScrapeUrlResponse;

export const zRagDocumentsControllerPreUploadEstimateBody2 = zRagDocumentsControllerPreUploadEstimateBody;

export const zRagDocumentsControllerPreUploadEstimatePath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerPreUploadEstimateResponse2 = zRagDocumentsControllerPreUploadEstimateResponse;

export const zRagDocumentsControllerUploadBody2 = zRagDocumentsControllerUploadBody;

export const zRagDocumentsControllerUploadPath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerUploadQuery = z.object({
    staged: z.union([
        z.boolean(),
        z.enum(['true', 'false'])
    ]).optional()
});

export const zRagDocumentsControllerUploadResponse2 = zRagDocumentsControllerUploadResponse;

export const zRagDocumentsControllerListEmbeddingModelsPath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerListEmbeddingModelsResponse2 = zRagDocumentsControllerListEmbeddingModelsResponse;

export const zRagDocumentsControllerModelSwitchEstimatePath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerModelSwitchEstimateQuery = z.object({
    model: z.string().min(1).max(200)
});

export const zRagDocumentsControllerModelSwitchEstimateResponse2 = zRagDocumentsControllerModelSwitchEstimateResponse;

export const zRagDocumentsControllerModelSwitchProgressPath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerModelSwitchProgressResponse2 = zRagDocumentsControllerModelSwitchProgressResponse;

export const zRagDocumentsControllerRefreshNowPath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerRefreshNowResponse2 = zRagDocumentsControllerRefreshNowResponse;

export const zRagDocumentsControllerSourcesSummaryPath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerSourcesSummaryResponse2 = zRagDocumentsControllerSourcesSummaryResponse;

export const zRagDocumentsControllerListNoHitQueriesPath = z.object({
    orgId: z.string()
});

export const zRagDocumentsControllerListNoHitQueriesQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(50),
    cursor: z.int().gte(1).lte(9007199254740991).optional(),
    sinceDays: z.int().gte(1).lte(365).optional(),
    from: z.string().max(30).optional(),
    to: z.string().max(30).optional(),
    channel: z.string().optional()
});

export const zRagDocumentsControllerListNoHitQueriesResponse2 = zRagDocumentsControllerListNoHitQueriesResponse;

export const zSummaryControllerListPath = z.object({
    orgId: z.string()
});

export const zSummaryControllerListQuery = z.object({
    contactId: z.string().optional(),
    channel: z.string().optional(),
    limit: z.int().gte(1).lte(200).optional(),
    offset: z.int().gte(0).lte(9007199254740991).optional(),
    from: z.string().max(30).optional(),
    to: z.string().max(30).optional()
});

export const zSummaryControllerListResponse2 = zSummaryControllerListResponse;

export const zSummaryControllerDeleteSummaryPath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zSummaryControllerDeleteSummaryResponse2 = zSummaryControllerDeleteSummaryResponse;

export const zSummaryControllerSaveBody2 = zSummaryControllerSaveBody;

export const zSummaryControllerSavePath = z.object({
    orgId: z.string()
});

export const zSummaryControllerSaveResponse2 = zSummaryControllerSaveResponse;

export const zSummaryControllerStreamBody2 = zSummaryControllerStreamBody;

export const zSummaryControllerStreamPath = z.object({
    orgId: z.string()
});

export const zTelegramOperatorControllerSendMessageBody2 = zTelegramOperatorControllerSendMessageBody;

export const zTelegramOperatorControllerSendMessagePath = z.object({
    orgId: z.string(),
    conversationId: z.string()
});

export const zTelegramOperatorControllerSendMessageResponse2 = zTelegramOperatorControllerSendMessageResponse;

export const zTelegramOperatorControllerSendReactionBody2 = zTelegramOperatorControllerSendReactionBody;

export const zTelegramOperatorControllerSendReactionPath = z.object({
    orgId: z.string(),
    conversationId: z.string()
});

export const zTelegramOperatorControllerSendReactionResponse2 = zTelegramOperatorControllerSendReactionResponse;

export const zTelegramOperatorControllerSendTypingBody2 = zTelegramOperatorControllerSendTypingBody;

export const zTelegramOperatorControllerSendTypingPath = z.object({
    orgId: z.string(),
    conversationId: z.string()
});

export const zTelegramOperatorControllerSendTypingResponse2 = zTelegramOperatorControllerSendTypingResponse;

export const zToolsControllerListPath = z.object({
    orgId: z.string()
});

export const zToolsControllerListResponse2 = zToolsControllerListResponse;

export const zTypingControllerSendBody2 = zTypingControllerSendBody;

export const zTypingControllerSendPath = z.object({
    orgId: z.string()
});

export const zTypingControllerSendResponse2 = zTypingControllerSendResponse;

export const zVacationTemplatesControllerListPath = z.object({
    orgId: z.string()
});

export const zVacationTemplatesControllerListResponse2 = zVacationTemplatesControllerListResponse;

export const zVacationTemplatesControllerCreateBody2 = zVacationTemplatesControllerCreateBody;

export const zVacationTemplatesControllerCreatePath = z.object({
    orgId: z.string()
});

export const zVacationTemplatesControllerCreateResponse2 = zVacationTemplatesControllerCreateResponse;

export const zVacationTemplatesControllerDeletePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zVacationTemplatesControllerDeleteResponse2 = zVacationTemplatesControllerDeleteResponse;

export const zVacationTemplatesControllerUpdateBody2 = zVacationTemplatesControllerUpdateBody;

export const zVacationTemplatesControllerUpdatePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zVacationTemplatesControllerUpdateResponse2 = zVacationTemplatesControllerUpdateResponse;

export const zVacationsControllerListPath = z.object({
    orgId: z.string()
});

export const zVacationsControllerListResponse2 = zVacationsControllerListResponse;

export const zVacationsControllerDeleteBody2 = zVacationsControllerDeleteBody;

export const zVacationsControllerDeletePath = z.object({
    orgId: z.string(),
    id: z.string()
});

export const zVacationsControllerDeleteResponse2 = zVacationsControllerDeleteResponse;

export const zVacationsControllerRestoreBody2 = zVacationsControllerRestoreBody;

export const zVacationsControllerRestorePath = z.object({
    orgId: z.string()
});

export const zVacationsControllerRestoreResponse2 = zVacationsControllerRestoreResponse;

export const zVacationsControllerUpdateBody2 = zVacationsControllerUpdateBody;

export const zVacationsControllerUpdatePath = z.object({
    orgId: z.string()
});

export const zVacationsControllerUpdateResponse2 = zVacationsControllerUpdateResponse;

export const zWaitlistControllerCountsPath = z.object({
    orgId: z.string()
});

export const zWaitlistControllerCountsResponse2 = zWaitlistControllerCountsResponse;

export const zWaitlistControllerListPath = z.object({
    orgId: z.string()
});

export const zWaitlistControllerListQuery = z.object({
    desired: z.object({
        from: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
        op: z.enum([
            'before',
            'after',
            'between',
            'blank',
            'notBlank'
        ]).optional(),
        to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional()
    }).optional(),
    desiredFrom: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    desiredTo: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z))$/).optional(),
    eventTypeIds: z.union([
        z.object({
            op: z.enum([
                'isAnyOf',
                'isNotAnyOf',
                'includesAll',
                'blank'
            ]),
            values: z.array(z.string().max(120)).max(50).optional()
        }),
        z.string()
    ]).optional(),
    limit: z.int().gte(1).lte(100).optional().default(25),
    offset: z.int().gte(0).lte(9007199254740991).optional().default(0),
    search: z.string().max(100).optional(),
    sources: z.union([
        z.object({
            op: z.enum([
                'isAnyOf',
                'isNotAnyOf',
                'includesAll',
                'blank'
            ]),
            values: z.array(z.enum(['agent', 'local'])).max(50).optional()
        }),
        z.string()
    ]).optional(),
    statuses: z.union([
        z.object({
            op: z.enum([
                'isAnyOf',
                'isNotAnyOf',
                'includesAll',
                'blank'
            ]),
            values: z.array(z.enum([
                'ACTIVE',
                'OFFERED',
                'FULFILLED',
                'CANCELLED',
                'LAPSED'
            ])).max(50).optional()
        }),
        z.string()
    ]).optional()
});

export const zWaitlistControllerListResponse2 = zWaitlistControllerListResponse;

export const zWaitlistControllerJoinBody2 = zWaitlistControllerJoinBody;

export const zWaitlistControllerJoinPath = z.object({
    orgId: z.string()
});

export const zWaitlistControllerJoinResponse2 = zWaitlistControllerJoinResponse;

export const zWaitlistControllerCancelBody2 = zWaitlistControllerCancelBody;

export const zWaitlistControllerCancelPath = z.object({
    orgId: z.string(),
    entryId: z.string()
});

export const zWaitlistControllerCancelResponse2 = zWaitlistControllerCancelResponse;

export const zPermissionsControllerListResponse2 = zPermissionsControllerListResponse;

export const zPlansControllerListAllResponse2 = zPlansControllerListAllResponse;

export const zPlansControllerCreateDraftBody2 = zPlansControllerCreateDraftBody;

export const zPlansControllerCreateDraftResponse2 = zPlansControllerCreateDraftResponse;

export const zPlansControllerSetDraftPricingBody2 = zPlansControllerSetDraftPricingBody;

export const zPlansControllerSetDraftPricingResponse2 = zPlansControllerSetDraftPricingResponse;

export const zPlansControllerPhaseOutBody2 = zPlansControllerPhaseOutBody;

export const zPlansControllerPhaseOutResponse2 = zPlansControllerPhaseOutResponse;

export const zPlansControllerPublishBody2 = zPlansControllerPublishBody;

export const zPlansControllerPublishResponse2 = zPlansControllerPublishResponse;

export const zListBookingsHeaders = z.object({
    'X-Bavard-Api-Version': z.string().optional()
});

export const zListBookingsQuery = z.object({
    fromDate: z.string().optional(),
    toDate: z.string().optional(),
    eventTypeId: z.string().optional(),
    includeCancelled: z.string().optional(),
    limit: z.string().optional(),
    startingAfter: z.string().optional()
});

export const zListBookingsResponse = zListBookingsResponseDto;

export const zCreateBookingBody = zCreateBookingDto;

export const zCreateBookingHeaders = z.object({
    'X-Bavard-Api-Version': z.string().optional()
});

export const zCreateBookingResponse = zCreateBookingResponseDto;

export const zGetBookingByUidHeaders = z.object({
    'X-Bavard-Api-Version': z.string().optional()
});

export const zGetBookingByUidPath = z.object({
    uid: z.string()
});

export const zGetBookingByUidResponse = zBookingItemDto;

export const zCancelBookingHeaders = z.object({
    'X-Bavard-Api-Version': z.string().optional()
});

export const zCancelBookingPath = z.object({
    uid: z.string()
});

export const zCancelBookingResponse = zCancelBookingResponseDto;

export const zListEventTypesHeaders = z.object({
    'X-Bavard-Api-Version': z.string().optional()
});

export const zListEventTypesQuery = z.object({
    includeInactive: z.string().optional(),
    includeFields: z.string().optional()
});

export const zListEventTypesResponse = zListEventTypesResponseDto;

export const zGetEventTypeHeaders = z.object({
    'X-Bavard-Api-Version': z.string().optional()
});

export const zGetEventTypePath = z.object({
    id: z.string()
});

export const zGetEventTypeResponse = zEventTypeDto;

export const zRealtimeControllerGetConnectionInfoResponse2 = zRealtimeControllerGetConnectionInfoResponse;

export const zRealtimeControllerSubscribeToConversationPath = z.object({
    phoneE164: z.string()
});

export const zRealtimeControllerSubscribeToConversationResponse2 = zRealtimeControllerSubscribeToConversationResponse;

export const zRealtimeControllerSetFiltersBody2 = zRealtimeControllerSetFiltersBody;

export const zRealtimeControllerSetFiltersResponse2 = zRealtimeControllerSetFiltersResponse;

export const zRealtimeControllerSubscribeToRoomPath = z.object({
    room: z.string()
});

export const zRealtimeControllerJoinRoomBody2 = zRealtimeControllerJoinRoomBody;

export const zRealtimeControllerJoinRoomResponse2 = zRealtimeControllerJoinRoomResponse;

export const zRealtimeControllerLeaveRoomBody2 = zRealtimeControllerLeaveRoomBody;

export const zRealtimeControllerLeaveRoomResponse2 = zRealtimeControllerLeaveRoomResponse;

export const zRealtimeControllerGetSnapshotResponse2 = zRealtimeControllerGetSnapshotResponse;

export const zRealtimeControllerGetServiceStatusResponse2 = zRealtimeControllerGetServiceStatusResponse;

export const zRealtimeControllerSubscribeQuery = z.object({
    types: z.array(z.string()).optional(),
    entities: z.array(z.string()).optional()
});

export const zRealtimeControllerSubscribeResponse2 = zRealtimeControllerSubscribeResponse;

export const zRolesControllerListQuery = z.object({
    organizationId: z.string().nullable()
});

export const zRolesControllerListResponse2 = zRolesControllerListResponse;

export const zRolesControllerCreateBody2 = zRolesControllerCreateBody;

export const zRolesControllerCreateResponse2 = zRolesControllerCreateResponse;

export const zRolesControllerAssignMemberBody2 = zRolesControllerAssignMemberBody;

export const zRolesControllerAssignMemberResponse2 = zRolesControllerAssignMemberResponse;

export const zRolesControllerDeleteBody2 = zRolesControllerDeleteBody;

export const zRolesControllerDeleteResponse2 = zRolesControllerDeleteResponse;

export const zRolesControllerListOrgMembersQuery = z.object({
    organizationId: z.string().min(1)
});

export const zRolesControllerListOrgMembersResponse2 = zRolesControllerListOrgMembersResponse;

export const zRolesControllerUnassignMemberBody2 = zRolesControllerUnassignMemberBody;

export const zRolesControllerUnassignMemberResponse2 = zRolesControllerUnassignMemberResponse;

export const zRolesControllerUpdateBody2 = zRolesControllerUpdateBody;

export const zRolesControllerUpdateResponse2 = zRolesControllerUpdateResponse;

export const zSubscriptionsControllerAllQuery = z.object({
    types: z.string(),
    entities: z.string()
});

export const zSubscriptionsControllerCalendarQuery = z.object({
    fromDate: z.string(),
    toDate: z.string()
});

export const zSubscriptionsControllerChatPath = z.object({
    phoneE164: z.string()
});

export const zSubscriptionsControllerStreamingPath = z.object({
    phoneE164: z.string()
});

export const zSuperadminControllerListChannelContactsQuery = z.object({
    orgId: z.string().min(1).optional(),
    limit: z.int().gte(1).lte(1000).optional()
});

export const zSuperadminControllerListChannelContactsResponse2 = zSuperadminControllerListChannelContactsResponse;

export const zSuperadminControllerGetDashboardQuery = z.object({
    orgId: z.string().min(1).optional()
});

export const zSuperadminControllerGetDashboardResponse2 = zSuperadminControllerGetDashboardResponse;

export const zSuperadminControllerEnterOrgBody2 = zSuperadminControllerEnterOrgBody;

export const zSuperadminControllerEnterOrgResponse2 = zSuperadminControllerEnterOrgResponse;

export const zSuperadminControllerExitOrgResponse2 = zSuperadminControllerExitOrgResponse;

export const zSuperadminControllerListMembersQuery = z.object({
    orgId: z.string().min(1).optional(),
    search: z.string().min(1).optional(),
    role: z.string().min(1).optional(),
    filters: z.object({
        customRoleName: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional(),
        email: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional(),
        isActive: z.object({
            value: z.boolean()
        }).optional(),
        isSuperuser: z.object({
            value: z.boolean()
        }).optional(),
        lastSignInAt: z.union([
            z.object({
                from: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional(),
                op: z.enum([
                    'before',
                    'after',
                    'between',
                    'blank',
                    'notBlank'
                ]),
                to: z.iso.datetime().regex(/^(?:(?:\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\d|30)|(?:02)-(?:0[1-9]|1\d|2[0-8])))T(?:(?:[01]\d|2[0-3]):[0-5]\d(?::[0-5]\d(?:\.\d+)?)?(?:Z|([+-](?:[01]\d|2[0-3]):[0-5]\d)))$/).optional()
            }),
            z.object({
                filter: z.string().max(120).optional(),
                type: z.enum([
                    'contains',
                    'notContains',
                    'equals',
                    'notEqual',
                    'startsWith',
                    'endsWith',
                    'blank',
                    'notBlank'
                ])
            })
        ]).optional(),
        name: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional(),
        orgName: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional(),
        role: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional()
    }).optional(),
    sort: z.array(z.object({
        colId: z.enum([
            'name',
            'email',
            'orgName',
            'role',
            'isActive',
            'isSuperuser',
            'lastSignInAt'
        ]),
        sort: z.enum(['asc', 'desc'])
    })).optional(),
    limit: z.int().gte(1).lte(1000).optional(),
    offset: z.int().gte(0).lte(9007199254740991).optional()
});

export const zSuperadminControllerListMembersResponse2 = zSuperadminControllerListMembersResponse;

export const zSuperadminControllerCreateMemberBody2 = zSuperadminControllerCreateMemberBody;

export const zSuperadminControllerCreateMemberResponse2 = zSuperadminControllerCreateMemberResponse;

export const zSuperadminControllerDeleteMemberPath = z.object({
    id: z.string()
});

export const zSuperadminControllerDeleteMemberResponse2 = zSuperadminControllerDeleteMemberResponse;

export const zSuperadminControllerUpdateMemberBody2 = zSuperadminControllerUpdateMemberBody;

export const zSuperadminControllerUpdateMemberPath = z.object({
    id: z.string()
});

export const zSuperadminControllerUpdateMemberResponse2 = zSuperadminControllerUpdateMemberResponse;

export const zSuperadminControllerDeleteMembersBody2 = zSuperadminControllerDeleteMembersBody;

export const zSuperadminControllerDeleteMembersResponse2 = zSuperadminControllerDeleteMembersResponse;

export const zSuperadminControllerListOrganizationsQuery = z.object({
    orgId: z.string().min(1).optional(),
    search: z.string().min(1).optional(),
    filters: z.object({
        isActive: z.object({
            value: z.boolean()
        }).optional(),
        name: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional(),
        plan: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional(),
        slug: z.object({
            filter: z.string().max(120).optional(),
            type: z.enum([
                'contains',
                'notContains',
                'equals',
                'notEqual',
                'startsWith',
                'endsWith',
                'blank',
                'notBlank'
            ])
        }).optional()
    }).optional(),
    sort: z.array(z.object({
        colId: z.enum([
            'name',
            'slug',
            'plan',
            'isActive',
            'balanceCredits',
            'createdAt'
        ]),
        sort: z.enum(['asc', 'desc'])
    })).optional(),
    limit: z.int().gte(1).lte(1000).optional(),
    offset: z.int().gte(0).lte(9007199254740991).optional()
});

export const zSuperadminControllerListOrganizationsResponse2 = zSuperadminControllerListOrganizationsResponse;

export const zSuperadminControllerCreateOrganizationBody2 = zSuperadminControllerCreateOrganizationBody;

export const zSuperadminControllerCreateOrganizationResponse2 = zSuperadminControllerCreateOrganizationResponse;

export const zSuperadminControllerDeleteOrganizationPath = z.object({
    id: z.string()
});

export const zSuperadminControllerDeleteOrganizationResponse2 = zSuperadminControllerDeleteOrganizationResponse;

export const zSuperadminControllerGetOrganizationPath = z.object({
    id: z.string()
});

export const zSuperadminControllerGetOrganizationResponse2 = zSuperadminControllerGetOrganizationResponse;

export const zSuperadminControllerUpdateOrganizationBody2 = zSuperadminControllerUpdateOrganizationBody;

export const zSuperadminControllerUpdateOrganizationPath = z.object({
    id: z.string()
});

export const zSuperadminControllerUpdateOrganizationResponse2 = zSuperadminControllerUpdateOrganizationResponse;

export const zSuperadminControllerGetOrgKeyBalancePath = z.object({
    id: z.string()
});

export const zSuperadminControllerGetOrgKeyBalanceResponse2 = zSuperadminControllerGetOrgKeyBalanceResponse;

export const zSuperadminControllerUpdateOrganizationSecretsBody2 = zSuperadminControllerUpdateOrganizationSecretsBody;

export const zSuperadminControllerUpdateOrganizationSecretsPath = z.object({
    id: z.string()
});

export const zSuperadminControllerUpdateOrganizationSecretsResponse2 = zSuperadminControllerUpdateOrganizationSecretsResponse;

export const zSuperadminControllerToggleOrganizationBody2 = zSuperadminControllerToggleOrganizationBody;

export const zSuperadminControllerToggleOrganizationPath = z.object({
    id: z.string()
});

export const zSuperadminControllerToggleOrganizationResponse2 = zSuperadminControllerToggleOrganizationResponse;

export const zSuperadminControllerGetSystemHealthResponse2 = zSuperadminControllerGetSystemHealthResponse;

export const zSystemAgentControllerDeleteTrailingMessagesBody2 = zSystemAgentControllerDeleteTrailingMessagesBody;

export const zSystemAgentControllerDeleteTrailingMessagesPath = z.object({
    messageId: z.string()
});

export const zSystemAgentControllerDeleteTrailingMessagesResponse2 = zSystemAgentControllerDeleteTrailingMessagesResponse;

export const zSystemAgentControllerCheckAvailabilityResponse2 = zSystemAgentControllerCheckAvailabilityResponse;

export const zSystemAgentControllerChatBody2 = zSystemAgentControllerChatBody;

export const zSystemAgentControllerResumeStreamPath = z.object({
    chatId: z.string()
});

export const zSystemAgentControllerResumeStreamQuery = z.object({
    resumeAt: z.int().gte(0).lte(9007199254740991).optional()
});

export const zSystemAgentControllerResumeStreamResponse2 = zSystemAgentControllerResumeStreamResponse;

export const zSystemAgentControllerCancelStreamPath = z.object({
    streamId: z.string()
});

export const zSystemAgentControllerCancelStreamResponse2 = zSystemAgentControllerCancelStreamResponse;

export const zSystemAgentControllerRewriteTextBody2 = zSystemAgentControllerRewriteTextBody;

export const zSystemAgentControllerRewriteTextResponse2 = zSystemAgentControllerRewriteTextResponse;

export const zSystemAgentControllerGetActiveStreamSnapshotPath = z.object({
    conversationId: z.string()
});

export const zSystemAgentControllerGetActiveStreamSnapshotResponse2 = zSystemAgentControllerGetActiveStreamSnapshotResponse;

export const zSystemAgentControllerPersistToolDenialBody2 = zSystemAgentControllerPersistToolDenialBody;

export const zSystemAgentControllerPersistToolDenialResponse2 = zSystemAgentControllerPersistToolDenialResponse;

export const zTeamControllerGetActivityQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(50),
    cursor: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    kinds: z.string().optional(),
    search: z.string().optional()
});

export const zTeamControllerGetActivityResponse2 = zTeamControllerGetActivityResponse;

export const zTeamControllerRemoveMemberPath = z.object({
    userId: z.string()
});

export const zTeamControllerRemoveMemberResponse2 = zTeamControllerRemoveMemberResponse;

export const zTeamControllerGetMemberPath = z.object({
    userId: z.string()
});

export const zTeamControllerGetMemberResponse2 = zTeamControllerGetMemberResponse;

export const zTeamControllerSetMemberActiveBody2 = zTeamControllerSetMemberActiveBody;

export const zTeamControllerSetMemberActivePath = z.object({
    userId: z.string()
});

export const zTeamControllerSetMemberActiveResponse2 = zTeamControllerSetMemberActiveResponse;

export const zTeamControllerGetMemberActivityPath = z.object({
    userId: z.string()
});

export const zTeamControllerGetMemberActivityQuery = z.object({
    limit: z.int().gte(1).lte(100).optional().default(50),
    cursor: z.string().optional(),
    from: z.string().optional(),
    to: z.string().optional(),
    kinds: z.string().optional(),
    search: z.string().optional()
});

export const zTeamControllerGetMemberActivityResponse2 = zTeamControllerGetMemberActivityResponse;

export const zTeamControllerNotifyMemberBody2 = zTeamControllerNotifyMemberBody;

export const zTeamControllerNotifyMemberPath = z.object({
    userId: z.string()
});

export const zTeamControllerNotifyMemberResponse2 = zTeamControllerNotifyMemberResponse;

export const zTeamControllerGetMemberSessionsPath = z.object({
    userId: z.string()
});

export const zTeamControllerGetMemberSessionsResponse2 = zTeamControllerGetMemberSessionsResponse;

export const zTeamControllerGetOverviewResponse2 = zTeamControllerGetOverviewResponse;

export const zTeamControllerGetRosterResponse2 = zTeamControllerGetRosterResponse;

export const zUsersControllerGetDocumentPath = z.object({
    phoneE164: z.string()
});

export const zUsersControllerGetDocumentResponse2 = zUsersControllerGetDocumentResponse;

export const zUsersControllerSaveDocumentBody2 = zUsersControllerSaveDocumentBody;

export const zUsersControllerSaveDocumentPath = z.object({
    phoneE164: z.string()
});

export const zUsersControllerSaveDocumentResponse2 = zUsersControllerSaveDocumentResponse;

export const zUsersControllerSetActiveBody2 = zUsersControllerSetActiveBody;

export const zUsersControllerSetActivePath = z.object({
    phoneE164: z.string()
});

export const zUsersControllerSetActiveResponse2 = zUsersControllerSetActiveResponse;

export const zUsersControllerEnsureDocumentPath = z.object({
    phoneE164: z.string()
});

export const zUsersControllerEnsureDocumentResponse2 = zUsersControllerEnsureDocumentResponse;

export const zUsersControllerSaveViewportBody2 = zUsersControllerSaveViewportBody;

export const zUsersControllerSaveViewportPath = z.object({
    phoneE164: z.string()
});

export const zUsersControllerSaveViewportResponse2 = zUsersControllerSaveViewportResponse;

export const zUsersControllerSetFavoriteBody2 = zUsersControllerSetFavoriteBody;

export const zUsersControllerSetFavoritePath = z.object({
    phoneE164: z.string()
});

export const zUsersControllerSetFavoriteResponse2 = zUsersControllerSetFavoriteResponse;

export const zUsersControllerGetDocumentMetaPath = z.object({
    phoneE164: z.string()
});

export const zUsersControllerGetDocumentMetaResponse2 = zUsersControllerGetDocumentMetaResponse;

export const zUsersControllerModifyPhoneBody2 = zUsersControllerModifyPhoneBody;

export const zUsersControllerModifyPhonePath = z.object({
    phoneE164: z.string()
});

export const zUsersControllerModifyPhoneResponse2 = zUsersControllerModifyPhoneResponse;

export const zUsersControllerGetStatsPath = z.object({
    phoneE164: z.string()
});

export const zUsersControllerGetStatsResponse2 = zUsersControllerGetStatsResponse;

export const zUsersControllerGetOrCreateBody2 = zUsersControllerGetOrCreateBody;

export const zUsersControllerGetOrCreateResponse2 = zUsersControllerGetOrCreateResponse;

export const zUsersControllerGetNamesResponse2 = zUsersControllerGetNamesResponse;

export const zPaymobWebhookControllerHandleEgQuery = z.object({
    hmac: z.string()
});

export const zPaymobWebhookControllerHandleSaQuery = z.object({
    hmac: z.string()
});

export const zWhatsappControllerCheckAvailabilityResponse2 = zWhatsappControllerCheckAvailabilityResponse;

export const zWhatsappControllerBlockUsersBody2 = zWhatsappControllerBlockUsersBody;

export const zWhatsappControllerBlockUsersResponse2 = zWhatsappControllerBlockUsersResponse;

export const zWhatsappControllerBroadcastBody2 = zWhatsappControllerBroadcastBody;

export const zWhatsappControllerBroadcastResponse2 = zWhatsappControllerBroadcastResponse;

export const zWhatsappControllerCancelReplyBody2 = zWhatsappControllerCancelReplyBody;

export const zWhatsappControllerCancelReplyResponse2 = zWhatsappControllerCancelReplyResponse;

export const zWhatsappControllerSendLocationBody2 = zWhatsappControllerSendLocationBody;

export const zWhatsappControllerSendLocationResponse2 = zWhatsappControllerSendLocationResponse;

export const zWhatsappControllerMarkAsReadBody2 = zWhatsappControllerMarkAsReadBody;

export const zWhatsappControllerMarkAsReadResponse2 = zWhatsappControllerMarkAsReadResponse;

export const zWhatsappControllerFetchMediaPath = z.object({
    mediaId: z.string()
});

export const zWhatsappControllerFetchMediaResponse2 = zWhatsappControllerFetchMediaResponse;

export const zWhatsappControllerUploadMediaBody2 = zWhatsappControllerUploadMediaBody;

export const zWhatsappControllerUploadMediaResponse2 = zWhatsappControllerUploadMediaResponse;

export const zWhatsappControllerSendMessageBody2 = zWhatsappControllerSendMessageBody;

export const zWhatsappControllerSendMessageResponse2 = zWhatsappControllerSendMessageResponse;

export const zWhatsappControllerSendReactionBody2 = zWhatsappControllerSendReactionBody;

export const zWhatsappControllerSendReactionResponse2 = zWhatsappControllerSendReactionResponse;

export const zWhatsappControllerSendTemplateBody2 = zWhatsappControllerSendTemplateBody;

export const zWhatsappControllerSendTemplateResponse2 = zWhatsappControllerSendTemplateResponse;

export const zWhatsappControllerDeleteTemplateBody2 = zWhatsappControllerDeleteTemplateBody;

export const zWhatsappControllerDeleteTemplateHeaders = z.object({
    'idempotency-key': z.string()
});

export const zWhatsappControllerDeleteTemplateResponse2 = zWhatsappControllerDeleteTemplateResponse;

export const zWhatsappControllerListTemplatesQuery = z.object({
    status: z.string().min(1).optional()
});

export const zWhatsappControllerListTemplatesResponse2 = zWhatsappControllerListTemplatesResponse;

export const zWhatsappControllerCreateTemplateBody2 = zWhatsappControllerCreateTemplateBody;

export const zWhatsappControllerCreateTemplateHeaders = z.object({
    'idempotency-key': z.string()
});

export const zWhatsappControllerCreateTemplateResponse2 = zWhatsappControllerCreateTemplateResponse;

export const zWhatsappControllerEditTemplateBody2 = zWhatsappControllerEditTemplateBody;

export const zWhatsappControllerEditTemplateHeaders = z.object({
    'idempotency-key': z.string()
});

export const zWhatsappControllerEditTemplatePath = z.object({
    name: z.string(),
    language: z.string()
});

export const zWhatsappControllerEditTemplateResponse2 = zWhatsappControllerEditTemplateResponse;

export const zWhatsappControllerTemplateCapabilityResponse2 = zWhatsappControllerTemplateCapabilityResponse;

export const zWhatsappControllerTestConfigResponse2 = zWhatsappControllerTestConfigResponse;

export const zWhatsappControllerSendTypingIndicatorBody2 = zWhatsappControllerSendTypingIndicatorBody;

export const zWhatsappControllerSendTypingIndicatorResponse2 = zWhatsappControllerSendTypingIndicatorResponse;

export const zWhatsappControllerUnblockUsersBody2 = zWhatsappControllerUnblockUsersBody;

export const zWhatsappControllerUnblockUsersResponse2 = zWhatsappControllerUnblockUsersResponse;

export const zJobsControllerGetMetricsResponse2 = zJobsControllerGetMetricsResponse;
